/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type AiAgentNotificationInput = {
  /** Channels for emergency-appointment-request notifications. */
  emergencyAppointmentRequest?: NotificationChannelInput | null | undefined
  /** Whether AI-agent notifications are enabled. */
  enabled?: boolean | null | undefined
  /** Channels for new AI-agent-call notifications. */
  newAIAgentCall?: NotificationChannelInput | null | undefined
  /** Channels for new-appointment-booked notifications. */
  newAppointmentBooked?: NotificationChannelInput | null | undefined
}

export type AiAgentOfferInput = {
  /** Insurance eligibility: Any, Insured, or Uninsured */
  eligibleInsurance: string
  /** Name of the offer */
  name: string
  /** Whether the offer is only eligible for emergencies */
  onlyEmergencyEligible: boolean
  /** Patient status the offer applies to: New Patient or Existing Patient */
  patientStatus?: string | null | undefined
}

export type AiAgentServiceInput = {
  /** Price of the required consult */
  consultPrice?: number | null | undefined
  /** Whether a consult is required for this service */
  consultRequired: boolean
  /** High end of the service price range */
  highPrice?: number | null | undefined
  /** Low end of the service price range */
  lowPrice?: number | null | undefined
  /** Name of the service */
  name: string
}

/** Visual presets for the patient-facing packet */
export type AppearanceInput = {
  /** Accent color used in the patient-facing packet. */
  accentColor: string
  /** white, warm, cool, or paper */
  backgroundPreset: string
  /** system, classic, or modern */
  fontPreset: string
}

export type CallAiInput = {
  /** AI-generated action items. */
  actionItems?: string | null | undefined
  /** Who answered the call. */
  answerer?: string | null | undefined
  /** Marketing channel attributed to the call. */
  channel?: string | null | undefined
  /** When extraction ran (ISO date/time). */
  extractionDate?: string | null | undefined
  /** Model used for extraction. */
  model?: string | null | undefined
  /** People identified on the call. */
  people?: Array<CallAiPersonInput> | null | undefined
  /** AI-generated call summary. */
  summary?: string | null | undefined
  /** Token usage for the extraction. */
  tokenUsage?: CallTokenUsageInput | null | undefined
}

export type CallAiPersonInput = {
  /** Appointment date (ISO date). */
  appointmentDate?: string | null | undefined
  /** Whether an appointment was requested. */
  appointmentRequested?: boolean | null | undefined
  /** Whether an appointment was scheduled. */
  appointmentScheduled?: boolean | null | undefined
  /** Appointment time. */
  appointmentTime?: string | null | undefined
  /** Person's birth date (ISO date). */
  birthDate?: string | null | undefined
  /** Person's email. */
  email?: string | null | undefined
  /** Index of this person within the call. */
  index?: number | null | undefined
  /** Insurance provider. */
  insuranceProvider?: string | null | undefined
  /** Whether this person is the caller. */
  isCaller?: boolean | null | undefined
  /** Person's name. */
  name?: string | null | undefined
  /** Call outcomes for this person. */
  outcomes?: Array<string> | null | undefined
  /** Patient type (e.g. new, existing). */
  patientType?: string | null | undefined
  /** Person's phone number. */
  phone?: string | null | undefined
  /** Reason an appointment was not scheduled. */
  reasonForNotScheduling?: string | null | undefined
  /** Referral source. */
  referral?: string | null | undefined
  /** Relationship to the caller. */
  relationship?: string | null | undefined
  /** Service requested. */
  serviceRequested?: string | null | undefined
  /** Treatment discussed. */
  treatment?: string | null | undefined
}

export type CallPatientInput = {
  /** Appointment date (ISO date). */
  appointmentDate?: string | null | undefined
  /** Whether an appointment was requested. */
  appointmentRequested?: boolean | null | undefined
  /** Whether an appointment was scheduled. */
  appointmentScheduled?: boolean | null | undefined
  /** Appointment time. */
  appointmentTime?: string | null | undefined
  /** Patient birth date (ISO date). */
  birthDate?: string | null | undefined
  /** Patient email. */
  email?: string | null | undefined
  /** Index of this patient within the call. */
  index?: number | null | undefined
  /** Patient's insurance provider. */
  insuranceProvider?: string | null | undefined
  /** Whether this patient is the caller. */
  isCaller?: boolean | null | undefined
  /** Location associated with the patient. */
  locationId?: string | null | undefined
  /** Patient name. */
  name?: string | null | undefined
  /** Call outcomes for this patient. */
  outcomes?: Array<string> | null | undefined
  /** Patient type (e.g. new, existing). */
  patientType?: string | null | undefined
  /** Patient phone number. */
  phone?: string | null | undefined
  /** Reason an appointment was not scheduled. */
  reasonForNotScheduling?: string | null | undefined
  /** Referral source for the patient. */
  referral?: string | null | undefined
  /** Patient's relationship to the caller. */
  relationship?: string | null | undefined
  /** Service the patient requested. */
  serviceRequested?: string | null | undefined
  /** Treatment discussed. */
  treatment?: string | null | undefined
}

export type CallStaffInput = {
  /** Staff member ID. */
  id?: string | number | null | undefined
  /** Staff member name. */
  name?: string | null | undefined
}

export type CallTokenUsageInput = {
  /** Input tokens consumed by extraction. */
  inputTokens?: number | null | undefined
  /** Output tokens produced by extraction. */
  outputTokens?: number | null | undefined
  /** Total tokens consumed by extraction. */
  totalTokens?: number | null | undefined
}

export type ClientType = 'NATIVE' | 'PWA'

export type ConnectorType = 'ASCEND' | 'CARESTACK' | 'KOLLA' | 'SIKKA'

export type ContactPipelineInput = {
  /** Pipeline id. */
  id: string
  /** Stage within the pipeline. */
  stage: string
}

export type ContactStaffInput = {
  /** Staff member id. */
  id: string | number
  /** Staff member name. */
  name: string
}

export type CreateActionInput = {
  /** Contact this action applies to. */
  contactId: string | number
  /** Optional free-text note on the action. */
  note?: string | null | undefined
  /** Identifier of the queue this action belongs to. */
  queueId: string
  /** Name of the queue this action belongs to. */
  queueName: string
  /** Current state of the action. */
  state: string
  /** Date the action is deferred until, if snoozed. */
  untilDate?: string | null | undefined
}

export type CreateActivityInput = {
  /** Contact the activity belongs to. */
  contactId: string
  /** Activity description. */
  description?: string | null | undefined
  /** Location the activity belongs to. */
  locationId?: string | null | undefined
  /** Activity type. */
  type: string
}

export type CreateAdPlatformMappingInput = {
  /** UTM medium to match. */
  medium: string
  /** Ad platform this source/medium maps to. */
  platform: string
  /** UTM source to match. */
  source: string
}

export type CreateAvailabilityInput = {
  /** Appointment type IDs this availability applies to. */
  appointmentTypeIds: Array<string>
  /** Whether this is backup availability, used only when primary availability is unavailable. */
  backupAvailability?: boolean | null | undefined
  /** Operatory IDs where the provider can be scheduled. */
  operatoryIds: Array<string>
  /** Provider this availability belongs to. */
  providerId: string | number
  /** Weekly time slots when the provider is available. */
  timeSlots: LocationOpenHoursInput
}

export type CreateBudgetInput = {
  /** Planned budget amount for the channel. */
  amount?: number | null | undefined
  /** Target number of appointments for the period. */
  appointmentGoal?: number | null | undefined
  /** Marketing channel this budget is for. */
  channel: string
  /** Internal spend goal for the period. */
  internalGoal?: number | null | undefined
  /** Target number of leads for the period. */
  leadGoal?: number | null | undefined
  /** Location this budget applies to. */
  locationId: string | number
  /** Target number of marketing qualified leads for the period. */
  mqlGoal?: number | null | undefined
  /** Target number of new patients for the period. */
  patientGoal?: number | null | undefined
  /** Target ad spend for the period. */
  targetSpend?: number | null | undefined
  /** Budget period in YYYY-MM format. */
  yearMonth: string
}

export type CreateCdtCodeMappingInput = {
  /** Category this CDT code maps to. */
  category: string
  /** CDT dental procedure code. */
  cdtCode: string
}

export type CreateChannelMappingInput = {
  /** Channel this source/medium maps to. */
  channel: string
  /** UTM medium to match. */
  medium: string
  /** UTM source to match. */
  source: string
}

export type CreateCommLogWritebackRuleInput = {
  /** PMS channel entries of this type are written under */
  channel: string
  /** Location this writeback rule applies to */
  locationId: string | number
  /** Comm-log writeback type the rule covers */
  type: string
}

export type CreateContactInput = {
  /** Date the contact became a lead. */
  becameLeadDate?: string | null | undefined
  /** Cell phone number. */
  cellPhone?: string | null | undefined
  /** Marketing channel for the contact. */
  channel?: string | null | undefined
  /** Email address. */
  email?: string | null | undefined
  /** Home phone number. */
  homePhone?: string | null | undefined
  /** Staff member who owns this lead. */
  leadOwner?: ContactStaffInput | null | undefined
  /** Lead status of the contact. */
  leadStatus?: string | null | undefined
  /** Location this contact belongs to. */
  locationId: string | number
  /** Contact name. */
  name: string
  /** Marketing attribution campaign (UTM campaign). */
  utmCampaign?: string | null | undefined
  /** Marketing attribution medium (UTM medium). */
  utmMedium?: string | null | undefined
  /** Marketing attribution source (UTM source). */
  utmSource?: string | null | undefined
  /** Work phone number. */
  workPhone?: string | null | undefined
}

export type CreateCustomPageInput = {
  /** JSON-encoded array of filters to apply. */
  filters?: string | null | undefined
  /** Join operator applied to the filters (e.g. AND/OR). */
  join: string
  /** Display name for the custom page. */
  name: string
  /** Base page/entity type the custom page is built on. */
  page: string
}

export type CreateExtractionPromptInput = {
  /** Whether the prompt is active */
  active?: boolean | null | undefined
  /** LLM model to use */
  model: string
  /** Free-form notes about the prompt */
  notes?: string | null | undefined
  /** Prompt text */
  prompt: string
  /** Version label for the prompt */
  promptVersion: string
  /** Extraction stage this prompt runs in */
  stage: string
}

export type CreateFeatureToggleInput = {
  /** Category grouping for the toggle. */
  category?: FeatureToggleCategory | null | undefined
  /** Description of what the feature toggle controls. */
  description?: string | null | undefined
  /** Human-readable display name for the toggle. */
  displayName?: string | null | undefined
  /** Internal name of the feature toggle. */
  name: string
  /** Release the toggle is associated with. */
  release?: string | null | undefined
  /** Scope type of the toggle, e.g. org, workspace, location. */
  type: string
  /** ID of the entity the toggle is scoped to. */
  typeId?: string | null | undefined
}

export type CreateFileImportInput = {
  /** Name of the uploaded file. */
  fileName: string
  /** Import IDs included in this file import. */
  importIds: Array<string>
}

export type CreateFollowUpInput = {
  /** Scheduled appointment date linked to this follow-up. */
  appointmentDate?: string | null | undefined
  /** Contact to create the follow-up for. */
  contactId: string | number
  /** Notes describing the follow-up. */
  description?: string | null | undefined
  /** Date the follow-up is due. */
  followUpDate?: string | null | undefined
  /** Whether contact was successfully reached. */
  isConnected?: boolean | null | undefined
  /** Whether an appointment was scheduled from this follow-up. */
  isScheduled?: boolean | null | undefined
  /** Location the follow-up is associated with. */
  locationId: string | number
  /** Skip updating the parent contact when creating this follow-up. */
  noContactUpdate?: boolean | null | undefined
  /** User to assign as the follow-up owner. */
  ownerId?: string | number | null | undefined
  /** Display name of the follow-up owner. */
  ownerName?: string | null | undefined
}

export type CreateFormFieldMappingInput = {
  /** Trackable form field the raw key maps to. */
  formField: string
  /** Raw incoming form key to map. */
  rawKey: string
}

export type CreateFormTemplateInput = {
  /** One of: registration, medicalHistory, consent, financialPolicy, custom */
  category: string
  /** Form description. */
  description?: string | null | undefined
  /** Form name. */
  name: string
  /** The ordered questions that make up the form. */
  questions: Array<FormQuestionInput>
}

export type CreateImportInput = {
  /** Date the activity occurred (ISO date). */
  activityDate?: string | null | undefined
  /** Marketing channel attributed to the import. */
  channel?: string | null | undefined
  /** Contact email on the record. */
  email?: string | null | undefined
  /** Whether the record is already scheduled. */
  isScheduled?: boolean | null | undefined
  /** Location the import belongs to. */
  locationId: string
  /** Name on the imported record. */
  name: string
  /** Contact phone number on the record. */
  phone?: string | null | undefined
  /** Requested appointment date (ISO date). */
  requestedAppointmentDate?: string | null | undefined
  /** Staff member associated with the import. */
  staff?: string | null | undefined
  /** Treatment or service referenced. */
  treatment?: string | null | undefined
  /** Activity type the import creates. */
  type: string
  /** UTM campaign attributed to the import. */
  utmCampaign?: string | null | undefined
  /** UTM medium attributed to the import. */
  utmMedium?: string | null | undefined
  /** UTM source attributed to the import. */
  utmSource?: string | null | undefined
  /** Vendor the record came from. */
  vendor?: string | null | undefined
}

export type CreateListInput = {
  /** Stage rule matches fall into when they have no stored stage row. */
  defaultStageId?: string | number | null | undefined
  /** Entity type the list is built from: Contact, Activity, TreatmentPlan, Appointment, or Task. */
  entityType: string
  /** List rule as a JSON-encoded FilterObject array. */
  filters?: string | null | undefined
  /** Join operator applied across the rule filters (e.g. and/or). */
  join?: string | null | undefined
  /** Display name of the new list. */
  name: string
  /** Initial stages/lanes for the list. */
  stages?: Array<ListStageInput> | null | undefined
  /** List visibility: shared (default) or personal (visible only to its creator). */
  visibility?: string | null | undefined
}

export type CreateListItemInput = {
  /** Entity (e.g. contact) to add as a member of the list. */
  entityId: string | number
  /** List to add the entity to. */
  listId: string | number
  /** Stage/lane to place the new member in; defaults to the list's match stage when omitted. */
  stageId?: string | number | null | undefined
}

export type CreateLocationInput = {
  /** Street address of the location. */
  address?: string | null | undefined
  /** Business phone number of the location. */
  businessPhone?: string | null | undefined
  /** City of the location. */
  city?: string | null | undefined
  /** Name of the location. */
  name: string
  /** Main office phone number of the location. */
  officeMainNumber?: string | null | undefined
  /** Weekly open hours for the location. */
  openHours?: LocationOpenHoursInput | null | undefined
  /** State of the location. */
  state?: string | null | undefined
  /** IANA timezone of the location. */
  timezone: string
  /** Type of location. */
  type?: string | null | undefined
  /** ZIP/postal code of the location. */
  zip?: string | null | undefined
}

export type CreateNoteTemplateInput = {
  /** Body text of the note template. */
  body: string
  /** Name of the note template. */
  name: string
}

export type CreatePaperworkInput = {
  /** Days until the link expires. Defaults to 14. */
  expiresInDays?: number | null | undefined
  /** The PaperworkTemplate to send */
  paperworkTemplateId: string | number
  /** The patient to send it to */
  patientId: string | number
}

export type CreatePaperworkTemplateInput = {
  /** Visual presets for the packet. */
  appearance?: AppearanceInput | null | undefined
  /** Practice branding for the packet. */
  branding?: PaperworkBrandingInput | null | undefined
  /** Completion screen content. */
  completion?: ScreenContentInput | null | undefined
  /** Optional description of the template. */
  description?: string | null | undefined
  /** Ordered list of forms to send */
  forms: Array<PaperworkFormInput>
  /** Name of the paperwork template. */
  name: string
  /** Welcome screen content. */
  welcome?: ScreenContentInput | null | undefined
}

export type CreatePipelineInput = {
  /** Pipeline name. */
  name: string
  /** Ordered stages for the pipeline. */
  stages?: Array<PipelineStageInput> | null | undefined
}

export type CreatePmsReferralMappingInput = {
  /** UTM campaign to attribute this referral type to. */
  campaign?: string | null | undefined
  /** Marketing channel to attribute this referral type to. */
  channel?: string | null | undefined
  /** Force the mapping even if it conflicts with existing rules. */
  force?: boolean | null | undefined
  /** UTM medium to attribute this referral type to. */
  medium?: string | null | undefined
  /** PMS referral type this mapping applies to. */
  referralType: string
  /** UTM source to attribute this referral type to. */
  source?: string | null | undefined
}

export type CreateRoleInput = {
  /** Name of the new role. */
  name: string
  /** Permission keys granted to the role. */
  permissions?: Array<string> | null | undefined
}

export type CreateScorecardInput = {
  /** Whether this is the default scorecard. */
  default?: boolean | null | undefined
  /** Grouping dimension for the scorecard. */
  grouping: string
  /** Scorecard name. */
  name: string
}

export type CreateSendingDomainInput = {
  /** The domain to send from, e.g. mail.smithdental.com */
  domain: string
  /** trackable (shared mail.trackable.io) or custom (own domain). Defaults to custom. */
  type?: string | null | undefined
}

export type CreateSmsTemplateInput = {
  /** Message body of the SMS template. */
  body: string
  /** Name of the SMS template. */
  name: string
}

export type CreateStaffInput = {
  /** Whether the staff member is active */
  active?: boolean | null | undefined
  /** Alternate names the staff member is also known by */
  aliases?: Array<string> | null | undefined
  /** Display name of the staff member */
  name: string
  /** Linked user account id to associate with this staff member */
  userId?: string | number | null | undefined
}

export type CreateStoredCredentialInput = {
  /** Human-readable label for the credential. */
  label: string
  /** Location this credential is scoped to, if any. */
  locationId?: string | null | undefined
  /** Optional JSON metadata for the credential. */
  metadata?: string | null | undefined
  /** Password for the credential (stored encrypted). */
  password: string
  /** Username for the credential. */
  username: string
}

export type CreateTagColorInput = {
  /** Display color for the tag (hex or named color). */
  color: string
  /** Entity the tag applies to (activities, contacts, or calls). */
  entity: string
  /** Tag value/label text. */
  name: string
}

export type CreateTaskInput = {
  /** Contact the task is linked to. */
  contactId?: string | null | undefined
  /** Task description. */
  description?: string | null | undefined
  /** Task due date (ISO date). */
  dueDate?: string | null | undefined
  /** Location the task belongs to. */
  locationId: string
  /** ID of the task owner. */
  ownerId?: string | null | undefined
  /** Role assigned to the task. */
  roleId?: string | null | undefined
  /** Task title. */
  title: string
}

export type CreateTaskTemplateInput = {
  /** Optional description applied to tasks created from this template. */
  description?: string | null | undefined
  /** Number of days after creation that the task is due. */
  dueInDays?: number | null | undefined
  /** Internal name of the task template. */
  name: string
  /** User assigned as the owner of tasks created from this template. */
  ownerId?: string | null | undefined
  /** Title applied to tasks created from this template. */
  title: string
}

export type CreateUserInput = {
  /** Location IDs the new user may access. */
  allowedLocationIds?: Array<string> | null | undefined
  /** New user's email address. */
  email: string
  /** New user's display name. */
  name: string
  /** New user's phone number. */
  phone?: string | null | undefined
  /** Role to assign to the new user. */
  roleId?: string | number | null | undefined
  /** Staff record to link to the new user. */
  staffId?: string | number | null | undefined
}

export type CreateUtmAliasInput = {
  /** Canonical value the original is aliased to. */
  alias: string
  /** Original UTM value to be normalized. */
  original: string
  /** UTM parameter type being aliased, e.g. source, medium, campaign. */
  type: string
}

/** Create a new workflow definition. Workflows are created inactive and must be activated via updateWorkflow(active: true) after the graph is valid. */
export type CreateWorkflowInput = {
  /** Opaque JSON blob for the frontend builder (preserved by the engine, never interpreted). Stores UI-only fields like node labels, editor state, and unsupported-node configs so round-trips are lossless. */
  builderJson?: string | null | undefined
  /** The workflow graph edges connecting nodes */
  edges: Array<WorkflowEdgeInput>
  /** Location this workflow belongs to */
  locationId: string
  /** Human-readable workflow name */
  name: string
  /** The workflow graph nodes */
  nodes: Array<WorkflowNodeInput>
  /** Say This, Not That rules scoped to this workflow. The SMS agent follows them only while this workflow's brief is active on a thread. Same limits as location rules: max 20, max 100 chars per phrase, non-empty, no line breaks. */
  sayThisNotThatRules?: Array<WorkflowSayThisNotThatRuleInput> | null | undefined
  /** JSON settings object (quiet hours, etc.) */
  settings?: string | null | undefined
  /** When this workflow should enroll contacts */
  trigger: WorkflowTriggerInput
  /** Date on which a date-based trigger starts evaluating; enrollments before it are ignored */
  triggerStartDate?: string | null | undefined
}

export type CreateWorkspaceInput = {
  /** Name of the new workspace. */
  name: string
}

export type CreateWorkspaceInviteInput = {
  /** Unique invite code the invitee uses to accept. */
  code: string
  /** Email address being invited. */
  email: string
  /** Invite expiration timestamp (ISO date). */
  expiresAt: string
  /** Locations the invitee will have access to. */
  locationIds?: Array<string> | null | undefined
  /** Role to assign the invitee on acceptance. */
  roleId: string
  /** Existing staff record to link to the invite, if any. */
  staffId?: string | null | undefined
}

export type CustomQuestionInput = {
  /** Optional help text describing the question. */
  description?: string | null | undefined
  /** Whether this question is enabled and shown. */
  enabled: boolean
  /** Field name/label of the custom question. */
  fieldName: string
  /** Input type of the question, e.g. text, select, boolean. */
  fieldType: string
  /** Unique identifier for the custom question. */
  id: string | number
  /** Whether this question is an opt-in consent checkbox. */
  optIn?: boolean | null | undefined
  /** Whether an answer is required. */
  required: boolean
}

export type DateRangeInput = {
  /** Start of the comparison date range (inclusive, ISO date). */
  compareFromDate?: string | null | undefined
  /** End of the comparison date range (inclusive, ISO date). */
  compareToDate?: string | null | undefined
  /** Start of the primary date range (inclusive, ISO date). */
  fromDate: string
  /** End of the primary date range (inclusive, ISO date). */
  toDate: string
}

export type EmailAttachmentInput = {
  /** Base64-encoded file contents. */
  base64: string
  /** Browser-reported MIME type. Falls back to the file extension when omitted or application/octet-stream. */
  contentType?: string | null | undefined
  /** File name, shown to the recipient. */
  filename: string
}

export type FacebookAdsCampaignInput = {
  /** Grandparent node ID in the ad hierarchy (account for an ad set). */
  grandparentId?: string | null | undefined
  /** Facebook object ID (campaign, ad set, or account). */
  id: string
  /** Parent node ID in the ad hierarchy. */
  parentId?: string | null | undefined
  /** Node type: account, campaign, or adSet. */
  type: string
}

export type FeatureToggleCategory =
  | 'ANALYTICS'
  | 'COMMUNICATIONS'
  | 'CONTACTS'
  | 'INTEGRATIONS'
  | 'INTERNAL'
  | 'PLATFORM'
  | 'SCHEDULING'

/** A single question in a form. The id is client-minted and preserved across versions. */
export type FormQuestionInput = {
  /** Optional help text shown under the question. */
  helpText?: string | null | undefined
  /** Client-minted, stable across edits and versions */
  id: string
  /** One of: shortText, longText, date, phone, email, address, singleSelect, multiSelect, yesNo, signature, initials, staticText */
  kind: string
  /** Question label shown to the respondent. */
  label: string
  /** The Contact field this answer maps to, or omit for answer-only */
  mappingTarget?: string | null | undefined
  /** Choices for singleSelect or multiSelect questions. */
  options?: Array<QuestionOptionInput> | null | undefined
  /** Whether an answer is required. */
  required: boolean
  /** Conditional display rule for this question. */
  showWhen?: ShowWhenInput | null | undefined
}

export type FormSubmissionsNotificationInput = {
  /** Whether form-submission notifications are enabled. */
  enabled?: boolean | null | undefined
  /** Channels for new-form-submission notifications. */
  newFormSubmission?: NotificationChannelInput | null | undefined
}

export type HealthStatus = 'AT_RISK' | 'HEALTHY' | 'STALE'

export type InitiateCallInput = {
  /** Contact to call. */
  contactId: string | number
  /** Number to place the call from. */
  fromNumber: string
  /** Primary tracking number used as the caller ID. */
  primaryTrackingNumber: string
  /** Number to dial. */
  toNumber: string
}

export type LeadOverrideConfigInput = {
  /** Amount of the lead override window. */
  amount: number
  /** Time unit for the override amount, e.g. days, hours. */
  unit: string
}

export type ListStageInput = {
  /** Display color of the stage. */
  color: string
  /** Stage id; omit to add a new stage (the server assigns one), pass to keep an existing stage. */
  id?: string | number | null | undefined
  /** Display name of the stage. */
  name: string
}

export type LocationFilter = {
  /** Limit results to these connector types. */
  connectorType?: Array<ConnectorType> | null | undefined
  /** Only include locations that have a connector. */
  hasConnector?: boolean | null | undefined
  /** Only include locations that currently have an error. */
  hasError?: boolean | null | undefined
  /** Limit results to these health statuses. */
  healthStatus?: Array<HealthStatus> | null | undefined
  /** Limit results to this organization. */
  orgId?: string | number | null | undefined
  /** Free-text or field-scoped search query. */
  search?: string | null | undefined
  /** Limit results to these workflow statuses. */
  workflowStatus?: Array<WorkflowStatus> | null | undefined
}

export type LocationOpenDayInput = {
  /** Open-hours ranges for the day. */
  hours: Array<OpenHoursRangeInput>
  /** Whether the location is open on this day. */
  open: boolean
}

export type LocationOpenHoursInput = {
  /** Open hours for Friday. */
  friday?: LocationOpenDayInput | null | undefined
  /** Open hours for Monday. */
  monday?: LocationOpenDayInput | null | undefined
  /** Open hours for Saturday. */
  saturday?: LocationOpenDayInput | null | undefined
  /** Open hours for Sunday. */
  sunday?: LocationOpenDayInput | null | undefined
  /** Open hours for Thursday. */
  thursday?: LocationOpenDayInput | null | undefined
  /** Open hours for Tuesday. */
  tuesday?: LocationOpenDayInput | null | undefined
  /** Open hours for Wednesday. */
  wednesday?: LocationOpenDayInput | null | undefined
}

export type MessageCategory = 'MARKETING' | 'TRANSACTIONAL'

export type MessageImageInput = {
  /** Base64-encoded image data */
  base64: string
  /** MIME content type (e.g., image/jpeg) */
  contentType: string
  /** Filename with extension */
  filename: string
}

export type NotificationChannelInput = {
  /** Deliver this notification in-app. */
  app?: boolean | null | undefined
  /** Deliver this notification by email. */
  email?: boolean | null | undefined
  /** Show this notification as a popup. */
  popup?: boolean | null | undefined
  /** Play a sound for this notification. */
  sound?: boolean | null | undefined
}

export type OpenHoursRangeInput = {
  /** Start time of the open-hours range (e.g. 09:00). */
  from: string
  /** End time of the open-hours range (e.g. 17:00). */
  to: string
}

/** Communication channel for a location-scoped opt-out record. */
export type OptOutType = 'EMAIL' | 'PHONE'

/** Offset-based pagination. Pages are zero-indexed: page 0 returns the first `limit` results, page 1 returns the next `limit`, etc. */
export type PaginationInput = {
  /** Maximum number of results per page. Defaults to 1000. Clamped to a maximum of 1000. */
  limit?: number
  /** Zero-based page number. Page 0 is the first page. */
  page?: number
}

/** Practice identity shown to the patient */
export type PaperworkBrandingInput = {
  /** Practice display name shown to the patient. */
  displayName: string
  /** URL of the practice logo. */
  logoUrl?: string | null | undefined
  /** Practice phone number shown to the patient. */
  phone?: string | null | undefined
}

export type PaperworkChartWriteStatus = 'FAILED' | 'NOT_SUPPORTED' | 'PENDING' | 'SUCCESS'

/** A form in a packet, pinned to a specific published version */
export type PaperworkFormInput = {
  /** Form included in the packet. */
  formId: string | number
  /** Published form version pinned for this packet. */
  formVersion: number
}

export type PaperworkProcessingStatus = 'FAILED' | 'IN_PROGRESS' | 'PARTIAL_FAILURE' | 'PENDING' | 'SUCCESS'

export type PhoneCallsNotificationInput = {
  /** Channels for all unscheduled-call notifications. */
  allUnscheduledCalls?: NotificationChannelInput | null | undefined
  /** Channels for callback-requested notifications. */
  callbackRequested?: NotificationChannelInput | null | undefined
  /** Channels for canceled-appointment notifications. */
  canceledAppointment?: NotificationChannelInput | null | undefined
  /** Whether phone-call notifications are enabled. */
  enabled?: boolean | null | undefined
  /** Channels for incoming-call notifications. */
  incomingCall?: NotificationChannelInput | null | undefined
  /** Channels for missed-call notifications. */
  missedCalls?: NotificationChannelInput | null | undefined
  /** Channels for new-patient unscheduled-call notifications. */
  newPatientUnscheduledCalls?: NotificationChannelInput | null | undefined
  /** Channels for voicemail notifications. */
  voicemail?: NotificationChannelInput | null | undefined
}

export type PhoneNumberType = 'MESSAGING' | 'VOICE'

export type PipelineStageInput = {
  /** Stage color (hex). */
  color: string
  /** Stage name. */
  name: string
  /** Position of the stage within the pipeline. */
  order: number
}

export type PmsDataNotificationInput = {
  /** Channels for broken-appointment notifications. */
  brokenAppointment?: NotificationChannelInput | null | undefined
  /** Whether PMS-data notifications are enabled. */
  enabled?: boolean | null | undefined
  /** Channels for no-appointment-found-on-scheduled-contact notifications. */
  noAppointmentFoundOnScheduledContact?: NotificationChannelInput | null | undefined
  /** Channels for no-patient-linked-on-scheduled-contact notifications. */
  noPatientLinkedOnScheduledContact?: NotificationChannelInput | null | undefined
}

/** One submitted answer */
export type PublicAnswerInput = {
  /** Id of the question being answered */
  questionId: string
  /** Answer value(s). A single-value answer is a one-element array. */
  value: Array<string>
}

export type PurchasePhoneNumberInput = {
  /** Human-readable label for the number. */
  label?: string | null | undefined
  /** Location that will own the purchased number. */
  locationId: string
  /** E.164 — required for voice (from search) */
  phone?: string | null | undefined
  /** Roles the number will fill (e.g. pool, ai). */
  roles: Array<string>
  /** Number capability type to purchase (e.g. voice, messaging). */
  type: PhoneNumberType
}

/** A choice for a singleSelect or multiSelect question */
export type QuestionOptionInput = {
  /** Stable id for this option. */
  id: string
  /** Display label for this option. */
  label: string
}

export type RcsCardInput = {
  /** Card description. */
  description?: string | null | undefined
  /** S3 keys for card images. */
  imageKeys?: Array<string> | null | undefined
  /** Suggested reply actions on the card. */
  suggestions?: Array<RcsCardSuggestionInput> | null | undefined
  /** Card title. */
  title?: string | null | undefined
}

export type RcsCardSuggestionInput = {
  /** ID of the suggested action. */
  actionId: string
  /** Reply text sent when the suggestion is tapped. */
  replyText: string
}

export type ReassignActivityInput = {
  /** ID of the new activity owner. */
  ownerId: string
  /** Name of the new activity owner. */
  ownerName: string
}

export type SaveIvrConfigInput = {
  /** Whether the IVR phone menu is enabled */
  enabled: boolean
  /** Location this IVR configuration applies to */
  locationId: string
  /** The IVR menu tree nodes */
  nodes: unknown
  /** Phone number this IVR is attached to */
  phoneNumberId?: string | null | undefined
  /** Node id of the IVR menu's entry/root node */
  root?: string | null | undefined
}

export type SayThisNotThatRuleInput = {
  /** voice, sms, or both */
  channel: string
  /** Phrase the agent should say instead of the stop phrase. */
  replacementPhrase: string
  /** Phrase the agent should avoid saying. */
  stopPhrase: string
}

export type SchedulerNotificationInput = {
  /** Whether scheduler notifications are enabled. */
  enabled?: boolean | null | undefined
  /** Channels for new-appointment-booked notifications. */
  newAppointmentBooked?: NotificationChannelInput | null | undefined
}

/** A welcome or completion screen */
export type ScreenContentInput = {
  /** Screen body text. */
  body: string
  /** Screen heading text. */
  title: string
}

export type SendContactEmailInput = {
  /** Inline attachments. Max 10 files, 10 MB total. */
  attachments?: Array<EmailAttachmentInput> | null | undefined
  /** Contact to email. */
  contactId: string
  /** HTML body. Sanitized server-side to a safe allowlist. */
  html: string
  /** Sending location (owns the From identity). */
  locationId: string
  /** Email subject line. */
  subject: string
  /** Recipient address. Defaults to the contact's email when omitted. */
  to?: string | null | undefined
}

export type SendMessageInput = {
  /** Message category: transactional (default) or marketing */
  category?: string | null | undefined
  /** Contact ID. Required for contact-based sends. */
  contactId?: string | null | undefined
  /** Bypass RCS, send SMS only */
  forceSms?: boolean | null | undefined
  /** Explicit sending number. If omitted, uses location default. */
  from?: string | null | undefined
  /** Outbound images as base64 */
  images?: Array<MessageImageInput> | null | undefined
  /** Sending location that owns the from number. */
  locationId: string
  /** Optional RCS rich card content */
  rcsCard?: RcsCardInput | null | undefined
  /** If set, hold the message and send it at this instant instead of immediately. */
  sendDate?: string | null | undefined
  /** Message body text. */
  text: string
  /** Recipient phone number. Required for number-based sends. */
  to?: string | null | undefined
}

export type SetLocationEmailIdentityInput = {
  /** The shared Trackable sending domain, used instead of sendingDomainId. */
  domain?: string | null | undefined
  /** Display name on the From header. */
  fromName?: string | null | undefined
  /** Local part of the From address. Unique per domain. */
  localPart: string
  /** Location to set the From identity for. */
  locationId: string
  /** Reply-To address for this location. */
  replyTo?: string | null | undefined
  /** The verified custom SendingDomain to send from. Omit when using the shared Trackable domain. */
  sendingDomainId?: string | null | undefined
}

/** One level of conditional display: show this question when another equals a value */
export type ShowWhenInput = {
  /** Value the controlling question must equal for this question to show. */
  equals: string
  /** Id of the question this visibility condition depends on. */
  questionId: string
}

export type SortDirection = 'ASC' | 'DESC'

export type SortInput = {
  /** Default sort direction (asc or desc) applied to keys that do not carry their own. */
  direction?: SortDirection
  /** Field to sort by. Pass a comma-separated list to sort by multiple keys in priority order (e.g. `date,time` sorts by day, then by time within the day). A key may carry its own `asc`/`desc` direction (e.g. `date:asc,time:desc`); keys without one use the top-level `direction`. */
  field: string
}

export type SuperNotificationSettingsInput = {
  /** Enable or disable alerts about agent appointment-type changes. */
  agentChangeAppointmentTypes?: boolean | null | undefined
  /** Enable or disable alerts about agent business-detail changes. */
  agentChangeBusinessDetails?: boolean | null | undefined
  /** Enable or disable alerts about agent insurance changes. */
  agentChangeInsurance?: boolean | null | undefined
  /** Enable or disable alerts about agent offer changes. */
  agentChangeOffers?: boolean | null | undefined
  /** Enable or disable alerts about agent service changes. */
  agentChangeServices?: boolean | null | undefined
  /** Enable or disable agent change alerts for this super user. */
  agentChangesEnabled?: boolean | null | undefined
  /** Enable or disable agent diagnostics alerts for this super user. */
  enabled?: boolean | null | undefined
  /** Enable or disable alerts for agents with no calls in 48 hours. */
  noCallsIn48h?: boolean | null | undefined
  /** Enable or disable emailed duplicate tool call alerts. */
  toolDuplicate?: boolean | null | undefined
  /** Enable or disable emailed tool error alerts. */
  toolError?: boolean | null | undefined
  /** Enable or disable emailed tool timeout alerts. */
  toolTimeout?: boolean | null | undefined
}

export type TextMessagesNotificationInput = {
  /** Whether text-message notifications are enabled. */
  enabled?: boolean | null | undefined
  /** Channels for new-text-message notifications. */
  newTextMessage?: NotificationChannelInput | null | undefined
}

export type TwilioNumberInput = {
  /** Twilio phone number ID (E.164 number). */
  id: string
}

export type UpdateAiAgentCompilerConfigInput = {
  /** Whether cleanings require an initial exam */
  cleaningRequiresInitialExam?: boolean | null | undefined
  /** Whether the practice is pediatric only */
  pediatricOnly?: boolean | null | undefined
  /** Addendum appended to the voice agent prompt */
  voiceAgentAddendum?: string | null | undefined
  /** Tools enabled for the voice agent */
  voiceAgentTools?: Array<string> | null | undefined
}

export type UpdateAiAgentLocationConfigInput = {
  /** Name the AI agent uses for itself */
  agentName?: string | null | undefined
  /** Business address the agent references */
  businessAddress?: string | null | undefined
  /** Business name the agent references */
  businessName?: string | null | undefined
  /** Greeting the agent opens with; keeps {{businessName}}/{{agentName}} placeholders verbatim */
  greeting?: string | null | undefined
  /** Message sent to the patient after a hygiene appointment booking */
  hygienePostBookingMessage?: string | null | undefined
  /** Offers the agent can mention to callers */
  offers?: Array<AiAgentOfferInput> | null | undefined
  /** Office main phone number */
  officeMainNumber?: string | null | undefined
  /** Office transfer phone number */
  officeTransferNumber?: string | null | undefined
  /** Message sent to the patient after booking */
  postBookingMessage?: string | null | undefined
  /** Say This, Not That phrase rules the agent applies when responding */
  sayThisNotThatRules?: Array<SayThisNotThatRuleInput> | null | undefined
  /** Services the agent offers */
  services?: Array<AiAgentServiceInput> | null | undefined
  /** Services the agent explicitly does not offer */
  servicesNotOffered?: Array<AiAgentServiceInput> | null | undefined
  /** Whether an SMS confirmation is sent after booking */
  smsConfirmationEnabled?: boolean | null | undefined
}

export type UpdateActionInput = {
  /** Updated free-text note on the action. */
  note?: string | null | undefined
  /** New state for the action. */
  state?: string | null | undefined
  /** New date the action is deferred until. */
  untilDate?: string | null | undefined
}

export type UpdateAdPlatformMappingInput = {
  /** UTM medium to match. */
  medium?: string | null | undefined
  /** Ad platform this source/medium maps to. */
  platform?: string | null | undefined
  /** UTM source to match. */
  source?: string | null | undefined
}

export type UpdateAppointmentTypeInput = {
  /** Whether the AI agent can book this appointment type. */
  activeAgent?: boolean | null | undefined
  /** Whether this type is available in the online scheduler. */
  activeScheduler?: boolean | null | undefined
  /** Display alias for the appointment type. */
  alias?: string | null | undefined
  /** Length of the appointment in minutes. */
  appointmentLength?: number | null | undefined
  /** Whether scheduling of this appointment type is blocked. */
  blockScheduling?: boolean | null | undefined
  /** Notes describing when scheduling is blocked. */
  blockSchedulingNotes?: Array<string> | null | undefined
  /** Whether this type is excluded from double-booking rules. */
  doubleBookingExclusion?: boolean | null | undefined
  /** Blockout ids excluded for this appointment type. */
  excludedBlockouts?: Array<string> | null | undefined
  /** General buffer in minutes applied around appointments. */
  generalBuffer?: number | null | undefined
  /** Additional buffer in minutes for morning appointments. */
  morningBuffer?: number | null | undefined
  /** Lookahead window in minutes for applying the morning buffer. */
  morningBufferLookahead?: number | null | undefined
  /** Sort order of the appointment type. */
  order?: number | null | undefined
  /** Patient type the appointment applies to (e.g. new, existing). */
  patientType?: string | null | undefined
  /** Increment in minutes between available start times. */
  startIncrement?: number | null | undefined
}

export type UpdateAvailabilityInput = {
  /** Appointment type IDs this availability applies to. */
  appointmentTypeIds?: Array<string> | null | undefined
  /** Whether this is backup availability, used only when primary availability is unavailable. */
  backupAvailability?: boolean | null | undefined
  /** Operatory IDs where the provider can be scheduled. */
  operatoryIds?: Array<string> | null | undefined
  /** Weekly time slots when the provider is available. */
  timeSlots?: LocationOpenHoursInput | null | undefined
}

export type UpdateBudgetInput = {
  /** New budgeted amount for the channel, in dollars. */
  amount?: number | null | undefined
  /** New goal for number of appointments. */
  appointmentGoal?: number | null | undefined
  /** New internal goal amount for the channel, in dollars. */
  internalGoal?: number | null | undefined
  /** New goal for number of leads. */
  leadGoal?: number | null | undefined
  /** New goal for number of MQLs. */
  mqlGoal?: number | null | undefined
  /** New goal for number of new patients. */
  patientGoal?: number | null | undefined
  /** New target ad spend for the channel, in dollars. */
  targetSpend?: number | null | undefined
}

export type UpdateCallInput = {
  /** AI extraction data for the call. */
  ai?: CallAiInput | null | undefined
  /** Appointment date as a string. */
  appointmentDateString?: string | null | undefined
  /** Marketing channel attributed to the call. */
  channel?: string | null | undefined
  /** Freeform note on the call. */
  note?: string | null | undefined
  /** Patients associated with the call. */
  patients?: Array<CallPatientInput> | null | undefined
  /** Staff member assigned to the call. */
  staff?: CallStaffInput | null | undefined
  /** Call status. */
  status?: string | null | undefined
  /** Tags applied to the call. */
  tags?: Array<string> | null | undefined
}

export type UpdateCdtCodeMappingInput = {
  /** Category this CDT code maps to. */
  category?: string | null | undefined
  /** CDT dental procedure code. */
  cdtCode?: string | null | undefined
}

export type UpdateChannelMappingInput = {
  /** Channel this source/medium maps to. */
  channel?: string | null | undefined
  /** UTM medium to match. */
  medium?: string | null | undefined
  /** UTM source to match. */
  source?: string | null | undefined
}

export type UpdateCommLogWritebackRuleInput = {
  /** PMS channel entries of this type are written under */
  channel?: string | null | undefined
  /** Comm-log writeback type the rule covers */
  type?: string | null | undefined
}

export type UpdateContactInput = {
  /** Date the contact became a lead. */
  becameLeadDate?: string | null | undefined
  /** Date the contact became a patient. */
  becamePatientDate?: string | null | undefined
  /** New cell phone number. */
  cellPhone?: string | null | undefined
  /** New marketing channel. */
  channel?: string | null | undefined
  /** Reason the lead was closed lost. */
  closedLostReason?: string | null | undefined
  /** New email address. */
  email?: string | null | undefined
  /** Date the first appointment was made. */
  firstAppointmentMadeDate?: string | null | undefined
  /** New home phone number. */
  homePhone?: string | null | undefined
  /** Whether the contact is marked qualified. */
  isQualified?: boolean | null | undefined
  /** Staff member who owns this lead. */
  leadOwner?: ContactStaffInput | null | undefined
  /** New lead status. */
  leadStatus?: string | null | undefined
  /** New lifecycle stage. */
  lifecycleStage?: string | null | undefined
  /** New contact name. */
  name?: string | null | undefined
  /** Note recorded with a Closed Lost transition. */
  note?: string | null | undefined
  /** Id of the staff member performing the change. */
  ownerId?: string | null | undefined
  /** Name of the staff member performing the change. */
  ownerName?: string | null | undefined
  /** New patient status. */
  patientStatus?: string | null | undefined
  /** Pipeline stage assignments for the contact. */
  pipelines?: Array<ContactPipelineInput> | null | undefined
  /** Preferred communication method. */
  preferredCommunicationMethod?: string | null | undefined
  /** Preferred contact person. */
  preferredContact?: string | null | undefined
  /** Preferred name for the contact. */
  preferredName?: string | null | undefined
  /** Lifetime production value for the contact. */
  productionLtv?: number | null | undefined
  /** Patient-reported attribution. */
  reportedAttribution?: string | null | undefined
  /** Scheduled production value for the contact. */
  scheduledProduction?: number | null | undefined
  /** Whether the contact consents to SMS marketing. */
  smsMarketingConsent?: boolean | null | undefined
  /** Tags applied to the contact. */
  tags?: Array<string> | null | undefined
  /** New UTM campaign. */
  utmCampaign?: string | null | undefined
  /** New UTM content. */
  utmContent?: string | null | undefined
  /** New UTM keywords. */
  utmKeywords?: string | null | undefined
  /** New UTM medium. */
  utmMedium?: string | null | undefined
  /** New UTM source. */
  utmSource?: string | null | undefined
  /** New work phone number. */
  workPhone?: string | null | undefined
}

export type UpdateCustomPageInput = {
  /** Updated JSON-encoded array of filters to apply. */
  filters?: string | null | undefined
  /** Updated join operator applied to the filters (e.g. AND/OR). */
  join?: string | null | undefined
  /** Updated display name for the custom page. */
  name?: string | null | undefined
  /** Updated base page/entity type the custom page is built on. */
  page?: string | null | undefined
}

export type UpdateFeatureToggleInput = {
  /** Whether the toggle is archived. */
  archived?: boolean | null | undefined
  /** Category grouping for the toggle. */
  category?: FeatureToggleCategory | null | undefined
  /** Description of what the feature toggle controls. */
  description?: string | null | undefined
  /** Human-readable display name for the toggle. */
  displayName?: string | null | undefined
  /** Internal name of the feature toggle. */
  name?: string | null | undefined
  /** Release the toggle is associated with. */
  release?: string | null | undefined
  /** Scope type of the toggle, e.g. org, workspace, location. */
  type?: string | null | undefined
  /** ID of the entity the toggle is scoped to. */
  typeId?: string | null | undefined
}

export type UpdateFollowUpInput = {
  /** Scheduled appointment date linked to this follow-up. */
  appointmentDate?: string | null | undefined
  /** Notes describing the follow-up. */
  description?: string | null | undefined
  /** Date the follow-up is due. */
  followUpDate?: string | null | undefined
  /** Whether contact was successfully reached. */
  isConnected?: boolean | null | undefined
  /** Whether an appointment was scheduled from this follow-up. */
  isScheduled?: boolean | null | undefined
  /** User to assign as the follow-up owner. */
  ownerId?: string | number | null | undefined
  /** Display name of the follow-up owner. */
  ownerName?: string | null | undefined
}

export type UpdateFormFieldMappingInput = {
  /** Trackable form field the raw key maps to. */
  formField?: string | null | undefined
  /** Raw incoming form key to map. */
  rawKey?: string | null | undefined
}

/** Update a draft form. Published versions are immutable — updating one mints a new draft version. */
export type UpdateFormTemplateInput = {
  /** One of: registration, medicalHistory, consent, financialPolicy, custom */
  category?: string | null | undefined
  /** Form description. */
  description?: string | null | undefined
  /** Form name. */
  name?: string | null | undefined
  /** The ordered questions that make up the form. */
  questions?: Array<FormQuestionInput> | null | undefined
}

export type UpdateListInput = {
  /** Updated default stage rule matches fall into when they have no stored row. */
  defaultStageId?: string | number | null | undefined
  /** Updated list rule as a JSON-encoded FilterObject array. */
  filters?: string | null | undefined
  /** Updated join operator applied across the rule filters (e.g. and/or). */
  join?: string | null | undefined
  /** Updated display name of the list. */
  name?: string | null | undefined
  /** Updated set of stages/lanes for the list. */
  stages?: Array<ListStageInput> | null | undefined
  /** Updated list visibility: shared or personal (only the creator may change a personal list). */
  visibility?: string | null | undefined
}

export type UpdateListItemInput = {
  /** Stage/lane to move the member into. */
  stageId?: string | number | null | undefined
}

export type UpdateLocationInput = {
  /** Street address of the location. */
  address?: string | null | undefined
  /** Second line of the street address. */
  addressLine2?: string | null | undefined
  /** End of the quiet-hours window for alarms. */
  alarmQuietEnd?: string | null | undefined
  /** Start of the quiet-hours window for alarms. */
  alarmQuietStart?: string | null | undefined
  /** Whether double-booking is allowed when scheduling. */
  allowDoubleBookingScheduling?: boolean | null | undefined
  /** Whether the location is archived. */
  archived?: boolean | null | undefined
  /** Availability mode used for scheduling. */
  availabilityMode?: string | null | undefined
  /** Business phone number of the location. */
  businessPhone?: string | null | undefined
  /** City of the location. */
  city?: string | null | undefined
  /** Current operational status of the location. */
  currentStatus?: string | null | undefined
  /** Hour of day the daily PMS sync runs. */
  dailySyncHour?: number | null | undefined
  /** Free-text description of the location. */
  description?: string | null | undefined
  /** Facebook ad set ids associated with the location. */
  facebookAdSetIds?: Array<string> | null | undefined
  /** Whether the AI agent is live for this location. */
  isAIAgentLive?: boolean | null | undefined
  /** Whether the online scheduler is live for this location. */
  isSchedulerLive?: boolean | null | undefined
  /** Labels applied to the location. */
  labels?: Array<string> | null | undefined
  /** Date the location was migrated, or null to clear it. */
  migrationDate?: string | null | undefined
  /** Name of the location. */
  name?: string | null | undefined
  /** Main office phone number of the location. */
  officeMainNumber?: string | null | undefined
  /** Number calls are transferred to from the office line. */
  officeTransferNumber?: string | null | undefined
  /** Identifier of the office transfer number. */
  officeTransferNumberId?: string | null | undefined
  /** Weekly open hours for the location. */
  openHours?: LocationOpenHoursInput | null | undefined
  /** Primary phone number of the location. */
  phone?: string | null | undefined
  /** Practice management system for the location. */
  pms?: string | null | undefined
  /** Identifier of the primary phone number. */
  primaryNumberId?: string | null | undefined
  /** Primary SMS number for the location. */
  primarySmsNumber?: string | null | undefined
  /** Primary tracking number for the location. */
  primaryTrackingNumber?: string | null | undefined
  /** Products associated with the location. */
  products?: Array<string> | null | undefined
  /** Questions asked during scheduling at this location. */
  schedulingQuestions?: Array<string> | null | undefined
  /** Arbitrary per-location settings. */
  settings?: unknown
  /** State of the location. */
  state?: string | null | undefined
  /** Tags applied to the location. */
  tags?: Array<string> | null | undefined
  /** IANA timezone of the location. */
  timezone?: string | null | undefined
  /** Twilio phone numbers configured for the location. */
  twilioNumbers?: unknown
  /** Type of location. */
  type?: string | null | undefined
  /** ZIP/postal code of the location. */
  zip?: string | null | undefined
}

export type UpdateMilestoneInput = {
  /** Reason the opportunity was closed lost. */
  closedLostReason?: string | null | undefined
  /** Whether the milestone is marked qualified. */
  isQualified?: boolean | null | undefined
  /** Freeform note on the milestone. */
  note?: string | null | undefined
  /** ID of the milestone owner. */
  ownerId?: string | null | undefined
  /** Name of the milestone owner. */
  ownerName?: string | null | undefined
}

export type UpdateNoteInput = {
  /** Note text. */
  description: string
}

export type UpdateNoteTemplateInput = {
  /** New body text for the note template. */
  body?: string | null | undefined
  /** New name for the note template. */
  name?: string | null | undefined
}

export type UpdateNotificationInput = {
  /** Set the notification's archived state. */
  archived?: boolean | null | undefined
  /** Set the notification's clicked state. */
  clicked?: boolean | null | undefined
  /** Set the notification's managed state. */
  managedNotification?: boolean | null | undefined
  /** Set the notification's read state. */
  read?: boolean | null | undefined
}

export type UpdatePaperworkTemplateInput = {
  /** Updated visual presets for the packet. */
  appearance?: AppearanceInput | null | undefined
  /** Updated practice branding for the packet. */
  branding?: PaperworkBrandingInput | null | undefined
  /** Updated completion screen content. */
  completion?: ScreenContentInput | null | undefined
  /** New description for the template. */
  description?: string | null | undefined
  /** Replacement ordered list of forms to send. */
  forms?: Array<PaperworkFormInput> | null | undefined
  /** New name for the paperwork template. */
  name?: string | null | undefined
  /** Updated welcome screen content. */
  welcome?: ScreenContentInput | null | undefined
}

export type UpdatePhoneNumberInput = {
  /** Whether this phone number is enabled. */
  enabled?: boolean | null | undefined
  /** Updated human-readable label. */
  label?: string | null | undefined
  /** Updated registration identifier from the provider. */
  registrationId?: string | null | undefined
  /** Updated 10DLC/toll-free registration status. */
  registrationStatus?: string | null | undefined
  /** Updated roles for this phone number. */
  roles?: Array<string> | null | undefined
}

export type UpdatePipelineInput = {
  /** Pipeline name. */
  name?: string | null | undefined
  /** Ordered stages for the pipeline. */
  stages?: Array<PipelineStageInput> | null | undefined
}

export type UpdatePmsReferralMappingInput = {
  /** Updated UTM campaign for this referral type. */
  campaign?: string | null | undefined
  /** Updated marketing channel for this referral type. */
  channel?: string | null | undefined
  /** Force the mapping even if it conflicts with existing rules. */
  force?: boolean | null | undefined
  /** Updated UTM medium for this referral type. */
  medium?: string | null | undefined
  /** Updated UTM source for this referral type. */
  source?: string | null | undefined
}

export type UpdateProviderInput = {
  /** Whether the provider is deactivated. */
  deactivated?: boolean | null | undefined
  /** Display name of the provider. */
  displayName?: string | null | undefined
  /** Sort priority of the provider. */
  priority?: number | null | undefined
}

export type UpdateRoleInput = {
  /** New name for the role. */
  name?: string | null | undefined
  /** Permission keys granted to the role. */
  permissions?: Array<string> | null | undefined
}

export type UpdateSchedulingConfigurationInput = {
  /** Whether double-booking of appointment slots is allowed. */
  allowDoubleBooking?: boolean | null | undefined
  /** Custom intake questions to ask when booking. */
  customQuestions?: Array<CustomQuestionInput> | null | undefined
  /** Maximum number of concurrent bookings allowed per slot. */
  doubleBookingCount?: number | null | undefined
  /** Slot granularity in minutes. */
  granularity?: number | null | undefined
  /** Insurance plans that are accepted. */
  insurancesAccepted?: Array<string> | null | undefined
  /** Insurance plans that are rejected. */
  insurancesRejected?: Array<string> | null | undefined
  /** Whether state insurance is accepted. */
  isStateInsuranceAccepted?: boolean | null | undefined
  /** Configuration for the lead override scheduling window. */
  leadOverrideConfig?: LeadOverrideConfigInput | null | undefined
  /** Whether lead override scheduling is enabled. */
  leadOverrideEnabled?: boolean | null | undefined
}

export type UpdateScorecardInput = {
  /** Ordered list of column IDs. */
  columnOrder?: Array<string> | null | undefined
  /** Per-column visibility settings. */
  columnVisibility?: unknown
  /** Date range preset for the scorecard. */
  dateRange?: string | null | undefined
  /** Whether this is the default scorecard. */
  default?: boolean | null | undefined
  /** Grouping dimension for the scorecard. */
  grouping?: string | null | undefined
  /** Lookback window amount. */
  lookbackAmount?: number | null | undefined
  /** Lookback window type. */
  lookbackType?: string | null | undefined
  /** Scorecard name. */
  name?: string | null | undefined
  /** IDs of objects included in the scorecard. */
  objectIds?: Array<string> | null | undefined
  /** Sort configuration for the scorecard. */
  sort?: unknown
}

export type UpdateSmsTemplateInput = {
  /** Updated message body of the SMS template. */
  body?: string | null | undefined
  /** Updated name of the SMS template. */
  name?: string | null | undefined
}

export type UpdateStaffInput = {
  /** Alternate names the staff member is also known by */
  aliases?: Array<string> | null | undefined
  /** Display name of the staff member */
  name?: string | null | undefined
  /** Linked user account id to associate with this staff member */
  userId?: string | number | null | undefined
}

export type UpdateStoredCredentialInput = {
  /** Human-readable label for the credential. */
  label?: string | null | undefined
  /** Location this credential is scoped to, if any. */
  locationId?: string | null | undefined
  /** Optional JSON metadata for the credential. */
  metadata?: string | null | undefined
  /** Password for the credential (stored encrypted). */
  password?: string | null | undefined
  /** Username for the credential. */
  username?: string | null | undefined
}

export type UpdateTaskInput = {
  /** Contact the task is linked to. */
  contactId?: string | null | undefined
  /** Task description. */
  description?: string | null | undefined
  /** Task due date (ISO date). */
  dueDate?: string | null | undefined
  /** ID of the task owner. */
  ownerId?: string | null | undefined
  /** Role assigned to the task. */
  roleId?: string | null | undefined
  /** Task status. */
  status?: string | null | undefined
  /** Task title. */
  title?: string | null | undefined
}

export type UpdateTaskTemplateInput = {
  /** Optional description applied to tasks created from this template. */
  description?: string | null | undefined
  /** Number of days after creation that the task is due. */
  dueInDays?: number | null | undefined
  /** Internal name of the task template. */
  name?: string | null | undefined
  /** User assigned as the owner of tasks created from this template. */
  ownerId?: string | null | undefined
  /** Title applied to tasks created from this template. */
  title?: string | null | undefined
}

export type UpdateThreadInput = {
  /** Whether the AI assistant is enabled for this thread. */
  aiEnabled?: boolean | null | undefined
  /** Display name for the thread. */
  name?: string | null | undefined
}

export type UpdateUserInput = {
  /** Location IDs this user is allowed to access. */
  allowedLocationIds?: Array<string> | null | undefined
  /** Whether the user is archived (deactivated). */
  archived?: boolean | null | undefined
  /** User's email address. */
  email?: string | null | undefined
  /** User's job title. */
  jobTitle?: string | null | undefined
  /** User's display name. */
  name?: string | null | undefined
  /** User's phone number. */
  phone?: string | null | undefined
  /** User's position/seniority within the practice. */
  position?: UserPosition | null | undefined
  /** Role assigned to the user. */
  roleId?: string | number | null | undefined
}

export type UpdateUtmAliasInput = {
  /** Canonical value the original is aliased to. */
  alias?: string | null | undefined
  /** Original UTM value to be normalized. */
  original?: string | null | undefined
  /** UTM parameter type being aliased, e.g. source, medium, campaign. */
  type?: string | null | undefined
}

/** Update an existing workflow. Only provided fields are changed. Setting active=true validates the graph before activating. */
export type UpdateWorkflowInput = {
  /** Activate or deactivate. Activation validates the graph (nodes must exist, edges must reference valid nodes). */
  active?: boolean | null | undefined
  /** Opaque JSON blob for the frontend builder (preserved, never interpreted by engine). */
  builderJson?: string | null | undefined
  /** The workflow graph edges connecting nodes */
  edges?: Array<WorkflowEdgeInput> | null | undefined
  /** Change the workflow's location (only while inactive) */
  locationId?: string | null | undefined
  /** Human-readable workflow name */
  name?: string | null | undefined
  /** The workflow graph nodes */
  nodes?: Array<WorkflowNodeInput> | null | undefined
  /** Pause or unpause a running workflow. While paused, patients stay at their current step, no steps run, and no new patients enroll. Unpausing resumes patients from where they stopped. Pausing does not end any run; use active=false to end them. */
  paused?: boolean | null | undefined
  /** Why the workflow is being paused. Required when paused is set to true. */
  pausedReason?: string | null | undefined
  /** Say This, Not That rules scoped to this workflow. The SMS agent follows them only while this workflow's brief is active on a thread. Same limits as location rules: max 20, max 100 chars per phrase, non-empty, no line breaks. Pass an empty array to clear. */
  sayThisNotThatRules?: Array<WorkflowSayThisNotThatRuleInput> | null | undefined
  /** JSON settings object (quiet hours, etc.) */
  settings?: string | null | undefined
  /** When this workflow should enroll contacts */
  trigger?: WorkflowTriggerInput | null | undefined
  /** Date on which a date-based trigger starts evaluating; enrollments before it are ignored */
  triggerStartDate?: string | null | undefined
}

export type UpdateWorkspaceInput = {
  /** Max workflow enrollments per hour across all workflows. Null = unlimited. */
  maxEnrollmentsPerHour?: number | null | undefined
  /** Max outbound actions all workflows may send per calendar day (Eastern TZ). Null = unlimited. */
  maxOutboundDaily?: number | null | undefined
  /** Max outbound actions all workflows may send per calendar month. Null = unlimited. */
  maxOutboundMonthly?: number | null | undefined
  /** New name for the workspace. */
  name?: string | null | undefined
  /** Additional prompt text appended to AI generations for this workspace. */
  promptAddendum?: string | null | undefined
}

export type UpdateWorkspaceInviteInput = {
  /** Email address being invited. */
  email?: string | null | undefined
  /** Invite expiration timestamp (ISO date). */
  expiresAt?: string | null | undefined
  /** Locations the invitee will have access to. */
  locationIds?: Array<string> | null | undefined
  /** Role to assign the invitee on acceptance. */
  roleId?: string | null | undefined
  /** Existing staff record to link to the invite, if any. */
  staffId?: string | null | undefined
}

export type UsageCostDetailInput = {
  /** Date range to pull drill-down records over. */
  dateRange: DateRangeInput
  /** Location to pull drill-down records for. */
  locationId: string
  /** Pagination controls for the drill-down list. */
  pagination?: PaginationInput | null | undefined
  /** Restrict to these workspace ids; omit for all accessible workspaces. */
  workspaceIds?: Array<string> | null | undefined
}

export type UsageCostInput = {
  /** Date range to compute usage and cost over. */
  dateRange: DateRangeInput
  /** Time bucket granularity: 'hourly' | 'daily' | 'weekly' | 'monthly'. */
  granularity: string
  /** Restrict to these location ids; omit for all accessible locations. */
  locationIds?: Array<string> | null | undefined
  /** Restrict to a product: 'voice' | 'sms' | 'all'. */
  product?: string | null | undefined
  /** Restrict to these workspace ids; omit for all accessible workspaces. */
  workspaceIds?: Array<string> | null | undefined
}

export type UserNotificationSettingsInput = {
  /** AI-agent notification preferences. */
  aiAgent?: AiAgentNotificationInput | null | undefined
  /** Form-submission notification preferences. */
  formSubmissions?: FormSubmissionsNotificationInput | null | undefined
  /** Phone-call notification preferences. */
  phoneCalls?: PhoneCallsNotificationInput | null | undefined
  /** PMS-data notification preferences. */
  pmsData?: PmsDataNotificationInput | null | undefined
  /** Scheduler notification preferences. */
  scheduler?: SchedulerNotificationInput | null | undefined
  /** Text-message notification preferences. */
  textMessages?: TextMessagesNotificationInput | null | undefined
  /** Workflow-paused notification preferences. */
  workflowPaused?: WorkflowPausedNotificationInput | null | undefined
}

export type UserPosition =
  | 'ADMINISTRATOR'
  | 'CONSULTANT'
  | 'DENTIST'
  | 'EXECUTIVE'
  | 'HYGIENIST'
  | 'MANAGER'
  | 'OTHER'
  | 'TREATMENT_COORDINATOR'

export type VoiceAgentDailyMetricsInput = {
  /** Date range to compute daily voice agent counts over. */
  dateRange: DateRangeInput
  /** Restrict to these location ids; omit for all accessible locations. */
  locationIds?: Array<string> | null | undefined
}

export type VoiceAgentLocationMetricsInput = {
  /** Optional previous period; when set, the same counts are returned as compareRows. */
  compareDateRange?: DateRangeInput | null | undefined
  /** Date range to compute per-location voice agent counts over. */
  dateRange: DateRangeInput
  /** Restrict to these location ids; omit for all accessible locations. */
  locationIds?: Array<string> | null | undefined
}

/** A directed connection between two nodes. sourceHandle determines which outcome port to follow (e.g. "done", "replied", "no_reply", "answered", "voicemail", "no_answer", "timeout"). */
export type WorkflowEdgeInput = {
  /** Unique edge ID (client-generated) */
  id: string
  /** Source node ID */
  source: string
  /** Output handle on the source node: "done" for action/wait nodes, or a named outcome for branch nodes ("replied", "no_reply", "answered", "voicemail", "no_answer", "timeout"). A Wait node with early-exit conditions uses "conditions_met" and "timed_out" instead of "done". */
  sourceHandle: string
  /** Target node ID */
  target: string
  /** Input handle on the target node (usually "in") */
  targetHandle: string
}

/** A single node in the workflow graph. The 'type' field determines which config fields are required. Unused fields for a given type should be omitted or null. */
export type WorkflowNodeInput = {
  /** edit_task: set the task archived flag. Archiving removes it from the Tasks list without closing it. */
  archived?: boolean | null | undefined
  /** User ID to assign the task to */
  assigneeId?: string | null | undefined
  /** The brief that sets the agent's goal for this conversation. The workflow supplies only this; the prompt and voice are shared. */
  brief?: string | null | undefined
  /** If true, adjusts the resume time to fall within the contact's location business hours */
  businessHoursOnly?: boolean | null | undefined
  /** What to do when the agent is already engaged on the thread: "take_over" (replace the active brief and send) or "do_nothing" (stand down). */
  busyBehavior?: string | null | undefined
  /** For "do_nothing": if the agent's last message is older than this many days, the prior engagement has lapsed and the workflow takes over anyway. Unset means always stand down. */
  busyLimitDays?: number | null | undefined
  /** Delivery channel: "app", "email", or "both" */
  channel?: string | null | undefined
  /** JSON array of conditions: [{ id, label?, filters: [{ attribute, operator, value }], filterLogic?, source? }]. source is "contact" (default), "activity", "appointment" (the appointment the run enrolled from — branch on an appointment field), or "thread" (the contact's SMS thread — e.g. filter thread.aiEnabled to skip a handoff when the agent is already engaged). Each condition's id is used as the sourceHandle for outgoing edges. A fallback edge uses sourceHandle "default". */
  conditions?: string | null | undefined
  /** log_follow_up: Connected value — "yes", "no", or "from_direction" (default: yes when the comm log was received, no for sent, unknown direction, or no comm log). */
  connected?: string | null | undefined
  /** Note content text */
  content?: string | null | undefined
  /** Task description/body */
  description?: string | null | undefined
  /** Absolute due date (ISO string). Takes precedence over dueInDays. */
  dueDate?: string | null | undefined
  /** Number of days from now for the task due date */
  dueInDays?: number | null | undefined
  /** Duration to pause, e.g. "30m", "2h", "1d" */
  duration?: string | null | undefined
  /** For a Wait node: optional early-exit conditions on the run's contact, as a JSON object { filters: [{ attribute, operator, value }], filterLogic? }. Same shape as a Filter step. When set, the Wait ends early with sourceHandle "conditions_met" the moment the contact matches (checked at wait start, on contact changes, and once a day), otherwise "timed_out" when the duration elapses. Omit for a plain single-path Wait. */
  earlyExit?: string | null | undefined
  /** Days until the paperwork link expires (default 14) */
  expiresInDays?: number | null | undefined
  /** JSON object of field names to values to set on the contact. Use null to clear a field. */
  fields?: string | null | undefined
  /** log_follow_up: whether the follow-up date is the comm log date ("comm_log", default) or the time the step runs ("now"). With no comm log on the run, both are the time the step runs. */
  followUpDate?: string | null | undefined
  /** send_email: the HTML email body. Supports {{token}} templating. */
  html?: string | null | undefined
  /** Unique node ID (client-generated, used in edge references) */
  id: string
  /** Message text to send, or the notification message body. */
  message?: string | null | undefined
  /** log_follow_up: the follow-up note text. Comm log event data is available as {{commLog.channelLabel}}, {{commLog.direction}}, {{commLog.subject}}, {{commLog.note}}, {{commLog.date}}. Empty inserts nothing. */
  note?: string | null | undefined
  /** edit_task: when true, only edit the branch task if its status is open; otherwise the step no-ops and its path continues. */
  onlyIfOpen?: boolean | null | undefined
  /** log_follow_up: the user to own the follow-up. A deactivated or missing user leaves the follow-up unowned. */
  ownerId?: string | null | undefined
  /** PaperworkTemplate ID to send to the enrolled contact's patient */
  paperworkTemplateId?: string | null | undefined
  /** Pipeline ID to set the stage on */
  pipelineId?: string | null | undefined
  /** Canvas position (x, y) */
  position: WorkflowNodePositionInput
  /** What to do when the send falls in quiet hours (20:00–08:00 location time): "hold" (default, sends at 08:00) or "skip" (don't send). */
  quietHoursAction?: string | null | undefined
  /** User IDs to notify */
  recipients?: Array<string> | null | undefined
  /** For a Wait for reply node: JSON array of named reply options [{ id, label, keywords: [String] }]. Each option's id is the sourceHandle of its outgoing edge; a reply matching one of its keywords (trim + lowercase, exact) takes that exit. Any other inbound text takes sourceHandle "other_reply"; the window ending with no reply takes "no_reply". Omit or pass an empty array for the original two exits, "replied" and "no_reply". */
  replyOptions?: string | null | undefined
  /** Staff phone number to ring and bridge to the contact. Caller ID is always the location primary tracking number. */
  ringNumber?: string | null | undefined
  /** Role ID to assign the task to. A task has a user or a role, not both. */
  roleId?: string | null | undefined
  /** Stage name to set */
  stage?: string | null | undefined
  /** edit_task: new task status, "open" or "closed". An edit_task close leaves completedByUserId empty; a reopen clears it. */
  status?: string | null | undefined
  /** Stop the run (without taking the no-reply path) once a person is handling this patient: a staff member replies, someone takes the thread over from the agent, or another workflow's brief supersedes this one. Unset defaults to on. An opt-out always ends the run regardless. */
  stopOnHumanTakeover?: boolean | null | undefined
  /** send_email: the email subject. Supports {{token}} templating. */
  subject?: string | null | undefined
  /** Tags to add or remove */
  tags?: Array<string> | null | undefined
  /** Target entity: "contact" (default) or "activity" */
  target?: string | null | undefined
  /** Max time to wait for the event before timing out, e.g. "24h", "7d" */
  timeout?: string | null | undefined
  /** Task title */
  title?: string | null | undefined
  /** Which phone field to send to: "cellPhone", "homePhone", "workPhone". Defaults to first available. */
  toField?: string | null | undefined
  /** Determines the node's behavior and which config fields are relevant */
  type: WorkflowNodeType
  /** User ID to assign as contact owner */
  userId?: string | null | undefined
  /** Optional TTS whisper message played to the staff member before bridging. Supports {{contact.*}} and {{activity.*}} template variables. */
  whisperMessage?: string | null | undefined
}

/** Canvas position for the node (used by the frontend builder, preserved by the backend) */
export type WorkflowNodePositionInput = {
  /** Horizontal canvas coordinate of the node */
  x: number
  /** Vertical canvas coordinate of the node */
  y: number
}

/** The type of action or control a workflow node performs */
export type WorkflowNodeType =
  | 'ADD_TAGS'
  | 'ASSIGN_OWNER'
  | 'BRANCH'
  | 'CONFIRM_APPOINTMENT'
  | 'CREATE_NOTE'
  | 'CREATE_TASK'
  | 'EDIT_ACTIVITY'
  | 'EDIT_CONTACT'
  | 'EDIT_TASK'
  | 'INITIATE_AGENT'
  | 'INITIATE_CALL'
  | 'LOG_FOLLOW_UP'
  | 'REMOVE_FROM_PIPELINE'
  | 'REMOVE_TAGS'
  | 'SEND_EMAIL'
  | 'SEND_NOTIFICATION'
  | 'SEND_PAPERWORK'
  | 'SEND_SMS'
  | 'SET_PIPELINE_STAGE'
  | 'WAIT'
  | 'WAIT_FOR_CALL_RESULT'
  | 'WAIT_FOR_REPLY'

export type WorkflowPausedNotificationInput = {
  /** Deliver workflow-paused notifications in-app. */
  app?: boolean | null | undefined
  /** Deliver workflow-paused notifications by email. */
  email?: boolean | null | undefined
  /** Whether workflow-paused notifications are enabled. */
  enabled?: boolean | null | undefined
}

/** How the workflow handles a contact that triggers again while already enrolled */
export type WorkflowReenrollmentPolicy = 'ALLOW_MULTIPLE' | 'IGNORE' | 'RESTART'

/** A Say This, Not That rule scoped to one workflow. The SMS agent follows it only while this workflow's brief is active on a thread. */
export type WorkflowSayThisNotThatRuleInput = {
  /** Phrase the agent should say instead of the stop phrase. */
  replacementPhrase: string
  /** Phrase the agent should avoid saying. */
  stopPhrase: string
}

export type WorkflowStatus = 'AWAITING' | 'IGNORED' | 'IN_PROGRESS' | 'UNREAD'

/** The entity lifecycle event that triggers workflow enrollment */
export type WorkflowTriggerEvent =
  | 'ACTIVITY_CREATED'
  | 'ACTIVITY_DATE_REACHED'
  | 'ACTIVITY_UPDATED'
  | 'APPOINTMENT_CREATED'
  | 'APPOINTMENT_DATE_REACHED'
  | 'APPOINTMENT_UPDATED'
  | 'CALL_CREATED'
  | 'CALL_DATE_REACHED'
  | 'CALL_FINISHED_PROCESSING'
  | 'CALL_UPDATED'
  | 'COMM_LOG_CREATED'
  | 'CONTACT_CREATED'
  | 'CONTACT_DATE_REACHED'
  | 'CONTACT_UPDATED'
  | 'FORM_CREATED'
  | 'FORM_DATE_REACHED'
  | 'FORM_UPDATED'
  | 'MESSAGE_CREATED'
  | 'MESSAGE_DATE_REACHED'
  | 'MESSAGE_THREAD_CREATED'
  | 'PAPERWORK_COMPLETED'
  | 'TASK_CREATED'
  | 'TASK_DATE_REACHED'
  | 'TASK_UPDATED'
  | 'TREATMENT_PLAN_CLOSED'
  | 'TREATMENT_PLAN_CREATED'
  | 'TREATMENT_PLAN_PROCEDURE_BOOKED'
  | 'TREATMENT_PLAN_PROCEDURE_BROKEN_BOOKING'
  | 'TREATMENT_PLAN_PROCEDURE_COMPLETED'
  | 'TREATMENT_PLAN_PROCEDURE_PRESENTED'
  | 'TREATMENT_PLAN_UPDATED'

/** A single filter condition evaluated against the triggering entity. All filters must match (AND logic). */
export type WorkflowTriggerFilterInput = {
  /** Dot-notation path on the entity to evaluate, e.g. "tags", "type", "leadStatus" */
  attribute: string
  /** Comparison operator: in, not_in, exactly, not_exactly, contains, not_contains, attribute_exists, attribute_not_exists, greater_than, greater_equal_than, lesser_than, between, in_the_past */
  operator: string
  /** The value to compare against. For array operators (in, not_in, between), pass a JSON-encoded array string. */
  value?: string | null | undefined
}

/** Defines when a workflow enrolls contacts. Combines an event type, filter conditions, and a re-enrollment policy. */
export type WorkflowTriggerInput = {
  /** The entity lifecycle event that fires this trigger */
  event: WorkflowTriggerEvent
  /** How to combine change filters: "and" (all must match, default) or "or" (any must match) */
  filterLogic?: string | null | undefined
  /** Change conditions — evaluated against the Event (field changed to X). AND logic by default. */
  filters: Array<WorkflowTriggerFilterInput>
  /** What happens if a contact triggers this workflow while already enrolled: ignore (skip), restart (cancel + re-enroll), allow_multiple (run in parallel) */
  reenrollment?: WorkflowReenrollmentPolicy
  /** When true, skip enrollment for activities that have no linked contacts (unknown callers, unmatched forms) */
  requireContactMatch?: boolean | null | undefined
  /** How to combine state filters: "and" (all must match, default) or "or" (any must match) */
  stateFilterLogic?: string | null | undefined
  /** State conditions — evaluated against the live source record at enrollment time (record currently is X). AND logic by default. */
  stateFilters?: Array<WorkflowTriggerFilterInput> | null | undefined
}

export type LazyPmsCommTypeNameQueryVariables = Exact<{
  locationId: string
  commType: number
}>

export type LazyPmsCommTypeNameQuery = { pmsCommTypeName: string | null }

export type LazyPmsUserNameQueryVariables = Exact<{
  locationId: string
  userNum: number
}>

export type LazyPmsUserNameQuery = { pmsUserName: string | null }

export type LazyStaffCellUserQueryVariables = Exact<{
  id: string
}>

export type LazyStaffCellUserQuery = { user: { id: string; name: string | null; email: string } | null }

export type LazyStaffCellStaffQueryVariables = Exact<{
  id: string
}>

export type LazyStaffCellStaffQuery = { staffMember: { id: string; name: string } }

export type ActionCenterExitStageCountQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type ActionCenterExitStageCountQuery = { contacts: { total: number } }

export type ActionCenterExitStageContactsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ActionCenterExitStageContactsQuery = {
  contacts: {
    total: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      patientIds: Array<string> | null
      patientName: string | null
      orgId: string
      workspaceId: string
      locationId: string
      name: string
      preferredName: string | null
      homePhone: string | null
      cellPhone: string | null
      workPhone: string | null
      otherPhone: Array<string> | null
      email: string | null
      birthDate: string | null
      addressLine1: string | null
      addressLine2: string | null
      lifecycleStage: string | null
      patientStatus: string | null
      leadStatus: string | null
      isQualified: boolean | null
      appointmentStatus: string | null
      nearestAppointmentDate: string | null
      city: string | null
      state: string | null
      zip: string | null
      becameLeadDate: string | null
      becamePatientDate: string | null
      patientCreatedDate: string | null
      firstAppointmentMadeDate: string | null
      firstAppointmentDate: string | null
      lastAppointmentDate: string | null
      firstTransactionDate: string | null
      lastTransactionDate: string | null
      lastHygieneDate: string | null
      hygieneDueDate: string | null
      isPerio: boolean | null
      tags: Array<string> | null
      matchTypes: Array<string> | null
      collectedLtv: number | null
      productionLtv: number | null
      scheduledProduction: number | null
      unbookedTreatmentValue: number | null
      lastTreatmentPlanDate: string | null
      fvv: number | null
      adClickDate: string | null
      patientReferral: string | null
      lastActivityDate: string | null
      lastCommDate: string | null
      lastCommActivityType: string | null
      lastCommActivitySubType: string | null
      utmSource: string | null
      utmMedium: string | null
      utmCampaign: string | null
      utmKeywords: string | null
      utmContent: string | null
      platform: string | null
      trackableCampaignId: string | null
      channel: string | null
      smsMarketingConsent: boolean | null
      firstContactReason: string | null
      firstActivityType: string | null
      activityTypes: Array<string> | null
      firstActivityDate: string | null
      becameInactiveDate: string | null
      closedLostReason: string | null
      preferredCommunicationMethod: string | null
      preferredContact: string | null
      archived: boolean | null
      neededAction: boolean | null
      reportedAttribution: string | null
      activityCount: number | null
      needsActionDate: string | null
      firstName: string | null
      lastName: string | null
      leadOwner: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
      convertedBy: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
      pipelines: Array<{ id: string; stage: string | null; key: string | null }> | null
    }>
  }
}

export type ActionCenterSnoozedNamesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type ActionCenterSnoozedNamesQuery = { contacts: { hits: Array<{ id: string; name: string }> } }

export type ActionCenterNewPatientValueQueryVariables = Exact<{
  dateRange: DateRangeInput
  locationIds?: Array<string> | string | null | undefined
}>

export type ActionCenterNewPatientValueQuery = {
  newPatientsMetrics: { summary: { averageProductionPerNewPatientVisit: number } }
}

export type ActionCenterProductionValueQueryVariables = Exact<{
  dateRange: DateRangeInput
  locationIds?: Array<string> | string | null | undefined
}>

export type ActionCenterProductionValueQuery = {
  revenueMetrics: { stats: { avgNetProductionPerVisit: number; avgGrossProductionPerVisit: number } }
}

export type ActionCenterCardCallQueryVariables = Exact<{
  id: string
}>

export type ActionCenterCardCallQuery = {
  call: {
    id: string
    answered: boolean | null
    duration: number | null
    waveforms: Array<string> | null
    ai: { summary: string | null } | null
  } | null
}

export type ActionCenterCardCallRecordingQueryVariables = Exact<{
  id: string
}>

export type ActionCenterCardCallRecordingQuery = { callRecordingUrl: string | null }

export type ActionCenterUpdateContactMutationVariables = Exact<{
  id: string
  input: UpdateContactInput
}>

export type ActionCenterUpdateContactMutation = { updateContact: { id: string } }

export type ActionCenterAddToPipelineMutationVariables = Exact<{
  id: string
  pipeline: ContactPipelineInput
}>

export type ActionCenterAddToPipelineMutation = {
  addToPipeline: { id: string; pipelines: Array<{ id: string; stage: string | null }> | null }
}

export type ActionCenterPipelinesQueryVariables = Exact<{ [key: string]: never }>

export type ActionCenterPipelinesQuery = {
  pipelines: Array<{ id: string; name: string; stages: Array<{ name: string; color: string; order: number }> | null }>
}

export type ActionCenterCloseLostMutationVariables = Exact<{
  id: string
  input: UpdateContactInput
}>

export type ActionCenterCloseLostMutation = {
  updateContact: { id: string; leadStatus: string | null; closedLostReason: string | null; isQualified: boolean | null }
}

export type ActionCenterCreateFollowUpMutationVariables = Exact<{
  input: CreateFollowUpInput
}>

export type ActionCenterCreateFollowUpMutation = {
  createFollowUp: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    contactId: string
    ownerName: string | null
    ownerId: string | null
    appointmentDate: string | null
    followUpDate: string | null
    isConnected: boolean | null
    isScheduled: boolean | null
    description: string | null
    createdDate: string | null
    updatedDate: string | null
  }
}

export type ActionCenterResponseQueueMessagesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ActionCenterResponseQueueMessagesQuery = {
  messages: {
    total: number
    hits: Array<{
      id: string
      threadId: string | null
      contactId: string | null
      from: string
      locationId: string
      direction: string | null
      text: string
      read: boolean | null
      createdDate: string
      sentByUserId: string | null
      isAgent: boolean | null
    }>
  }
}

export type ActionCenterContactMessagesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ActionCenterContactMessagesQuery = {
  messages: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      threadId: string | null
      from: string
      to: string
      callerId: string | null
      sentByUserId: string | null
      isAgent: boolean | null
      aiWorkflowId: string | null
      aiWorkflowName: string | null
      isInitialMessage: boolean | null
      contactId: string | null
      channel: string
      subject: string | null
      text: string
      read: boolean | null
      archived: boolean | null
      direction: string | null
      createdDate: string
      updatedDate: string
      version: number
    }>
  }
}

export type ActionCenterLatestAppointmentQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ActionCenterLatestAppointmentQuery = {
  appointments: {
    total: number
    hits: Array<{
      id: string
      date: string | null
      status: string | null
      type: string | null
      locationId: string
      patientId: string | null
      procedureCodes: Array<string> | null
    }>
  }
}

export type ActionCenterBandContactsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ActionCenterBandContactsQuery = {
  contacts: {
    total: number
    hits: Array<{
      id: string
      name: string
      cellPhone: string | null
      patientIds: Array<string> | null
      locationId: string
      unbookedTreatmentValue: number | null
      lastTreatmentPlanDate: string | null
      lastAppointmentDate: string | null
      productionLtv: number | null
      scheduledProduction: number | null
      treatmentStatus: string | null
      pipelines: Array<{ id: string; stage: string | null }> | null
    }>
  }
}

export type ActionCenterBandAppointmentsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ActionCenterBandAppointmentsQuery = {
  appointments: {
    total: number
    hits: Array<{
      id: string
      patientId: string | null
      locationId: string
      status: string | null
      pmsStatus: string | null
      date: string | null
      amount: number | null
      type: string | null
      description: string | null
      procedureCodes: Array<string> | null
    }>
  }
}

export type ActionCenterBandProceduresQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ActionCenterBandProceduresQuery = {
  procedures: {
    total: number
    hits: Array<{
      id: string
      patientId: string | null
      locationId: string
      providerId: string | null
      procedureCode: string | null
      description: string | null
      tooth: string | null
      state: string | null
      feeAmount: number | null
      appointmentIds: Array<string> | null
      planIds: Array<string> | null
      procedureCreateDate: string | null
      priority: string | null
    }>
  }
}

export type ActionCenterBandPlansQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ActionCenterBandPlansQuery = {
  treatmentPlans: {
    total: number
    hits: Array<{
      id: string
      patientId: string | null
      displayName: string | null
      state: string | null
      status: string | null
      planCreateDate: string | null
    }>
  }
}

export type ActionCenterHoldsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type ActionCenterHoldsQuery = {
  actions: {
    total: number
    hits: Array<{
      actionId: string
      queueName: string
      queueId: string
      contactId: string
      state: string
      untilDate: string | null
      note: string | null
      userId: string
      version: number
      createdDate: string
      updatedDate: string
      orgId: string
      workspaceId: string
    }>
  }
}

export type ActionCenterCreateHoldMutationVariables = Exact<{
  input: CreateActionInput
}>

export type ActionCenterCreateHoldMutation = {
  createAction: {
    actionId: string
    queueName: string
    queueId: string
    contactId: string
    state: string
    untilDate: string | null
    note: string | null
    userId: string
    version: number
    createdDate: string
    updatedDate: string
    orgId: string
    workspaceId: string
  }
}

export type ActionCenterWakeHoldMutationVariables = Exact<{
  actionId: string
  input: UpdateActionInput
}>

export type ActionCenterWakeHoldMutation = {
  updateAction: {
    actionId: string
    queueName: string
    queueId: string
    contactId: string
    state: string
    untilDate: string | null
    note: string | null
    userId: string
    version: number
    createdDate: string
    updatedDate: string
    orgId: string
    workspaceId: string
  }
}

export type ActionCenterLocationsQueryVariables = Exact<{
  pagination?: PaginationInput | null | undefined
}>

export type ActionCenterLocationsQuery = {
  locations: {
    hits: Array<{ id: string; name: string; primaryTrackingNumber: string | null; callRailCompanyId: string | null }>
  }
}

export type ActivateAccountQueryVariables = Exact<{
  token: string
  email: string
}>

export type ActivateAccountQuery = {
  activateAccount: {
    allowGoogle: boolean
    code: string
    email: string
    name: string | null
    phone: string | null
    position: string | null
  } | null
}

export type ActivateSetPasswordMutationVariables = Exact<{
  token: string
  email: string
  password: string
  clientType: ClientType
}>

export type ActivateSetPasswordMutation = { setPassword: { accessToken: string } }

export type ActivateUpdateMeMutationVariables = Exact<{
  input: UpdateUserInput
}>

export type ActivateUpdateMeMutation = { updateMe: { id: string } }

export type FollowUpQueryVariables = Exact<{
  id: string
}>

export type FollowUpQuery = {
  followUp: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    contactId: string
    ownerName: string | null
    ownerId: string | null
    appointmentDate: string | null
    followUpDate: string | null
    isConnected: boolean | null
    isScheduled: boolean | null
    description: string | null
    createdDate: string | null
    updatedDate: string | null
  }
}

export type CreateFollowUpMutationVariables = Exact<{
  input: CreateFollowUpInput
}>

export type CreateFollowUpMutation = {
  createFollowUp: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    contactId: string
    ownerName: string | null
    ownerId: string | null
    appointmentDate: string | null
    followUpDate: string | null
    isConnected: boolean | null
    isScheduled: boolean | null
    description: string | null
    createdDate: string | null
    updatedDate: string | null
  }
}

export type UpdateFollowUpMutationVariables = Exact<{
  id: string
  input: UpdateFollowUpInput
}>

export type UpdateFollowUpMutation = {
  updateFollowUp: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    contactId: string
    ownerName: string | null
    ownerId: string | null
    appointmentDate: string | null
    followUpDate: string | null
    isConnected: boolean | null
    isScheduled: boolean | null
    description: string | null
    createdDate: string | null
    updatedDate: string | null
  }
}

export type FollowUpFormDeleteFollowUpMutationVariables = Exact<{
  id: string
}>

export type FollowUpFormDeleteFollowUpMutation = { deleteFollowUp: boolean }

export type InboundCallQueryVariables = Exact<{
  id: string
}>

export type InboundCallQuery = {
  call: {
    aiAgent: boolean | null
    allPatientOutcomes: Array<string> | null
    answered: boolean | null
    answerer: string | null
    appointmentDateString: string | null
    archived: boolean | null
    callerId: string | null
    callerPhone: string | null
    channel: string | null
    duration: number | null
    elevenLabsConversationId: string | null
    gclid: string | null
    id: string
    landingPageUrl: string | null
    locationId: string
    note: string | null
    patientNames: string | null
    recordingDuration: number | null
    referringUrl: string | null
    status: string | null
    tags: Array<string> | null
    trackingNumber: string | null
    trackingNumberName: string | null
    treatment: string | null
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    vendor: string | null
    waveforms: Array<string> | null
    workspaceId: string
    ai: {
      actionItems: string | null
      answerer: string | null
      channel: string | null
      extractionDate: string | null
      model: string | null
      summary: string | null
      people: Array<{
        appointmentDate: string | null
        appointmentRequested: boolean | null
        appointmentScheduled: boolean | null
        appointmentTime: string | null
        birthDate: string | null
        email: string | null
        index: number | null
        insuranceProvider: string | null
        isCaller: boolean | null
        name: string | null
        outcomes: Array<string> | null
        patientType: string | null
        phone: string | null
        reasonForNotScheduling: string | null
        referral: string | null
        relationship: string | null
        serviceRequested: string | null
        treatment: string | null
      }> | null
      tokenUsage: { inputTokens: number | null; outputTokens: number | null; totalTokens: number | null } | null
    } | null
    staff: { id: string | null; name: string } | null
  } | null
}

export type CallRecordingUrlQueryVariables = Exact<{
  id: string
}>

export type CallRecordingUrlQuery = { callRecordingUrl: string | null }

export type CallDatumQueryVariables = Exact<{
  id: string
}>

export type CallDatumQuery = {
  callDatum: {
    id: string
    callId: string
    elevenLabsConversationId: string | null
    extractedData: Record<string, unknown> | null
    data: Record<string, unknown> | null
  }
}

export type RematchActivityMutationVariables = Exact<{
  id: string
  contactId?: string | null | undefined
}>

export type RematchActivityMutation = { rematchActivity: { id: string } }

export type OutboundCallQueryVariables = Exact<{
  id: string
}>

export type OutboundCallQuery = {
  call: {
    aiAgent: boolean | null
    allPatientOutcomes: Array<string> | null
    answered: boolean | null
    answerer: string | null
    appointmentDateString: string | null
    archived: boolean | null
    callerId: string | null
    callerPhone: string | null
    channel: string | null
    createdDate: string
    direction: string | null
    duration: number | null
    gclid: string | null
    golden: boolean | null
    id: string
    landingPageUrl: string | null
    locationId: string
    note: string | null
    patientNames: string | null
    recordingDuration: number | null
    recordings: Array<string> | null
    referringUrl: string | null
    status: string | null
    tags: Array<string> | null
    trackingNumber: string | null
    trackingNumberName: string | null
    treatment: string | null
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    vendor: string | null
    waveforms: Array<string> | null
    workspaceId: string
    ai: {
      actionItems: string | null
      answerer: string | null
      channel: string | null
      extractionDate: string | null
      model: string | null
      summary: string | null
      people: Array<{
        appointmentDate: string | null
        appointmentRequested: boolean | null
        appointmentScheduled: boolean | null
        appointmentTime: string | null
        birthDate: string | null
        email: string | null
        index: number | null
        insuranceProvider: string | null
        isCaller: boolean | null
        name: string | null
        outcomes: Array<string> | null
        patientType: string | null
        phone: string | null
        reasonForNotScheduling: string | null
        referral: string | null
        relationship: string | null
        serviceRequested: string | null
        treatment: string | null
      }> | null
      tokenUsage: { inputTokens: number | null; outputTokens: number | null; totalTokens: number | null } | null
    } | null
    staff: { id: string | null; name: string } | null
  } | null
}

export type OutboundCallRecordingUrlQueryVariables = Exact<{
  id: string
}>

export type OutboundCallRecordingUrlQuery = { callRecordingUrl: string | null }

export type OutboundCallTranscriptionQueryVariables = Exact<{
  id: string
}>

export type OutboundCallTranscriptionQuery = { callTranscription: string | null }

export type AiAgentConfigForApptTypesQueryVariables = Exact<{
  locationId: string
}>

export type AiAgentConfigForApptTypesQuery = {
  aiAgentConfiguration: {
    id: string
    locationId: string
    generalApptId: string | null
    emergencyApptId: string | null
    consultApptId: string | null
    limitedExamApptId: string | null
  } | null
}

export type SmsAgentDeploymentQueryVariables = Exact<{
  locationId: string
}>

export type SmsAgentDeploymentQuery = {
  aiAgentConfiguration: {
    id: string
    systemPrompt: string | null
    promptVersion: string | null
    promptDeployedDate: string | null
    model: string | null
    temperature: number | null
    tools: Record<string, unknown> | null
  } | null
}

export type AiAgentLocationSetLiveMutationVariables = Exact<{
  id: string
  input: UpdateLocationInput
}>

export type AiAgentLocationSetLiveMutation = { updateLocation: { id: string; isAIAgentLive: boolean | null } }

export type AiAgentSettingsConfigQueryVariables = Exact<{
  locationId: string
}>

export type AiAgentSettingsConfigQuery = {
  aiAgentConfiguration: {
    id: string
    locationId: string
    agentName: string | null
    greeting: string | null
    businessName: string | null
    businessAddress: string | null
    postBookingMessage: string | null
    hygienePostBookingMessage: string | null
    smsConfirmationEnabled: boolean | null
    generalApptId: string | null
    emergencyApptId: string | null
    consultApptId: string | null
    limitedExamApptId: string | null
    offers: Array<{
      name: string
      patientStatus: string | null
      eligibleInsurance: string
      onlyEmergencyEligible: boolean
    }> | null
    services: Array<{
      name: string
      lowPrice: number | null
      highPrice: number | null
      consultRequired: boolean
      consultPrice: number | null
    }> | null
    servicesNotOffered: Array<{
      name: string
      lowPrice: number | null
      highPrice: number | null
      consultRequired: boolean
      consultPrice: number | null
    }> | null
    sayThisNotThatRules: Array<{ stopPhrase: string; replacementPhrase: string; channel: string }> | null
  } | null
}

export type AiAgentSettingsOperatoriesQueryVariables = Exact<{
  locationId: string
}>

export type AiAgentSettingsOperatoriesQuery = {
  operatories: Array<{ id: string | null; remote_id: string; name: string; display_name: string }>
}

export type AiAgentSettingsUpdateMutationVariables = Exact<{
  locationId: string
  input: UpdateAiAgentLocationConfigInput
}>

export type AiAgentSettingsUpdateMutation = {
  updateAIAgentLocationConfig: {
    id: string
    locationId: string
    agentName: string | null
    greeting: string | null
    businessName: string | null
    businessAddress: string | null
    sayThisNotThatRules: Array<{ stopPhrase: string; replacementPhrase: string; channel: string }> | null
  }
}

export type AiAgentSettingsHoursSourceQueryVariables = Exact<{
  locationId: string
}>

export type AiAgentSettingsHoursSourceQuery = {
  aiAgentConfigurations: Array<{ id: string; voiceAgentTools: Array<string> | null }>
}

export type AiAgentSettingsCompilerToolsMutationVariables = Exact<{
  locationId: string
  input: UpdateAiAgentCompilerConfigInput
}>

export type AiAgentSettingsCompilerToolsMutation = {
  opsUpdateAIAgentCompilerConfig: { id: string; voiceAgentTools: Array<string> | null }
}

export type SmsOpsTakeoverEventsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type SmsOpsTakeoverEventsQuery = {
  events: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      type: string
      typeId: string
      action: string
      source: string
      data: Record<string, unknown>
      eventDate: string
      createdDate: string
      updatedDate: string
      version: number
    }>
  }
}

export type SmsOpsMessagesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type SmsOpsMessagesQuery = {
  messages: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      threadId: string | null
      contactId: string | null
      channel: string
      category: string | null
      direction: string | null
      source: string | null
      from: string
      to: string
      status: string | null
      errorCode: string | null
      errorMessage: string | null
      provider: string | null
      providerMessageId: string | null
      callerId: string | null
      isAgent: boolean | null
      isInitialMessage: boolean | null
      aiWorkflowId: string | null
      aiWorkflowName: string | null
      workflowRunId: string | null
      sentByUserId: string | null
      sendDate: string | null
      read: boolean | null
      archived: boolean | null
      createdDate: string
      updatedDate: string
      version: number
    }>
  }
}

export type SmsOpsThreadsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type SmsOpsThreadsQuery = {
  threads: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      name: string | null
      phone: string | null
      lastIncomingMessageDate: string | null
      lastOutgoingMessageDate: string | null
      aiEnabled: boolean | null
      activeWorkflowId: string | null
      agentActivityId: string | null
      agentBrief: string | null
      agentBriefSetDate: string | null
      agentLastMessageDate: string | null
      agentReplyDueDate: string | null
      nameSetAtDate: string | null
      nameSetByUserId: string | null
      createdDate: string
      updatedDate: string
      version: number
    }>
  }
}

export type SmsOpsOptOutsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type SmsOpsOptOutsQuery = {
  optOuts: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      key: string
      type: OptOutType
      createdDate: string
      updatedDate: string
      version: number
    }>
  }
}

export type SmsOpsAiTurnsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type SmsOpsAiTurnsQuery = {
  aiConversationTurns: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      threadId: string
      model: string | null
      latencyMs: number | null
      createdDate: string
      steps: Array<{ toolResults: Array<{ toolName: string; isError: boolean }> | null }> | null
    }>
  }
}

export type SmsOpsReplyAttemptsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type SmsOpsReplyAttemptsQuery = {
  aiConversationTurns: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      threadId: string
      contactId: string
      messageId: string | null
      model: string | null
      failed: boolean | null
      failureReason: string | null
      failureMessage: string | null
      createdDate: string
    }>
  }
}

export type OpsVoiceAgentLocationMetricsQueryVariables = Exact<{
  input: VoiceAgentLocationMetricsInput
}>

export type OpsVoiceAgentLocationMetricsQuery = {
  opsVoiceAgentLocationMetrics: {
    rows: Array<{
      locationId: string
      locationName: string | null
      workspaceId: string | null
      workspaceName: string | null
      aiCalls: number
      newPatientCalls: number
      appointmentsBooked: number
      appointmentsCompleted: number
      toolErrorCalls: number
      toolTimeoutCalls: number
      toolDuplicateCalls: number
      failedCalls: number
      llmFailedCalls: number
      llmSlowCalls: number
      disconnectedCalls: number
      maxDurationCalls: number
      errorCalls: number
      unsuccessfulCalls: number
      gptFailedCalls: number
      elevenLabsFailedCalls: number
    }>
    total: {
      locationId: string
      aiCalls: number
      newPatientCalls: number
      appointmentsBooked: number
      appointmentsCompleted: number
      toolErrorCalls: number
      toolTimeoutCalls: number
      toolDuplicateCalls: number
      failedCalls: number
      llmFailedCalls: number
      llmSlowCalls: number
      disconnectedCalls: number
      maxDurationCalls: number
      errorCalls: number
      unsuccessfulCalls: number
      gptFailedCalls: number
      elevenLabsFailedCalls: number
    }
    compareRows: Array<{ locationId: string; newPatientCalls: number; appointmentsBooked: number }> | null
    compareTotal: { locationId: string; newPatientCalls: number; appointmentsBooked: number } | null
  }
}

export type OpsVoiceAgentDailyMetricsQueryVariables = Exact<{
  input: VoiceAgentDailyMetricsInput
}>

export type OpsVoiceAgentDailyMetricsQuery = {
  opsVoiceAgentDailyMetrics: {
    daily: Array<{
      date: string
      aiCalls: number
      failedCalls: number
      gptFailedCalls: number
      elevenLabsFailedCalls: number
    }>
    locations: Array<{
      locationId: string
      lastCallBeforeRange: string | null
      days: Array<{ date: string; aiCalls: number }>
    }>
  }
}

export type OpsVoiceAgentCallDataQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type OpsVoiceAgentCallDataQuery = {
  callData: {
    total: number
    page: number
    hits: Array<{
      id: string
      callId: string
      locationId: string
      callDate: string | null
      duration: number | null
      extractedData: Record<string, unknown> | null
      toolError: boolean | null
      toolTimeout: boolean | null
      toolDuplicate: boolean | null
      terminationReason: string | null
      errorCode: number | null
      errorReason: string | null
      callSuccessful: string | null
      noBookingReason: string | null
    }>
  }
}

export type VoiceAgentMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput
  locationIds?: Array<string> | string | null | undefined
}>

export type VoiceAgentMetricsQuery = {
  voiceAgentMetrics: {
    scheduleRate: number
    newPatientCalls: number
    appointmentsBooked: number
    appointmentsCompleted: number
    totalCalls: number
    locationCount: number
  }
}

export type AgentBookingsCountQueryVariables = Exact<{
  search?: string | null | undefined
}>

export type AgentBookingsCountQuery = { appointments: { total: number } }

export type AgentAppointmentsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type AgentAppointmentsQuery = {
  appointments: {
    total: number
    hits: Array<{
      amount: number | null
      appointmentMadeDate: string | null
      confirmed: boolean | null
      createdDate: string
      date: string | null
      description: string | null
      duration: string | null
      id: string
      locationId: string
      note: string | null
      patientId: string | null
      pmsStatus: string | null
      procedureCode1: string | null
      procedureCode1Amount: string | null
      procedureCode1Time: string | null
      procedureCode2: string | null
      procedureCode2Amount: string | null
      procedureCode2Time: string | null
      procedureCode3: string | null
      procedureCode3Amount: string | null
      procedureCode3Time: string | null
      procedureCodes: Array<string> | null
      providerId: string | null
      sikkaOfficeId: string | null
      sikkaPracticeId: string | null
      source: string | null
      status: string | null
      time: string | null
      timeToAppointment: number | null
      type: string | null
      updatedDate: string
      version: number
    }>
  }
}

export type AgentPatientContactsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type AgentPatientContactsQuery = {
  contacts: { hits: Array<{ id: string; name: string; patientIds: Array<string> | null }> }
}

export type ConversionsDashboardMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput
  locationIds?: Array<string> | string | null | undefined
}>

export type ConversionsDashboardMetricsQuery = {
  conversionMetrics: {
    total: number
    QUALIFIED_LEAD_GENERATED: { total: number; failed: number }
    NEW_PATIENT_APPOINTMENT_SCHEDULED: { total: number; failed: number }
    NEW_PATIENT_GENERATED: { total: number; failed: number }
    ADDITIONAL_TREATMENT_REVENUE: { total: number; failed: number }
  }
}

export type FinancialPageMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput
  compareRange?: DateRangeInput | null | undefined
  locationIds?: Array<string> | string | null | undefined
  integrationStatus?: string | null | undefined
}>

export type FinancialPageMetricsQuery = {
  revenueMetrics: {
    stats: {
      grossProduction: number
      netProduction: number
      adjustments: number
      collections: number
      avgGrossProductionPerVisit: number
      avgNetProductionPerVisit: number
      avgAdjustmentsPerVisit: number
    }
    comparisonStats: {
      grossProduction: number
      netProduction: number
      adjustments: number
      collections: number
      avgGrossProductionPerVisit: number
      avgNetProductionPerVisit: number
      avgAdjustmentsPerVisit: number
    } | null
    dailyMetrics: Array<{ bucket: string; grossProduction: number; netProduction: number; collections: number }>
    comparisonDailyMetrics: Array<{
      bucket: string
      grossProduction: number
      netProduction: number
      collections: number
    }>
  }
}

export type MarketingLocationsQueryVariables = Exact<{ [key: string]: never }>

export type MarketingLocationsQuery = {
  locations: {
    hits: Array<{
      id: string
      name: string
      tags: Array<string> | null
      orgTags: Array<string> | null
      pmsIntegrated: boolean
      lastPmsSyncDate: string | null
      workspaceId: string
    }>
  }
}

export type MarketingStaffBreakdownQueryVariables = Exact<{
  dateRange: DateRangeInput
  channel?: string | null | undefined
  locationIds?: Array<string> | string | null | undefined
  integrationStatus?: string | null | undefined
  filters?: string | null | undefined
}>

export type MarketingStaffBreakdownQuery = {
  staffBreakdown: {
    hits: Array<{
      bucket: string
      id: string
      date: string
      isStaff: boolean
      newPatientCalls: number
      qualifiedNPCalls: number
      disqualifiedNPCalls: number
      scheduledNPCalls: number
      unscheduledNPCalls: number
      averageDuration: number
      speedToLead: number
      NPCallScheduleRate: number
    }>
  }
}

export type NewPatientsMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput
  compareRange?: DateRangeInput | null | undefined
  channel?: string | null | undefined
  locationIds?: Array<string> | string | null | undefined
  integrationStatus?: string | null | undefined
  filters?: string | null | undefined
  platform?: string | null | undefined
  hideMultiLocationPatients?: boolean | null | undefined
}>

export type NewPatientsMetricsQuery = {
  newPatientsMetrics: {
    summary: {
      completed: number
      scheduled: number
      reappointments: number
      reappointmentPercentage: number
      averageTimeToAppointment: number
      averageProductionPerNewPatientVisit: number
      byChannel: Array<{ channel: string; count: number }>
    }
    comparisonSummary: {
      completed: number
      scheduled: number
      reappointments: number
      reappointmentPercentage: number
      averageTimeToAppointment: number
      averageProductionPerNewPatientVisit: number
      byChannel: Array<{ channel: string; count: number }>
    } | null
    dailyMetrics: Array<{ bucket: string; count: number; byChannel: Array<{ channel: string; count: number }> }>
    comparisonMetrics: Array<{ bucket: string; count: number; byChannel: Array<{ channel: string; count: number }> }>
    dailyScheduledMetrics: Array<{
      bucket: string
      count: number
      byChannel: Array<{ channel: string; count: number }>
    }>
    rows: Array<{
      bucket: string
      reappointmentPercentage: number
      reappointments: number
      completed: number
      brokenAppointmentCount: number
      averageTimeToAppointment: number
      averageProductionPerNewPatientVisit: number
      newPatients: number
      newPatientsFromDigitalMarketing: number
      newPatientsFromReferralMarketing: number
      newPatientsFromTraditionalMarketing: number
      newPatientsFromUnknown: number
      scheduledNewPatients: number
      location: { id: string; name: string; pmsIntegrated: boolean; lastPmsSyncDate: string | null } | null
    }>
  }
}

export type AttributionFlowFilteredQueryVariables = Exact<{
  dateRange: DateRangeInput
  groupBy: string
  locationIds?: Array<string> | string | null | undefined
  integrationStatus?: string | null | undefined
  filters?: string | null | undefined
  showDisqualified?: boolean | null | undefined
}>

export type AttributionFlowFilteredQuery = {
  marketingMetrics: {
    hits: Array<{
      bucket: string
      leads: number
      mqls: number
      appointments: number
      patients: number
      production: number
      scheduledProduction: number
      googleSpend: number
      facebookSpend: number
      roi: number
      budget: number
    }>
    summary: { leads: number; mqls: number; appointments: number; patients: number }
  }
}

export type LeadsBreakdownQueryVariables = Exact<{
  dateRange: DateRangeInput
  channel?: string | null | undefined
  locationIds?: Array<string> | string | null | undefined
  integrationStatus?: string | null | undefined
  filters?: string | null | undefined
  platform?: string | null | undefined
  showDisqualified?: boolean | null | undefined
}>

export type LeadsBreakdownQuery = {
  leadsBreakdown: {
    byActivityTypes: Array<{ bucket: string; leads: number }>
    rows: Array<{
      bucket: string
      date: string
      leads: number
      leadsByFirstActivityType: Array<{ type: string; count: number }>
      leadsByStatus: Array<{ status: string; count: number }>
    }>
  }
}

export type ScheduleRateQualifiedLeadCountsQueryVariables = Exact<{
  dateRange: DateRangeInput
  compareFromDate?: string | null | undefined
  compareToDate?: string | null | undefined
  channel?: string | null | undefined
  locationIds?: Array<string> | string | null | undefined
  activityType?: string | null | undefined
  integrationStatus?: string | null | undefined
  filters?: string | null | undefined
  platform?: string | null | undefined
}>

export type ScheduleRateQualifiedLeadCountsQuery = {
  qualifiedLeadCounts: {
    total: number
    qualified: number
    disqualified: number
    stats: { scheduleRate: number; mqls: number; scheduled: number; notScheduled: number }
    comparisonStats: { scheduleRate: number; mqls: number; scheduled: number; notScheduled: number } | null
    series: Array<{ date: string; scheduled: number; leads: number; scheduledRate: number }>
  }
}

export type AvailabilityProvidersQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type AvailabilityProvidersQuery = {
  providers: {
    total: number
    page: number
    hits: Array<{ id: string; displayName: string; deactivated: boolean | null }>
  }
}

export type UpdateProviderStatusMutationVariables = Exact<{
  id: string
  input: UpdateProviderInput
}>

export type UpdateProviderStatusMutation = {
  updateProvider: { id: string; deactivated: boolean | null; displayName: string }
}

export type SyncAvailabilityProvidersMutationVariables = Exact<{
  locationId: string
}>

export type SyncAvailabilityProvidersMutation = {
  syncProviders: { success: boolean | null; synced: number | null; error: string | null }
}

export type AvailabilitySettingsQueryVariables = Exact<{
  locationId: string
}>

export type AvailabilitySettingsQuery = {
  schedulingConfiguration: {
    id: string
    locationId: string
    allowDoubleBooking: boolean | null
    doubleBookingCount: number | null
    insurancesAccepted: Array<string> | null
    insurancesRejected: Array<string> | null
    isStateInsuranceAccepted: boolean | null
    granularity: number
  } | null
}

export type SaveAvailabilitySettingsMutationVariables = Exact<{
  locationId: string
  schedInput: UpdateSchedulingConfigurationInput
  locInput: UpdateLocationInput
}>

export type SaveAvailabilitySettingsMutation = {
  updateSchedulingConfiguration: {
    id: string
    allowDoubleBooking: boolean | null
    doubleBookingCount: number | null
    insurancesAccepted: Array<string> | null
    insurancesRejected: Array<string> | null
    isStateInsuranceAccepted: boolean | null
    granularity: number
  }
  updateLocation: {
    id: string
    isSchedulerLive: boolean | null
    isAIAgentLive: boolean | null
    availabilityMode: string | null
  }
}

export type AvailabilityViewOperatoriesQueryVariables = Exact<{
  locationId: string
}>

export type AvailabilityViewOperatoriesQuery = {
  operatories: Array<{
    name: string
    remote_id: string
    type: string
    display_name: string
    id: string | null
    locationId: string | null
  }>
}

export type SyncProvidersMutationVariables = Exact<{
  locationId: string
}>

export type SyncProvidersMutation = { syncProviders: { success: boolean | null; error: string | null } }

export type SyncSchedulesMutationVariables = Exact<{
  locationId: string
}>

export type SyncSchedulesMutation = { syncSchedules: { success: boolean | null; error: string | null } }

export type CallTranscriptionQueryVariables = Exact<{
  id: string
}>

export type CallTranscriptionQuery = { callTranscription: string | null }

export type CallInfoUpdateCallMutationVariables = Exact<{
  id: string
  input: UpdateCallInput
}>

export type CallInfoUpdateCallMutation = {
  updateCall: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    elevenLabsConversationId: string | null
    archived: boolean | null
    channel: string | null
    vendor: string | null
    answerer: string | null
    answered: boolean | null
    treatment: string | null
    patientNames: string | null
    callerId: string | null
    trackingNumber: string | null
    trackingNumberName: string | null
    tags: Array<string> | null
    waveforms: Array<string> | null
    appointmentDateString: string | null
    callerPhone: string | null
    businessPhone: string | null
    callDate: string | null
    note: string | null
    status: string | null
    recordingDuration: number | null
    duration: number | null
    utmSource: string | null
    utmMedium: string | null
    utmCampaign: string | null
    utmKeywords: string | null
    utmContent: string | null
    referringUrl: string | null
    gclid: string | null
    landingPageUrl: string | null
    recordings: Array<string> | null
    aiAgent: boolean | null
    golden: boolean | null
    direction: string | null
    allPatientOutcomes: Array<string> | null
    ai: {
      summary: string | null
      actionItems: string | null
      answerer: string | null
      channel: string | null
      extractionDate: string | null
      model: string | null
      people: Array<{
        name: string | null
        treatment: string | null
        serviceRequested: string | null
        relationship: string | null
        appointmentDate: string | null
        appointmentTime: string | null
        phone: string | null
        patientType: string | null
        appointmentScheduled: boolean | null
        appointmentRequested: boolean | null
        birthDate: string | null
        referral: string | null
        insuranceProvider: string | null
        outcomes: Array<string> | null
        reasonForNotScheduling: string | null
        isCaller: boolean | null
        index: number | null
        email: string | null
      }> | null
      tokenUsage: { inputTokens: number | null; outputTokens: number | null; totalTokens: number | null } | null
    } | null
    patients: Array<{
      name: string | null
      treatment: string | null
      serviceRequested: string | null
      relationship: string | null
      appointmentDate: string | null
      appointmentTime: string | null
      phone: string | null
      patientType: string | null
      appointmentScheduled: boolean | null
      appointmentRequested: boolean | null
      birthDate: string | null
      referral: string | null
      insuranceProvider: string | null
      outcomes: Array<string> | null
      reasonForNotScheduling: string | null
      isCaller: boolean | null
      index: number | null
      email: string | null
    }> | null
    staff: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
    people: Array<{
      name: string | null
      treatment: string | null
      serviceRequested: string | null
      relationship: string | null
      appointmentDate: string | null
      appointmentTime: string | null
      phone: string | null
      patientType: string | null
      appointmentScheduled: boolean | null
      appointmentRequested: boolean | null
      birthDate: string | null
      referral: string | null
      insuranceProvider: string | null
      outcomes: Array<string> | null
      reasonForNotScheduling: string | null
      isCaller: boolean | null
      index: number | null
      email: string | null
    }> | null
  }
}

export type CarestackDashboardQueryVariables = Exact<{
  period: string
}>

export type CarestackDashboardQuery = {
  carestackDashboard: { base64: string; workspaces: Array<{ workspaceId: string; workspaceName: string | null }> }
}

export type InitiateCallMutationVariables = Exact<{
  input: InitiateCallInput
}>

export type InitiateCallMutation = {
  initiateCall: { success: boolean; callId: string | null; calledNumber: string | null; error: string | null }
}

export type OutboundNumbersQueryVariables = Exact<{
  id: string
}>

export type OutboundNumbersQuery = {
  location: {
    id: string
    officeMainNumber: string | null
    businessPhone: string | null
    primaryTrackingNumber: string | null
    callRailCompanyId: string | null
  } | null
}

export type LocationMarketingMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput
  groupBy: string
  channel?: string | null | undefined
  showDisqualified?: boolean | null | undefined
}>

export type LocationMarketingMetricsQuery = {
  marketingMetrics: {
    summary: {
      budget: number
      facebookSpend: number
      googleSpend: number
      targetSpend: number
      leadGoal: number
      leads: number
      MQLs: number
      appointments: number
      patients: number
      production: number
      scheduledProduction: number
      ROI: number
      scheduleRate: number
      CPL: number
      CPQL: number
      CPA: number
      CAC: number
      disqualified: number
    }
    rows: Array<{
      bucket: string
      locationId: string | null
      leads: number
      MQLs: number
      appointments: number
      patients: number
      scheduleRate: number
      cpls: number
      roi: number
      budget: number
      facebookSpend: number
      googleSpend: number
      targetSpend: number
      leadGoal: number
      iCPL: number
      iCPQL: number
    }>
  }
}

export type LocationTotalsQueryVariables = Exact<{
  dateRange: DateRangeInput
  groupBy: string
  channel?: string | null | undefined
  locationIds?: Array<string> | string | null | undefined
}>

export type LocationTotalsQuery = {
  marketingMetrics: {
    rows: Array<{
      bucket: string
      leads: number
      MQLs: number
      cpls: number
      roi: number
      budget: number
      facebookSpend: number
      googleSpend: number
      targetSpend: number
      leadGoal: number
      iCPL: number
      iCPQL: number
    }>
  }
}

export type WorkspaceMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput
  groupBy: string
  channel?: string | null | undefined
}>

export type WorkspaceMetricsQuery = {
  marketingMetrics: {
    rows: Array<{
      bucket: string
      workspaceId: string | null
      leads: number
      MQLs: number
      appointments: number
      patients: number
      scheduleRate: number
      cpls: number
      roi: number
      budget: number
      facebookSpend: number
      googleSpend: number
      targetSpend: number
      leadGoal: number
      iCPL: number
      iCPQL: number
    }>
  }
}

export type CreateWorkspaceMutationVariables = Exact<{
  input: CreateWorkspaceInput
}>

export type CreateWorkspaceMutation = { createWorkspace: { id: string; name: string; orgId: string } }

export type ContactHoverableQueryVariables = Exact<{
  id: string
}>

export type ContactHoverableQuery = {
  contact: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    patientIds: Array<string> | null
    patientName: string | null
    orgId: string
    workspaceId: string
    locationId: string
    name: string
    preferredName: string | null
    homePhone: string | null
    cellPhone: string | null
    workPhone: string | null
    otherPhone: Array<string> | null
    email: string | null
    birthDate: string | null
    addressLine1: string | null
    addressLine2: string | null
    lifecycleStage: string | null
    patientStatus: string | null
    leadStatus: string | null
    isQualified: boolean | null
    appointmentStatus: string | null
    nearestAppointmentDate: string | null
    city: string | null
    state: string | null
    zip: string | null
    becameLeadDate: string | null
    becamePatientDate: string | null
    patientCreatedDate: string | null
    firstAppointmentMadeDate: string | null
    firstAppointmentDate: string | null
    lastAppointmentDate: string | null
    firstTransactionDate: string | null
    lastTransactionDate: string | null
    lastHygieneDate: string | null
    hygieneDueDate: string | null
    isPerio: boolean | null
    tags: Array<string> | null
    matchTypes: Array<string> | null
    collectedLtv: number | null
    productionLtv: number | null
    scheduledProduction: number | null
    unbookedTreatmentValue: number | null
    lastTreatmentPlanDate: string | null
    fvv: number | null
    adClickDate: string | null
    patientReferral: string | null
    lastActivityDate: string | null
    lastCommDate: string | null
    lastCommActivityType: string | null
    lastCommActivitySubType: string | null
    utmSource: string | null
    utmMedium: string | null
    utmCampaign: string | null
    utmKeywords: string | null
    utmContent: string | null
    platform: string | null
    trackableCampaignId: string | null
    channel: string | null
    smsMarketingConsent: boolean | null
    firstContactReason: string | null
    firstActivityType: string | null
    activityTypes: Array<string> | null
    firstActivityDate: string | null
    becameInactiveDate: string | null
    closedLostReason: string | null
    preferredCommunicationMethod: string | null
    preferredContact: string | null
    archived: boolean | null
    neededAction: boolean | null
    reportedAttribution: string | null
    activityCount: number | null
    needsActionDate: string | null
    firstName: string | null
    lastName: string | null
    leadOwner: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
    convertedBy: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
    pipelines: Array<{ id: string; stage: string | null; key: string | null }> | null
  }
}

export type UpdateContactLeadStatusMutationVariables = Exact<{
  id: string
  input: UpdateContactInput
}>

export type UpdateContactLeadStatusMutation = {
  updateContact: { id: string; leadStatus: string | null; closedLostReason: string | null; isQualified: boolean | null }
}

export type CommLogEntriesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type CommLogEntriesQuery = {
  commLogs: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      vendorId: string
      patientId: string | null
      pmsPatientId: string | null
      mode: number | null
      commType: number | null
      sentOrReceived: number | null
      note: string | null
      userNum: number | null
      commSource: number | null
      programNum: number | null
      channel: string | null
      provider: string | null
      subject: string | null
      sourceId: string | null
      commDate: string | null
      commEndDate: string | null
      pmsUpdatedDate: string | null
      version: number
    }>
  }
}

export type CommLogCountQueryVariables = Exact<{
  search?: string | null | undefined
}>

export type CommLogCountQuery = { commLogs: { total: number } }

export type CloseLostFromDrawerMutationVariables = Exact<{
  id: string
  input: UpdateContactInput
}>

export type CloseLostFromDrawerMutation = {
  updateContact: { id: string; leadStatus: string | null; closedLostReason: string | null; isQualified: boolean | null }
}

export type ContactTagsTagValuesQueryVariables = Exact<{
  entity: string
  search?: string | null | undefined
}>

export type ContactTagsTagValuesQuery = { tagValues: Array<string> }

export type CreateNoteMutationVariables = Exact<{
  input: CreateActivityInput
}>

export type CreateNoteMutation = {
  createNote: {
    id: string
    type: string
    description: string | null
    activityDate: string | null
    source: string | null
    locationId: string
    orgId: string
    workspaceId: string
    owner: { id: string | null; name: string } | null
    contacts: Array<{ id: string; name: string | null }> | null
  }
}

export type LastCommCallQueryVariables = Exact<{
  id: string
}>

export type LastCommCallQuery = {
  call: {
    id: string
    direction: string | null
    duration: number | null
    answered: boolean | null
    answerer: string | null
    note: string | null
    allPatientOutcomes: Array<string> | null
    ai: { summary: string | null; answerer: string | null } | null
  } | null
}

export type ContactStatusChangesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ContactStatusChangesQuery = {
  activities: {
    total: number
    hits: Array<{
      id: string
      activityDate: string | null
      createdDate: string
      source: string | null
      data: Record<string, unknown> | null
      description: string | null
    }>
  }
}

export type SendSmsMutationVariables = Exact<{
  input: SendMessageInput
}>

export type SendSmsMutation = {
  sendSms: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    threadId: string | null
    from: string
    to: string
    callerId: string | null
    sentByUserId: string | null
    isAgent: boolean | null
    aiWorkflowId: string | null
    aiWorkflowName: string | null
    isInitialMessage: boolean | null
    contactId: string | null
    channel: string
    subject: string | null
    text: string
    read: boolean | null
    archived: boolean | null
    createdDate: string
    updatedDate: string
    status: string | null
    providerMessageId: string | null
    errorCode: string | null
    errorMessage: string | null
  }
}

export type ThreadEventsQueryVariables = Exact<{
  search?: string | null | undefined
  sort?: SortInput | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type ThreadEventsQuery = {
  events: { hits: Array<{ id: string; data: Record<string, unknown>; createdDate: string }> }
}

export type SmsOptOutQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type SmsOptOutQuery = { optOuts: { total: number } }

export type InboxSmsProviderQueryVariables = Exact<{
  id: string
}>

export type InboxSmsProviderQuery = {
  location: {
    id: string
    primaryTrackingNumber: string | null
    callRailCompanyId: string | null
    twilioNumbers: Array<{ phone: string | null }> | null
  } | null
}

export type InboxDebugTracesQueryVariables = Exact<{
  threadId?: string | null | undefined
  sort?: SortInput | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type InboxDebugTracesQuery = {
  aiConversationTurns: {
    total: number
    page: number
    hits: Array<{
      id: string
      messageId: string | null
      aiWorkflowId: string | null
      turnIndex: number | null
      createdDate: string
      isInitialMessage: boolean | null
      model: string | null
      temperature: number | null
      latencyMs: number | null
      response: string | null
      systemPrompt: string | null
      tokenUsage: {
        inputTokens: number | null
        outputTokens: number | null
        totalTokens: number | null
        cachedInputTokens: number | null
        inputTokenDetails: { cacheReadTokens: number | null } | null
      } | null
      steps: Array<{
        text: string | null
        toolCalls: Array<{ toolName: string; args: Record<string, unknown> | null }> | null
        toolResults: Array<{ toolName: string; result: Record<string, unknown> | null; isError: boolean }> | null
      }> | null
    }>
  }
}

export type EmailAttachmentUrlsQueryVariables = Exact<{
  id: string
}>

export type EmailAttachmentUrlsQuery = {
  emailAttachmentUrls: Array<{ filename: string; contentType: string; sizeBytes: number; url: string }>
}

export type LocationCanSendEmailQueryVariables = Exact<{
  locationId: string
}>

export type LocationCanSendEmailQuery = { locationCanSendEmail: boolean }

export type ContactTreatmentProceduresQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type ContactTreatmentProceduresQuery = {
  procedures: {
    total: number
    hits: Array<{
      id: string
      patientId: string | null
      procedureCode: string | null
      description: string | null
      tooth: string | null
      state: string | null
      feeAmount: number | null
      appointmentIds: Array<string> | null
      planIds: Array<string> | null
      procedureCreateDate: string | null
      priority: string | null
    }>
  }
}

export type ContactKollaTreatmentPlansQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type ContactKollaTreatmentPlansQuery = {
  treatmentPlans: {
    total: number
    hits: Array<{
      id: string
      patientId: string | null
      displayName: string | null
      state: string | null
      status: string | null
      planCreateDate: string | null
      procedureIds: Array<string> | null
    }>
  }
}

export type BulkCreateTagColorMutationVariables = Exact<{
  input: CreateTagColorInput
}>

export type BulkCreateTagColorMutation = { createTagColor: { id: string } }

export type SwitchWorkspaceMutationVariables = Exact<{
  targetWorkspaceId?: string | null | undefined
}>

export type SwitchWorkspaceMutation = { switchWorkspace: { accessToken: string } }

export type DniPoolNumbersQueryVariables = Exact<{
  dniId: string
}>

export type DniPoolNumbersQuery = { dniPoolNumbers: Array<{ phone: string; createdDate: string }> }

export type DniIntegrationStatusQueryVariables = Exact<{
  locationId: string
}>

export type DniIntegrationStatusQuery = { integrationStatus: { status: string } }

export type UpdateLocationFacebookMutationVariables = Exact<{
  id: string
  input: UpdateLocationInput
}>

export type UpdateLocationFacebookMutation = {
  updateLocation: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    pms: string | null
    pmsIntegratedDate: string | null
    migrationDate: string | null
    sikkaOfficeId: string | null
    sikkaPracticeId: string | null
    kollaConnectorId: string | null
    kollaConsumerId: string | null
    kollaPracticeId: string | null
    kollaPageSize: number | null
    availabilityMode: string | null
    callRailCompanyId: string | null
    elevenLabsAgentId: string | null
    callRailBackfillStartDate: string | null
    jotformFormIds: Array<string> | null
    facebookFormIds: Array<string> | null
    carestackId: string | null
    ringCentralPhoneNumbers: Array<string> | null
    primaryNumberId: string | null
    officeTransferNumberId: string | null
    googleAdsCustomerId: string | null
    facebookAdSetIds: Array<string> | null
    city: string | null
    state: string | null
    address: string | null
    zip: string | null
    phone: string | null
    description: string | null
    addressLine2: string | null
    timezone: string | null
    tags: Array<string> | null
    orgTags: Array<string> | null
    labels: Array<string> | null
    products: Array<string> | null
    type: string | null
    primaryTrackingNumber: string | null
    primarySmsNumber: string | null
    businessPhone: string | null
    officeMainNumber: string | null
    officeTransferNumber: string | null
    jotFormIgnoredForms: Array<string> | null
    lastPmsSyncDate: string | null
    lastSyncFailureDate: string | null
    lastPmsSyncStartDate: string | null
    lastPmsSyncCompleteDate: string | null
    currentStatus: string | null
    lastRingCentralSyncDate: string | null
    lastCallrailWebhookDate: string | null
    lastTwilioWebhookDate: string | null
    lastAICallDate: string | null
    lastSikkaWebhookDate: string | null
    lastJotformWebhookDate: string | null
    lastFacebookWebhookDate: string | null
    facebookSpendUpdateDate: string | null
    googleSpendUpdateDate: string | null
    facebookAdsActive: boolean | null
    googleAdsActive: boolean | null
    isSchedulerLive: boolean | null
    isAIAgentLive: boolean | null
    allowDoubleBookingScheduling: boolean | null
    gravityFormsKey: string | null
    webflowFormsKey: string | null
    archived: boolean | null
    lastGravityFormWebhookDate: string | null
    lastPatientSyncDate: string | null
    lastAppointmentSyncDate: string | null
    lastTransactionSyncDate: string | null
    lastProcedureSyncDate: string | null
    lastTreatmentPlanSyncDate: string | null
    lastPatientReceivedDate: string | null
    lastAppointmentReceivedDate: string | null
    lastTransactionReceivedDate: string | null
    lastProcedureReceivedDate: string | null
    lastTreatmentPlanReceivedDate: string | null
    ascendLocationId: string | null
    alarmQuietStart: string | null
    alarmQuietEnd: string | null
    dailySyncHour: number | null
    pmsIntegrated: boolean
    twilioNumbers: Array<{
      id: string | null
      type: string
      phone: string | null
      sourceName: string | null
      label: string | null
      poolId: string | null
      areaCode: string | null
      poolSize: number | null
      sessionDuration: number | null
    }> | null
    openHours: {
      sunday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      monday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      tuesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      wednesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      thursday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      friday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      saturday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
    } | null
    callRailRouting: Array<{ tag: string | null; locationId: string | null }> | null
    notes: Array<{ text: string; date: string; userId: string }> | null
    googleAdsV2: Array<{ accountId: string; campaignId: string | null; adGroupId: string | null }> | null
    googleAdsV3: {
      accountId: string
      campaignIds: Array<string> | null
      conversionActions: Record<string, unknown> | null
    } | null
    facebookAdsV2: Array<{ accountId: string | null; campaignId: string | null; adSetId: string | null }> | null
    facebookLeadsPages: Array<{ id: string; formIds: Array<string> | null }> | null
    jotform: Array<{ folderId: string; formIds: Array<string> | null }> | null
    jotformV2: Array<{ labelId: string; formIds: Array<string> | null }> | null
    settings: {
      newPatientCalculation: string | null
      appointmentsSetNewPatient: boolean | null
      appointmentCompletionStatuses: Array<string> | null
      transactionBrokenCodes: Array<string> | null
      newPatientCodes: Array<string> | null
      ignorePII: boolean | null
      excludeParentsFromNewPatients: boolean | null
      firstVisitSetNewPatient: boolean | null
    } | null
  }
}

export type AddOverrideOpsUsersQueryVariables = Exact<{
  search?: string | null | undefined
}>

export type AddOverrideOpsUsersQuery = {
  opsUsers: { hits: Array<{ id: string; name: string | null; email: string | null }> }
}

export type FeatureToggleOpsUsersQueryVariables = Exact<{
  search?: string | null | undefined
}>

export type FeatureToggleOpsUsersQuery = { opsUsers: { hits: Array<{ id: string; name: string | null }> } }

export type OverrideNameWorkspaceQueryVariables = Exact<{
  id: string
}>

export type OverrideNameWorkspaceQuery = { workspace: { id: string; name: string } }

export type CacheFlushMutationVariables = Exact<{
  pattern: string
}>

export type CacheFlushMutation = { cacheFlush: { success: boolean | null; error: string | null } }

export type ResetPasswordMutationVariables = Exact<{
  email: string
}>

export type ResetPasswordMutation = { resetPassword: boolean }

export type PaperworkByTokenQueryVariables = Exact<{
  token: string
}>

export type PaperworkByTokenQuery = {
  paperworkByToken: {
    linkState: string
    status: string | null
    expiresDate: string | null
    packet: Record<string, unknown> | null
    submittedFormIds: Record<string, unknown> | null
    practice: { displayName: string; phone: string | null; logoUrl: string | null } | null
  }
}

export type SubmitPaperworkFormMutationVariables = Exact<{
  token: string
  formId: string
  formVersion: number
  answers: Array<PublicAnswerInput> | PublicAnswerInput
}>

export type SubmitPaperworkFormMutation = {
  submitPaperworkForm: { linkState: string; status: string | null; submittedFormIds: Record<string, unknown> | null }
}

export type PaletteContactsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type PaletteContactsQuery = {
  contacts: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      patientIds: Array<string> | null
      patientName: string | null
      orgId: string
      workspaceId: string
      locationId: string
      name: string
      preferredName: string | null
      homePhone: string | null
      cellPhone: string | null
      workPhone: string | null
      otherPhone: Array<string> | null
      email: string | null
      birthDate: string | null
      addressLine1: string | null
      addressLine2: string | null
      lifecycleStage: string | null
      patientStatus: string | null
      leadStatus: string | null
      isQualified: boolean | null
      appointmentStatus: string | null
      nearestAppointmentDate: string | null
      city: string | null
      state: string | null
      zip: string | null
      becameLeadDate: string | null
      becamePatientDate: string | null
      patientCreatedDate: string | null
      firstAppointmentMadeDate: string | null
      firstAppointmentDate: string | null
      lastAppointmentDate: string | null
      firstTransactionDate: string | null
      lastTransactionDate: string | null
      lastHygieneDate: string | null
      hygieneDueDate: string | null
      isPerio: boolean | null
      tags: Array<string> | null
      matchTypes: Array<string> | null
      collectedLtv: number | null
      productionLtv: number | null
      scheduledProduction: number | null
      unbookedTreatmentValue: number | null
      lastTreatmentPlanDate: string | null
      fvv: number | null
      adClickDate: string | null
      patientReferral: string | null
      lastActivityDate: string | null
      lastCommDate: string | null
      lastCommActivityType: string | null
      lastCommActivitySubType: string | null
      utmSource: string | null
      utmMedium: string | null
      utmCampaign: string | null
      utmKeywords: string | null
      utmContent: string | null
      platform: string | null
      trackableCampaignId: string | null
      channel: string | null
      smsMarketingConsent: boolean | null
      firstContactReason: string | null
      firstActivityType: string | null
      activityTypes: Array<string> | null
      firstActivityDate: string | null
      becameInactiveDate: string | null
      closedLostReason: string | null
      preferredCommunicationMethod: string | null
      preferredContact: string | null
      archived: boolean | null
      neededAction: boolean | null
      reportedAttribution: string | null
      activityCount: number | null
      needsActionDate: string | null
      firstName: string | null
      lastName: string | null
      leadOwner: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
      convertedBy: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
      pipelines: Array<{ id: string; stage: string | null; key: string | null }> | null
    }>
  }
}

export type PaletteMessagesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type PaletteMessagesQuery = {
  messages: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      threadId: string | null
      from: string
      to: string
      callerId: string | null
      sentByUserId: string | null
      isAgent: boolean | null
      isInitialMessage: boolean | null
      aiWorkflowId: string | null
      aiWorkflowName: string | null
      workflowRunId: string | null
      direction: string | null
      contactId: string | null
      channel: string
      category: string | null
      subject: string | null
      text: string
      read: boolean | null
      archived: boolean | null
      status: string | null
      provider: string | null
      providerMessageId: string | null
      errorCode: string | null
      errorMessage: string | null
      images: Array<string> | null
    }>
  }
}

export type PaletteActivitiesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type PaletteActivitiesQuery = {
  activities: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      archived: boolean | null
      contactCount: number | null
      type: string
      typeId: string | null
      subType: string | null
      description: string | null
      note: string | null
      activityDate: string | null
      needsReview: boolean | null
      reviewReason: string | null
      matchTypes: Array<string> | null
      contactName: string | null
      contactPhone: string | null
      nameFromActivity: string | null
      nameSource: string | null
      phoneFromActivity: string | null
      source: string | null
      utmSource: string | null
      utmMedium: string | null
      utmCampaign: string | null
      utmKeywords: string | null
      utmContent: string | null
      referringUrl: string | null
      tags: Array<string> | null
      utmAccountId: string | null
      utmCampaignId: string | null
      trackableCampaignId: string | null
      vendor: string | null
      fbclid: string | null
      gclid: string | null
      data: Record<string, unknown> | null
      email: string | null
      channel: string | null
      isQualified: boolean | null
      smsMarketingOptIn: boolean | null
      trackingNumber: string | null
      trackingNumberName: string | null
      contacts: Array<{
        id: string
        name: string | null
        phone: string | null
        matchDate: string | null
        nameFromActivity: string | null
        peopleIndex: number | null
        lifecycleStage: string | null
        locationId: string | null
      }> | null
      owner: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
    }>
  }
}

export type OpsWorkspaceSearchQueryVariables = Exact<{
  query: string
}>

export type OpsWorkspaceSearchQuery = {
  opsWorkspaceSearch: Array<{
    workspaceId: string
    workspaceName: string
    orgId: string
    locationId: string | null
    locationName: string | null
  }>
}

export type FileImportsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type FileImportsQuery = {
  fileImports: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string | null
      fileName: string
      importIds: Array<string>
      archived: boolean | null
      createdDate: string | null
      updatedDate: string | null
    }>
  }
}

export type FileImportQueryVariables = Exact<{
  id: string
}>

export type FileImportQuery = {
  fileImport: {
    id: string
    orgId: string
    workspaceId: string | null
    fileName: string
    importIds: Array<string>
    archived: boolean | null
    createdDate: string | null
    updatedDate: string | null
  }
}

export type DeleteFileImportMutationVariables = Exact<{
  id: string
}>

export type DeleteFileImportMutation = { deleteFileImport: boolean }

export type ImportsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ImportsQuery = {
  imports: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      fileImportId: string | null
      name: string
      type: string
      vendor: string | null
      email: string | null
      phone: string | null
      activityDate: string | null
      requestedAppointmentTime: string | null
      treatment: string | null
      isScheduled: boolean | null
      channel: string | null
      utmSource: string | null
      utmMedium: string | null
      utmCampaign: string | null
      staff: string | null
      createdDate: string
      updatedDate: string
    }>
  }
}

export type ImportDetailQueryVariables = Exact<{
  id: string
}>

export type ImportDetailQuery = {
  importDetail: {
    vendor: string | null
    name: string
    requestedAppointmentTime: string | null
    isScheduled: boolean | null
    phone: string | null
    email: string | null
    treatment: string | null
    channel: string | null
    staff: string | null
  }
}

export type CreateImportMutationVariables = Exact<{
  input: CreateImportInput
}>

export type CreateImportMutation = { createImport: { id: string } }

export type CreateFileImportMutationVariables = Exact<{
  input: CreateFileImportInput
}>

export type CreateFileImportMutation = { createFileImport: { id: string } }

export type InboxLocationQueryVariables = Exact<{
  id: string
}>

export type InboxLocationQuery = {
  location: { id: string; name: string; primaryTrackingNumber: string | null; products: Array<string> | null } | null
}

export type InboxCallerIdQueryVariables = Exact<{
  callerPhone: string
  locationId: string
}>

export type InboxCallerIdQuery = { callerId: { callerId: string | null; customerName: string | null } | null }

export type HasActiveAgentQueryVariables = Exact<{
  locationId: string
}>

export type HasActiveAgentQuery = { aiAgentConfigurations: Array<{ id: string; systemPrompt: string | null }> }

export type ThreadQueryVariables = Exact<{
  id: string
}>

export type ThreadQuery = { thread: { id: string; aiEnabled: boolean | null; name: string | null } }

export type InboxThreadsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type InboxThreadsQuery = {
  threads: { hits: Array<{ id: string; aiEnabled: boolean | null; name: string | null }> }
}

export type ThreadEngageAgentMutationVariables = Exact<{
  threadId: string
}>

export type ThreadEngageAgentMutation = {
  threadEngageAgent: { id: string; aiEnabled: boolean | null; name: string | null }
}

export type UpdateThreadMutationVariables = Exact<{
  id: string
  input: UpdateThreadInput
}>

export type UpdateThreadMutation = { updateThread: { id: string; aiEnabled: boolean | null; name: string | null } }

export type LocationIntegrationStatusQueryVariables = Exact<{
  integration: string
  locationId: string
}>

export type LocationIntegrationStatusQuery = {
  integrationStatus: {
    status: string
    completion: number | null
    patientsCompletion: number | null
    appointmentsCompletion: number | null
    transactionsCompletion: number | null
    remainingPatients: number | null
    remainingAppointments: number | null
    remainingTransactions: number | null
    remainingCalls: number | null
    remainingForms: number | null
    remainingSpendRecords: number | null
    configuredPages: number | null
  }
}

export type SyncJobProgressFragment = {
  id: string
  jobId: string
  type: string
  description: string | null
  locationId: string | null
  orgId: string | null
  totalTasks: number
  remaining: number
  completed: number
  percentComplete: number
  complete: boolean
  createdAt: string
  completedAt: string | null
} & { ' $fragmentName'?: 'SyncJobProgressFragment' }

export type RecentSyncJobsQueryVariables = Exact<{
  pagination?: PaginationInput | null | undefined
}>

export type RecentSyncJobsQuery = {
  kolla: { nodes: Array<{ ' $fragmentRefs'?: { SyncJobProgressFragment: SyncJobProgressFragment } }> }
  sikka: { nodes: Array<{ ' $fragmentRefs'?: { SyncJobProgressFragment: SyncJobProgressFragment } }> }
  carestack: { nodes: Array<{ ' $fragmentRefs'?: { SyncJobProgressFragment: SyncJobProgressFragment } }> }
  ascend: { nodes: Array<{ ' $fragmentRefs'?: { SyncJobProgressFragment: SyncJobProgressFragment } }> }
}

export type FacebookAdSetsQueryVariables = Exact<{
  refresh?: boolean | null | undefined
}>

export type FacebookAdSetsQuery = { integrationOptions: { facebookAdSets: Array<{ id: string; name: string }> } }

export type DniManagedNumbersQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type DniManagedNumbersQuery = {
  phoneNumbers: { hits: Array<{ id: string; phone: string; label: string | null; roles: Array<string> }> }
}

export type DniForModalQueryVariables = Exact<{
  id: string
}>

export type DniForModalQuery = {
  dni: {
    id: string
    label: string | null
    forwardTo: string
    areaCode: string
    poolSize: number
    sessionDuration: number
    maxPoolSize: number | null
    minFree: number | null
    buyStep: number | null
    minPoolSize: number | null
    ivrConfigId: string | null
  }
}

export type RingCentralPhoneNumbersQueryVariables = Exact<{
  locationId?: string | null | undefined
}>

export type RingCentralPhoneNumbersQuery = {
  integrationOptions: { ringCentralPhoneNumbers: Array<{ id: string; name: string; isUsed: boolean }> }
}

export type CallRailCompaniesQueryVariables = Exact<{
  locationId?: string | null | undefined
}>

export type CallRailCompaniesQuery = {
  integrationOptions: { callRailCompanies: Array<{ id: string; name: string; isUsed: boolean }> }
}

export type SikkaOfficesQueryVariables = Exact<{
  locationId?: string | null | undefined
}>

export type SikkaOfficesQuery = {
  integrationOptions: {
    sikkaOffices: Array<{ id: string; name: string; practices: Array<{ id: string; name: string; isUsed: boolean }> }>
  }
}

export type AscendLocationsQueryVariables = Exact<{
  locationId?: string | null | undefined
}>

export type AscendLocationsQuery = {
  integrationOptions: { ascendLocations: Array<{ id: string; name: string; isUsed: boolean }> }
}

export type CarestackPracticesQueryVariables = Exact<{
  locationId?: string | null | undefined
}>

export type CarestackPracticesQuery = {
  integrationOptions: { carestackPractices: Array<{ id: string; name: string; isUsed: boolean }> }
}

export type JotformFormsQueryVariables = Exact<{
  locationId?: string | null | undefined
}>

export type JotformFormsQuery = {
  integrationOptions: {
    jotformForms: Array<{
      id: string
      name: string
      labelId: string | null
      labelName: string | null
      isUsed: boolean
      usedByLocationName: string | null
    }>
  }
}

export type TwilioPhoneNumbersQueryVariables = Exact<{
  locationId?: string | null | undefined
}>

export type TwilioPhoneNumbersQuery = {
  integrationOptions: { twilioPhoneNumbers: Array<{ id: string; name: string; isUsed: boolean }> }
}

export type ElevenLabsAgentsQueryVariables = Exact<{ [key: string]: never }>

export type ElevenLabsAgentsQuery = {
  integrationOptions: { elevenLabsAgents: Array<{ id: string; name: string; isUsed: boolean }> }
}

export type ElevenLabsBoundLocationsQueryVariables = Exact<{ [key: string]: never }>

export type ElevenLabsBoundLocationsQuery = {
  locations: { hits: Array<{ id: string; elevenLabsAgentId: string | null }> }
}

export type BindLocationElevenLabsAgentMutationVariables = Exact<{
  locationId: string
  elevenLabsAgentId: string
}>

export type BindLocationElevenLabsAgentMutation = {
  bindLocationElevenLabsAgent: { id: string; elevenLabsAgentId: string | null }
}

export type UnbindLocationElevenLabsAgentMutationVariables = Exact<{
  locationId: string
}>

export type UnbindLocationElevenLabsAgentMutation = { unbindLocationElevenLabsAgent: { id: string } }

export type SaveGravityFormsIntegrationMutationVariables = Exact<{
  locationId: string
  gravityFormsKey: string
  isNew?: boolean | null | undefined
}>

export type SaveGravityFormsIntegrationMutation = {
  saveGravityFormsIntegration: { success: boolean; error: string | null }
}

export type SaveWebflowFormsIntegrationMutationVariables = Exact<{
  locationId: string
  webflowFormsKey: string
  isNew?: boolean | null | undefined
}>

export type SaveWebflowFormsIntegrationMutation = {
  saveWebflowFormsIntegration: { success: boolean; error: string | null }
}

export type SaveFacebookAdsIntegrationMutationVariables = Exact<{
  locationId: string
  account?: string | null | undefined
  campaigns?: Array<FacebookAdsCampaignInput> | FacebookAdsCampaignInput | null | undefined
  isNew?: boolean | null | undefined
}>

export type SaveFacebookAdsIntegrationMutation = {
  saveFacebookAdsIntegration: { success: boolean; error: string | null }
}

export type SaveCallRailIntegrationMutationVariables = Exact<{
  locationId: string
  companyId: string
  backfillStartDate?: string | null | undefined
  isNew?: boolean | null | undefined
}>

export type SaveCallRailIntegrationMutation = { saveCallRailIntegration: { success: boolean; error: string | null } }

export type SaveCarestackIntegrationMutationVariables = Exact<{
  locationId: string
  selection: string
}>

export type SaveCarestackIntegrationMutation = { saveCarestackIntegration: { success: boolean; error: string | null } }

export type SaveAscendIntegrationMutationVariables = Exact<{
  locationId: string
  ascendLocationId: string
}>

export type SaveAscendIntegrationMutation = { saveAscendIntegration: { success: boolean; error: string | null } }

export type SaveSikkaIntegrationMutationVariables = Exact<{
  locationId: string
  selection: string
}>

export type SaveSikkaIntegrationMutation = { saveSikkaIntegration: { success: boolean; error: string | null } }

export type SaveRingCentralIntegrationMutationVariables = Exact<{
  locationId: string
  phoneNumbers: Array<string> | string
  isNew?: boolean | null | undefined
}>

export type SaveRingCentralIntegrationMutation = {
  saveRingCentralIntegration: { success: boolean; error: string | null }
}

export type SaveTwilioIntegrationMutationVariables = Exact<{
  locationId: string
  poolSelection?: Array<TwilioNumberInput> | TwilioNumberInput | null | undefined
  aiSelection?: string | null | undefined
  aiTestingSelection?: string | null | undefined
  isNew?: boolean | null | undefined
}>

export type SaveTwilioIntegrationMutation = { saveTwilioIntegration: { success: boolean; error: string | null } }

export type SaveKollaIntegrationMutationVariables = Exact<{
  locationId: string
  kollaConsumerId: string
  kollaConnectorId?: string | null | undefined
  kollaPracticeId?: string | null | undefined
}>

export type SaveKollaIntegrationMutation = { saveKollaIntegration: { success: boolean; error: string | null } }

export type RemoveLocationIntegrationMutationVariables = Exact<{
  locationId: string
  integration: string
}>

export type RemoveLocationIntegrationMutation = {
  removeLocationIntegration: { success: boolean; error: string | null }
}

export type DeleteStaffMutationVariables = Exact<{
  id: string
}>

export type DeleteStaffMutation = { deleteStaff: boolean }

export type IvrPhoneNumbersQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type IvrPhoneNumbersQuery = {
  phoneNumbers: { hits: Array<{ id: string; phone: string; roles: Array<string>; label: string | null }> }
}

export type IvrConfigQueryVariables = Exact<{
  phoneNumberId: string
}>

export type IvrConfigQuery = {
  ivrConfig: {
    id: string
    locationId: string
    phoneNumberId: string | null
    enabled: boolean
    root: string | null
    nodes: Record<string, unknown>
  } | null
}

export type IvrConfigsQueryVariables = Exact<{
  locationId: string
}>

export type IvrConfigsQuery = { ivrConfigs: Array<{ id: string; phoneNumberId: string | null }> }

export type CreateIvrConfigMutationVariables = Exact<{
  input: SaveIvrConfigInput
}>

export type CreateIvrConfigMutation = {
  createIvrConfig: {
    id: string
    locationId: string
    phoneNumberId: string | null
    enabled: boolean
    root: string | null
    nodes: Record<string, unknown>
  }
}

export type UpdateIvrConfigMutationVariables = Exact<{
  input: SaveIvrConfigInput
}>

export type UpdateIvrConfigMutation = {
  updateIvrConfig: {
    id: string
    locationId: string
    phoneNumberId: string | null
    enabled: boolean
    root: string | null
    nodes: Record<string, unknown>
  }
}

export type SendingDomainsForIdentityQueryVariables = Exact<{
  search?: string | null | undefined
}>

export type SendingDomainsForIdentityQuery = {
  sendingDomains: { total: number; hits: Array<{ id: string; domain: string; type: string; status: string }> }
}

export type TrackableSendingDomainQueryVariables = Exact<{ [key: string]: never }>

export type TrackableSendingDomainQuery = { trackableSendingDomain: string }

export type CheckSendingEmailAvailableQueryVariables = Exact<{
  localPart: string
  domain: string
  locationId?: string | null | undefined
}>

export type CheckSendingEmailAvailableQuery = { checkSendingEmailAvailable: boolean }

export type LocationEmailIdentitiesQueryVariables = Exact<{
  search?: string | null | undefined
}>

export type LocationEmailIdentitiesQuery = {
  locationEmailIdentities: {
    total: number
    hits: Array<{
      id: string
      locationId: string
      sendingDomainId: string | null
      domain: string
      localPart: string
      address: string
      fromName: string | null
      replyTo: string | null
    }>
  }
}

export type SetLocationEmailIdentityMutationVariables = Exact<{
  input: SetLocationEmailIdentityInput
}>

export type SetLocationEmailIdentityMutation = {
  setLocationEmailIdentity: {
    id: string
    locationId: string
    sendingDomainId: string | null
    domain: string
    localPart: string
    address: string
    fromName: string | null
    replyTo: string | null
  }
}

export type DeleteLocationEmailIdentityMutationVariables = Exact<{
  id: string
}>

export type DeleteLocationEmailIdentityMutation = { deleteLocationEmailIdentity: boolean }

export type LocationPhoneNumbersQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type LocationPhoneNumbersQuery = {
  phoneNumbers: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      phone: string
      provider: string
      providerResourceId: string
      roles: Array<string>
      label: string | null
      registrationStatus: string | null
      registrationId: string | null
      enabled: boolean
      provisioningStatus: string
      provisioningError: string | null
      createdDate: string
      updatedDate: string
    }>
  }
}

export type SearchAvailablePhoneNumbersQueryVariables = Exact<{
  type: PhoneNumberType
  areaCode: string
  limit?: number | null | undefined
}>

export type SearchAvailablePhoneNumbersQuery = {
  searchAvailablePhoneNumbers: Array<{ phone: string; type: PhoneNumberType; locality: string | null }>
}

export type PurchasePhoneNumberMutationVariables = Exact<{
  input: PurchasePhoneNumberInput
}>

export type PurchasePhoneNumberMutation = {
  purchasePhoneNumber: {
    id: string
    phone: string
    provider: string
    roles: Array<string>
    label: string | null
    provisioningStatus: string
    provisioningError: string | null
    registrationStatus: string | null
    enabled: boolean
    createdDate: string
  }
}

export type UpdatePhoneNumberRolesMutationVariables = Exact<{
  id: string
  input: UpdatePhoneNumberInput
}>

export type UpdatePhoneNumberRolesMutation = {
  updatePhoneNumber: { id: string; roles: Array<string>; label: string | null; enabled: boolean; updatedDate: string }
}

export type ReleasePhoneNumberMutationVariables = Exact<{
  id: string
}>

export type ReleasePhoneNumberMutation = {
  releasePhoneNumber: { id: string; provisioningStatus: string; enabled: boolean }
}

export type LocationSmsNumbersQueryVariables = Exact<{
  locationId: string
}>

export type LocationSmsNumbersQuery = {
  locationSmsNumbers: Array<{ phone: string; provider: string; label: string | null }>
}

export type DeleteBudgetMutationVariables = Exact<{
  id: string
}>

export type DeleteBudgetMutation = { deleteBudget: { id: string | null } }

export type UpdateBudgetMutationVariables = Exact<{
  id: string
  input: UpdateBudgetInput
}>

export type UpdateBudgetMutation = { updateBudget: { id: string | null } }

export type CreateBudgetMutationVariables = Exact<{
  input: CreateBudgetInput
}>

export type CreateBudgetMutation = { createBudget: { id: string | null } }

export type CreateAdPlatformMappingMutationVariables = Exact<{
  input: CreateAdPlatformMappingInput
}>

export type CreateAdPlatformMappingMutation = {
  createAdPlatformMapping: {
    id: string
    source: string
    medium: string
    platform: string
    orgId: string
    workspaceId: string
  }
}

export type UpdateAdPlatformMappingMutationVariables = Exact<{
  id: string
  input: UpdateAdPlatformMappingInput
}>

export type UpdateAdPlatformMappingMutation = {
  updateAdPlatformMapping: {
    id: string
    source: string
    medium: string
    platform: string
    orgId: string
    workspaceId: string
  }
}

export type DeleteAdPlatformMappingMutationVariables = Exact<{
  id: string
}>

export type DeleteAdPlatformMappingMutation = { deleteAdPlatformMapping: boolean }

export type CreateUtmAliasMutationVariables = Exact<{
  input: CreateUtmAliasInput
}>

export type CreateUtmAliasMutation = { createUtmAlias: { id: string; original: string; alias: string; type: string } }

export type UpdateUtmAliasMutationVariables = Exact<{
  id: string
  input: UpdateUtmAliasInput
}>

export type UpdateUtmAliasMutation = { updateUtmAlias: { id: string; original: string; alias: string; type: string } }

export type DeleteUtmAliasMutationVariables = Exact<{
  id: string
}>

export type DeleteUtmAliasMutation = { deleteUtmAlias: boolean }

export type CreateChannelMappingMutationVariables = Exact<{
  input: CreateChannelMappingInput
}>

export type CreateChannelMappingMutation = {
  createChannelMapping: {
    id: string
    source: string
    medium: string
    channel: string
    orgId: string
    workspaceId: string
  }
}

export type UpdateChannelMappingMutationVariables = Exact<{
  id: string
  input: UpdateChannelMappingInput
}>

export type UpdateChannelMappingMutation = {
  updateChannelMapping: {
    id: string
    source: string
    medium: string
    channel: string
    orgId: string
    workspaceId: string
  }
}

export type DeleteChannelMappingMutationVariables = Exact<{
  id: string
}>

export type DeleteChannelMappingMutation = { deleteChannelMapping: boolean }

export type CreateFormFieldMappingMutationVariables = Exact<{
  input: CreateFormFieldMappingInput
}>

export type CreateFormFieldMappingMutation = {
  createFormFieldMapping: { id: string; rawKey: string; formField: string }
}

export type UpdateFormFieldMappingMutationVariables = Exact<{
  id: string
  input: UpdateFormFieldMappingInput
}>

export type UpdateFormFieldMappingMutation = {
  updateFormFieldMapping: { id: string; rawKey: string; formField: string }
}

export type DeleteFormFieldMappingMutationVariables = Exact<{
  id: string
}>

export type DeleteFormFieldMappingMutation = { deleteFormFieldMapping: boolean }

export type OnlineSchedulerLocationQueryVariables = Exact<{
  locationId: string
}>

export type OnlineSchedulerLocationQuery = {
  location: { id: string; name: string; isSchedulerLive: boolean | null } | null
  schedulingConfiguration: {
    id: string
    locationId: string
    allowDoubleBooking: boolean | null
    insurancesAccepted: Array<string> | null
    insurancesRejected: Array<string> | null
    isStateInsuranceAccepted: boolean | null
    granularity: number
    leadOverrideEnabled: boolean | null
    customQuestions: Array<{
      id: string
      fieldName: string
      required: boolean
      fieldType: string
      enabled: boolean
      description: string | null
      marketingConsent: boolean | null
      optIn: boolean | null
    }> | null
    leadOverrideConfig: { amount: number; unit: string } | null
  } | null
}

export type UpdateOnlineSchedulerConfigMutationVariables = Exact<{
  locationId: string
  input: UpdateSchedulingConfigurationInput
}>

export type UpdateOnlineSchedulerConfigMutation = {
  updateSchedulingConfiguration: {
    id: string
    locationId: string
    allowDoubleBooking: boolean | null
    insurancesAccepted: Array<string> | null
    insurancesRejected: Array<string> | null
    isStateInsuranceAccepted: boolean | null
    granularity: number
    leadOverrideEnabled: boolean | null
    customQuestions: Array<{
      id: string
      fieldName: string
      required: boolean
      fieldType: string
      enabled: boolean
      description: string | null
      marketingConsent: boolean | null
      optIn: boolean | null
    }> | null
    leadOverrideConfig: { amount: number; unit: string } | null
  }
}

export type ToggleOnlineSchedulerLiveMutationVariables = Exact<{
  id: string
  input: UpdateLocationInput
}>

export type ToggleOnlineSchedulerLiveMutation = { updateLocation: { id: string; isSchedulerLive: boolean | null } }

export type OnlineSchedulerLocationsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
  schedulerSort?: SortInput | null | undefined
}>

export type OnlineSchedulerLocationsQuery = {
  locations: { total: number; page: number; hits: Array<{ id: string; name: string; isSchedulerLive: boolean | null }> }
  schedulers: { hits: Array<{ locationId: string; createdDate: string }> }
}

export type CacheSearchMutationVariables = Exact<{
  pattern: string
}>

export type CacheSearchMutation = { cacheSearch: Record<string, unknown> | null }

export type CacheDeleteMutationVariables = Exact<{
  pattern: string
}>

export type CacheDeleteMutation = { cacheDelete: Record<string, unknown> | null }

export type ExtractionDashboardQueryVariables = Exact<{ [key: string]: never }>

export type ExtractionDashboardQuery = {
  extractionDashboard: {
    workspaceId: string | null
    shadowStats: {
      total: number
      last24h: number
      avgMatchScore: number
      byWorkspace: Array<{ name: string; total: number }>
    }
  }
}

export type OpsReconcileCandidatesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type OpsReconcileCandidatesQuery = {
  contacts: {
    hits: Array<{
      id: string
      name: string
      patientStatus: string | null
      appointmentStatus: string | null
      hygieneDueDate: string | null
      nearestAppointmentDate: string | null
      birthDate: string | null
      isPerio: boolean | null
      unbookedTreatmentValue: number | null
      pipelines: Array<{ id: string; stage: string | null }> | null
    }>
  }
}

export type OpsReconcileAddToPipelineMutationVariables = Exact<{
  id: string
  pipeline: ContactPipelineInput
}>

export type OpsReconcileAddToPipelineMutation = { addToPipeline: { id: string } }

export type PaperworkFormTemplatesQueryVariables = Exact<{
  archived?: boolean | null | undefined
  formId?: string | null | undefined
  status?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type PaperworkFormTemplatesQuery = {
  formTemplates: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      orgId: string
      workspaceId: string
      formId: string
      name: string
      description: string | null
      category: string
      formVersion: number
      status: string
      publishedDate: string | null
      archived: boolean
      questionsJson: Record<string, unknown>
    }>
  }
}

export type PaperworkFormTemplateQueryVariables = Exact<{
  id: string
}>

export type PaperworkFormTemplateQuery = {
  formTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    formId: string
    name: string
    description: string | null
    category: string
    formVersion: number
    status: string
    publishedDate: string | null
    archived: boolean
    questionsJson: Record<string, unknown>
  }
}

export type PaperworkCreateFormTemplateMutationVariables = Exact<{
  input: CreateFormTemplateInput
}>

export type PaperworkCreateFormTemplateMutation = {
  createFormTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    formId: string
    name: string
    description: string | null
    category: string
    formVersion: number
    status: string
    publishedDate: string | null
    archived: boolean
    questionsJson: Record<string, unknown>
  }
}

export type PaperworkUpdateFormTemplateMutationVariables = Exact<{
  id: string
  input: UpdateFormTemplateInput
}>

export type PaperworkUpdateFormTemplateMutation = {
  updateFormTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    formId: string
    name: string
    description: string | null
    category: string
    formVersion: number
    status: string
    publishedDate: string | null
    archived: boolean
    questionsJson: Record<string, unknown>
  }
}

export type PaperworkPublishFormTemplateMutationVariables = Exact<{
  id: string
}>

export type PaperworkPublishFormTemplateMutation = {
  publishFormTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    formId: string
    name: string
    description: string | null
    category: string
    formVersion: number
    status: string
    publishedDate: string | null
    archived: boolean
    questionsJson: Record<string, unknown>
  }
}

export type PaperworkDraftNextFormTemplateVersionMutationVariables = Exact<{
  id: string
}>

export type PaperworkDraftNextFormTemplateVersionMutation = {
  draftNextFormTemplateVersion: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    formId: string
    name: string
    description: string | null
    category: string
    formVersion: number
    status: string
    publishedDate: string | null
    archived: boolean
    questionsJson: Record<string, unknown>
  }
}

export type PaperworkDeleteFormTemplateMutationVariables = Exact<{
  id: string
}>

export type PaperworkDeleteFormTemplateMutation = { deleteFormTemplate: boolean }

export type PaperworkTemplatesQueryVariables = Exact<{
  archived?: boolean | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type PaperworkTemplatesQuery = {
  paperworkTemplates: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      orgId: string
      workspaceId: string
      name: string
      description: string | null
      archived: boolean
      formsJson: Record<string, unknown>
      brandingJson: Record<string, unknown> | null
      appearanceJson: Record<string, unknown> | null
      welcomeJson: Record<string, unknown> | null
      completionJson: Record<string, unknown> | null
    }>
  }
}

export type PaperworkTemplateQueryVariables = Exact<{
  id: string
}>

export type PaperworkTemplateQuery = {
  paperworkTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    description: string | null
    archived: boolean
    formsJson: Record<string, unknown>
    brandingJson: Record<string, unknown> | null
    appearanceJson: Record<string, unknown> | null
    welcomeJson: Record<string, unknown> | null
    completionJson: Record<string, unknown> | null
  }
}

export type PaperworkCreateTemplateMutationVariables = Exact<{
  input: CreatePaperworkTemplateInput
}>

export type PaperworkCreateTemplateMutation = {
  createPaperworkTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    description: string | null
    archived: boolean
    formsJson: Record<string, unknown>
    brandingJson: Record<string, unknown> | null
    appearanceJson: Record<string, unknown> | null
    welcomeJson: Record<string, unknown> | null
    completionJson: Record<string, unknown> | null
  }
}

export type PaperworkUpdateTemplateMutationVariables = Exact<{
  id: string
  input: UpdatePaperworkTemplateInput
}>

export type PaperworkUpdateTemplateMutation = {
  updatePaperworkTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    description: string | null
    archived: boolean
    formsJson: Record<string, unknown>
    brandingJson: Record<string, unknown> | null
    appearanceJson: Record<string, unknown> | null
    welcomeJson: Record<string, unknown> | null
    completionJson: Record<string, unknown> | null
  }
}

export type PaperworkDeleteTemplateMutationVariables = Exact<{
  id: string
}>

export type PaperworkDeleteTemplateMutation = { deletePaperworkTemplate: boolean }

export type PaperworkBrandingLocationsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type PaperworkBrandingLocationsQuery = {
  locations: { total: number; page: number; hits: Array<{ id: string; name: string; businessPhone: string | null }> }
}

export type ContactPaperworksQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ContactPaperworksQuery = {
  paperworks: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      paperworkTemplateId: string
      patientId: string
      token: string
      expiresDate: string
      status: string
      openedDate: string | null
      completedDate: string | null
      cancelledDate: string | null
      snapshotJson: Record<string, unknown>
      submissionsJson: Record<string, unknown> | null
      processingStatus: PaperworkProcessingStatus
      processingCompletedDate: string | null
      chartWritesJson: Record<string, unknown> | null
      link: string
      fullyComplete: boolean
      formStatuses: Array<{ formId: string; name: string; completed: boolean; submittedDate: string | null }>
      chartWriteStatuses: Array<{
        formId: string
        status: PaperworkChartWriteStatus
        externalId: string | null
        errorMessage: string | null
        completedDate: string | null
      }>
    }>
  }
}

export type ResendPaperworkMutationVariables = Exact<{
  id: string
}>

export type ResendPaperworkMutation = {
  resendPaperwork: {
    id: string
    status: string
    expiresDate: string
    openedDate: string | null
    cancelledDate: string | null
    link: string
    token: string
  }
}

export type CancelPaperworkMutationVariables = Exact<{
  id: string
}>

export type CancelPaperworkMutation = { cancelPaperwork: { id: string; status: string; cancelledDate: string | null } }

export type PaperworkPatientsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type PaperworkPatientsQuery = {
  patients: {
    total: number
    page: number
    hits: Array<{
      id: string
      pmsPatientId: string | null
      firstName: string | null
      lastName: string | null
      preferredName: string | null
      birthDate: string | null
      status: string | null
      lastVisit: string | null
    }>
  }
}

export type CreatePaperworkMutationVariables = Exact<{
  input: CreatePaperworkInput
}>

export type CreatePaperworkMutation = {
  createPaperwork: { id: string; patientId: string; status: string; expiresDate: string; link: string }
}

export type PipelineCardPreviewLocationQueryVariables = Exact<{
  pagination?: PaginationInput | null | undefined
}>

export type PipelineCardPreviewLocationQuery = { locations: { hits: Array<{ id: string; name: string }> } }

export type CreateCommLogWritebackRuleMutationVariables = Exact<{
  input: CreateCommLogWritebackRuleInput
}>

export type CreateCommLogWritebackRuleMutation = {
  createCommLogWritebackRule: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    type: string
    channel: string
    version: number
    createdDate: string
    updatedDate: string
  }
}

export type UpdateCommLogWritebackRuleMutationVariables = Exact<{
  id: string
  input: UpdateCommLogWritebackRuleInput
}>

export type UpdateCommLogWritebackRuleMutation = {
  updateCommLogWritebackRule: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    type: string
    channel: string
    version: number
    createdDate: string
    updatedDate: string
  }
}

export type DeleteCommLogWritebackRuleMutationVariables = Exact<{
  id: string
}>

export type DeleteCommLogWritebackRuleMutation = { deleteCommLogWritebackRule: boolean }

export type PmsReferralMappingsQueryVariables = Exact<{
  pagination?: PaginationInput | null | undefined
}>

export type PmsReferralMappingsQuery = {
  pmsReferralMappings: {
    total: number
    hits: Array<{
      id: string
      referralType: string
      channel: string | null
      source: string | null
      medium: string | null
      campaign: string | null
      force: boolean | null
    }>
  }
}

export type CreatePmsReferralMappingMutationVariables = Exact<{
  input: CreatePmsReferralMappingInput
}>

export type CreatePmsReferralMappingMutation = {
  createPmsReferralMapping: {
    id: string
    referralType: string
    channel: string | null
    source: string | null
    medium: string | null
    campaign: string | null
    force: boolean | null
  }
}

export type UpdatePmsReferralMappingMutationVariables = Exact<{
  id: string
  input: UpdatePmsReferralMappingInput
}>

export type UpdatePmsReferralMappingMutation = {
  updatePmsReferralMapping: {
    id: string
    referralType: string
    channel: string | null
    source: string | null
    medium: string | null
    campaign: string | null
    force: boolean | null
  }
}

export type PatientsReferralTypesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type PatientsReferralTypesQuery = {
  patients: { total: number; hits: Array<{ id: string; referralType: string | null; locationId: string }> }
}

export type PatientsCountQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type PatientsCountQuery = { patients: { total: number } }

export type PmsSchedulesLocationQueryVariables = Exact<{
  locationId: string
}>

export type PmsSchedulesLocationQuery = {
  location: { id: string; name: string; kollaConsumerId: string | null } | null
}

export type PmsSchedulesQueryVariables = Exact<{
  schedulesSearch?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  locationId: string
}>

export type PmsSchedulesQuery = {
  resourceSchedules: {
    total: number
    hits: Array<{
      id: string
      name: string
      date: string
      blocks: Array<{ startTime: string; endTime: string }>
      notes: Array<{
        startTime: string
        endTime: string
        note: string
        additionalData: { appointmentType: string | null } | null
      }>
    }>
  }
  appointmentTypes: {
    hits: Array<{
      id: string
      vendorId: string
      displayName: string
      appointmentLength: number
      activeScheduler: boolean | null
    }>
  }
}

export type ResetSetPasswordMutationVariables = Exact<{
  email: string
  password: string
  token: string
  clientType: ClientType
}>

export type ResetSetPasswordMutation = { setPassword: { accessToken: string } }

export type ScheduleWeekAppointmentsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ScheduleWeekAppointmentsQuery = {
  appointments: {
    total: number
    hits: Array<{
      id: string
      locationId: string
      patientId: string | null
      providerId: string | null
      date: string | null
      time: string | null
      duration: string | null
      status: string | null
      pmsStatus: string | null
      type: string | null
      description: string | null
      note: string | null
      amount: number | null
      procedureCodes: Array<string> | null
    }>
  }
}

export type ScheduleSlotCandidatesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ScheduleSlotCandidatesQuery = {
  contacts: {
    total: number
    hits: Array<{
      id: string
      name: string
      cellPhone: string | null
      locationId: string
      lastHygieneDate: string | null
      patientIds: Array<string> | null
    }>
  }
}

export type ScheduleWeekOperatoriesQueryVariables = Exact<{
  locationId: string
}>

export type ScheduleWeekOperatoriesQuery = {
  operatories: Array<{
    id: string | null
    name: string
    remote_id: string
    display_name: string
    type: string
    locationId: string | null
  }>
}

export type ScheduleRoomSchedulesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type ScheduleRoomSchedulesQuery = {
  resourceSchedules: {
    total: number
    hits: Array<{
      id: string
      name: string
      type: string
      date: string
      blocks: Array<{ startTime: string; endTime: string }>
      notes: Array<{ startTime: string; endTime: string; note: string }>
    }>
  }
}

export type ScheduleDayLocationQueryVariables = Exact<{
  id: string
}>

export type ScheduleDayLocationQuery = { location: { id: string; kollaConsumerId: string | null } | null }

export type ScheduleWeekLocationQueryVariables = Exact<{
  id: string
}>

export type ScheduleWeekLocationQuery = {
  location: { id: string; name: string; timezone: string | null; lastAppointmentSyncDate: string | null } | null
}

export type SchedulingAvailabilityQueryVariables = Exact<{
  locationId: string
}>

export type SchedulingAvailabilityQuery = {
  location: { id: string; availabilityMode: string | null; kollaConsumerId: string | null } | null
  providers: {
    hits: Array<{
      id: string
      displayName: string
      resourceName: string
      vendorId: string
      deactivated: boolean | null
      kollaConsumerId: string
      hasProfilePicture: boolean | null
      priority: number | null
      isPrimary: boolean | null
      pmsDisplayName: string | null
      pmsShortDisplayName: string | null
      taxonomy: string | null
      workspaceId: string
      orgId: string
    }>
  }
  appointmentTypes: {
    hits: Array<{
      id: string
      name: string
      displayName: string
      vendorId: string
      appointmentLength: number
      activeScheduler: boolean | null
      patientType: string | null
    }>
  }
}

export type SchedulingLocationQueryVariables = Exact<{
  locationId: string
}>

export type SchedulingLocationQuery = {
  location: { id: string; name: string; isSchedulerLive: boolean | null; products: Array<string> | null } | null
}

export type ToggleSchedulerLiveMutationVariables = Exact<{
  id: string
  input: UpdateLocationInput
}>

export type ToggleSchedulerLiveMutation = { updateLocation: { id: string; isSchedulerLive: boolean | null } }

export type SchedulingSettingsQueryVariables = Exact<{
  locationId: string
}>

export type SchedulingSettingsQuery = {
  schedulingConfiguration: {
    id: string
    locationId: string
    allowDoubleBooking: boolean | null
    insurancesAccepted: Array<string> | null
    insurancesRejected: Array<string> | null
    isStateInsuranceAccepted: boolean | null
    granularity: number
    leadOverrideEnabled: boolean | null
    customQuestions: Array<{
      id: string
      fieldName: string
      required: boolean
      fieldType: string
      enabled: boolean
      description: string | null
      marketingConsent: boolean | null
      optIn: boolean | null
    }> | null
    leadOverrideConfig: { amount: number; unit: string } | null
  } | null
}

export type UpdateSchedulingConfigurationMutationVariables = Exact<{
  locationId: string
  input: UpdateSchedulingConfigurationInput
}>

export type UpdateSchedulingConfigurationMutation = {
  updateSchedulingConfiguration: {
    id: string
    locationId: string
    allowDoubleBooking: boolean | null
    insurancesAccepted: Array<string> | null
    insurancesRejected: Array<string> | null
    isStateInsuranceAccepted: boolean | null
    granularity: number
    leadOverrideEnabled: boolean | null
    customQuestions: Array<{
      id: string
      fieldName: string
      required: boolean
      fieldType: string
      enabled: boolean
      description: string | null
      marketingConsent: boolean | null
      optIn: boolean | null
    }> | null
    leadOverrideConfig: { amount: number; unit: string } | null
  }
}

export type CreateAvailabilityMutationVariables = Exact<{
  input: CreateAvailabilityInput
}>

export type CreateAvailabilityMutation = {
  createAvailability: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    kollaConsumerId: string
    providerId: string
    archived: boolean | null
    operatoryId: string | null
    operatoryIds: Array<string> | null
    appointmentTypeIds: Array<string> | null
    backupAvailability: boolean | null
  }
}

export type UpdateAvailabilityMutationVariables = Exact<{
  id: string
  input: UpdateAvailabilityInput
}>

export type UpdateAvailabilityMutation = {
  updateAvailability: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    kollaConsumerId: string
    providerId: string
    archived: boolean | null
    operatoryId: string | null
    operatoryIds: Array<string> | null
    appointmentTypeIds: Array<string> | null
    backupAvailability: boolean | null
  }
}

export type ProviderAvailabilitiesQueryVariables = Exact<{
  providerId: string
}>

export type ProviderAvailabilitiesQuery = {
  providerAvailabilities: Array<{
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    kollaConsumerId: string
    providerId: string
    archived: boolean | null
    operatoryId: string | null
    operatoryIds: Array<string> | null
    appointmentTypeIds: Array<string> | null
    backupAvailability: boolean | null
    createdDate: string | null
    updatedDate: string | null
    timeSlots: {
      sunday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      monday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      tuesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      wednesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      thursday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      friday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      saturday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
    } | null
  }>
}

export type DeleteProviderAvailabilityMutationVariables = Exact<{
  id: string
}>

export type DeleteProviderAvailabilityMutation = { deleteProviderAvailability: boolean }

export type CallsModalStaffCallActivitiesQueryVariables = Exact<{
  dateRange: DateRangeInput
  bucket: string
  staffId?: string | null | undefined
  staffName?: string | null | undefined
  locationId?: string | null | undefined
  channel?: string | null | undefined
  locationIds?: Array<string> | string | null | undefined
  filters?: string | null | undefined
  query?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type CallsModalStaffCallActivitiesQuery = {
  staffCallActivities: {
    total: number
    hits: Array<{
      id: string
      type: string
      subType: string | null
      activityDate: string | null
      contactName: string | null
      locationId: string
      vendor: string | null
      phoneFromActivity: string | null
      channel: string | null
      utmSource: string | null
      utmMedium: string | null
      utmKeywords: string | null
      utmContent: string | null
      utmCampaign: string | null
      gclid: string | null
      referringUrl: string | null
      tags: Array<string> | null
      workspaceId: string
      contacts: Array<{ id: string; name: string | null; phone: string | null }> | null
    }>
  }
}

export type CreateScorecardMutationVariables = Exact<{
  input: CreateScorecardInput
}>

export type CreateScorecardMutation = { createScorecard: { id: string } }

export type UpdateScorecardMutationVariables = Exact<{
  id: string
  input: UpdateScorecardInput
}>

export type UpdateScorecardMutation = { updateScorecard: { id: string } }

export type ScorecardMetricsQueryVariables = Exact<{
  dateRange: string
  grouping: string
  locations?: Array<string> | string | null | undefined
  staff?: Array<string> | string | null | undefined
  lookbackType?: string | null | undefined
  lookbackAmount?: number | null | undefined
}>

export type ScorecardMetricsQuery = {
  scorecardMetrics: Array<{
    bucket: string
    period: string | null
    leads: number
    MQLs: number
    appointments: number
    patients: number
    production: number
    scheduledProduction: number
    budget: number
    totalSpend: number
    ROI: number
    CPL: number
    CPQL: number
    CPA: number
    CAC: number
    scheduleRate: number
    leadsNeedsAction: number
    leadsInProgress: number
    leadsScheduled: number
    leadsClosedWon: number
    leadsClosedLost: number
    subRows: Array<{
      bucket: string
      period: string | null
      leads: number
      MQLs: number
      appointments: number
      patients: number
      production: number
      scheduledProduction: number
      budget: number
      totalSpend: number
      ROI: number
      CPL: number
      CPQL: number
      CPA: number
      CAC: number
      scheduleRate: number
      leadsNeedsAction: number
      leadsInProgress: number
      leadsScheduled: number
      leadsClosedWon: number
      leadsClosedLost: number
    }> | null
  }>
}

export type SendingDomainsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type SendingDomainsQuery = {
  sendingDomains: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      domain: string
      type: string
      status: string
      createdDate: string
      updatedDate: string
      dnsRecords: Array<{ type: string; name: string; value: string; found: boolean | null }> | null
    }>
  }
}

export type CreateSendingDomainMutationVariables = Exact<{
  input: CreateSendingDomainInput
}>

export type CreateSendingDomainMutation = {
  createSendingDomain: {
    id: string
    domain: string
    type: string
    status: string
    createdDate: string
    dnsRecords: Array<{ type: string; name: string; value: string; found: boolean | null }> | null
  }
}

export type VerifySendingDomainMutationVariables = Exact<{
  id: string
}>

export type VerifySendingDomainMutation = {
  verifySendingDomain: {
    id: string
    status: string
    updatedDate: string
    dnsRecords: Array<{ type: string; name: string; value: string; found: boolean | null }> | null
  }
}

export type DeleteSendingDomainMutationVariables = Exact<{
  id: string
}>

export type DeleteSendingDomainMutation = { deleteSendingDomain: boolean }

export type SettingsAiAgentLocationSetLiveMutationVariables = Exact<{
  id: string
  input: UpdateLocationInput
}>

export type SettingsAiAgentLocationSetLiveMutation = { updateLocation: { id: string; isAIAgentLive: boolean | null } }

export type PatientIdsByReferralTypeQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type PatientIdsByReferralTypeQuery = { patients: { total: number; hits: Array<{ id: string }> } }

export type ContactCardQueryVariables = Exact<{
  id: string
}>

export type ContactCardQuery = {
  contact: {
    id: string
    name: string
    birthDate: string | null
    becameLeadDate: string | null
    becamePatientDate: string | null
    cellPhone: string | null
    leadStatus: string | null
    lifecycleStage: string | null
    matchTypes: Array<string> | null
    patientStatus: string | null
    tags: Array<string> | null
    workspaceId: string
  }
}

export type LocationKollaConsumerQueryVariables = Exact<{
  id: string
}>

export type LocationKollaConsumerQuery = { location: { id: string; kollaConsumerId: string | null } | null }

export type MonthlyMarketingMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput
  groupBy: string
  channel?: string | null | undefined
  locationIds?: Array<string> | string | null | undefined
  showDisqualified?: boolean | null | undefined
}>

export type MonthlyMarketingMetricsQuery = {
  marketingMetrics: {
    rows: Array<{
      bucket: string
      locationId: string | null
      leads: number
      MQLs: number
      mqls: number
      appointments: number
      patients: number
      budget: number
      production: number
      scheduledProduction: number
      ROI: number
      CPL: number
      CPQL: number
      CPA: number
      CAC: number
      cpls: number
      roi: number
      facebookSpend: number
      googleSpend: number
      targetSpend: number
      leadGoal: number
      iCPL: number
      iCPQL: number
    }>
  }
}

export type NewPatientsMonthlyQueryVariables = Exact<{
  dateRange: DateRangeInput
  locationIds?: Array<string> | string | null | undefined
  channel?: string | null | undefined
}>

export type NewPatientsMonthlyQuery = {
  newPatientsMonthlyBreakdown: Array<{
    bucket: string
    reappointmentPercentage: number
    brokenAppointmentCount: number
    averageTimeToAppointment: number
    averageProductionPerNewPatientVisit: number
    newPatients: number
    scheduledNewPatients: number
  }>
}

export type CreateStaffMutationVariables = Exact<{
  input: CreateStaffInput
}>

export type CreateStaffMutation = {
  createStaff: {
    id: string | null
    name: string | null
    aliases: Array<string> | null
    userId: string | null
    error: string | null
    isDuplicated: boolean | null
  }
}

export type StaffFormUpdateStaffMutationVariables = Exact<{
  id: string
  input: UpdateStaffInput
}>

export type StaffFormUpdateStaffMutation = {
  updateStaff: {
    id: string | null
    name: string | null
    aliases: Array<string> | null
    userId: string | null
    isDuplicated: boolean | null
  }
}

export type StaffFormDeleteStaffMutationVariables = Exact<{
  id: string
}>

export type StaffFormDeleteStaffMutation = { deleteStaff: boolean }

export type StoredCredentialsQueryVariables = Exact<{
  search?: string | null | undefined
}>

export type StoredCredentialsQuery = {
  storedCredentials: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string | null
      label: string
      username: string
      metadata: string | null
      createdBy: string
      updatedBy: string
      createdDate: string
      updatedDate: string
    }>
  }
}

export type StoredCredentialPasswordQueryVariables = Exact<{
  id: string
}>

export type StoredCredentialPasswordQuery = { storedCredentialPassword: { id: string; password: string } }

export type CreateStoredCredentialMutationVariables = Exact<{
  targetWorkspaceId: string
  input: CreateStoredCredentialInput
}>

export type CreateStoredCredentialMutation = {
  createStoredCredential: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string | null
    label: string
    username: string
    metadata: string | null
    createdBy: string
    updatedBy: string
    createdDate: string
    updatedDate: string
  }
}

export type UpdateStoredCredentialMutationVariables = Exact<{
  id: string
  input: UpdateStoredCredentialInput
}>

export type UpdateStoredCredentialMutation = {
  updateStoredCredential: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string | null
    label: string
    username: string
    metadata: string | null
    createdBy: string
    updatedBy: string
    createdDate: string
    updatedDate: string
  }
}

export type DeleteStoredCredentialMutationVariables = Exact<{
  id: string
}>

export type DeleteStoredCredentialMutation = { deleteStoredCredential: boolean }

export type StoredCredentialOpsLocationsQueryVariables = Exact<{
  filter?: LocationFilter | null | undefined
}>

export type StoredCredentialOpsLocationsQuery = {
  opsLocations: { nodes: Array<{ id: string; name: string; workspaceId: string | null }> }
}

export type AssignCellUpdateStaffMutationVariables = Exact<{
  id: string
  input: UpdateStaffInput
}>

export type AssignCellUpdateStaffMutation = {
  updateStaff: { id: string | null; name: string | null; userId: string | null }
}

export type AddTagShadcnTagColorsQueryVariables = Exact<{
  search?: string | null | undefined
}>

export type AddTagShadcnTagColorsQuery = { tagColors: { hits: Array<{ name: string; color: string | null }> } }

export type TaskFieldsFragment = {
  __typename: 'Task'
  contactId: string | null
  createdById: string
  createdDate: string
  description: string | null
  dueDate: string
  id: string
  locationId: string
  ownerId: string | null
  roleId: string | null
  completedByUserId: string | null
  status: string
  title: string
  updatedDate: string
  version: number
  workspaceId: string
} & { ' $fragmentName'?: 'TaskFieldsFragment' }

export type TaskQueryVariables = Exact<{
  id: string
}>

export type TaskQuery = { task: { ' $fragmentRefs'?: { TaskFieldsFragment: TaskFieldsFragment } } }

export type TaskOwnerQueryVariables = Exact<{
  id: string
}>

export type TaskOwnerQuery = { user: { __typename: 'User'; id: string; name: string | null; email: string } | null }

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput
}>

export type CreateTaskMutation = { createTask: { ' $fragmentRefs'?: { TaskFieldsFragment: TaskFieldsFragment } } }

export type UpdateTaskMutationVariables = Exact<{
  id: string
  input: UpdateTaskInput
}>

export type UpdateTaskMutation = { updateTask: { ' $fragmentRefs'?: { TaskFieldsFragment: TaskFieldsFragment } } }

export type DeleteTaskMutationVariables = Exact<{
  id: string
}>

export type DeleteTaskMutation = { deleteTask: boolean }

export type OpsUsageCostMetricsQueryVariables = Exact<{
  input: UsageCostInput
}>

export type OpsUsageCostMetricsQuery = {
  opsUsageCostMetrics: {
    voiceTransferredCalls: number
    avgSmsLatencyMs: number | null
    summary: {
      totalCostUsd: number
      voiceCalls: number
      smsConversations: number
      voiceMinutes: number
      totalTokensInput: number
      totalTokensOutput: number
      avgCostPerVoiceCall: number
      avgCostPerSmsConversation: number
      telephonyCostUsd: number
      elevenLabsLlmUsd: number
      elevenLabsPlatformUsd: number
      elevenLabsTotalUsd: number
      smsLlmCostUsd: number
      smsCarrierCostUsd: number
    }
    buckets: Array<{
      date: string
      voiceCalls: number
      smsConversations: number
      voiceCostUsd: number
      smsCostUsd: number
      voiceMinutes: number
      tokensInput: number
      tokensOutput: number
    }>
    locations: Array<{
      locationId: string
      locationName: string | null
      workspaceName: string | null
      voiceCalls: number
      smsConversations: number
      totalCostUsd: number
      voiceCostUsd: number
      smsCostUsd: number
      avgCostPerInteraction: number
    }>
    voiceOutcomes: Array<{ key: string; count: number }>
    smsToolCalls: Array<{ key: string; count: number }>
  }
}

export type OpsUsageCostVoiceCallsQueryVariables = Exact<{
  input: UsageCostDetailInput
  sort?: SortInput | null | undefined
}>

export type OpsUsageCostVoiceCallsQuery = {
  opsUsageCostVoiceCalls: {
    total: number
    page: number
    hits: Array<{
      callId: string
      callDate: string | null
      callerPhone: string | null
      status: string | null
      transferred: boolean
      durationSeconds: number
      telephonyCostUsd: number
      elevenLabsAsrUsd: number
      elevenLabsTtsUsd: number
      elevenLabsLlmUsd: number
      elevenLabsPlatformUsd: number
      elevenLabsTotalUsd: number
      llmInputTokens: number
      llmOutputTokens: number
      totalCostUsd: number
    }>
  }
}

export type OpsUsageCostSmsThreadsQueryVariables = Exact<{
  input: UsageCostDetailInput
}>

export type OpsUsageCostSmsThreadsQuery = {
  opsUsageCostSmsThreads: {
    total: number
    page: number
    hits: Array<{
      threadId: string
      contactId: string | null
      turns: number
      firstTurnDate: string | null
      lastTurnDate: string | null
      tokensInput: number
      tokensOutput: number
      llmCostUsd: number
      carrierCostUsd: number
      totalCostUsd: number
      avgLatencyMs: number | null
    }>
  }
}

export type UserActivityQueryVariables = Exact<{
  userId: string
}>

export type UserActivityQuery = {
  userActivity: { activities: Array<{ action: string; dateTime: string; email: string; role: string }> }
}

export type ImpersonateUserMutationVariables = Exact<{
  userId: string
}>

export type ImpersonateUserMutation = { impersonateUser: { accessToken: string } }

export type CreateUserFromDetailsMutationVariables = Exact<{
  input: CreateUserInput
}>

export type CreateUserFromDetailsMutation = { createUser: { id: string } }

export type UpdateUserFromDetailsMutationVariables = Exact<{
  id: string
  input: UpdateUserInput
}>

export type UpdateUserFromDetailsMutation = { updateUser: { id: string } }

export type OpsSetUserTypeMutationVariables = Exact<{
  userId: string
  type: string
}>

export type OpsSetUserTypeMutation = { opsSetUserType: { id: string; type: string } }

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput
}>

export type CreateUserMutation = { createUser: { id: string } }

export type CreateWorkspaceInviteMutationVariables = Exact<{
  input: CreateWorkspaceInviteInput
}>

export type CreateWorkspaceInviteMutation = { createWorkspaceInvite: { id: string } }

export type UserNotificationSettingsQueryVariables = Exact<{
  userId: string
}>

export type UserNotificationSettingsQuery = {
  userNotificationSettings: {
    phoneCalls: {
      enabled: boolean | null
      canceledAppointment: { email: boolean | null; app: boolean | null } | null
      allUnscheduledCalls: { email: boolean | null; app: boolean | null } | null
      newPatientUnscheduledCalls: { email: boolean | null; app: boolean | null } | null
      callbackRequested: { email: boolean | null; app: boolean | null } | null
      missedCalls: { email: boolean | null; app: boolean | null } | null
      voicemail: { email: boolean | null; app: boolean | null } | null
      incomingCall: { popup: boolean | null; sound: boolean | null } | null
    } | null
    aiAgent: {
      enabled: boolean | null
      newAIAgentCall: { email: boolean | null; app: boolean | null } | null
      emergencyAppointmentRequest: { email: boolean | null; app: boolean | null } | null
      newAppointmentBooked: { email: boolean | null; app: boolean | null } | null
    } | null
    textMessages: {
      enabled: boolean | null
      newTextMessage: {
        email: boolean | null
        app: boolean | null
        popup: boolean | null
        sound: boolean | null
      } | null
    } | null
    formSubmissions: {
      enabled: boolean | null
      newFormSubmission: { email: boolean | null; app: boolean | null } | null
    } | null
    scheduler: {
      enabled: boolean | null
      newAppointmentBooked: { email: boolean | null; app: boolean | null } | null
    } | null
    pmsData: {
      enabled: boolean | null
      noPatientLinkedOnScheduledContact: { email: boolean | null; app: boolean | null } | null
      noAppointmentFoundOnScheduledContact: { email: boolean | null; app: boolean | null } | null
      brokenAppointment: { email: boolean | null; app: boolean | null } | null
    } | null
    workflowPaused: { enabled: boolean | null; email: boolean | null; app: boolean | null } | null
  } | null
}

export type UpdateUserNotificationSettingsMutationVariables = Exact<{
  userId: string
  input: UserNotificationSettingsInput
}>

export type UpdateUserNotificationSettingsMutation = { updateUserNotificationSettings: { success: boolean | null } }

export type GetSuperNotificationsQueryVariables = Exact<{ [key: string]: never }>

export type GetSuperNotificationsQuery = {
  getSuperNotifications: {
    enabled: boolean
    toolError: boolean
    toolTimeout: boolean
    toolDuplicate: boolean
    noCallsIn48h: boolean
    agentChangesEnabled: boolean
    agentChangeOffers: boolean
    agentChangeServices: boolean
    agentChangeBusinessDetails: boolean
    agentChangeAppointmentTypes: boolean
    agentChangeInsurance: boolean
  }
}

export type UpdateSuperNotificationsMutationVariables = Exact<{
  input: SuperNotificationSettingsInput
}>

export type UpdateSuperNotificationsMutation = {
  updateSuperNotifications: {
    enabled: boolean
    toolError: boolean
    toolTimeout: boolean
    toolDuplicate: boolean
    noCallsIn48h: boolean
    agentChangesEnabled: boolean
    agentChangeOffers: boolean
    agentChangeServices: boolean
    agentChangeBusinessDetails: boolean
    agentChangeAppointmentTypes: boolean
    agentChangeInsurance: boolean
  }
}

export type WorkspaceSmsConsentQueryVariables = Exact<{
  id: string
}>

export type WorkspaceSmsConsentQuery = {
  workspace: { id: string; name: string; marketingConsentConfirmedDate: string | null }
}

export type ConfirmMarketingConsentMutationVariables = Exact<{ [key: string]: never }>

export type ConfirmMarketingConsentMutation = {
  confirmMarketingConsent: {
    id: string
    marketingConsentConfirmedDate: string | null
    marketingConsentConfirmedByUserId: string | null
  }
}

export type WorkflowDateTriggerFieldsQueryVariables = Exact<{
  sourceType?: string | null | undefined
}>

export type WorkflowDateTriggerFieldsQuery = {
  workflowDateTriggerFields: Array<{ sourceType: string; attribute: string; storage: string }>
}

export type SmsAgentReadyQueryVariables = Exact<{
  locationId: string
}>

export type SmsAgentReadyQuery = { smsAgentReady: boolean }

export type ThreadAgentStateQueryVariables = Exact<{
  id: string
}>

export type ThreadAgentStateQuery = { thread: { id: string; aiEnabled: boolean | null } }

export type ContactThreadIdsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ContactThreadIdsQuery = {
  messages: { hits: Array<{ id: string; contactId: string | null; threadId: string | null }> }
}

export type ThreadsAgentStateQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type ThreadsAgentStateQuery = { threads: { hits: Array<{ id: string; aiEnabled: boolean | null }> } }

export type BlockoutNotesQueryVariables = Exact<{
  locationId: string
}>

export type BlockoutNotesQuery = { blockoutNotes: Array<{ note: string }> }

export type InboxLocationsQueryVariables = Exact<{
  pagination?: PaginationInput | null | undefined
}>

export type InboxLocationsQuery = {
  locations: { hits: Array<{ id: string; name: string; products: Array<string> | null }> }
}

export type ListMembersQueryVariables = Exact<{
  listId: string
  stageId?: string | null | undefined
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ListMembersQuery = {
  listMembers: {
    total: number
    page: number
    members: Array<{ type: string; entityId: string; stageId: string | null }>
  }
}

export type ListStageCountsQueryVariables = Exact<{
  listId: string
  search?: string | null | undefined
}>

export type ListStageCountsQuery = { listStageCounts: Array<{ stageId: string; count: number }> }

export type CreateListItemMutationVariables = Exact<{
  input: CreateListItemInput
}>

export type CreateListItemMutation = {
  createListItem: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    listId: string
    entityId: string
    stageId: string | null
    version: number
    createdDate: string
    updatedDate: string
  }
}

export type UpdateListItemMutationVariables = Exact<{
  id: string
  input: UpdateListItemInput
}>

export type UpdateListItemMutation = {
  updateListItem: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    listId: string
    entityId: string
    stageId: string | null
    version: number
    createdDate: string
    updatedDate: string
  }
}

export type DeleteListItemMutationVariables = Exact<{
  id: string
}>

export type DeleteListItemMutation = { deleteListItem: boolean }

export type ListItemsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type ListItemsQuery = {
  listItems: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      listId: string
      entityId: string
      stageId: string | null
      version: number
      createdDate: string
      updatedDate: string
    }>
  }
}

export type SidebarListsQueryVariables = Exact<{ [key: string]: never }>

export type SidebarListsQuery = {
  lists: Array<{
    id: string
    entityType: string
    system: boolean | null
    join: string | null
    filters: Array<{
      attribute: string
      secondaryAttribute: string | null
      displayName: string | null
      operator: string
      value: Record<string, unknown> | null
      secondaryValue: Array<string> | null
      static: boolean | null
      uniqOperator: string | null
      readOnly: boolean | null
      nonEmpty: boolean | null
      useAsterisk: boolean | null
      group: string | null
      subQuery: string | null
      type: string | null
      defaultValue: Record<string, unknown> | null
      dateOperator: string | null
      includeToday: boolean | null
      includeYesterday: boolean | null
      includeWeeks: boolean | null
      limitToMonth: boolean | null
      includeInThePast: boolean | null
      options: Record<string, unknown> | null
    }> | null
  }>
}

export type SystemListQueryVariables = Exact<{
  id: string
}>

export type SystemListQuery = {
  list: {
    id: string
    orgId: string
    workspaceId: string
    name: string
    entityType: string
    defaultStageId: string | null
    join: string | null
    system: boolean | null
    version: number
    createdDate: string
    updatedDate: string
    stages: Array<{ id: string; name: string; color: string; system: boolean | null }> | null
    filters: Array<{
      attribute: string
      secondaryAttribute: string | null
      displayName: string | null
      operator: string
      value: Record<string, unknown> | null
      secondaryValue: Array<string> | null
      static: boolean | null
      uniqOperator: string | null
      readOnly: boolean | null
      nonEmpty: boolean | null
      useAsterisk: boolean | null
      group: string | null
      subQuery: string | null
      type: string | null
      defaultValue: Record<string, unknown> | null
      dateOperator: string | null
      includeToday: boolean | null
      includeYesterday: boolean | null
      includeWeeks: boolean | null
      limitToMonth: boolean | null
      includeInThePast: boolean | null
      options: Record<string, unknown> | null
    }> | null
  }
}

export type MarketingContactsModalQueryVariables = Exact<{
  filterBy: string
  fromDate: string
  toDate: string
  locationIds?: Array<string> | string | null | undefined
  channel?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type MarketingContactsModalQuery = {
  marketingContacts: {
    total: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      patientIds: Array<string> | null
      patientName: string | null
      orgId: string
      workspaceId: string
      locationId: string
      name: string
      preferredName: string | null
      homePhone: string | null
      cellPhone: string | null
      workPhone: string | null
      otherPhone: Array<string> | null
      email: string | null
      birthDate: string | null
      addressLine1: string | null
      addressLine2: string | null
      lifecycleStage: string | null
      patientStatus: string | null
      leadStatus: string | null
      isQualified: boolean | null
      appointmentStatus: string | null
      nearestAppointmentDate: string | null
      city: string | null
      state: string | null
      zip: string | null
      becameLeadDate: string | null
      becamePatientDate: string | null
      patientCreatedDate: string | null
      firstAppointmentMadeDate: string | null
      firstAppointmentDate: string | null
      lastAppointmentDate: string | null
      firstTransactionDate: string | null
      lastTransactionDate: string | null
      lastHygieneDate: string | null
      hygieneDueDate: string | null
      isPerio: boolean | null
      tags: Array<string> | null
      matchTypes: Array<string> | null
      collectedLtv: number | null
      productionLtv: number | null
      scheduledProduction: number | null
      unbookedTreatmentValue: number | null
      lastTreatmentPlanDate: string | null
      fvv: number | null
      adClickDate: string | null
      patientReferral: string | null
      lastActivityDate: string | null
      lastCommDate: string | null
      lastCommActivityType: string | null
      lastCommActivitySubType: string | null
      utmSource: string | null
      utmMedium: string | null
      utmCampaign: string | null
      utmKeywords: string | null
      utmContent: string | null
      platform: string | null
      trackableCampaignId: string | null
      channel: string | null
      smsMarketingConsent: boolean | null
      firstContactReason: string | null
      firstActivityType: string | null
      activityTypes: Array<string> | null
      firstActivityDate: string | null
      becameInactiveDate: string | null
      closedLostReason: string | null
      preferredCommunicationMethod: string | null
      preferredContact: string | null
      archived: boolean | null
      neededAction: boolean | null
      reportedAttribution: string | null
      activityCount: number | null
      needsActionDate: string | null
      firstName: string | null
      lastName: string | null
      leadOwner: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
      convertedBy: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
      pipelines: Array<{ id: string; stage: string | null; key: string | null }> | null
    }>
  }
}

export type MarketingContactsTableQueryVariables = Exact<{
  filterBy: string
  fromDate: string
  toDate: string
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
  locationIds?: Array<string> | string | null | undefined
  channel?: string | null | undefined
  rawChannel?: string | null | undefined
  platform?: string | null | undefined
  leadOwnerId?: string | null | undefined
  leadOwnerName?: string | null | undefined
  schedulingActivityType?: string | null | undefined
  firstActivityType?: string | null | undefined
  campaign?: string | null | undefined
  utmSource?: string | null | undefined
  utmMedium?: string | null | undefined
  utmCampaign?: string | null | undefined
  trackableCampaignId?: string | null | undefined
  reportedAttribution?: string | null | undefined
  showDisqualified?: boolean | null | undefined
  hideNonPatients?: boolean | null | undefined
  hideMultiLocationPatients?: boolean | null | undefined
  search?: string | null | undefined
  filters?: string | null | undefined
}>

export type MarketingContactsTableQuery = {
  marketingContacts: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      patientIds: Array<string> | null
      patientName: string | null
      orgId: string
      workspaceId: string
      locationId: string
      name: string
      preferredName: string | null
      homePhone: string | null
      cellPhone: string | null
      workPhone: string | null
      otherPhone: Array<string> | null
      email: string | null
      birthDate: string | null
      addressLine1: string | null
      addressLine2: string | null
      lifecycleStage: string | null
      patientStatus: string | null
      leadStatus: string | null
      isQualified: boolean | null
      appointmentStatus: string | null
      nearestAppointmentDate: string | null
      city: string | null
      state: string | null
      zip: string | null
      becameLeadDate: string | null
      becamePatientDate: string | null
      patientCreatedDate: string | null
      firstAppointmentMadeDate: string | null
      firstAppointmentDate: string | null
      lastAppointmentDate: string | null
      firstTransactionDate: string | null
      lastTransactionDate: string | null
      lastHygieneDate: string | null
      hygieneDueDate: string | null
      isPerio: boolean | null
      tags: Array<string> | null
      matchTypes: Array<string> | null
      collectedLtv: number | null
      productionLtv: number | null
      scheduledProduction: number | null
      unbookedTreatmentValue: number | null
      lastTreatmentPlanDate: string | null
      fvv: number | null
      adClickDate: string | null
      patientReferral: string | null
      lastActivityDate: string | null
      lastCommDate: string | null
      lastCommActivityType: string | null
      lastCommActivitySubType: string | null
      utmSource: string | null
      utmMedium: string | null
      utmCampaign: string | null
      utmKeywords: string | null
      utmContent: string | null
      platform: string | null
      trackableCampaignId: string | null
      channel: string | null
      smsMarketingConsent: boolean | null
      firstContactReason: string | null
      firstActivityType: string | null
      activityTypes: Array<string> | null
      firstActivityDate: string | null
      becameInactiveDate: string | null
      closedLostReason: string | null
      preferredCommunicationMethod: string | null
      preferredContact: string | null
      archived: boolean | null
      neededAction: boolean | null
      reportedAttribution: string | null
      activityCount: number | null
      needsActionDate: string | null
      firstName: string | null
      lastName: string | null
      leadOwner: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
      convertedBy: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
      pipelines: Array<{ id: string; stage: string | null; key: string | null }> | null
    }>
  }
}

export type MarkMessageReadMutationVariables = Exact<{
  id: string
  read: boolean
}>

export type MarkMessageReadMutation = {
  markMessageRead: { id: string; read: boolean | null; archived: boolean | null }
}

export type ArchiveMessageMutationVariables = Exact<{
  id: string
  archived: boolean
}>

export type ArchiveMessageMutation = { archiveMessage: { id: string; read: boolean | null; archived: boolean | null } }

export type LinkMessageToContactMutationVariables = Exact<{
  id: string
  contactId: string
}>

export type LinkMessageToContactMutation = { linkMessageToContact: { id: string; contactId: string | null } }

export type RoleNameQueryVariables = Exact<{
  id: string
}>

export type RoleNameQuery = { role: { id: string; name: string } | null }

export type HeldMessagesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type HeldMessagesQuery = {
  messages: {
    total: number
    page: number
    hits: Array<{
      id: string
      text: string
      sendDate: string | null
      status: string | null
      errorCode: string | null
      contactId: string | null
      threadId: string | null
      to: string
      from: string
      sentByUserId: string | null
      createdDate: string
      read: boolean | null
    }>
  }
}

export type CancelScheduledMessageMutationVariables = Exact<{
  id: string
}>

export type CancelScheduledMessageMutation = {
  cancelScheduledMessage: { id: string; status: string | null; errorCode: string | null; sendDate: string | null }
}

export type AttributionMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput
  groupBy: string
  locationIds?: Array<string> | string | null | undefined
  integrationStatus?: string | null | undefined
  filters?: string | null | undefined
}>

export type AttributionMetricsQuery = {
  marketingMetrics: {
    hits: Array<{
      bucket: string
      leads: number
      mqls: number
      appointments: number
      patients: number
      production: number
      scheduledProduction: number
      googleSpend: number
      facebookSpend: number
      roi: number
      budget: number
      byChannel: Array<{ channel: string }> | null
    }>
    summary: {
      leads: number
      mqls: number
      appointments: number
      patients: number
      production: number
      scheduledProduction: number
    }
  }
}

export type AttributionAdCampaignsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type AttributionAdCampaignsQuery = { campaigns: { hits: Array<{ id: string; name: string }> } }

export type AttributionDaysQueryVariables = Exact<{
  dateRange: DateRangeInput
  locationIds?: Array<string> | string | null | undefined
  integrationStatus?: string | null | undefined
  filters?: string | null | undefined
}>

export type AttributionDaysQuery = {
  marketingMetrics: {
    hits: Array<{
      bucket: string
      leads: number
      mqls: number
      appointments: number
      patients: number
      byChannel: Array<{ channel: string; leads: number; mqls: number; appointments: number; patients: number }> | null
    }>
  }
}

export type FeatureToggleOverrideUserQueryVariables = Exact<{
  id: string
}>

export type FeatureToggleOverrideUserQuery = { user: { id: string; email: string } | null }

export type LiveAlertPreferencesQueryVariables = Exact<{
  userId: string
}>

export type LiveAlertPreferencesQuery = {
  userNotificationSettings: {
    textMessages: { newTextMessage: { popup: boolean | null; sound: boolean | null } | null } | null
    phoneCalls: { incomingCall: { popup: boolean | null; sound: boolean | null } | null } | null
  } | null
}

export type LocationMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput
  compareRange?: DateRangeInput | null | undefined
  groupBy: string
  channel?: string | null | undefined
  channelOp?: string | null | undefined
  query?: string | null | undefined
  locationIds?: Array<string> | string | null | undefined
  integrationStatus?: string | null | undefined
  filters?: string | null | undefined
  platform?: string | null | undefined
  showDisqualified?: boolean | null | undefined
  hideMultiLocationPatients?: boolean | null | undefined
}>

export type LocationMetricsQuery = {
  marketingMetrics: {
    total: number
    hits: Array<{
      locationId: string | null
      bucket: string
      leads: number
      MQLs: number
      mqls: number
      appointments: number
      patients: number
      budget: number
      production: number
      scheduledProduction: number
      ROI: number
      CPL: number
      CPQL: number
      CPA: number
      CAC: number
      qualified: number
      disqualified: number
      scheduled: number
      closedWon: number
      closedLost: number
      leadsClosedWon: number
      leadsNeedsAction: number
      leadsScheduled: number
      leadsInProgress: number
      leadsClosedLost: number
      cpls: number
      roi: number
      facebookSpend: number
      googleSpend: number
      targetSpend: number
      leadGoal: number
      patientGoal: number
      iCPL: number
      iCPQL: number
      scheduleRate: number
    }>
    summary: {
      leads: number
      MQLs: number
      mqls: number
      appointments: number
      patients: number
      budget: number
      facebookSpend: number
      googleSpend: number
      production: number
      scheduledProduction: number
      ROI: number
      CPL: number
      CPQL: number
      CPA: number
      CAC: number
      qualified: number
      disqualified: number
      scheduled: number
      closedWon: number
      closedLost: number
      leadsClosedWon: number
      leadsNeedsAction: number
      leadsScheduled: number
      leadsInProgress: number
      leadsClosedLost: number
      leadsByFirstActivityType: Array<{
        type: string
        leads: number
        mqls: number
        appointments: number
        patients: number
      }> | null
    }
    compareTo: {
      leads: number
      MQLs: number
      mqls: number
      appointments: number
      patients: number
      budget: number
      facebookSpend: number
      googleSpend: number
      production: number
      scheduledProduction: number
      ROI: number
      CPL: number
      CPQL: number
      CPA: number
      CAC: number
      qualified: number
      disqualified: number
      scheduled: number
      closedWon: number
      closedLost: number
      leadsClosedWon: number
      leadsNeedsAction: number
      leadsScheduled: number
      leadsInProgress: number
      leadsClosedLost: number
      leadsByFirstActivityType: Array<{
        type: string
        leads: number
        mqls: number
        appointments: number
        patients: number
      }> | null
    } | null
  }
}

export type LocationOptOutsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type LocationOptOutsQuery = {
  optOuts: { total: number; hits: Array<{ id: string; key: string; createdDate: string }> }
}

export type LocationTimezoneQueryVariables = Exact<{
  id: string
}>

export type LocationTimezoneQuery = { location: { id: string; timezone: string | null } | null }

export type PipelineCommContextQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type PipelineCommContextQuery = {
  messages: {
    hits: Array<{
      contactId: string | null
      channel: string
      sentByUserId: string | null
      isAgent: boolean | null
      createdDate: string
      read: boolean | null
    }>
  }
}

export type PipelineTaskCountsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type PipelineTaskCountsQuery = {
  tasks: { hits: Array<{ contactId: string | null; status: string; dueDate: string }> }
}

export type PipelinesQueryVariables = Exact<{ [key: string]: never }>

export type PipelinesQuery = {
  pipelines: Array<{
    id: string
    name: string
    orgId: string
    workspaceId: string
    stages: Array<{ name: string; color: string; order: number }> | null
  }>
}

export type SidebarCountsQueryVariables = Exact<{
  activeLeadsSearch?: string | null | undefined
  activitiesSearch?: string | null | undefined
  scheduledLeadsSearch?: string | null | undefined
  closedLostLeadsSearch?: string | null | undefined
  dueForHygieneSearch?: string | null | undefined
  dueIn30DaysSearch?: string | null | undefined
  openTasksSearch?: string | null | undefined
  myTasksSearch?: string | null | undefined
  allTasksSearch?: string | null | undefined
}>

export type SidebarCountsQuery = {
  allContacts: { total: number }
  allActivities: { total: number }
  activeLeads: { total: number }
  scheduledLeads: { total: number }
  closedLostLeads: { total: number }
  dueForHygiene: { total: number }
  dueIn30Days: { total: number }
  openTasks: { total: number }
  myTasks: { total: number }
  allTasks: { total: number }
  allWorkspaces: { total: number }
  allLocations: { total: number }
}

export type UnreadInboxMessagesQueryVariables = Exact<{ [key: string]: never }>

export type UnreadInboxMessagesQuery = {
  messages: { hits: Array<{ threadId: string | null; locationId: string; from: string }> }
}

export type ContactSidebarCustomPagesQueryVariables = Exact<{ [key: string]: never }>

export type ContactSidebarCustomPagesQuery = {
  customPages: {
    hits: Array<{
      id: string
      orgId: string
      userId: string
      name: string
      page: string
      join: string
      filters: Array<{
        attribute: string
        secondaryAttribute: string | null
        displayName: string | null
        operator: string
        value: Record<string, unknown> | null
        secondaryValue: Array<string> | null
        static: boolean | null
        uniqOperator: string | null
        readOnly: boolean | null
        nonEmpty: boolean | null
        useAsterisk: boolean | null
        group: string | null
        subQuery: string | null
        type: string | null
        defaultValue: Record<string, unknown> | null
        dateOperator: string | null
        includeToday: boolean | null
        includeYesterday: boolean | null
        includeWeeks: boolean | null
        limitToMonth: boolean | null
        includeInThePast: boolean | null
        options: Record<string, unknown> | null
      }> | null
    }>
  }
}

export type ActivitySidebarCustomPagesQueryVariables = Exact<{ [key: string]: never }>

export type ActivitySidebarCustomPagesQuery = {
  customPages: {
    hits: Array<{
      id: string
      orgId: string
      userId: string
      name: string
      page: string
      join: string
      filters: Array<{
        attribute: string
        secondaryAttribute: string | null
        displayName: string | null
        operator: string
        value: Record<string, unknown> | null
        secondaryValue: Array<string> | null
        static: boolean | null
        uniqOperator: string | null
        readOnly: boolean | null
        nonEmpty: boolean | null
        useAsterisk: boolean | null
        group: string | null
        subQuery: string | null
        type: string | null
        defaultValue: Record<string, unknown> | null
        dateOperator: string | null
        includeToday: boolean | null
        includeYesterday: boolean | null
        includeWeeks: boolean | null
        limitToMonth: boolean | null
        includeInThePast: boolean | null
        options: Record<string, unknown> | null
      }> | null
    }>
  }
}

export type TaskSidebarCustomPagesQueryVariables = Exact<{ [key: string]: never }>

export type TaskSidebarCustomPagesQuery = {
  customPages: {
    hits: Array<{
      id: string
      orgId: string
      userId: string
      name: string
      page: string
      join: string
      filters: Array<{
        attribute: string
        secondaryAttribute: string | null
        displayName: string | null
        operator: string
        value: Record<string, unknown> | null
        secondaryValue: Array<string> | null
        static: boolean | null
        uniqOperator: string | null
        readOnly: boolean | null
        nonEmpty: boolean | null
        useAsterisk: boolean | null
        group: string | null
        subQuery: string | null
        type: string | null
        defaultValue: Record<string, unknown> | null
        dateOperator: string | null
        includeToday: boolean | null
        includeYesterday: boolean | null
        includeWeeks: boolean | null
        limitToMonth: boolean | null
        includeInThePast: boolean | null
        options: Record<string, unknown> | null
      }> | null
    }>
  }
}

export type SidebarPipelinesQueryVariables = Exact<{ [key: string]: never }>

export type SidebarPipelinesQuery = { pipelines: Array<{ id: string; name: string }> }

export type QualifiedLeadCountsQueryVariables = Exact<{
  dateRange: DateRangeInput
  locationIds?: Array<string> | string | null | undefined
  channel?: string | null | undefined
  integrationStatus?: string | null | undefined
  filters?: string | null | undefined
  platform?: string | null | undefined
}>

export type QualifiedLeadCountsQuery = {
  qualifiedLeadCounts: {
    total: number
    qualified: number
    disqualified: number
    staffConversionMetrics: Array<{
      userId: string
      userName: string
      leads: number
      qualified: number
      disqualified: number
    }>
  }
}

export type AddActivityTagsMutationVariables = Exact<{
  id: string
  tags: Array<string> | string
}>

export type AddActivityTagsMutation = { addActivityTags: { id: string; tags: Array<string> | null } }

export type RemoveActivityTagsMutationVariables = Exact<{
  id: string
  tags: Array<string> | string
}>

export type RemoveActivityTagsMutation = { removeActivityTags: { id: string; tags: Array<string> | null } }

export type AddContactTagsMutationVariables = Exact<{
  id: string
  tags: Array<string> | string
}>

export type AddContactTagsMutation = { addTags: { id: string; tags: Array<string> | null } }

export type RemoveContactTagsMutationVariables = Exact<{
  id: string
  tags: Array<string> | string
}>

export type RemoveContactTagsMutation = { removeTags: { id: string; tags: Array<string> | null } }

export type ActivityTagsQueryVariables = Exact<{
  id: string
}>

export type ActivityTagsQuery = { activity: { id: string; tags: Array<string> | null } }

export type ContactTagsQueryVariables = Exact<{
  id: string
}>

export type ContactTagsQuery = { contact: { id: string; tags: Array<string> | null } }

export type UpdateTagsCreateTagColorMutationVariables = Exact<{
  input: CreateTagColorInput
}>

export type UpdateTagsCreateTagColorMutation = { createTagColor: { id: string } }

export type AddWorkspaceOrgTagMutationVariables = Exact<{
  id: string
  tag: string
}>

export type AddWorkspaceOrgTagMutation = { addWorkspaceOrgTag: { id: string; orgTags: Array<string> | null } }

export type RemoveWorkspaceOrgTagMutationVariables = Exact<{
  id: string
  tag: string
}>

export type RemoveWorkspaceOrgTagMutation = { removeWorkspaceOrgTag: { id: string; orgTags: Array<string> | null } }

export type PipelinesForFilterQueryVariables = Exact<{ [key: string]: never }>

export type PipelinesForFilterQuery = {
  pipelines: Array<{
    id: string
    name: string
    orgId: string
    workspaceId: string
    stages: Array<{ name: string; color: string; order: number }> | null
  }>
}

export type TagColorsFilterQueryVariables = Exact<{
  search?: string | null | undefined
}>

export type TagColorsFilterQuery = { tagColors: { hits: Array<{ name: string }> } }

export type TagValuesQueryVariables = Exact<{
  entity: string
  search?: string | null | undefined
}>

export type TagValuesQuery = { tagValues: Array<string> }

export type InboxMessagesWithArchivedQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type InboxMessagesWithArchivedQuery = {
  messages: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      threadId: string | null
      from: string
      to: string
      callerId: string | null
      sentByUserId: string | null
      isAgent: boolean | null
      aiWorkflowId: string | null
      aiWorkflowName: string | null
      isInitialMessage: boolean | null
      contactId: string | null
      channel: string
      subject: string | null
      htmlBody: string | null
      text: string
      read: boolean | null
      archived: boolean | null
      createdDate: string
      updatedDate: string
      status: string | null
      providerMessageId: string | null
      errorCode: string | null
      errorMessage: string | null
      attachments: Array<{ filename: string; contentType: string; sizeBytes: number }> | null
    }>
  }
}

export type UnreadOptOutKeysQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type UnreadOptOutKeysQuery = { optOuts: { hits: Array<{ key: string; locationId: string }> } }

export type SetWorkflowCategoryMutationVariables = Exact<{
  id: string
  category: MessageCategory
}>

export type SetWorkflowCategoryMutation = { setWorkflowCategory: { id: string; category: string | null } }

export type WorkflowsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type WorkflowsQuery = {
  workflows: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      orgId: string
      workspaceId: string
      locationId: string | null
      name: string
      active: boolean
      paused: boolean
      pausedReason: string | null
      pausedNodeId: string | null
      pausedDate: string | null
      triggerStartDate: string
      triggerJson: Record<string, unknown>
      nodesJson: Record<string, unknown>
      edgesJson: Record<string, unknown>
      settingsJson: Record<string, unknown> | null
      builderJson: Record<string, unknown> | null
      category: string | null
    }>
  }
}

export type FormActivitiesForPickerQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type FormActivitiesForPickerQuery = {
  activities: { total: number; hits: Array<{ id: string; typeId: string | null }> }
}

export type TriggerSampleActivitiesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type TriggerSampleActivitiesQuery = {
  activities: {
    hits: Array<{
      id: string
      typeId: string | null
      type: string
      subType: string | null
      activityDate: string | null
      contactName: string | null
      contactPhone: string | null
      source: string | null
      vendor: string | null
      channel: string | null
      trackingNumberName: string | null
      tags: Array<string> | null
      contacts: Array<{ id: string; name: string | null }> | null
    }>
  }
}

export type WorkflowQueryVariables = Exact<{
  id: string
}>

export type WorkflowQuery = {
  workflow: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    locationId: string | null
    name: string
    active: boolean
    paused: boolean
    pausedReason: string | null
    pausedNodeId: string | null
    pausedDate: string | null
    triggerStartDate: string
    triggerJson: Record<string, unknown>
    nodesJson: Record<string, unknown>
    edgesJson: Record<string, unknown>
    settingsJson: Record<string, unknown> | null
    builderJson: Record<string, unknown> | null
    category: string | null
  }
}

export type CreateWorkflowMutationVariables = Exact<{
  input: CreateWorkflowInput
}>

export type CreateWorkflowMutation = {
  createWorkflow: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    locationId: string | null
    name: string
    active: boolean
    paused: boolean
    pausedReason: string | null
    pausedNodeId: string | null
    pausedDate: string | null
    triggerStartDate: string
    triggerJson: Record<string, unknown>
    nodesJson: Record<string, unknown>
    edgesJson: Record<string, unknown>
    settingsJson: Record<string, unknown> | null
    builderJson: Record<string, unknown> | null
    category: string | null
  }
}

export type UpdateWorkflowMutationVariables = Exact<{
  id: string
  input: UpdateWorkflowInput
}>

export type UpdateWorkflowMutation = {
  updateWorkflow: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    locationId: string | null
    name: string
    active: boolean
    paused: boolean
    pausedReason: string | null
    pausedNodeId: string | null
    pausedDate: string | null
    triggerStartDate: string
    triggerJson: Record<string, unknown>
    nodesJson: Record<string, unknown>
    edgesJson: Record<string, unknown>
    settingsJson: Record<string, unknown> | null
    builderJson: Record<string, unknown> | null
    category: string | null
  }
}

export type DeleteWorkflowMutationVariables = Exact<{
  id: string
}>

export type DeleteWorkflowMutation = { deleteWorkflow: boolean }

export type WorkflowTriggerEventsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type WorkflowTriggerEventsQuery = {
  events: {
    total: number
    hits: Array<{
      id: string
      type: string
      typeId: string
      action: string
      eventDate: string
      createdDate: string
      source: string
      data: Record<string, unknown>
      workflowIds: Array<string>
    }>
  }
}

export type WorkflowEnrollmentEventQueryVariables = Exact<{
  id: string
}>

export type WorkflowEnrollmentEventQuery = {
  event: {
    id: string
    type: string
    typeId: string
    action: string
    eventDate: string
    source: string
    data: Record<string, unknown>
  }
}

export type WorkflowRunsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type WorkflowRunsQuery = {
  workflowRuns: {
    total: number
    page: number
    hits: Array<{
      id: string
      updatedDate: string
      workflowId: string
      contactId: string | null
      activityId: string | null
      status: string
      currentNodeId: string
      resumeAt: string | null
      waitingFor: string | null
      startedAt: string
      exitReason: string | null
      enrollmentEventId: string | null
    }>
  }
}

export type WorkflowStoppedQueryVariables = Exact<{
  id: string
  heldSearch?: string | null | undefined
}>

export type WorkflowStoppedQuery = {
  workflow: {
    id: string
    paused: boolean
    pausedReason: string | null
    pausedNodeId: string | null
    pausedDate: string | null
  }
  workflowRuns: { total: number }
}

export type WorkflowRejectionsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type WorkflowRejectionsQuery = {
  workflowRunEvents: {
    total: number
    hits: Array<{
      id: string
      eventId: string | null
      contactId: string | null
      outputJson: Record<string, unknown> | null
      createdDate: string
    }>
  }
}

export type WorkflowRunEventsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type WorkflowRunEventsQuery = {
  workflowRunEvents: {
    total: number
    page: number
    hits: Array<{
      id: string
      runId: string | null
      nodeId: string
      nodeType: string
      status: string
      timestamp: string
      outputJson: Record<string, unknown> | null
    }>
  }
}

export type CancelWorkflowRunMutationVariables = Exact<{
  id: string
}>

export type CancelWorkflowRunMutation = { cancelWorkflowRun: { id: string; status: string; exitReason: string | null } }

export type TriggerWorkflowOnContactMutationVariables = Exact<{
  workflowId: string
  contactId: string
}>

export type TriggerWorkflowOnContactMutation = {
  triggerWorkflowOnContact: { success: boolean; workflowType: string; workflowId: string; contactId: string }
}

export type WorkflowTestContactsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type WorkflowTestContactsQuery = {
  contacts: { total: number; hits: Array<{ id: string; name: string; cellPhone: string | null }> }
}

export type WorkspaceThrottleQueryVariables = Exact<{
  id: string
}>

export type WorkspaceThrottleQuery = {
  workspace: {
    id: string
    maxOutboundMonthly: number | null
    maxOutboundDaily: number | null
    maxEnrollmentsPerHour: number | null
  }
}

export type WorkflowLocationsQueryVariables = Exact<{
  pagination?: PaginationInput | null | undefined
}>

export type WorkflowLocationsQuery = {
  locations: {
    total: number
    hits: Array<{
      id: string
      name: string
      products: Array<string> | null
      pms: string | null
      pmsIntegrated: boolean
      kollaConsumerId: string | null
      kollaConnectorId: string | null
      callRailCompanyId: string | null
      primaryTrackingNumber: string | null
      timezone: string | null
      openHours: {
        sunday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        monday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        tuesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        wednesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        thursday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        friday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        saturday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      } | null
    }>
  }
}

export type WorkflowLookbackContactsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type WorkflowLookbackContactsQuery = {
  contacts: {
    total: number
    hits: Array<{
      id: string
      name: string
      archived: boolean | null
      pipelines: Array<{ id: string; stage: string | null; key: string | null }> | null
    }>
  }
}

export type WorkflowLookbackAppointmentsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type WorkflowLookbackAppointmentsQuery = {
  appointments: {
    total: number
    hits: Array<{ id: string; type: string | null; status: string | null; date: string | null; time: string | null }>
  }
}

export type PreviewWorkflowTriggerQueryVariables = Exact<{
  trigger: WorkflowTriggerInput
  locationId: string
  windowStart: string
  windowEnd: string
  pagination?: PaginationInput | null | undefined
}>

export type PreviewWorkflowTriggerQuery = {
  previewWorkflowTrigger: {
    total: number
    page: number
    examinedCount: number
    eventHistoryStart: string
    matches: Array<{
      sourceType: string
      sourceId: string
      eventId: string | null
      contactId: string | null
      date: string
      conditionValues: Record<string, unknown>
      reconstructedFromRecord: boolean
    }>
    conditionRejections: Array<{
      attribute: string
      operator: string
      value: Record<string, unknown> | null
      rejectedCount: number
    }>
  }
}

export type UpdateMeMutationVariables = Exact<{
  input: UpdateUserInput
}>

export type UpdateMeMutation = { updateMe: { id: string } }

export type DeleteTagColorMutationVariables = Exact<{
  id: string
}>

export type DeleteTagColorMutation = { deleteTagColor: boolean }

export type SettingsCreateTagColorMutationVariables = Exact<{
  input: CreateTagColorInput
}>

export type SettingsCreateTagColorMutation = {
  createTagColor: { id: string; name: string; color: string | null; entity: string }
}

export type UpdateTagColorMutationVariables = Exact<{
  id: string
  color: string
}>

export type UpdateTagColorMutation = { updateTagColor: { id: string; name: string; color: string | null } }

export type AiAgentConfigurationsQueryVariables = Exact<{
  search?: string | null | undefined
  locationId?: string | null | undefined
}>

export type AiAgentConfigurationsQuery = {
  aiAgentConfigurations: Array<{
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    agentName: string | null
    agentVoiceId: string | null
    greeting: string | null
    businessName: string | null
    businessAddress: string | null
    emergencyApptId: string | null
    generalApptId: string | null
    smsConfirmationEnabled: boolean | null
    postBookingMessage: string | null
    hygienePostBookingMessage: string | null
    consultApptId: string | null
    limitedExamApptId: string | null
    voiceAgentAddendum: string | null
    cleaningRequiresInitialExam: boolean | null
    pediatricOnly: boolean | null
    voiceAgentTools: Array<string> | null
    services: Array<{
      name: string
      lowPrice: number | null
      highPrice: number | null
      consultRequired: boolean
      consultPrice: number | null
    }> | null
    servicesNotOffered: Array<{
      name: string
      lowPrice: number | null
      highPrice: number | null
      consultRequired: boolean
      consultPrice: number | null
    }> | null
    offers: Array<{
      name: string
      patientStatus: string | null
      eligibleInsurance: string
      onlyEmergencyEligible: boolean
    }> | null
  }>
}

export type ActivitiesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ActivitiesQuery = {
  activities: {
    total: number
    page: number
    hits: Array<{
      activityDate: string | null
      archived: boolean | null
      channel: string | null
      contactName: string | null
      contactPhone: string | null
      createdDate: string
      data: Record<string, unknown> | null
      description: string | null
      fbclid: string | null
      gclid: string | null
      id: string
      isQualified: boolean | null
      locationId: string
      nameFromActivity: string | null
      needsReview: boolean | null
      note: string | null
      orgId: string
      phoneFromActivity: string | null
      referringUrl: string | null
      source: string | null
      subType: string | null
      tags: Array<string> | null
      trackingNumber: string | null
      trackingNumberName: string | null
      type: string
      typeId: string | null
      updatedDate: string
      utmCampaign: string | null
      utmContent: string | null
      utmKeywords: string | null
      utmMedium: string | null
      utmSource: string | null
      vendor: string | null
      version: number
      workspaceId: string
      contacts: Array<{
        id: string
        lifecycleStage: string | null
        locationId: string | null
        name: string | null
        peopleIndex: number | null
        phone: string | null
      }> | null
      owner: { id: string | null; name: string; userId: string | null } | null
    }>
  }
}

export type ActivityQueryVariables = Exact<{
  id: string
}>

export type ActivityQuery = {
  activity: {
    activityDate: string | null
    archived: boolean | null
    channel: string | null
    contactName: string | null
    contactPhone: string | null
    createdDate: string
    data: Record<string, unknown> | null
    description: string | null
    fbclid: string | null
    gclid: string | null
    id: string
    isQualified: boolean | null
    locationId: string
    nameFromActivity: string | null
    needsReview: boolean | null
    note: string | null
    orgId: string
    phoneFromActivity: string | null
    referringUrl: string | null
    source: string | null
    subType: string | null
    tags: Array<string> | null
    trackingNumber: string | null
    trackingNumberName: string | null
    type: string
    typeId: string | null
    updatedDate: string
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    vendor: string | null
    version: number
    workspaceId: string
    contacts: Array<{
      id: string
      lifecycleStage: string | null
      locationId: string | null
      name: string | null
      peopleIndex: number | null
      phone: string | null
    }> | null
    owner: { id: string | null; name: string; userId: string | null } | null
  }
}

export type DeleteActivityMutationVariables = Exact<{
  id: string
}>

export type DeleteActivityMutation = { deleteActivity: boolean }

export type UpdateNoteMutationVariables = Exact<{
  id: string
  input: UpdateNoteInput
}>

export type UpdateNoteMutation = {
  updateNote: {
    activityDate: string | null
    archived: boolean | null
    channel: string | null
    contactName: string | null
    contactPhone: string | null
    createdDate: string
    data: Record<string, unknown> | null
    description: string | null
    fbclid: string | null
    gclid: string | null
    id: string
    isQualified: boolean | null
    locationId: string
    nameFromActivity: string | null
    needsReview: boolean | null
    note: string | null
    orgId: string
    phoneFromActivity: string | null
    referringUrl: string | null
    source: string | null
    subType: string | null
    tags: Array<string> | null
    trackingNumber: string | null
    trackingNumberName: string | null
    type: string
    typeId: string | null
    updatedDate: string
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    vendor: string | null
    version: number
    workspaceId: string
    contacts: Array<{
      id: string
      lifecycleStage: string | null
      locationId: string | null
      name: string | null
      peopleIndex: number | null
      phone: string | null
    }> | null
    owner: { id: string | null; name: string; userId: string | null } | null
  }
}

export type UpdateMilestoneMutationVariables = Exact<{
  id: string
  input: UpdateMilestoneInput
}>

export type UpdateMilestoneMutation = {
  updateMilestone: {
    activityDate: string | null
    archived: boolean | null
    channel: string | null
    contactName: string | null
    contactPhone: string | null
    createdDate: string
    data: Record<string, unknown> | null
    description: string | null
    fbclid: string | null
    gclid: string | null
    id: string
    isQualified: boolean | null
    locationId: string
    nameFromActivity: string | null
    needsReview: boolean | null
    note: string | null
    orgId: string
    phoneFromActivity: string | null
    referringUrl: string | null
    source: string | null
    subType: string | null
    tags: Array<string> | null
    trackingNumber: string | null
    trackingNumberName: string | null
    type: string
    typeId: string | null
    updatedDate: string
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    vendor: string | null
    version: number
    workspaceId: string
    contacts: Array<{
      id: string
      lifecycleStage: string | null
      locationId: string | null
      name: string | null
      peopleIndex: number | null
      phone: string | null
    }> | null
    owner: { id: string | null; name: string; userId: string | null } | null
  }
}

export type ReassignActivityMutationVariables = Exact<{
  id: string
  input: ReassignActivityInput
}>

export type ReassignActivityMutation = {
  reassignActivity: {
    activityDate: string | null
    archived: boolean | null
    channel: string | null
    contactName: string | null
    contactPhone: string | null
    createdDate: string
    data: Record<string, unknown> | null
    description: string | null
    fbclid: string | null
    gclid: string | null
    id: string
    isQualified: boolean | null
    locationId: string
    nameFromActivity: string | null
    needsReview: boolean | null
    note: string | null
    orgId: string
    phoneFromActivity: string | null
    referringUrl: string | null
    source: string | null
    subType: string | null
    tags: Array<string> | null
    trackingNumber: string | null
    trackingNumberName: string | null
    type: string
    typeId: string | null
    updatedDate: string
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    vendor: string | null
    version: number
    workspaceId: string
    contacts: Array<{
      id: string
      lifecycleStage: string | null
      locationId: string | null
      name: string | null
      peopleIndex: number | null
      phone: string | null
    }> | null
    owner: { id: string | null; name: string; userId: string | null } | null
  }
}

export type AdCampaignsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type AdCampaignsQuery = {
  campaigns: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      type: string
      platform: string | null
      name: string
      vendorCampaignId: string | null
      accountId: string | null
      accountName: string | null
    }>
  }
}

export type AdCampaignQueryVariables = Exact<{
  id: string
}>

export type AdCampaignQuery = {
  campaign: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    type: string
    platform: string | null
    name: string
    vendorCampaignId: string | null
    accountId: string | null
    accountName: string | null
  }
}

export type AdPlatformMappingsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type AdPlatformMappingsQuery = {
  adPlatformMappings: {
    total: number
    page: number
    hits: Array<{
      createdDate: string
      id: string
      medium: string
      orgId: string
      platform: string
      source: string
      updatedDate: string
      version: number
      workspaceId: string
    }>
  }
}

export type CreateAdPlatformMappingStoreMutationVariables = Exact<{
  input: CreateAdPlatformMappingInput
}>

export type CreateAdPlatformMappingStoreMutation = {
  createAdPlatformMapping: {
    createdDate: string
    id: string
    medium: string
    orgId: string
    platform: string
    source: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type UpdateAdPlatformMappingStoreMutationVariables = Exact<{
  id: string
  input: UpdateAdPlatformMappingInput
}>

export type UpdateAdPlatformMappingStoreMutation = {
  updateAdPlatformMapping: {
    createdDate: string
    id: string
    medium: string
    orgId: string
    platform: string
    source: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type AppointmentsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type AppointmentsQuery = {
  appointments: {
    total: number
    page: number
    hits: Array<{
      amount: number | null
      appointmentMadeDate: string | null
      confirmed: boolean | null
      createdDate: string
      date: string | null
      description: string | null
      duration: string | null
      id: string
      locationId: string
      note: string | null
      patientId: string | null
      pmsStatus: string | null
      procedureCode1: string | null
      procedureCode1Amount: string | null
      procedureCode1Time: string | null
      procedureCode2: string | null
      procedureCode2Amount: string | null
      procedureCode2Time: string | null
      procedureCode3: string | null
      procedureCode3Amount: string | null
      procedureCode3Time: string | null
      procedureCodes: Array<string> | null
      providerId: string | null
      sikkaOfficeId: string | null
      sikkaPracticeId: string | null
      source: string | null
      status: string | null
      time: string | null
      timeToAppointment: number | null
      type: string | null
      updatedDate: string
      version: number
    }>
  }
}

export type AppointmentQueryVariables = Exact<{
  id: string
}>

export type AppointmentQuery = {
  appointment: {
    amount: number | null
    appointmentMadeDate: string | null
    confirmed: boolean | null
    createdDate: string
    date: string | null
    description: string | null
    duration: string | null
    id: string
    locationId: string
    note: string | null
    patientId: string | null
    pmsStatus: string | null
    procedureCode1: string | null
    procedureCode1Amount: string | null
    procedureCode1Time: string | null
    procedureCode2: string | null
    procedureCode2Amount: string | null
    procedureCode2Time: string | null
    procedureCode3: string | null
    procedureCode3Amount: string | null
    procedureCode3Time: string | null
    procedureCodes: Array<string> | null
    providerId: string | null
    sikkaOfficeId: string | null
    sikkaPracticeId: string | null
    source: string | null
    status: string | null
    time: string | null
    timeToAppointment: number | null
    type: string | null
    updatedDate: string
    version: number
  }
}

export type AppointmentTypesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
  locationId: string
}>

export type AppointmentTypesQuery = {
  appointmentTypes: {
    total: number
    page: number
    hits: Array<{
      activeAgent: boolean | null
      activeScheduler: boolean | null
      alias: string | null
      appointmentLength: number
      blockScheduling: boolean | null
      blockSchedulingNotes: Array<string> | null
      createdDate: string
      displayName: string
      doubleBookingExclusion: boolean | null
      excludedBlockouts: Array<string> | null
      generalBuffer: number | null
      id: string
      kollaConsumerId: string
      morningBuffer: number | null
      morningBufferLookahead: number | null
      name: string
      order: number | null
      orgId: string
      patientType: string | null
      procedureCodes: Array<string> | null
      startIncrement: number | null
      updatedDate: string
      vendor: string | null
      vendorId: string
      version: number
      workspaceId: string
    }>
  }
}

export type UpdateAppointmentTypeStoreMutationVariables = Exact<{
  id: string
  input: UpdateAppointmentTypeInput
}>

export type UpdateAppointmentTypeStoreMutation = {
  updateAppointmentType: {
    activeAgent: boolean | null
    activeScheduler: boolean | null
    alias: string | null
    appointmentLength: number
    blockScheduling: boolean | null
    blockSchedulingNotes: Array<string> | null
    createdDate: string
    displayName: string
    doubleBookingExclusion: boolean | null
    excludedBlockouts: Array<string> | null
    generalBuffer: number | null
    id: string
    kollaConsumerId: string
    morningBuffer: number | null
    morningBufferLookahead: number | null
    name: string
    order: number | null
    orgId: string
    patientType: string | null
    procedureCodes: Array<string> | null
    startIncrement: number | null
    updatedDate: string
    vendor: string | null
    vendorId: string
    version: number
    workspaceId: string
  }
}

export type AuthStoreMeQueryVariables = Exact<{ [key: string]: never }>

export type AuthStoreMeQuery = {
  me: {
    id: string
    name: string | null
    email: string
    phone: string | null
    type: string
    orgId: string
    workspaceId: string | null
    position: string | null
    jobTitle: string | null
    timezone: string | null
    roleId: string | null
    permissions: Array<string> | null
    isOrgRole: boolean | null
    allowedLocationIds: Array<string> | null
    assignedWorkspaceIds: Array<string> | null
    products: Array<string>
    workspaces: Array<{ id: string; roleId: string; locationIds: Array<string> | null }> | null
  }
}

export type AuthWorkspaceQueryVariables = Exact<{
  id: string
}>

export type AuthWorkspaceQuery = { workspace: { id: string; name: string } }

export type LoginMutationVariables = Exact<{
  email: string
  password: string
  clientType: ClientType
}>

export type LoginMutation = {
  login: { accessToken: string | null; pendingToken: string | null; channel: string | null }
}

export type VerifyOtpMutationVariables = Exact<{
  pendingToken: string
  code: string
  clientType: ClientType
}>

export type VerifyOtpMutation = { verifyOtp: { accessToken: string } }

export type LoginWithGoogleCodeMutationVariables = Exact<{
  code: string
  redirectUri: string
  clientType: ClientType
}>

export type LoginWithGoogleCodeMutation = {
  loginWithGoogleCode: { accessToken: string | null; pendingToken: string | null; channel: string | null }
}

export type LogoutMutationVariables = Exact<{ [key: string]: never }>

export type LogoutMutation = { logout: boolean }

export type BudgetsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type BudgetsQuery = {
  budgets: {
    total: number
    page: number
    hits: Array<{
      amount: number | null
      appointmentGoal: number | null
      channel: string
      id: string | null
      internalGoal: number | null
      leadGoal: number | null
      locationId: string
      mqlGoal: number | null
      patientGoal: number | null
      targetSpend: number | null
      yearMonth: string
    }>
  }
}

export type UpdateBudgetStoreMutationVariables = Exact<{
  id: string
  input: UpdateBudgetInput
}>

export type UpdateBudgetStoreMutation = {
  updateBudget: {
    amount: number | null
    appointmentGoal: number | null
    channel: string
    id: string | null
    internalGoal: number | null
    leadGoal: number | null
    locationId: string
    mqlGoal: number | null
    patientGoal: number | null
    targetSpend: number | null
    yearMonth: string
  }
}

export type CallsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type CallsQuery = {
  calls: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      elevenLabsConversationId: string | null
      archived: boolean | null
      channel: string | null
      vendor: string | null
      answerer: string | null
      answered: boolean | null
      treatment: string | null
      patientNames: string | null
      callerId: string | null
      trackingNumber: string | null
      trackingNumberName: string | null
      tags: Array<string> | null
      waveforms: Array<string> | null
      appointmentDateString: string | null
      callerPhone: string | null
      businessPhone: string | null
      callDate: string | null
      note: string | null
      status: string | null
      recordingDuration: number | null
      duration: number | null
      utmSource: string | null
      utmMedium: string | null
      utmCampaign: string | null
      utmKeywords: string | null
      utmContent: string | null
      referringUrl: string | null
      gclid: string | null
      landingPageUrl: string | null
      recordings: Array<string> | null
      aiAgent: boolean | null
      golden: boolean | null
      direction: string | null
      allPatientOutcomes: Array<string> | null
      ai: {
        summary: string | null
        actionItems: string | null
        answerer: string | null
        channel: string | null
        extractionDate: string | null
        model: string | null
        people: Array<{
          name: string | null
          treatment: string | null
          serviceRequested: string | null
          relationship: string | null
          appointmentDate: string | null
          appointmentTime: string | null
          phone: string | null
          patientType: string | null
          appointmentScheduled: boolean | null
          appointmentRequested: boolean | null
          birthDate: string | null
          referral: string | null
          insuranceProvider: string | null
          outcomes: Array<string> | null
          reasonForNotScheduling: string | null
          isCaller: boolean | null
          index: number | null
          email: string | null
        }> | null
        tokenUsage: { inputTokens: number | null; outputTokens: number | null; totalTokens: number | null } | null
      } | null
      patients: Array<{
        name: string | null
        treatment: string | null
        serviceRequested: string | null
        relationship: string | null
        appointmentDate: string | null
        appointmentTime: string | null
        phone: string | null
        patientType: string | null
        appointmentScheduled: boolean | null
        appointmentRequested: boolean | null
        birthDate: string | null
        referral: string | null
        insuranceProvider: string | null
        outcomes: Array<string> | null
        reasonForNotScheduling: string | null
        isCaller: boolean | null
        index: number | null
        email: string | null
      }> | null
      staff: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
      people: Array<{
        name: string | null
        treatment: string | null
        serviceRequested: string | null
        relationship: string | null
        appointmentDate: string | null
        appointmentTime: string | null
        phone: string | null
        patientType: string | null
        appointmentScheduled: boolean | null
        appointmentRequested: boolean | null
        birthDate: string | null
        referral: string | null
        insuranceProvider: string | null
        outcomes: Array<string> | null
        reasonForNotScheduling: string | null
        isCaller: boolean | null
        index: number | null
        email: string | null
      }> | null
    }>
  }
}

export type CallQueryVariables = Exact<{
  id: string
}>

export type CallQuery = {
  call: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    elevenLabsConversationId: string | null
    archived: boolean | null
    channel: string | null
    vendor: string | null
    answerer: string | null
    answered: boolean | null
    treatment: string | null
    patientNames: string | null
    callerId: string | null
    trackingNumber: string | null
    trackingNumberName: string | null
    tags: Array<string> | null
    waveforms: Array<string> | null
    appointmentDateString: string | null
    callerPhone: string | null
    businessPhone: string | null
    callDate: string | null
    note: string | null
    status: string | null
    recordingDuration: number | null
    duration: number | null
    utmSource: string | null
    utmMedium: string | null
    utmCampaign: string | null
    utmKeywords: string | null
    utmContent: string | null
    referringUrl: string | null
    gclid: string | null
    landingPageUrl: string | null
    recordings: Array<string> | null
    aiAgent: boolean | null
    golden: boolean | null
    direction: string | null
    allPatientOutcomes: Array<string> | null
    ai: {
      summary: string | null
      actionItems: string | null
      answerer: string | null
      channel: string | null
      extractionDate: string | null
      model: string | null
      people: Array<{
        name: string | null
        treatment: string | null
        serviceRequested: string | null
        relationship: string | null
        appointmentDate: string | null
        appointmentTime: string | null
        phone: string | null
        patientType: string | null
        appointmentScheduled: boolean | null
        appointmentRequested: boolean | null
        birthDate: string | null
        referral: string | null
        insuranceProvider: string | null
        outcomes: Array<string> | null
        reasonForNotScheduling: string | null
        isCaller: boolean | null
        index: number | null
        email: string | null
      }> | null
      tokenUsage: { inputTokens: number | null; outputTokens: number | null; totalTokens: number | null } | null
    } | null
    patients: Array<{
      name: string | null
      treatment: string | null
      serviceRequested: string | null
      relationship: string | null
      appointmentDate: string | null
      appointmentTime: string | null
      phone: string | null
      patientType: string | null
      appointmentScheduled: boolean | null
      appointmentRequested: boolean | null
      birthDate: string | null
      referral: string | null
      insuranceProvider: string | null
      outcomes: Array<string> | null
      reasonForNotScheduling: string | null
      isCaller: boolean | null
      index: number | null
      email: string | null
    }> | null
    staff: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
    people: Array<{
      name: string | null
      treatment: string | null
      serviceRequested: string | null
      relationship: string | null
      appointmentDate: string | null
      appointmentTime: string | null
      phone: string | null
      patientType: string | null
      appointmentScheduled: boolean | null
      appointmentRequested: boolean | null
      birthDate: string | null
      referral: string | null
      insuranceProvider: string | null
      outcomes: Array<string> | null
      reasonForNotScheduling: string | null
      isCaller: boolean | null
      index: number | null
      email: string | null
    }> | null
  } | null
}

export type UpdateCallMutationVariables = Exact<{
  id: string
  input: UpdateCallInput
}>

export type UpdateCallMutation = {
  updateCall: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    elevenLabsConversationId: string | null
    archived: boolean | null
    channel: string | null
    vendor: string | null
    answerer: string | null
    answered: boolean | null
    treatment: string | null
    patientNames: string | null
    callerId: string | null
    trackingNumber: string | null
    trackingNumberName: string | null
    tags: Array<string> | null
    waveforms: Array<string> | null
    appointmentDateString: string | null
    callerPhone: string | null
    businessPhone: string | null
    callDate: string | null
    note: string | null
    status: string | null
    recordingDuration: number | null
    duration: number | null
    utmSource: string | null
    utmMedium: string | null
    utmCampaign: string | null
    utmKeywords: string | null
    utmContent: string | null
    referringUrl: string | null
    gclid: string | null
    landingPageUrl: string | null
    recordings: Array<string> | null
    aiAgent: boolean | null
    golden: boolean | null
    direction: string | null
    allPatientOutcomes: Array<string> | null
    ai: {
      summary: string | null
      actionItems: string | null
      answerer: string | null
      channel: string | null
      extractionDate: string | null
      model: string | null
      people: Array<{
        name: string | null
        treatment: string | null
        serviceRequested: string | null
        relationship: string | null
        appointmentDate: string | null
        appointmentTime: string | null
        phone: string | null
        patientType: string | null
        appointmentScheduled: boolean | null
        appointmentRequested: boolean | null
        birthDate: string | null
        referral: string | null
        insuranceProvider: string | null
        outcomes: Array<string> | null
        reasonForNotScheduling: string | null
        isCaller: boolean | null
        index: number | null
        email: string | null
      }> | null
      tokenUsage: { inputTokens: number | null; outputTokens: number | null; totalTokens: number | null } | null
    } | null
    patients: Array<{
      name: string | null
      treatment: string | null
      serviceRequested: string | null
      relationship: string | null
      appointmentDate: string | null
      appointmentTime: string | null
      phone: string | null
      patientType: string | null
      appointmentScheduled: boolean | null
      appointmentRequested: boolean | null
      birthDate: string | null
      referral: string | null
      insuranceProvider: string | null
      outcomes: Array<string> | null
      reasonForNotScheduling: string | null
      isCaller: boolean | null
      index: number | null
      email: string | null
    }> | null
    staff: { id: string | null; name: string; aliases: Array<string> | null; userId: string | null } | null
    people: Array<{
      name: string | null
      treatment: string | null
      serviceRequested: string | null
      relationship: string | null
      appointmentDate: string | null
      appointmentTime: string | null
      phone: string | null
      patientType: string | null
      appointmentScheduled: boolean | null
      appointmentRequested: boolean | null
      birthDate: string | null
      referral: string | null
      insuranceProvider: string | null
      outcomes: Array<string> | null
      reasonForNotScheduling: string | null
      isCaller: boolean | null
      index: number | null
      email: string | null
    }> | null
  }
}

export type DeleteCallMutationVariables = Exact<{
  id: string
}>

export type DeleteCallMutation = { deleteCall: boolean }

export type CdtCodeMappingsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type CdtCodeMappingsQuery = {
  cdtCodeMappings: {
    total: number
    page: number
    hits: Array<{
      category: string
      cdtCode: string
      createdDate: string
      id: string
      orgId: string
      updatedDate: string
      version: number
      workspaceId: string
    }>
  }
}

export type CreateCdtCodeMappingStoreMutationVariables = Exact<{
  input: CreateCdtCodeMappingInput
}>

export type CreateCdtCodeMappingStoreMutation = {
  createCdtCodeMapping: {
    category: string
    cdtCode: string
    createdDate: string
    id: string
    orgId: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type UpdateCdtCodeMappingStoreMutationVariables = Exact<{
  id: string
  input: UpdateCdtCodeMappingInput
}>

export type UpdateCdtCodeMappingStoreMutation = {
  updateCdtCodeMapping: {
    category: string
    cdtCode: string
    createdDate: string
    id: string
    orgId: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type DeleteCdtCodeMappingMutationVariables = Exact<{
  id: string
}>

export type DeleteCdtCodeMappingMutation = { deleteCdtCodeMapping: boolean }

export type ChannelMappingsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ChannelMappingsQuery = {
  channelMappings: {
    total: number
    page: number
    hits: Array<{
      channel: string
      createdDate: string
      id: string
      medium: string
      orgId: string
      source: string
      updatedDate: string
      version: number
      workspaceId: string
    }>
  }
}

export type CreateChannelMappingStoreMutationVariables = Exact<{
  input: CreateChannelMappingInput
}>

export type CreateChannelMappingStoreMutation = {
  createChannelMapping: {
    channel: string
    createdDate: string
    id: string
    medium: string
    orgId: string
    source: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type UpdateChannelMappingStoreMutationVariables = Exact<{
  id: string
  input: UpdateChannelMappingInput
}>

export type UpdateChannelMappingStoreMutation = {
  updateChannelMapping: {
    channel: string
    createdDate: string
    id: string
    medium: string
    orgId: string
    source: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type ContactsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
  magicTerms?: boolean | null | undefined
  fields?: Array<string> | string | null | undefined
}>

export type ContactsQuery = {
  contacts: {
    total: number
    page: number
    hits: Array<{
      activityCount: number | null
      activityTypes: Array<string> | null
      adClickDate: string | null
      addressLine1: string | null
      addressLine2: string | null
      appointmentStatus: string | null
      archived: boolean | null
      becameInactiveDate: string | null
      becameLeadDate: string | null
      becamePatientDate: string | null
      birthDate: string | null
      cellPhone: string | null
      channel: string | null
      city: string | null
      closedLostReason: string | null
      collectedLtv: number | null
      createdDate: string
      email: string | null
      fbclid: string | null
      firstActivityDate: string | null
      firstActivityType: string | null
      firstAppointmentDate: string | null
      firstAppointmentMadeDate: string | null
      firstContactReason: string | null
      firstName: string | null
      firstTransactionDate: string | null
      fvv: number | null
      gclid: string | null
      homePhone: string | null
      hygieneDueDate: string | null
      hygieneStatus: string | null
      id: string
      isPerio: boolean | null
      isQualified: boolean | null
      landingPageURL: string | null
      lastActivityDate: string | null
      lastAppointmentDate: string | null
      lastCommActivitySubType: string | null
      lastCommActivityType: string | null
      lastCommDate: string | null
      lastHygieneDate: string | null
      lastName: string | null
      lastTransactionDate: string | null
      lastTreatmentPlanDate: string | null
      leadConversionStatus: string | null
      leadStatus: string | null
      lifecycleStage: string | null
      locationId: string
      matchTypes: Array<string> | null
      name: string
      nearestAppointmentDate: string | null
      neededAction: boolean | null
      needsActionDate: string | null
      orgId: string
      otherPhone: Array<string> | null
      patientCreatedDate: string | null
      patientIds: Array<string> | null
      patientName: string | null
      patientReferral: string | null
      patientStatus: string | null
      platform: string | null
      preferredCommunicationMethod: string | null
      preferredContact: string | null
      preferredName: string | null
      productionLtv: number | null
      referralURL: string | null
      reportedAttribution: string | null
      scheduledProduction: number | null
      smsMarketingConsent: boolean | null
      state: string | null
      tags: Array<string> | null
      trackableCampaignId: string | null
      treatmentStatus: string | null
      unbookedTreatmentValue: number | null
      updatedDate: string
      utmCampaign: string | null
      utmContent: string | null
      utmKeywords: string | null
      utmMedium: string | null
      utmSource: string | null
      version: number
      workPhone: string | null
      workspaceId: string
      zip: string | null
      convertedBy: { id: string | null; name: string } | null
      leadOwner: { id: string | null; name: string } | null
      pipelines: Array<{ id: string; stage: string | null }> | null
    }>
  }
}

export type ContactQueryVariables = Exact<{
  id: string
}>

export type ContactQuery = {
  contact: {
    activityCount: number | null
    activityTypes: Array<string> | null
    adClickDate: string | null
    addressLine1: string | null
    addressLine2: string | null
    appointmentStatus: string | null
    archived: boolean | null
    becameInactiveDate: string | null
    becameLeadDate: string | null
    becamePatientDate: string | null
    birthDate: string | null
    cellPhone: string | null
    channel: string | null
    city: string | null
    closedLostReason: string | null
    collectedLtv: number | null
    createdDate: string
    email: string | null
    fbclid: string | null
    firstActivityDate: string | null
    firstActivityType: string | null
    firstAppointmentDate: string | null
    firstAppointmentMadeDate: string | null
    firstContactReason: string | null
    firstName: string | null
    firstTransactionDate: string | null
    fvv: number | null
    gclid: string | null
    homePhone: string | null
    hygieneDueDate: string | null
    hygieneStatus: string | null
    id: string
    isPerio: boolean | null
    isQualified: boolean | null
    landingPageURL: string | null
    lastActivityDate: string | null
    lastAppointmentDate: string | null
    lastCommActivitySubType: string | null
    lastCommActivityType: string | null
    lastCommDate: string | null
    lastHygieneDate: string | null
    lastName: string | null
    lastTransactionDate: string | null
    lastTreatmentPlanDate: string | null
    leadConversionStatus: string | null
    leadStatus: string | null
    lifecycleStage: string | null
    locationId: string
    matchTypes: Array<string> | null
    name: string
    nearestAppointmentDate: string | null
    neededAction: boolean | null
    needsActionDate: string | null
    orgId: string
    otherPhone: Array<string> | null
    patientCreatedDate: string | null
    patientIds: Array<string> | null
    patientName: string | null
    patientReferral: string | null
    patientStatus: string | null
    platform: string | null
    preferredCommunicationMethod: string | null
    preferredContact: string | null
    preferredName: string | null
    productionLtv: number | null
    referralURL: string | null
    reportedAttribution: string | null
    scheduledProduction: number | null
    smsMarketingConsent: boolean | null
    state: string | null
    tags: Array<string> | null
    trackableCampaignId: string | null
    treatmentStatus: string | null
    unbookedTreatmentValue: number | null
    updatedDate: string
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    version: number
    workPhone: string | null
    workspaceId: string
    zip: string | null
    convertedBy: { id: string | null; name: string } | null
    leadOwner: { id: string | null; name: string } | null
    pipelines: Array<{ id: string; stage: string | null }> | null
  }
}

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput
}>

export type CreateContactMutation = {
  createContact: {
    activityCount: number | null
    activityTypes: Array<string> | null
    addressLine1: string | null
    addressLine2: string | null
    appointmentStatus: string | null
    archived: boolean | null
    becameInactiveDate: string | null
    becameLeadDate: string | null
    becamePatientDate: string | null
    birthDate: string | null
    cellPhone: string | null
    channel: string | null
    city: string | null
    closedLostReason: string | null
    collectedLtv: number | null
    createdDate: string
    email: string | null
    firstActivityDate: string | null
    firstActivityType: string | null
    firstAppointmentDate: string | null
    firstAppointmentMadeDate: string | null
    firstContactReason: string | null
    firstTransactionDate: string | null
    fvv: number | null
    homePhone: string | null
    id: string
    hygieneDueDate: string | null
    hygieneStatus: string | null
    treatmentStatus: string | null
    isPerio: boolean | null
    isQualified: boolean | null
    lastActivityDate: string | null
    lastAppointmentDate: string | null
    lastCommDate: string | null
    lastCommActivityType: string | null
    lastCommActivitySubType: string | null
    lastHygieneDate: string | null
    lastTransactionDate: string | null
    leadStatus: string | null
    lifecycleStage: string | null
    locationId: string
    matchTypes: Array<string> | null
    name: string
    nearestAppointmentDate: string | null
    neededAction: boolean | null
    needsActionDate: string | null
    orgId: string
    otherPhone: Array<string> | null
    patientCreatedDate: string | null
    patientIds: Array<string> | null
    patientName: string | null
    patientReferral: string | null
    patientStatus: string | null
    platform: string | null
    preferredCommunicationMethod: string | null
    preferredContact: string | null
    preferredName: string | null
    productionLtv: number | null
    reportedAttribution: string | null
    scheduledProduction: number | null
    smsMarketingConsent: boolean | null
    state: string | null
    tags: Array<string> | null
    trackableCampaignId: string | null
    updatedDate: string
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    version: number
    workPhone: string | null
    workspaceId: string
    zip: string | null
    leadOwner: { id: string | null; name: string } | null
    pipelines: Array<{ id: string; stage: string | null }> | null
  }
}

export type UpdateContactStoreMutationVariables = Exact<{
  id: string
  input: UpdateContactInput
}>

export type UpdateContactStoreMutation = {
  updateContact: {
    activityCount: number | null
    activityTypes: Array<string> | null
    addressLine1: string | null
    addressLine2: string | null
    appointmentStatus: string | null
    archived: boolean | null
    becameInactiveDate: string | null
    becameLeadDate: string | null
    becamePatientDate: string | null
    birthDate: string | null
    cellPhone: string | null
    channel: string | null
    city: string | null
    closedLostReason: string | null
    collectedLtv: number | null
    createdDate: string
    email: string | null
    firstActivityDate: string | null
    firstActivityType: string | null
    firstAppointmentDate: string | null
    firstAppointmentMadeDate: string | null
    firstContactReason: string | null
    firstTransactionDate: string | null
    fvv: number | null
    homePhone: string | null
    id: string
    hygieneDueDate: string | null
    hygieneStatus: string | null
    treatmentStatus: string | null
    isPerio: boolean | null
    isQualified: boolean | null
    lastActivityDate: string | null
    lastAppointmentDate: string | null
    lastCommDate: string | null
    lastCommActivityType: string | null
    lastCommActivitySubType: string | null
    lastHygieneDate: string | null
    lastTransactionDate: string | null
    leadStatus: string | null
    lifecycleStage: string | null
    locationId: string
    matchTypes: Array<string> | null
    name: string
    nearestAppointmentDate: string | null
    neededAction: boolean | null
    needsActionDate: string | null
    orgId: string
    otherPhone: Array<string> | null
    patientCreatedDate: string | null
    patientIds: Array<string> | null
    patientName: string | null
    patientReferral: string | null
    patientStatus: string | null
    platform: string | null
    preferredCommunicationMethod: string | null
    preferredContact: string | null
    preferredName: string | null
    productionLtv: number | null
    reportedAttribution: string | null
    scheduledProduction: number | null
    smsMarketingConsent: boolean | null
    state: string | null
    tags: Array<string> | null
    trackableCampaignId: string | null
    updatedDate: string
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    version: number
    workPhone: string | null
    workspaceId: string
    zip: string | null
    leadOwner: { id: string | null; name: string } | null
    pipelines: Array<{ id: string; stage: string | null }> | null
  }
}

export type MergeContactsMutationVariables = Exact<{
  leftId: string
  rightId: string
}>

export type MergeContactsMutation = { mergeContacts: { id: string } }

export type RecalculateContactMutationVariables = Exact<{
  id: string
}>

export type RecalculateContactMutation = {
  recalculateContact: {
    activityCount: number | null
    activityTypes: Array<string> | null
    addressLine1: string | null
    addressLine2: string | null
    appointmentStatus: string | null
    archived: boolean | null
    becameInactiveDate: string | null
    becameLeadDate: string | null
    becamePatientDate: string | null
    birthDate: string | null
    cellPhone: string | null
    channel: string | null
    city: string | null
    closedLostReason: string | null
    collectedLtv: number | null
    createdDate: string
    email: string | null
    firstActivityDate: string | null
    firstActivityType: string | null
    firstAppointmentDate: string | null
    firstAppointmentMadeDate: string | null
    firstContactReason: string | null
    firstTransactionDate: string | null
    fvv: number | null
    homePhone: string | null
    id: string
    hygieneDueDate: string | null
    hygieneStatus: string | null
    treatmentStatus: string | null
    isPerio: boolean | null
    isQualified: boolean | null
    lastActivityDate: string | null
    lastAppointmentDate: string | null
    lastCommDate: string | null
    lastCommActivityType: string | null
    lastCommActivitySubType: string | null
    lastHygieneDate: string | null
    lastTransactionDate: string | null
    leadStatus: string | null
    lifecycleStage: string | null
    locationId: string
    matchTypes: Array<string> | null
    name: string
    nearestAppointmentDate: string | null
    neededAction: boolean | null
    needsActionDate: string | null
    orgId: string
    otherPhone: Array<string> | null
    patientCreatedDate: string | null
    patientIds: Array<string> | null
    patientName: string | null
    patientReferral: string | null
    patientStatus: string | null
    platform: string | null
    preferredCommunicationMethod: string | null
    preferredContact: string | null
    preferredName: string | null
    productionLtv: number | null
    reportedAttribution: string | null
    scheduledProduction: number | null
    smsMarketingConsent: boolean | null
    state: string | null
    tags: Array<string> | null
    trackableCampaignId: string | null
    updatedDate: string
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    version: number
    workPhone: string | null
    workspaceId: string
    zip: string | null
    leadOwner: { id: string | null; name: string } | null
    pipelines: Array<{ id: string; stage: string | null }> | null
  }
}

export type AddTagsMutationVariables = Exact<{
  id: string
  tags: Array<string> | string
}>

export type AddTagsMutation = {
  addTags: {
    activityCount: number | null
    activityTypes: Array<string> | null
    addressLine1: string | null
    addressLine2: string | null
    appointmentStatus: string | null
    archived: boolean | null
    becameInactiveDate: string | null
    becameLeadDate: string | null
    becamePatientDate: string | null
    birthDate: string | null
    cellPhone: string | null
    channel: string | null
    city: string | null
    closedLostReason: string | null
    collectedLtv: number | null
    createdDate: string
    email: string | null
    firstActivityDate: string | null
    firstActivityType: string | null
    firstAppointmentDate: string | null
    firstAppointmentMadeDate: string | null
    firstContactReason: string | null
    firstTransactionDate: string | null
    fvv: number | null
    homePhone: string | null
    id: string
    hygieneDueDate: string | null
    hygieneStatus: string | null
    treatmentStatus: string | null
    isPerio: boolean | null
    isQualified: boolean | null
    lastActivityDate: string | null
    lastAppointmentDate: string | null
    lastCommDate: string | null
    lastCommActivityType: string | null
    lastCommActivitySubType: string | null
    lastHygieneDate: string | null
    lastTransactionDate: string | null
    leadStatus: string | null
    lifecycleStage: string | null
    locationId: string
    matchTypes: Array<string> | null
    name: string
    nearestAppointmentDate: string | null
    neededAction: boolean | null
    needsActionDate: string | null
    orgId: string
    otherPhone: Array<string> | null
    patientCreatedDate: string | null
    patientIds: Array<string> | null
    patientName: string | null
    patientReferral: string | null
    patientStatus: string | null
    platform: string | null
    preferredCommunicationMethod: string | null
    preferredContact: string | null
    preferredName: string | null
    productionLtv: number | null
    reportedAttribution: string | null
    scheduledProduction: number | null
    smsMarketingConsent: boolean | null
    state: string | null
    tags: Array<string> | null
    trackableCampaignId: string | null
    updatedDate: string
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    version: number
    workPhone: string | null
    workspaceId: string
    zip: string | null
    leadOwner: { id: string | null; name: string } | null
    pipelines: Array<{ id: string; stage: string | null }> | null
  }
}

export type AddToPipelineMutationVariables = Exact<{
  id: string
  pipeline: ContactPipelineInput
}>

export type AddToPipelineMutation = {
  addToPipeline: {
    activityCount: number | null
    activityTypes: Array<string> | null
    addressLine1: string | null
    addressLine2: string | null
    appointmentStatus: string | null
    archived: boolean | null
    becameInactiveDate: string | null
    becameLeadDate: string | null
    becamePatientDate: string | null
    birthDate: string | null
    cellPhone: string | null
    channel: string | null
    city: string | null
    closedLostReason: string | null
    collectedLtv: number | null
    createdDate: string
    email: string | null
    firstActivityDate: string | null
    firstActivityType: string | null
    firstAppointmentDate: string | null
    firstAppointmentMadeDate: string | null
    firstContactReason: string | null
    firstTransactionDate: string | null
    fvv: number | null
    homePhone: string | null
    id: string
    hygieneDueDate: string | null
    hygieneStatus: string | null
    treatmentStatus: string | null
    isPerio: boolean | null
    isQualified: boolean | null
    lastActivityDate: string | null
    lastAppointmentDate: string | null
    lastCommDate: string | null
    lastCommActivityType: string | null
    lastCommActivitySubType: string | null
    lastHygieneDate: string | null
    lastTransactionDate: string | null
    leadStatus: string | null
    lifecycleStage: string | null
    locationId: string
    matchTypes: Array<string> | null
    name: string
    nearestAppointmentDate: string | null
    neededAction: boolean | null
    needsActionDate: string | null
    orgId: string
    otherPhone: Array<string> | null
    patientCreatedDate: string | null
    patientIds: Array<string> | null
    patientName: string | null
    patientReferral: string | null
    patientStatus: string | null
    platform: string | null
    preferredCommunicationMethod: string | null
    preferredContact: string | null
    preferredName: string | null
    productionLtv: number | null
    reportedAttribution: string | null
    scheduledProduction: number | null
    smsMarketingConsent: boolean | null
    state: string | null
    tags: Array<string> | null
    trackableCampaignId: string | null
    updatedDate: string
    utmCampaign: string | null
    utmContent: string | null
    utmKeywords: string | null
    utmMedium: string | null
    utmSource: string | null
    version: number
    workPhone: string | null
    workspaceId: string
    zip: string | null
    leadOwner: { id: string | null; name: string } | null
    pipelines: Array<{ id: string; stage: string | null }> | null
  }
}

export type ConversionLogsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ConversionLogsQuery = {
  conversionLogs: {
    total: number
    page: number
    hits: Array<{
      becameLeadDate: string | null
      becamePatientDate: string | null
      contactId: string
      contactName: string | null
      conversionDateTime: string
      conversionType: string
      conversionValue: number | null
      createdDate: string
      errorMessage: string | null
      firstAppointmentMadeDate: string | null
      gclid: string | null
      googleAdsAccountId: string
      id: string
      locationId: string
      status: string
    }>
  }
}

export type CustomPagesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type CustomPagesQuery = {
  customPages: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      userId: string
      name: string
      page: string
      join: string
      filters: Array<{
        attribute: string
        secondaryAttribute: string | null
        displayName: string | null
        operator: string
        value: Record<string, unknown> | null
        secondaryValue: Array<string> | null
        static: boolean | null
        uniqOperator: string | null
        readOnly: boolean | null
        nonEmpty: boolean | null
        useAsterisk: boolean | null
        group: string | null
        subQuery: string | null
        type: string | null
        defaultValue: Record<string, unknown> | null
        dateOperator: string | null
        includeToday: boolean | null
        includeYesterday: boolean | null
        includeWeeks: boolean | null
        limitToMonth: boolean | null
        includeInThePast: boolean | null
        options: Record<string, unknown> | null
      }> | null
    }>
  }
}

export type CustomPageQueryVariables = Exact<{
  id: string
}>

export type CustomPageQuery = {
  customPage: {
    id: string
    orgId: string
    userId: string
    name: string
    page: string
    join: string
    filters: Array<{
      attribute: string
      secondaryAttribute: string | null
      displayName: string | null
      operator: string
      value: Record<string, unknown> | null
      secondaryValue: Array<string> | null
      static: boolean | null
      uniqOperator: string | null
      readOnly: boolean | null
      nonEmpty: boolean | null
      useAsterisk: boolean | null
      group: string | null
      subQuery: string | null
      type: string | null
      defaultValue: Record<string, unknown> | null
      dateOperator: string | null
      includeToday: boolean | null
      includeYesterday: boolean | null
      includeWeeks: boolean | null
      limitToMonth: boolean | null
      includeInThePast: boolean | null
      options: Record<string, unknown> | null
    }> | null
  }
}

export type CreateCustomPageMutationVariables = Exact<{
  input: CreateCustomPageInput
}>

export type CreateCustomPageMutation = {
  createCustomPage: {
    id: string
    orgId: string
    userId: string
    name: string
    page: string
    join: string
    filters: Array<{
      attribute: string
      secondaryAttribute: string | null
      displayName: string | null
      operator: string
      value: Record<string, unknown> | null
      secondaryValue: Array<string> | null
      static: boolean | null
      uniqOperator: string | null
      readOnly: boolean | null
      nonEmpty: boolean | null
      useAsterisk: boolean | null
      group: string | null
      subQuery: string | null
      type: string | null
      defaultValue: Record<string, unknown> | null
      dateOperator: string | null
      includeToday: boolean | null
      includeYesterday: boolean | null
      includeWeeks: boolean | null
      limitToMonth: boolean | null
      includeInThePast: boolean | null
      options: Record<string, unknown> | null
    }> | null
  }
}

export type UpdateCustomPageMutationVariables = Exact<{
  id: string
  input: UpdateCustomPageInput
}>

export type UpdateCustomPageMutation = {
  updateCustomPage: {
    id: string
    orgId: string
    userId: string
    name: string
    page: string
    join: string
    filters: Array<{
      attribute: string
      secondaryAttribute: string | null
      displayName: string | null
      operator: string
      value: Record<string, unknown> | null
      secondaryValue: Array<string> | null
      static: boolean | null
      uniqOperator: string | null
      readOnly: boolean | null
      nonEmpty: boolean | null
      useAsterisk: boolean | null
      group: string | null
      subQuery: string | null
      type: string | null
      defaultValue: Record<string, unknown> | null
      dateOperator: string | null
      includeToday: boolean | null
      includeYesterday: boolean | null
      includeWeeks: boolean | null
      limitToMonth: boolean | null
      includeInThePast: boolean | null
      options: Record<string, unknown> | null
    }> | null
  }
}

export type DeleteCustomPageMutationVariables = Exact<{
  id: string
}>

export type DeleteCustomPageMutation = { deleteCustomPage: boolean }

export type ExtractionPromptsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ExtractionPromptsQuery = {
  extractionPrompts: {
    total: number
    page: number
    hits: Array<{
      active: boolean
      createdBy: string | null
      createdDate: string
      id: string
      model: string
      notes: string | null
      prompt: string
      promptVersion: string
      stage: string
      updatedDate: string
      version: number
    }>
  }
}

export type ExtractionPromptQueryVariables = Exact<{
  slug: string
}>

export type ExtractionPromptQuery = {
  extractionPrompt: {
    active: boolean
    createdBy: string | null
    createdDate: string
    id: string
    model: string
    notes: string | null
    prompt: string
    promptVersion: string
    stage: string
    updatedDate: string
    version: number
  } | null
}

export type CreateExtractionPromptMutationVariables = Exact<{
  input: CreateExtractionPromptInput
}>

export type CreateExtractionPromptMutation = {
  createExtractionPrompt: {
    active: boolean
    createdBy: string | null
    createdDate: string
    id: string
    model: string
    notes: string | null
    prompt: string
    promptVersion: string
    stage: string
    updatedDate: string
    version: number
  }
}

export type FeatureToggleDefinitionsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type FeatureToggleDefinitionsQuery = {
  featureToggleDefinitions: {
    total: number
    page: number
    hits: Array<{
      id: string
      name: string
      displayName: string | null
      description: string | null
      category: FeatureToggleCategory | null
      archived: boolean
      release: string | null
      createdDate: string
      updatedDate: string
    }>
  }
}

export type FeatureTogglesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
}>

export type FeatureTogglesQuery = {
  featureToggles: {
    total: number
    page: number
    hits: Array<{
      archived: boolean
      createdDate: string
      description: string | null
      id: string
      name: string
      type: string
      typeId: string | null
      updatedDate: string
      version: number
    }>
  }
}

export type FeatureTogglesByNameQueryVariables = Exact<{
  names: Array<string> | string
}>

export type FeatureTogglesByNameQuery = { featureTogglesByName: Array<{ id: string; name: string }> }

export type CreateFeatureToggleMutationVariables = Exact<{
  input: CreateFeatureToggleInput
}>

export type CreateFeatureToggleMutation = {
  createFeatureToggle: {
    archived: boolean
    createdDate: string
    description: string | null
    id: string
    name: string
    type: string
    typeId: string | null
    updatedDate: string
    version: number
  }
}

export type UpdateFeatureToggleMutationVariables = Exact<{
  id: string
  input: UpdateFeatureToggleInput
}>

export type UpdateFeatureToggleMutation = {
  updateFeatureToggle: {
    archived: boolean
    createdDate: string
    description: string | null
    id: string
    name: string
    type: string
    typeId: string | null
    updatedDate: string
    version: number
  }
}

export type DeleteFeatureToggleMutationVariables = Exact<{
  id: string
}>

export type DeleteFeatureToggleMutation = { deleteFeatureToggle: boolean }

export type FollowUpStoreListQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type FollowUpStoreListQuery = {
  followUps: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      contactId: string
      ownerName: string | null
      ownerId: string | null
      appointmentDate: string | null
      followUpDate: string | null
      isConnected: boolean | null
      isScheduled: boolean | null
      description: string | null
      associatedType: string | null
      associatedTypeId: string | null
      associatedPeopleIndex: number | null
      createdDate: string | null
      updatedDate: string | null
    }>
  }
}

export type FollowUpStoreGetQueryVariables = Exact<{
  id: string
}>

export type FollowUpStoreGetQuery = {
  followUp: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    contactId: string
    ownerName: string | null
    ownerId: string | null
    appointmentDate: string | null
    followUpDate: string | null
    isConnected: boolean | null
    isScheduled: boolean | null
    description: string | null
    associatedType: string | null
    associatedTypeId: string | null
    associatedPeopleIndex: number | null
    createdDate: string | null
    updatedDate: string | null
  }
}

export type FollowUpStoreCreateMutationVariables = Exact<{
  input: CreateFollowUpInput
}>

export type FollowUpStoreCreateMutation = {
  createFollowUp: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    contactId: string
    ownerName: string | null
    ownerId: string | null
    appointmentDate: string | null
    followUpDate: string | null
    isConnected: boolean | null
    isScheduled: boolean | null
    description: string | null
    associatedType: string | null
    associatedTypeId: string | null
    associatedPeopleIndex: number | null
    createdDate: string | null
    updatedDate: string | null
  }
}

export type FollowUpStoreUpdateMutationVariables = Exact<{
  id: string
  input: UpdateFollowUpInput
}>

export type FollowUpStoreUpdateMutation = {
  updateFollowUp: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    contactId: string
    ownerName: string | null
    ownerId: string | null
    appointmentDate: string | null
    followUpDate: string | null
    isConnected: boolean | null
    isScheduled: boolean | null
    description: string | null
    associatedType: string | null
    associatedTypeId: string | null
    associatedPeopleIndex: number | null
    createdDate: string | null
    updatedDate: string | null
  }
}

export type DeleteFollowUpMutationVariables = Exact<{
  id: string
}>

export type DeleteFollowUpMutation = { deleteFollowUp: boolean }

export type FormFieldMappingsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type FormFieldMappingsQuery = {
  formFieldMappings: {
    total: number
    page: number
    hits: Array<{
      createdDate: string
      formField: string
      id: string
      orgId: string
      rawKey: string
      updatedDate: string
      version: number
      workspaceId: string
    }>
  }
}

export type CreateFormFieldMappingStoreMutationVariables = Exact<{
  input: CreateFormFieldMappingInput
}>

export type CreateFormFieldMappingStoreMutation = {
  createFormFieldMapping: {
    createdDate: string
    formField: string
    id: string
    orgId: string
    rawKey: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type UpdateFormFieldMappingStoreMutationVariables = Exact<{
  id: string
  input: UpdateFormFieldMappingInput
}>

export type UpdateFormFieldMappingStoreMutation = {
  updateFormFieldMapping: {
    createdDate: string
    formField: string
    id: string
    orgId: string
    rawKey: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type ImportsStoreQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ImportsStoreQuery = {
  imports: {
    total: number
    page: number
    hits: Array<{
      activityDate: string | null
      archived: boolean | null
      channel: string | null
      createdDate: string
      email: string | null
      fileImportId: string | null
      id: string
      isScheduled: boolean | null
      locationId: string
      name: string
      orgId: string
      phone: string | null
      requestedAppointmentTime: string | null
      staff: string | null
      treatment: string | null
      type: string
      updatedDate: string
      utmCampaign: string | null
      utmMedium: string | null
      utmSource: string | null
      vendor: string | null
      version: number
      workspaceId: string
    }>
  }
}

export type ImportDetailStoreQueryVariables = Exact<{
  id: string
}>

export type ImportDetailStoreQuery = {
  importDetail: {
    activityDate: string | null
    archived: boolean | null
    channel: string | null
    createdDate: string
    email: string | null
    fileImportId: string | null
    id: string
    isScheduled: boolean | null
    locationId: string
    name: string
    orgId: string
    phone: string | null
    requestedAppointmentTime: string | null
    staff: string | null
    treatment: string | null
    type: string
    updatedDate: string
    utmCampaign: string | null
    utmMedium: string | null
    utmSource: string | null
    vendor: string | null
    version: number
    workspaceId: string
  }
}

export type IncomingCallsQueryVariables = Exact<{ [key: string]: never }>

export type IncomingCallsQuery = {
  incomingCalls: Array<{
    id: string
    workspaceId: string
    locationId: string
    callerPhone: string
    callerName: string | null
    callerCity: string | null
    callerState: string | null
    source: string | null
    trackingNumber: string | null
    trackingNumberName: string | null
    startedAt: string
    contactIds: Array<string>
  }>
}

export type ListsStoreQueryVariables = Exact<{ [key: string]: never }>

export type ListsStoreQuery = {
  lists: Array<{
    id: string
    orgId: string
    workspaceId: string
    name: string
    entityType: string
    defaultStageId: string | null
    join: string | null
    system: boolean | null
    visibility: string | null
    createdByUserId: string | null
    version: number
    createdDate: string
    updatedDate: string
    stages: Array<{ id: string; name: string; color: string; system: boolean | null }> | null
    filters: Array<{
      attribute: string
      secondaryAttribute: string | null
      displayName: string | null
      operator: string
      value: Record<string, unknown> | null
      secondaryValue: Array<string> | null
      static: boolean | null
      uniqOperator: string | null
      readOnly: boolean | null
      nonEmpty: boolean | null
      useAsterisk: boolean | null
      group: string | null
      subQuery: string | null
      type: string | null
      defaultValue: Record<string, unknown> | null
      dateOperator: string | null
      includeToday: boolean | null
      includeYesterday: boolean | null
      includeWeeks: boolean | null
      limitToMonth: boolean | null
      includeInThePast: boolean | null
      options: Record<string, unknown> | null
    }> | null
  }>
}

export type ListQueryVariables = Exact<{
  id: string
}>

export type ListQuery = {
  list: {
    id: string
    orgId: string
    workspaceId: string
    name: string
    entityType: string
    defaultStageId: string | null
    join: string | null
    system: boolean | null
    visibility: string | null
    createdByUserId: string | null
    version: number
    createdDate: string
    updatedDate: string
    stages: Array<{ id: string; name: string; color: string; system: boolean | null }> | null
    filters: Array<{
      attribute: string
      secondaryAttribute: string | null
      displayName: string | null
      operator: string
      value: Record<string, unknown> | null
      secondaryValue: Array<string> | null
      static: boolean | null
      uniqOperator: string | null
      readOnly: boolean | null
      nonEmpty: boolean | null
      useAsterisk: boolean | null
      group: string | null
      subQuery: string | null
      type: string | null
      defaultValue: Record<string, unknown> | null
      dateOperator: string | null
      includeToday: boolean | null
      includeYesterday: boolean | null
      includeWeeks: boolean | null
      limitToMonth: boolean | null
      includeInThePast: boolean | null
      options: Record<string, unknown> | null
    }> | null
  }
}

export type CreateListMutationVariables = Exact<{
  input: CreateListInput
}>

export type CreateListMutation = {
  createList: {
    id: string
    orgId: string
    workspaceId: string
    name: string
    entityType: string
    defaultStageId: string | null
    join: string | null
    system: boolean | null
    visibility: string | null
    createdByUserId: string | null
    version: number
    createdDate: string
    updatedDate: string
    stages: Array<{ id: string; name: string; color: string; system: boolean | null }> | null
    filters: Array<{
      attribute: string
      secondaryAttribute: string | null
      displayName: string | null
      operator: string
      value: Record<string, unknown> | null
      secondaryValue: Array<string> | null
      static: boolean | null
      uniqOperator: string | null
      readOnly: boolean | null
      nonEmpty: boolean | null
      useAsterisk: boolean | null
      group: string | null
      subQuery: string | null
      type: string | null
      defaultValue: Record<string, unknown> | null
      dateOperator: string | null
      includeToday: boolean | null
      includeYesterday: boolean | null
      includeWeeks: boolean | null
      limitToMonth: boolean | null
      includeInThePast: boolean | null
      options: Record<string, unknown> | null
    }> | null
  }
}

export type UpdateListMutationVariables = Exact<{
  id: string
  input: UpdateListInput
}>

export type UpdateListMutation = {
  updateList: {
    id: string
    orgId: string
    workspaceId: string
    name: string
    entityType: string
    defaultStageId: string | null
    join: string | null
    system: boolean | null
    visibility: string | null
    createdByUserId: string | null
    version: number
    createdDate: string
    updatedDate: string
    stages: Array<{ id: string; name: string; color: string; system: boolean | null }> | null
    filters: Array<{
      attribute: string
      secondaryAttribute: string | null
      displayName: string | null
      operator: string
      value: Record<string, unknown> | null
      secondaryValue: Array<string> | null
      static: boolean | null
      uniqOperator: string | null
      readOnly: boolean | null
      nonEmpty: boolean | null
      useAsterisk: boolean | null
      group: string | null
      subQuery: string | null
      type: string | null
      defaultValue: Record<string, unknown> | null
      dateOperator: string | null
      includeToday: boolean | null
      includeYesterday: boolean | null
      includeWeeks: boolean | null
      limitToMonth: boolean | null
      includeInThePast: boolean | null
      options: Record<string, unknown> | null
    }> | null
  }
}

export type DeleteListMutationVariables = Exact<{
  id: string
}>

export type DeleteListMutation = { deleteList: boolean }

export type LocationStoreLocationsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type LocationStoreLocationsQuery = {
  locations: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      orgId: string
      workspaceId: string
      name: string
      pms: string | null
      pmsIntegratedDate: string | null
      migrationDate: string | null
      sikkaOfficeId: string | null
      sikkaPracticeId: string | null
      kollaConnectorId: string | null
      kollaConsumerId: string | null
      kollaPracticeId: string | null
      kollaPageSize: number | null
      availabilityMode: string | null
      callRailCompanyId: string | null
      elevenLabsAgentId: string | null
      callRailBackfillStartDate: string | null
      jotformFormIds: Array<string> | null
      facebookFormIds: Array<string> | null
      carestackId: string | null
      ringCentralPhoneNumbers: Array<string> | null
      primaryNumberId: string | null
      officeTransferNumberId: string | null
      googleAdsCustomerId: string | null
      facebookAdSetIds: Array<string> | null
      city: string | null
      state: string | null
      address: string | null
      zip: string | null
      phone: string | null
      description: string | null
      addressLine2: string | null
      timezone: string | null
      tags: Array<string> | null
      orgTags: Array<string> | null
      labels: Array<string> | null
      products: Array<string> | null
      type: string | null
      primaryTrackingNumber: string | null
      primarySmsNumber: string | null
      businessPhone: string | null
      officeMainNumber: string | null
      officeTransferNumber: string | null
      jotFormIgnoredForms: Array<string> | null
      lastPmsSyncDate: string | null
      lastSyncFailureDate: string | null
      lastPmsSyncStartDate: string | null
      lastPmsSyncCompleteDate: string | null
      currentStatus: string | null
      lastRingCentralSyncDate: string | null
      lastCallrailWebhookDate: string | null
      lastTwilioWebhookDate: string | null
      lastAICallDate: string | null
      lastSikkaWebhookDate: string | null
      lastJotformWebhookDate: string | null
      lastFacebookWebhookDate: string | null
      facebookSpendUpdateDate: string | null
      googleSpendUpdateDate: string | null
      facebookAdsActive: boolean | null
      googleAdsActive: boolean | null
      isSchedulerLive: boolean | null
      isAIAgentLive: boolean | null
      allowDoubleBookingScheduling: boolean | null
      gravityFormsKey: string | null
      webflowFormsKey: string | null
      archived: boolean | null
      lastGravityFormWebhookDate: string | null
      lastPatientSyncDate: string | null
      lastAppointmentSyncDate: string | null
      lastTransactionSyncDate: string | null
      lastProcedureSyncDate: string | null
      lastTreatmentPlanSyncDate: string | null
      lastPatientReceivedDate: string | null
      lastAppointmentReceivedDate: string | null
      lastTransactionReceivedDate: string | null
      lastProcedureReceivedDate: string | null
      lastTreatmentPlanReceivedDate: string | null
      ascendLocationId: string | null
      alarmQuietStart: string | null
      alarmQuietEnd: string | null
      dailySyncHour: number | null
      pmsIntegrated: boolean
      twilioNumbers: Array<{
        id: string | null
        type: string
        phone: string | null
        sourceName: string | null
        label: string | null
        poolId: string | null
        areaCode: string | null
        poolSize: number | null
        sessionDuration: number | null
      }> | null
      openHours: {
        sunday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        monday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        tuesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        wednesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        thursday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        friday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
        saturday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      } | null
      callRailRouting: Array<{ tag: string | null; locationId: string | null }> | null
      notes: Array<{ text: string; date: string; userId: string }> | null
      googleAdsV2: Array<{ accountId: string; campaignId: string | null; adGroupId: string | null }> | null
      googleAdsV3: {
        accountId: string
        campaignIds: Array<string> | null
        conversionActions: Record<string, unknown> | null
      } | null
      facebookAdsV2: Array<{ accountId: string | null; campaignId: string | null; adSetId: string | null }> | null
      facebookLeadsPages: Array<{ id: string; formIds: Array<string> | null }> | null
      jotform: Array<{ folderId: string; formIds: Array<string> | null }> | null
      jotformV2: Array<{ labelId: string; formIds: Array<string> | null }> | null
      settings: {
        newPatientCalculation: string | null
        appointmentsSetNewPatient: boolean | null
        appointmentCompletionStatuses: Array<string> | null
        transactionBrokenCodes: Array<string> | null
        newPatientCodes: Array<string> | null
        ignorePII: boolean | null
        excludeParentsFromNewPatients: boolean | null
        firstVisitSetNewPatient: boolean | null
        commLogWritebackEnabled: boolean | null
        commLogWritebackEnabledDate: string | null
        commLogWritebackProvider: string | null
      } | null
    }>
  }
}

export type LocationStoreLocationQueryVariables = Exact<{
  id: string
}>

export type LocationStoreLocationQuery = {
  location: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    pms: string | null
    pmsIntegratedDate: string | null
    migrationDate: string | null
    sikkaOfficeId: string | null
    sikkaPracticeId: string | null
    kollaConnectorId: string | null
    kollaConsumerId: string | null
    kollaPracticeId: string | null
    kollaPageSize: number | null
    availabilityMode: string | null
    callRailCompanyId: string | null
    elevenLabsAgentId: string | null
    callRailBackfillStartDate: string | null
    jotformFormIds: Array<string> | null
    facebookFormIds: Array<string> | null
    carestackId: string | null
    ringCentralPhoneNumbers: Array<string> | null
    primaryNumberId: string | null
    officeTransferNumberId: string | null
    googleAdsCustomerId: string | null
    facebookAdSetIds: Array<string> | null
    city: string | null
    state: string | null
    address: string | null
    zip: string | null
    phone: string | null
    description: string | null
    addressLine2: string | null
    timezone: string | null
    tags: Array<string> | null
    orgTags: Array<string> | null
    labels: Array<string> | null
    products: Array<string> | null
    type: string | null
    primaryTrackingNumber: string | null
    primarySmsNumber: string | null
    businessPhone: string | null
    officeMainNumber: string | null
    officeTransferNumber: string | null
    jotFormIgnoredForms: Array<string> | null
    lastPmsSyncDate: string | null
    lastSyncFailureDate: string | null
    lastPmsSyncStartDate: string | null
    lastPmsSyncCompleteDate: string | null
    currentStatus: string | null
    lastRingCentralSyncDate: string | null
    lastCallrailWebhookDate: string | null
    lastTwilioWebhookDate: string | null
    lastAICallDate: string | null
    lastSikkaWebhookDate: string | null
    lastJotformWebhookDate: string | null
    lastFacebookWebhookDate: string | null
    facebookSpendUpdateDate: string | null
    googleSpendUpdateDate: string | null
    facebookAdsActive: boolean | null
    googleAdsActive: boolean | null
    isSchedulerLive: boolean | null
    isAIAgentLive: boolean | null
    allowDoubleBookingScheduling: boolean | null
    gravityFormsKey: string | null
    webflowFormsKey: string | null
    archived: boolean | null
    lastGravityFormWebhookDate: string | null
    lastPatientSyncDate: string | null
    lastAppointmentSyncDate: string | null
    lastTransactionSyncDate: string | null
    lastProcedureSyncDate: string | null
    lastTreatmentPlanSyncDate: string | null
    lastPatientReceivedDate: string | null
    lastAppointmentReceivedDate: string | null
    lastTransactionReceivedDate: string | null
    lastProcedureReceivedDate: string | null
    lastTreatmentPlanReceivedDate: string | null
    ascendLocationId: string | null
    alarmQuietStart: string | null
    alarmQuietEnd: string | null
    dailySyncHour: number | null
    pmsIntegrated: boolean
    twilioNumbers: Array<{
      id: string | null
      type: string
      phone: string | null
      sourceName: string | null
      label: string | null
      poolId: string | null
      areaCode: string | null
      poolSize: number | null
      sessionDuration: number | null
    }> | null
    openHours: {
      sunday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      monday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      tuesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      wednesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      thursday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      friday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      saturday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
    } | null
    callRailRouting: Array<{ tag: string | null; locationId: string | null }> | null
    notes: Array<{ text: string; date: string; userId: string }> | null
    googleAdsV2: Array<{ accountId: string; campaignId: string | null; adGroupId: string | null }> | null
    googleAdsV3: {
      accountId: string
      campaignIds: Array<string> | null
      conversionActions: Record<string, unknown> | null
    } | null
    facebookAdsV2: Array<{ accountId: string | null; campaignId: string | null; adSetId: string | null }> | null
    facebookLeadsPages: Array<{ id: string; formIds: Array<string> | null }> | null
    jotform: Array<{ folderId: string; formIds: Array<string> | null }> | null
    jotformV2: Array<{ labelId: string; formIds: Array<string> | null }> | null
    settings: {
      newPatientCalculation: string | null
      appointmentsSetNewPatient: boolean | null
      appointmentCompletionStatuses: Array<string> | null
      transactionBrokenCodes: Array<string> | null
      newPatientCodes: Array<string> | null
      ignorePII: boolean | null
      excludeParentsFromNewPatients: boolean | null
      firstVisitSetNewPatient: boolean | null
      commLogWritebackEnabled: boolean | null
      commLogWritebackEnabledDate: string | null
      commLogWritebackProvider: string | null
    } | null
  } | null
}

export type LocationStoreCreateMutationVariables = Exact<{
  input: CreateLocationInput
}>

export type LocationStoreCreateMutation = {
  createLocation: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    pms: string | null
    pmsIntegratedDate: string | null
    migrationDate: string | null
    sikkaOfficeId: string | null
    sikkaPracticeId: string | null
    kollaConnectorId: string | null
    kollaConsumerId: string | null
    kollaPracticeId: string | null
    kollaPageSize: number | null
    availabilityMode: string | null
    callRailCompanyId: string | null
    elevenLabsAgentId: string | null
    callRailBackfillStartDate: string | null
    jotformFormIds: Array<string> | null
    facebookFormIds: Array<string> | null
    carestackId: string | null
    ringCentralPhoneNumbers: Array<string> | null
    primaryNumberId: string | null
    officeTransferNumberId: string | null
    googleAdsCustomerId: string | null
    facebookAdSetIds: Array<string> | null
    city: string | null
    state: string | null
    address: string | null
    zip: string | null
    phone: string | null
    description: string | null
    addressLine2: string | null
    timezone: string | null
    tags: Array<string> | null
    orgTags: Array<string> | null
    labels: Array<string> | null
    products: Array<string> | null
    type: string | null
    primaryTrackingNumber: string | null
    primarySmsNumber: string | null
    businessPhone: string | null
    officeMainNumber: string | null
    officeTransferNumber: string | null
    jotFormIgnoredForms: Array<string> | null
    lastPmsSyncDate: string | null
    lastSyncFailureDate: string | null
    lastPmsSyncStartDate: string | null
    lastPmsSyncCompleteDate: string | null
    currentStatus: string | null
    lastRingCentralSyncDate: string | null
    lastCallrailWebhookDate: string | null
    lastTwilioWebhookDate: string | null
    lastAICallDate: string | null
    lastSikkaWebhookDate: string | null
    lastJotformWebhookDate: string | null
    lastFacebookWebhookDate: string | null
    facebookSpendUpdateDate: string | null
    googleSpendUpdateDate: string | null
    facebookAdsActive: boolean | null
    googleAdsActive: boolean | null
    isSchedulerLive: boolean | null
    isAIAgentLive: boolean | null
    allowDoubleBookingScheduling: boolean | null
    gravityFormsKey: string | null
    webflowFormsKey: string | null
    archived: boolean | null
    lastGravityFormWebhookDate: string | null
    lastPatientSyncDate: string | null
    lastAppointmentSyncDate: string | null
    lastTransactionSyncDate: string | null
    lastProcedureSyncDate: string | null
    lastTreatmentPlanSyncDate: string | null
    lastPatientReceivedDate: string | null
    lastAppointmentReceivedDate: string | null
    lastTransactionReceivedDate: string | null
    lastProcedureReceivedDate: string | null
    lastTreatmentPlanReceivedDate: string | null
    ascendLocationId: string | null
    alarmQuietStart: string | null
    alarmQuietEnd: string | null
    dailySyncHour: number | null
    pmsIntegrated: boolean
    twilioNumbers: Array<{
      id: string | null
      type: string
      phone: string | null
      sourceName: string | null
      label: string | null
      poolId: string | null
      areaCode: string | null
      poolSize: number | null
      sessionDuration: number | null
    }> | null
    openHours: {
      sunday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      monday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      tuesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      wednesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      thursday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      friday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      saturday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
    } | null
    callRailRouting: Array<{ tag: string | null; locationId: string | null }> | null
    notes: Array<{ text: string; date: string; userId: string }> | null
    googleAdsV2: Array<{ accountId: string; campaignId: string | null; adGroupId: string | null }> | null
    googleAdsV3: {
      accountId: string
      campaignIds: Array<string> | null
      conversionActions: Record<string, unknown> | null
    } | null
    facebookAdsV2: Array<{ accountId: string | null; campaignId: string | null; adSetId: string | null }> | null
    facebookLeadsPages: Array<{ id: string; formIds: Array<string> | null }> | null
    jotform: Array<{ folderId: string; formIds: Array<string> | null }> | null
    jotformV2: Array<{ labelId: string; formIds: Array<string> | null }> | null
    settings: {
      newPatientCalculation: string | null
      appointmentsSetNewPatient: boolean | null
      appointmentCompletionStatuses: Array<string> | null
      transactionBrokenCodes: Array<string> | null
      newPatientCodes: Array<string> | null
      ignorePII: boolean | null
      excludeParentsFromNewPatients: boolean | null
      firstVisitSetNewPatient: boolean | null
      commLogWritebackEnabled: boolean | null
      commLogWritebackEnabledDate: string | null
      commLogWritebackProvider: string | null
    } | null
  }
}

export type LocationStoreUpdateMutationVariables = Exact<{
  id: string
  input: UpdateLocationInput
}>

export type LocationStoreUpdateMutation = {
  updateLocation: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    pms: string | null
    pmsIntegratedDate: string | null
    migrationDate: string | null
    sikkaOfficeId: string | null
    sikkaPracticeId: string | null
    kollaConnectorId: string | null
    kollaConsumerId: string | null
    kollaPracticeId: string | null
    kollaPageSize: number | null
    availabilityMode: string | null
    callRailCompanyId: string | null
    elevenLabsAgentId: string | null
    callRailBackfillStartDate: string | null
    jotformFormIds: Array<string> | null
    facebookFormIds: Array<string> | null
    carestackId: string | null
    ringCentralPhoneNumbers: Array<string> | null
    primaryNumberId: string | null
    officeTransferNumberId: string | null
    googleAdsCustomerId: string | null
    facebookAdSetIds: Array<string> | null
    city: string | null
    state: string | null
    address: string | null
    zip: string | null
    phone: string | null
    description: string | null
    addressLine2: string | null
    timezone: string | null
    tags: Array<string> | null
    orgTags: Array<string> | null
    labels: Array<string> | null
    products: Array<string> | null
    type: string | null
    primaryTrackingNumber: string | null
    primarySmsNumber: string | null
    businessPhone: string | null
    officeMainNumber: string | null
    officeTransferNumber: string | null
    jotFormIgnoredForms: Array<string> | null
    lastPmsSyncDate: string | null
    lastSyncFailureDate: string | null
    lastPmsSyncStartDate: string | null
    lastPmsSyncCompleteDate: string | null
    currentStatus: string | null
    lastRingCentralSyncDate: string | null
    lastCallrailWebhookDate: string | null
    lastTwilioWebhookDate: string | null
    lastAICallDate: string | null
    lastSikkaWebhookDate: string | null
    lastJotformWebhookDate: string | null
    lastFacebookWebhookDate: string | null
    facebookSpendUpdateDate: string | null
    googleSpendUpdateDate: string | null
    facebookAdsActive: boolean | null
    googleAdsActive: boolean | null
    isSchedulerLive: boolean | null
    isAIAgentLive: boolean | null
    allowDoubleBookingScheduling: boolean | null
    gravityFormsKey: string | null
    webflowFormsKey: string | null
    archived: boolean | null
    lastGravityFormWebhookDate: string | null
    lastPatientSyncDate: string | null
    lastAppointmentSyncDate: string | null
    lastTransactionSyncDate: string | null
    lastProcedureSyncDate: string | null
    lastTreatmentPlanSyncDate: string | null
    lastPatientReceivedDate: string | null
    lastAppointmentReceivedDate: string | null
    lastTransactionReceivedDate: string | null
    lastProcedureReceivedDate: string | null
    lastTreatmentPlanReceivedDate: string | null
    ascendLocationId: string | null
    alarmQuietStart: string | null
    alarmQuietEnd: string | null
    dailySyncHour: number | null
    pmsIntegrated: boolean
    twilioNumbers: Array<{
      id: string | null
      type: string
      phone: string | null
      sourceName: string | null
      label: string | null
      poolId: string | null
      areaCode: string | null
      poolSize: number | null
      sessionDuration: number | null
    }> | null
    openHours: {
      sunday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      monday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      tuesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      wednesday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      thursday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      friday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
      saturday: { open: boolean; hours: Array<{ from: string; to: string }> } | null
    } | null
    callRailRouting: Array<{ tag: string | null; locationId: string | null }> | null
    notes: Array<{ text: string; date: string; userId: string }> | null
    googleAdsV2: Array<{ accountId: string; campaignId: string | null; adGroupId: string | null }> | null
    googleAdsV3: {
      accountId: string
      campaignIds: Array<string> | null
      conversionActions: Record<string, unknown> | null
    } | null
    facebookAdsV2: Array<{ accountId: string | null; campaignId: string | null; adSetId: string | null }> | null
    facebookLeadsPages: Array<{ id: string; formIds: Array<string> | null }> | null
    jotform: Array<{ folderId: string; formIds: Array<string> | null }> | null
    jotformV2: Array<{ labelId: string; formIds: Array<string> | null }> | null
    settings: {
      newPatientCalculation: string | null
      appointmentsSetNewPatient: boolean | null
      appointmentCompletionStatuses: Array<string> | null
      transactionBrokenCodes: Array<string> | null
      newPatientCodes: Array<string> | null
      ignorePII: boolean | null
      excludeParentsFromNewPatients: boolean | null
      firstVisitSetNewPatient: boolean | null
      commLogWritebackEnabled: boolean | null
      commLogWritebackEnabledDate: string | null
      commLogWritebackProvider: string | null
    } | null
  }
}

export type DeleteLocationMutationVariables = Exact<{
  id: string
}>

export type DeleteLocationMutation = { deleteLocation: boolean }

export type MessagesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type MessagesQuery = {
  messages: {
    total: number
    page: number
    hits: Array<{
      aiWorkflowId: string | null
      aiWorkflowName: string | null
      isInitialMessage: boolean | null
      archived: boolean | null
      callerId: string | null
      channel: string
      contactId: string | null
      createdDate: string
      errorCode: string | null
      errorMessage: string | null
      from: string
      htmlBody: string | null
      id: string
      isAgent: boolean | null
      locationId: string
      orgId: string
      providerMessageId: string | null
      read: boolean | null
      sentByUserId: string | null
      status: string | null
      subject: string | null
      text: string
      threadId: string | null
      to: string
      updatedDate: string
      version: number
      workspaceId: string
      attachments: Array<{ filename: string; contentType: string; sizeBytes: number }> | null
    }>
  }
}

export type MessageQueryVariables = Exact<{
  id: string
}>

export type MessageQuery = {
  message: {
    aiWorkflowId: string | null
    aiWorkflowName: string | null
    isInitialMessage: boolean | null
    archived: boolean | null
    callerId: string | null
    channel: string
    contactId: string | null
    createdDate: string
    errorCode: string | null
    errorMessage: string | null
    from: string
    htmlBody: string | null
    id: string
    isAgent: boolean | null
    locationId: string
    orgId: string
    providerMessageId: string | null
    read: boolean | null
    sentByUserId: string | null
    status: string | null
    subject: string | null
    text: string
    threadId: string | null
    to: string
    updatedDate: string
    version: number
    workspaceId: string
    attachments: Array<{ filename: string; contentType: string; sizeBytes: number }> | null
  }
}

export type SendContactEmailMutationVariables = Exact<{
  input: SendContactEmailInput
}>

export type SendContactEmailMutation = {
  sendContactEmail: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    threadId: string | null
    from: string
    to: string
    sentByUserId: string | null
    isAgent: boolean | null
    contactId: string | null
    channel: string
    subject: string | null
    htmlBody: string | null
    text: string
    read: boolean | null
    archived: boolean | null
    createdDate: string
    updatedDate: string
    status: string | null
    providerMessageId: string | null
    errorCode: string | null
    errorMessage: string | null
    attachments: Array<{ filename: string; contentType: string; sizeBytes: number }> | null
  }
}

export type NoteTemplatesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type NoteTemplatesQuery = {
  noteTemplates: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      orgId: string
      workspaceId: string
      name: string
      body: string
    }>
  }
}

export type NoteTemplateQueryVariables = Exact<{
  id: string
}>

export type NoteTemplateQuery = {
  noteTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    body: string
  }
}

export type CreateNoteTemplateMutationVariables = Exact<{
  input: CreateNoteTemplateInput
}>

export type CreateNoteTemplateMutation = {
  createNoteTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    body: string
  }
}

export type UpdateNoteTemplateMutationVariables = Exact<{
  id: string
  input: UpdateNoteTemplateInput
}>

export type UpdateNoteTemplateMutation = {
  updateNoteTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    body: string
  }
}

export type DeleteNoteTemplateMutationVariables = Exact<{
  id: string
}>

export type DeleteNoteTemplateMutation = { deleteNoteTemplate: boolean }

export type NotificationsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type NotificationsQuery = {
  notifications: {
    total: number
    page: number
    hits: Array<{
      activityId: string | null
      archived: boolean | null
      clicked: boolean | null
      contactId: string | null
      createdDate: string
      id: string
      locationId: string | null
      managedNotification: boolean | null
      medium: string
      messageId: string | null
      objectType: string
      orgId: string
      read: boolean | null
      triggerDate: string
      types: Array<string> | null
      updatedDate: string
      userId: string
      version: number
      workflowId: string | null
      workflowReason: string | null
      workflowStep: string | null
      workspaceId: string
    }>
  }
}

export type NotificationQueryVariables = Exact<{
  id: string
}>

export type NotificationQuery = {
  notification: {
    activityId: string | null
    archived: boolean | null
    clicked: boolean | null
    contactId: string | null
    createdDate: string
    id: string
    locationId: string | null
    managedNotification: boolean | null
    medium: string
    messageId: string | null
    objectType: string
    orgId: string
    read: boolean | null
    triggerDate: string
    types: Array<string> | null
    updatedDate: string
    userId: string
    version: number
    workflowId: string | null
    workflowReason: string | null
    workflowStep: string | null
    workspaceId: string
  } | null
}

export type UpdateNotificationMutationVariables = Exact<{
  id: string
  input: UpdateNotificationInput
}>

export type UpdateNotificationMutation = {
  updateNotification: {
    activityId: string | null
    archived: boolean | null
    clicked: boolean | null
    contactId: string | null
    createdDate: string
    id: string
    locationId: string | null
    managedNotification: boolean | null
    medium: string
    messageId: string | null
    objectType: string
    orgId: string
    read: boolean | null
    triggerDate: string
    types: Array<string> | null
    updatedDate: string
    userId: string
    version: number
    workflowId: string | null
    workflowReason: string | null
    workflowStep: string | null
    workspaceId: string
  }
}

export type NotificationUnreadCountQueryVariables = Exact<{ [key: string]: never }>

export type NotificationUnreadCountQuery = { notifications: { total: number } }

export type MarkAllNotificationsReadMutationVariables = Exact<{ [key: string]: never }>

export type MarkAllNotificationsReadMutation = { markAllNotificationsRead: { success: boolean | null } }

export type ResetNotificationUnseenMutationVariables = Exact<{ [key: string]: never }>

export type ResetNotificationUnseenMutation = { resetNotificationUnseen: { success: boolean | null } }

export type PatientsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type PatientsQuery = {
  patients: {
    total: number
    page: number
    hits: Array<{
      birthDate: string | null
      cellPhone: string | null
      createdDate: string
      email: string | null
      firstName: string | null
      firstVisit: string | null
      gender: string | null
      guarantorFirstName: string | null
      guarantorId: string | null
      guarantorLastName: string | null
      homePhone: string | null
      id: string
      insuranceProvider: string | null
      lastName: string | null
      lastVisit: string | null
      locationId: string
      patientReferral: string | null
      preferredName: string | null
      referralType: string | null
      status: string | null
      subscriberId: string | null
      updatedDate: string
      version: number
      workPhone: string | null
    }>
  }
}

export type PatientQueryVariables = Exact<{
  id: string
}>

export type PatientQuery = {
  patient: {
    birthDate: string | null
    cellPhone: string | null
    createdDate: string
    email: string | null
    firstName: string | null
    firstVisit: string | null
    gender: string | null
    guarantorFirstName: string | null
    guarantorId: string | null
    guarantorLastName: string | null
    homePhone: string | null
    id: string
    insuranceProvider: string | null
    lastName: string | null
    lastVisit: string | null
    locationId: string
    patientReferral: string | null
    preferredName: string | null
    referralType: string | null
    status: string | null
    subscriberId: string | null
    updatedDate: string
    version: number
    workPhone: string | null
  }
}

export type PipelinesStoreQueryVariables = Exact<{ [key: string]: never }>

export type PipelinesStoreQuery = {
  pipelines: Array<{
    id: string
    name: string
    orgId: string
    workspaceId: string
    stages: Array<{ name: string; color: string; order: number }> | null
  }>
}

export type PipelineQueryVariables = Exact<{
  id: string
}>

export type PipelineQuery = {
  pipeline: {
    id: string
    name: string
    orgId: string
    workspaceId: string
    stages: Array<{ name: string; color: string; order: number }> | null
  }
}

export type CreatePipelineMutationVariables = Exact<{
  input: CreatePipelineInput
}>

export type CreatePipelineMutation = {
  createPipeline: {
    id: string
    name: string
    orgId: string
    workspaceId: string
    stages: Array<{ name: string; color: string; order: number }> | null
  }
}

export type UpdatePipelineMutationVariables = Exact<{
  id: string
  input: UpdatePipelineInput
}>

export type UpdatePipelineMutation = {
  updatePipeline: {
    id: string
    name: string
    orgId: string
    workspaceId: string
    stages: Array<{ name: string; color: string; order: number }> | null
  }
}

export type DeletePipelineMutationVariables = Exact<{
  id: string
}>

export type DeletePipelineMutation = { deletePipeline: boolean }

export type ProceduresQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ProceduresQuery = {
  procedures: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      vendor: string | null
      vendorId: string
      patientId: string | null
      providerId: string | null
      procedureCode: string | null
      description: string | null
      tooth: string | null
      state: string | null
      priority: string | null
      feeAmount: number | null
      billedAmount: number | null
      appointmentIds: Array<string> | null
      planIds: Array<string> | null
      procedureCreateDate: string | null
      procedureUpdateDate: string | null
      createdDate: string
      updatedDate: string
      version: number
    }>
  }
}

export type ProcedureQueryVariables = Exact<{
  id: string
}>

export type ProcedureQuery = {
  procedure: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    vendor: string | null
    vendorId: string
    patientId: string | null
    providerId: string | null
    procedureCode: string | null
    description: string | null
    tooth: string | null
    state: string | null
    priority: string | null
    feeAmount: number | null
    billedAmount: number | null
    appointmentIds: Array<string> | null
    planIds: Array<string> | null
    procedureCreateDate: string | null
    procedureUpdateDate: string | null
    createdDate: string
    updatedDate: string
    version: number
  }
}

export type ProvidersQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ProvidersQuery = {
  providers: {
    total: number
    page: number
    hits: Array<{
      createdDate: string
      deactivated: boolean | null
      displayName: string
      hasProfilePicture: boolean | null
      id: string
      isPrimary: boolean | null
      kollaConsumerId: string
      orgId: string
      pmsDisplayName: string | null
      pmsShortDisplayName: string | null
      practiceIds: Array<string> | null
      priority: number | null
      resourceName: string
      taxonomy: string | null
      updatedDate: string
      vendor: string | null
      vendorId: string
      version: number
      workspaceId: string
    }>
  }
}

export type ProviderQueryVariables = Exact<{
  id: string
}>

export type ProviderQuery = {
  provider: {
    createdDate: string
    deactivated: boolean | null
    displayName: string
    hasProfilePicture: boolean | null
    id: string
    isPrimary: boolean | null
    kollaConsumerId: string
    orgId: string
    pmsDisplayName: string | null
    pmsShortDisplayName: string | null
    practiceIds: Array<string> | null
    priority: number | null
    resourceName: string
    taxonomy: string | null
    updatedDate: string
    vendor: string | null
    vendorId: string
    version: number
    workspaceId: string
  }
}

export type UpdateProviderMutationVariables = Exact<{
  id: string
  input: UpdateProviderInput
}>

export type UpdateProviderMutation = {
  updateProvider: {
    createdDate: string
    deactivated: boolean | null
    displayName: string
    hasProfilePicture: boolean | null
    id: string
    isPrimary: boolean | null
    kollaConsumerId: string
    orgId: string
    pmsDisplayName: string | null
    pmsShortDisplayName: string | null
    practiceIds: Array<string> | null
    priority: number | null
    resourceName: string
    taxonomy: string | null
    updatedDate: string
    vendor: string | null
    vendorId: string
    version: number
    workspaceId: string
  }
}

export type RolesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type RolesQuery = {
  roles: {
    total: number
    page: number
    hits: Array<{
      createdDate: string
      id: string
      isDefault: boolean
      name: string
      orgId: string
      permissions: Array<string>
      updatedDate: string
      version: number
      workspaceId: string | null
    }>
  }
}

export type RoleQueryVariables = Exact<{
  id: string
}>

export type RoleQuery = {
  role: {
    createdDate: string
    id: string
    isDefault: boolean
    name: string
    orgId: string
    permissions: Array<string>
    updatedDate: string
    version: number
    workspaceId: string | null
  } | null
}

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput
}>

export type CreateRoleMutation = {
  createRole: {
    createdDate: string
    id: string
    isDefault: boolean
    name: string
    orgId: string
    permissions: Array<string>
    updatedDate: string
    version: number
    workspaceId: string | null
  }
}

export type UpdateRoleMutationVariables = Exact<{
  id: string
  input: UpdateRoleInput
}>

export type UpdateRoleMutation = {
  updateRole: {
    createdDate: string
    id: string
    isDefault: boolean
    name: string
    orgId: string
    permissions: Array<string>
    updatedDate: string
    version: number
    workspaceId: string | null
  }
}

export type DeleteRoleMutationVariables = Exact<{
  id: string
}>

export type DeleteRoleMutation = { deleteRole: boolean }

export type ScorecardsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type ScorecardsQuery = {
  scorecards: {
    total: number
    page: number
    hits: Array<{
      objectIds: Array<string> | null
      dateRange: string | null
      lookbackType: string | null
      lookbackAmount: number | null
      columnVisibility: Record<string, unknown> | null
      columnOrder: Array<string> | null
      sort: Record<string, unknown> | null
      default: boolean | null
      createdDate: string
      grouping: string
      id: string
      name: string
      orgId: string
      updatedDate: string
      version: number
      workspaceId: string
    }>
  }
}

export type CreateScorecardStoreMutationVariables = Exact<{
  input: CreateScorecardInput
}>

export type CreateScorecardStoreMutation = {
  createScorecard: {
    objectIds: Array<string> | null
    dateRange: string | null
    lookbackType: string | null
    lookbackAmount: number | null
    columnVisibility: Record<string, unknown> | null
    columnOrder: Array<string> | null
    sort: Record<string, unknown> | null
    default: boolean | null
    createdDate: string
    grouping: string
    id: string
    name: string
    orgId: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type UpdateScorecardStoreMutationVariables = Exact<{
  id: string
  input: UpdateScorecardInput
}>

export type UpdateScorecardStoreMutation = {
  updateScorecard: {
    objectIds: Array<string> | null
    dateRange: string | null
    lookbackType: string | null
    lookbackAmount: number | null
    columnVisibility: Record<string, unknown> | null
    columnOrder: Array<string> | null
    sort: Record<string, unknown> | null
    default: boolean | null
    createdDate: string
    grouping: string
    id: string
    name: string
    orgId: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type SmsTemplatesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type SmsTemplatesQuery = {
  smsTemplates: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      orgId: string
      workspaceId: string
      name: string
      body: string
    }>
  }
}

export type SmsTemplateQueryVariables = Exact<{
  id: string
}>

export type SmsTemplateQuery = {
  smsTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    body: string
  }
}

export type CreateSmsTemplateMutationVariables = Exact<{
  input: CreateSmsTemplateInput
}>

export type CreateSmsTemplateMutation = {
  createSmsTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    body: string
  }
}

export type UpdateSmsTemplateMutationVariables = Exact<{
  id: string
  input: UpdateSmsTemplateInput
}>

export type UpdateSmsTemplateMutation = {
  updateSmsTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    body: string
  }
}

export type DeleteSmsTemplateMutationVariables = Exact<{
  id: string
}>

export type DeleteSmsTemplateMutation = { deleteSmsTemplate: boolean }

export type TagColorsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type TagColorsQuery = {
  tagColors: {
    total: number
    page: number
    hits: Array<{
      color: string | null
      createdDate: string
      entity: string
      id: string
      isOrgTag: boolean
      lastUsedDate: string | null
      name: string
      orgId: string
      updatedDate: string
      version: number
      workspaceId: string | null
    }>
  }
}

export type TagColorQueryVariables = Exact<{
  id: string
}>

export type TagColorQuery = {
  tagColor: {
    color: string | null
    createdDate: string
    entity: string
    id: string
    isOrgTag: boolean
    lastUsedDate: string | null
    name: string
    orgId: string
    updatedDate: string
    version: number
    workspaceId: string | null
  }
}

export type TasksQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type TasksQuery = {
  tasks: {
    total: number
    page: number
    hits: Array<{
      contactId: string | null
      createdById: string
      createdDate: string
      description: string | null
      dueDate: string
      id: string
      locationId: string
      ownerId: string | null
      roleId: string | null
      completedByUserId: string | null
      status: string
      title: string
      updatedDate: string
      version: number
    }>
  }
}

export type TaskStoreQueryVariables = Exact<{
  id: string
}>

export type TaskStoreQuery = {
  task: {
    contactId: string | null
    createdById: string
    createdDate: string
    description: string | null
    dueDate: string
    id: string
    locationId: string
    ownerId: string | null
    roleId: string | null
    completedByUserId: string | null
    status: string
    title: string
    updatedDate: string
    version: number
  }
}

export type CreateTaskStoreMutationVariables = Exact<{
  input: CreateTaskInput
}>

export type CreateTaskStoreMutation = {
  createTask: {
    contactId: string | null
    createdById: string
    createdDate: string
    description: string | null
    dueDate: string
    id: string
    locationId: string
    ownerId: string | null
    roleId: string | null
    completedByUserId: string | null
    status: string
    title: string
    updatedDate: string
    version: number
  }
}

export type UpdateTaskStoreMutationVariables = Exact<{
  id: string
  input: UpdateTaskInput
}>

export type UpdateTaskStoreMutation = {
  updateTask: {
    contactId: string | null
    createdById: string
    createdDate: string
    description: string | null
    dueDate: string
    id: string
    locationId: string
    ownerId: string | null
    roleId: string | null
    completedByUserId: string | null
    status: string
    title: string
    updatedDate: string
    version: number
  }
}

export type TaskTemplatesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type TaskTemplatesQuery = {
  taskTemplates: {
    total: number
    page: number
    hits: Array<{
      version: number
      createdDate: string
      updatedDate: string
      id: string
      orgId: string
      workspaceId: string
      name: string
      title: string
      description: string | null
      dueInDays: number | null
      ownerId: string | null
    }>
  }
}

export type TaskTemplateQueryVariables = Exact<{
  id: string
}>

export type TaskTemplateQuery = {
  taskTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    title: string
    description: string | null
    dueInDays: number | null
    ownerId: string | null
  }
}

export type CreateTaskTemplateMutationVariables = Exact<{
  input: CreateTaskTemplateInput
}>

export type CreateTaskTemplateMutation = {
  createTaskTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    title: string
    description: string | null
    dueInDays: number | null
    ownerId: string | null
  }
}

export type UpdateTaskTemplateMutationVariables = Exact<{
  id: string
  input: UpdateTaskTemplateInput
}>

export type UpdateTaskTemplateMutation = {
  updateTaskTemplate: {
    version: number
    createdDate: string
    updatedDate: string
    id: string
    orgId: string
    workspaceId: string
    name: string
    title: string
    description: string | null
    dueInDays: number | null
    ownerId: string | null
  }
}

export type DeleteTaskTemplateMutationVariables = Exact<{
  id: string
}>

export type DeleteTaskTemplateMutation = { deleteTaskTemplate: boolean }

export type TransactionsQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type TransactionsQuery = {
  transactions: {
    total: number
    page: number
    hits: Array<{
      amount: number | null
      createdDate: string
      id: string
      locationId: string
      orgId: string | null
      patientId: string
      procedureCode: string | null
      procedureDescription: string | null
      providerId: string | null
      sikkaOfficeId: string | null
      transactionDate: string | null
      transactionEntryDate: string | null
      transactionSrNo: string | null
      transactionType: string | null
      treatmentCategory: string | null
      type: string | null
      updatedDate: string
      vendor: string | null
      version: number
      workspaceId: string | null
    }>
  }
}

export type TransactionQueryVariables = Exact<{
  id: string
}>

export type TransactionQuery = {
  transaction: {
    amount: number | null
    createdDate: string
    id: string
    locationId: string
    orgId: string | null
    patientId: string
    procedureCode: string | null
    procedureDescription: string | null
    providerId: string | null
    sikkaOfficeId: string | null
    transactionDate: string | null
    transactionEntryDate: string | null
    transactionSrNo: string | null
    transactionType: string | null
    treatmentCategory: string | null
    type: string | null
    updatedDate: string
    vendor: string | null
    version: number
    workspaceId: string | null
  }
}

export type TreatmentPlansQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type TreatmentPlansQuery = {
  treatmentPlans: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      locationId: string
      vendor: string | null
      vendorId: string
      patientId: string | null
      displayName: string | null
      state: string | null
      status: string | null
      procedureIds: Array<string> | null
      procedureFeeOverrides: string | null
      planCreateDate: string | null
      planUpdateDate: string | null
      createdDate: string
      updatedDate: string
      version: number
    }>
  }
}

export type TreatmentPlanQueryVariables = Exact<{
  id: string
}>

export type TreatmentPlanQuery = {
  treatmentPlan: {
    id: string
    orgId: string
    workspaceId: string
    locationId: string
    vendor: string | null
    vendorId: string
    patientId: string | null
    displayName: string | null
    state: string | null
    status: string | null
    procedureIds: Array<string> | null
    procedureFeeOverrides: string | null
    planCreateDate: string | null
    planUpdateDate: string | null
    createdDate: string
    updatedDate: string
    version: number
  }
}

export type UnmappedFormKeysQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type UnmappedFormKeysQuery = {
  unmappedFormKeys: {
    total: number
    page: number
    hits: Array<{
      id: string
      orgId: string
      workspaceId: string
      rawKey: string
      vendors: Record<string, unknown> | null
      createdDate: string
      updatedDate: string
      version: number
    }>
  }
}

export type UserSettingsQueryVariables = Exact<{
  key: string
}>

export type UserSettingsQuery = { userSettings: string | null }

export type SaveUserSettingsMutationVariables = Exact<{
  key: string
  value: string
}>

export type SaveUserSettingsMutation = { saveUserSettings: { key: string; value: Record<string, unknown> | null } }

export type UsersQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type UsersQuery = {
  users: {
    total: number
    page: number
    hits: Array<{
      aliases: Array<string> | null
      allowedLocationIds: Array<string> | null
      archived: boolean | null
      assignedLocationIds: Array<string> | null
      assignedWorkspaceIds: Array<string> | null
      createdDate: string
      email: string
      id: string
      jobTitle: string | null
      lastLoginDate: string | null
      name: string | null
      orgId: string
      phone: string | null
      position: string | null
      preferredChannel: string | null
      role: number | null
      roleId: string | null
      timezone: string | null
      type: string
      updatedDate: string
      version: number
      workspaceId: string | null
      workspaces: Array<{ id: string; locationIds: Array<string> | null; roleId: string }> | null
    }>
  }
}

export type UserQueryVariables = Exact<{
  id: string
}>

export type UserQuery = {
  user: {
    aliases: Array<string> | null
    allowedLocationIds: Array<string> | null
    archived: boolean | null
    assignedLocationIds: Array<string> | null
    assignedWorkspaceIds: Array<string> | null
    createdDate: string
    email: string
    id: string
    jobTitle: string | null
    lastLoginDate: string | null
    name: string | null
    orgId: string
    phone: string | null
    position: string | null
    preferredChannel: string | null
    role: number | null
    roleId: string | null
    timezone: string | null
    type: string
    updatedDate: string
    version: number
    workspaceId: string | null
    workspaces: Array<{ id: string; locationIds: Array<string> | null; roleId: string }> | null
  } | null
}

export type DeleteUserMutationVariables = Exact<{
  id: string
}>

export type DeleteUserMutation = { deleteUser: boolean }

export type UpdateUserMutationVariables = Exact<{
  id: string
  input: UpdateUserInput
}>

export type UpdateUserMutation = {
  updateUser: {
    aliases: Array<string> | null
    allowedLocationIds: Array<string> | null
    archived: boolean | null
    assignedLocationIds: Array<string> | null
    assignedWorkspaceIds: Array<string> | null
    createdDate: string
    email: string
    id: string
    jobTitle: string | null
    lastLoginDate: string | null
    name: string | null
    orgId: string
    phone: string | null
    position: string | null
    preferredChannel: string | null
    role: number | null
    roleId: string | null
    timezone: string | null
    type: string
    updatedDate: string
    version: number
    workspaceId: string | null
    workspaces: Array<{ id: string; locationIds: Array<string> | null; roleId: string }> | null
  }
}

export type UtmAliasesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type UtmAliasesQuery = {
  utmAliases: {
    total: number
    page: number
    hits: Array<{
      alias: string
      createdDate: string
      id: string
      orgId: string
      original: string
      type: string
      updatedDate: string
      version: number
      workspaceId: string
    }>
  }
}

export type CreateUtmAliasStoreMutationVariables = Exact<{
  input: CreateUtmAliasInput
}>

export type CreateUtmAliasStoreMutation = {
  createUtmAlias: {
    alias: string
    createdDate: string
    id: string
    orgId: string
    original: string
    type: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type UpdateUtmAliasStoreMutationVariables = Exact<{
  id: string
  input: UpdateUtmAliasInput
}>

export type UpdateUtmAliasStoreMutation = {
  updateUtmAlias: {
    alias: string
    createdDate: string
    id: string
    orgId: string
    original: string
    type: string
    updatedDate: string
    version: number
    workspaceId: string
  }
}

export type WorkspaceInvitesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type WorkspaceInvitesQuery = {
  workspaceInvites: {
    total: number
    page: number
    hits: Array<{
      code: string
      createdAt: string
      createdDate: string
      email: string
      expiresAt: string
      id: string
      invitedBy: string
      locationIds: Array<string> | null
      orgId: string
      roleId: string
      staffId: string | null
      updatedDate: string
      userId: string | null
      version: number
      workspaceId: string
    }>
  }
}

export type WorkspaceInviteQueryVariables = Exact<{
  id: string
}>

export type WorkspaceInviteQuery = {
  workspaceInvite: {
    code: string
    createdAt: string
    createdDate: string
    email: string
    expiresAt: string
    id: string
    invitedBy: string
    locationIds: Array<string> | null
    orgId: string
    roleId: string
    staffId: string | null
    updatedDate: string
    userId: string | null
    version: number
    workspaceId: string
  }
}

export type CreateWorkspaceInviteStoreMutationVariables = Exact<{
  input: CreateWorkspaceInviteInput
}>

export type CreateWorkspaceInviteStoreMutation = {
  createWorkspaceInvite: {
    code: string
    createdAt: string
    createdDate: string
    email: string
    expiresAt: string
    id: string
    invitedBy: string
    locationIds: Array<string> | null
    orgId: string
    roleId: string
    staffId: string | null
    updatedDate: string
    userId: string | null
    version: number
    workspaceId: string
  }
}

export type UpdateWorkspaceInviteMutationVariables = Exact<{
  id: string
  input: UpdateWorkspaceInviteInput
}>

export type UpdateWorkspaceInviteMutation = {
  updateWorkspaceInvite: {
    code: string
    createdAt: string
    createdDate: string
    email: string
    expiresAt: string
    id: string
    invitedBy: string
    locationIds: Array<string> | null
    orgId: string
    roleId: string
    staffId: string | null
    updatedDate: string
    userId: string | null
    version: number
    workspaceId: string
  }
}

export type DeleteWorkspaceInviteMutationVariables = Exact<{
  id: string
}>

export type DeleteWorkspaceInviteMutation = { deleteWorkspaceInvite: boolean }

export type WorkspacesQueryVariables = Exact<{
  search?: string | null | undefined
  pagination?: PaginationInput | null | undefined
  sort?: SortInput | null | undefined
}>

export type WorkspacesQuery = {
  workspaces: {
    total: number
    page: number
    hits: Array<{
      archived: boolean | null
      carestackId: string | null
      createdDate: string
      id: string
      lastFacebookLeadsErrorDate: string | null
      lastPmsSyncDate: string | null
      maxEnrollmentsPerHour: number | null
      maxOutboundDaily: number | null
      maxOutboundMonthly: number | null
      name: string
      orgId: string
      orgTags: Array<string> | null
      promptAddendum: string | null
      updatedDate: string
      version: number
    }>
  }
}

export type UpdateWorkspaceMutationVariables = Exact<{
  id: string
  input: UpdateWorkspaceInput
}>

export type UpdateWorkspaceMutation = {
  updateWorkspace: {
    archived: boolean | null
    carestackId: string | null
    createdDate: string
    id: string
    lastFacebookLeadsErrorDate: string | null
    lastPmsSyncDate: string | null
    maxEnrollmentsPerHour: number | null
    maxOutboundDaily: number | null
    maxOutboundMonthly: number | null
    name: string
    orgId: string
    orgTags: Array<string> | null
    promptAddendum: string | null
    updatedDate: string
    version: number
  }
}

export type WorkspaceQueryVariables = Exact<{
  id: string
}>

export type WorkspaceQuery = {
  workspace: {
    archived: boolean | null
    carestackId: string | null
    createdDate: string
    id: string
    lastFacebookLeadsErrorDate: string | null
    lastPmsSyncDate: string | null
    maxEnrollmentsPerHour: number | null
    maxOutboundDaily: number | null
    maxOutboundMonthly: number | null
    name: string
    orgId: string
    orgTags: Array<string> | null
    promptAddendum: string | null
    updatedDate: string
    version: number
  }
}

export type DeleteWorkspaceMutationVariables = Exact<{
  id: string
}>

export type DeleteWorkspaceMutation = { deleteWorkspace: boolean }

export type UpdateBudgetTableMutationVariables = Exact<{
  id: string
  input: UpdateBudgetInput
}>

export type UpdateBudgetTableMutation = { updateBudget: { id: string | null } }

export type UpdateContactTableMutationVariables = Exact<{
  id: string
  input: UpdateContactInput
}>

export type UpdateContactTableMutation = { updateContact: { id: string } }

export type UpdateTaskTableMutationVariables = Exact<{
  id: string
  input: UpdateTaskInput
}>

export type UpdateTaskTableMutation = { updateTask: { id: string } }

export type SwitchWorkspaceOrgMutationVariables = Exact<{
  targetWorkspaceId?: string | null | undefined
  targetOrgId?: string | null | undefined
}>

export type SwitchWorkspaceOrgMutation = { switchWorkspace: { accessToken: string } }

export const SyncJobProgressFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SyncJobProgress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BackgroundJobProgress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SyncJobProgressFragment, unknown>
export const TaskFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdById' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskFieldsFragment, unknown>
export const LazyPmsCommTypeNameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LazyPmsCommTypeName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'commType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pmsCommTypeName' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'commType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'commType' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LazyPmsCommTypeNameQuery, LazyPmsCommTypeNameQueryVariables>
export const LazyPmsUserNameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LazyPmsUserName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userNum' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pmsUserName' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userNum' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LazyPmsUserNameQuery, LazyPmsUserNameQueryVariables>
export const LazyStaffCellUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LazyStaffCellUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LazyStaffCellUserQuery, LazyStaffCellUserQueryVariables>
export const LazyStaffCellStaffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LazyStaffCellStaff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffMember' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LazyStaffCellStaffQuery, LazyStaffCellStaffQueryVariables>
export const ActionCenterExitStageCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterExitStageCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterExitStageCountQuery, ActionCenterExitStageCountQueryVariables>
export const ActionCenterExitStageContactsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterExitStageContacts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unbookedTreatmentValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adClickDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'leadOwner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'convertedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pipelines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterExitStageContactsQuery, ActionCenterExitStageContactsQueryVariables>
export const ActionCenterSnoozedNamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterSnoozedNames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterSnoozedNamesQuery, ActionCenterSnoozedNamesQueryVariables>
export const ActionCenterNewPatientValueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterNewPatientValue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newPatientsMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'averageProductionPerNewPatientVisit' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterNewPatientValueQuery, ActionCenterNewPatientValueQueryVariables>
export const ActionCenterProductionValueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterProductionValue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revenueMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'avgNetProductionPerVisit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgGrossProductionPerVisit' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterProductionValueQuery, ActionCenterProductionValueQueryVariables>
export const ActionCenterCardCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterCardCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answered' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'waveforms' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ai' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'summary' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterCardCallQuery, ActionCenterCardCallQueryVariables>
export const ActionCenterCardCallRecordingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterCardCallRecording' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecordingUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterCardCallRecordingQuery, ActionCenterCardCallRecordingQueryVariables>
export const ActionCenterUpdateContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActionCenterUpdateContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateContactInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterUpdateContactMutation, ActionCenterUpdateContactMutationVariables>
export const ActionCenterAddToPipelineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActionCenterAddToPipeline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pipeline' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactPipelineInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addToPipeline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pipeline' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pipeline' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pipelines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterAddToPipelineMutation, ActionCenterAddToPipelineMutationVariables>
export const ActionCenterPipelinesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterPipelines' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pipelines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterPipelinesQuery, ActionCenterPipelinesQueryVariables>
export const ActionCenterCloseLostDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActionCenterCloseLost' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateContactInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterCloseLostMutation, ActionCenterCloseLostMutationVariables>
export const ActionCenterCreateFollowUpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActionCenterCreateFollowUp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFollowUpInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFollowUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'followUpDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterCreateFollowUpMutation, ActionCenterCreateFollowUpMutationVariables>
export const ActionCenterResponseQueueMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterResponseQueueMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAgent' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterResponseQueueMessagesQuery, ActionCenterResponseQueueMessagesQueryVariables>
export const ActionCenterContactMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterContactMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isInitialMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterContactMessagesQuery, ActionCenterContactMessagesQueryVariables>
export const ActionCenterLatestAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterLatestAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCodes' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterLatestAppointmentQuery, ActionCenterLatestAppointmentQueryVariables>
export const ActionCenterBandContactsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterBandContacts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unbookedTreatmentValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pipelines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatmentStatus' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterBandContactsQuery, ActionCenterBandContactsQueryVariables>
export const ActionCenterBandAppointmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterBandAppointments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCodes' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterBandAppointmentsQuery, ActionCenterBandAppointmentsQueryVariables>
export const ActionCenterBandProceduresDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterBandProcedures' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'procedures' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tooth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'feeAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'planIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCreateDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterBandProceduresQuery, ActionCenterBandProceduresQueryVariables>
export const ActionCenterBandPlansDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterBandPlans' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'treatmentPlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'planCreateDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterBandPlansQuery, ActionCenterBandPlansQueryVariables>
export const ActionCenterHoldsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterHolds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'queueId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'untilDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterHoldsQuery, ActionCenterHoldsQueryVariables>
export const ActionCenterCreateHoldDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActionCenterCreateHold' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateActionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'queueId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'untilDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterCreateHoldMutation, ActionCenterCreateHoldMutationVariables>
export const ActionCenterWakeHoldDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActionCenterWakeHold' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateActionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'queueId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'untilDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterWakeHoldMutation, ActionCenterWakeHoldMutationVariables>
export const ActionCenterLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionCenterLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryTrackingNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callRailCompanyId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionCenterLocationsQuery, ActionCenterLocationsQueryVariables>
export const ActivateAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActivateAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activateAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'allowGoogle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivateAccountQuery, ActivateAccountQueryVariables>
export const ActivateSetPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActivateSetPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accessToken' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivateSetPasswordMutation, ActivateSetPasswordMutationVariables>
export const ActivateUpdateMeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActivateUpdateMe' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMe' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivateUpdateMeMutation, ActivateUpdateMeMutationVariables>
export const FollowUpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FollowUp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'followUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'followUpDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FollowUpQuery, FollowUpQueryVariables>
export const CreateFollowUpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFollowUp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFollowUpInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFollowUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'followUpDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFollowUpMutation, CreateFollowUpMutationVariables>
export const UpdateFollowUpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFollowUp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFollowUpInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFollowUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'followUpDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFollowUpMutation, UpdateFollowUpMutationVariables>
export const FollowUpFormDeleteFollowUpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FollowUpFormDeleteFollowUp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFollowUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FollowUpFormDeleteFollowUpMutation, FollowUpFormDeleteFollowUpMutationVariables>
export const InboundCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InboundCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ai' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionItems' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'extractionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'people' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tokenUsage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'inputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTokens' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'aiAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allPatientOutcomes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answered' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDateString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsConversationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'landingPageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recordingDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staff' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'waveforms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboundCallQuery, InboundCallQueryVariables>
export const CallRecordingUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CallRecordingUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecordingUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CallRecordingUrlQuery, CallRecordingUrlQueryVariables>
export const CallDatumDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CallDatum' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callDatum' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsConversationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractedData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CallDatumQuery, CallDatumQueryVariables>
export const RematchActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RematchActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rematchActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contactId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RematchActivityMutation, RematchActivityMutationVariables>
export const OutboundCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OutboundCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ai' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionItems' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'extractionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'people' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tokenUsage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'inputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTokens' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'aiAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allPatientOutcomes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answered' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDateString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'golden' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'landingPageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recordingDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recordings' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staff' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'waveforms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OutboundCallQuery, OutboundCallQueryVariables>
export const OutboundCallRecordingUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OutboundCallRecordingUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecordingUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OutboundCallRecordingUrlQuery, OutboundCallRecordingUrlQueryVariables>
export const OutboundCallTranscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OutboundCallTranscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callTranscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OutboundCallTranscriptionQuery, OutboundCallTranscriptionQueryVariables>
export const AiAgentConfigForApptTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AiAgentConfigForApptTypes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aiAgentConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generalApptId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emergencyApptId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consultApptId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limitedExamApptId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AiAgentConfigForApptTypesQuery, AiAgentConfigForApptTypesQueryVariables>
export const SmsAgentDeploymentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmsAgentDeployment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'aiAgentConfiguration' },
            name: { kind: 'Name', value: 'opsAIAgentConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'systemPrompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promptVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promptDeployedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                { kind: 'Field', name: { kind: 'Name', value: 'temperature' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tools' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SmsAgentDeploymentQuery, SmsAgentDeploymentQueryVariables>
export const AiAgentLocationSetLiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AIAgentLocationSetLive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateLocationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAIAgentLive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AiAgentLocationSetLiveMutation, AiAgentLocationSetLiveMutationVariables>
export const AiAgentSettingsConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AiAgentSettingsConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aiAgentConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postBookingMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygienePostBookingMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'smsConfirmationEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generalApptId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emergencyApptId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consultApptId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limitedExamApptId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'offers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eligibleInsurance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onlyEmergencyEligible' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'services' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lowPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'highPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consultRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consultPrice' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'servicesNotOffered' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lowPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'highPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consultRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consultPrice' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sayThisNotThatRules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'stopPhrase' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'replacementPhrase' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AiAgentSettingsConfigQuery, AiAgentSettingsConfigQueryVariables>
export const AiAgentSettingsOperatoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AiAgentSettingsOperatories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remote_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AiAgentSettingsOperatoriesQuery, AiAgentSettingsOperatoriesQueryVariables>
export const AiAgentSettingsUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AiAgentSettingsUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAIAgentLocationConfigInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAIAgentLocationConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sayThisNotThatRules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'stopPhrase' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'replacementPhrase' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AiAgentSettingsUpdateMutation, AiAgentSettingsUpdateMutationVariables>
export const AiAgentSettingsHoursSourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AiAgentSettingsHoursSource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aiAgentConfigurations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voiceAgentTools' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AiAgentSettingsHoursSourceQuery, AiAgentSettingsHoursSourceQueryVariables>
export const AiAgentSettingsCompilerToolsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AiAgentSettingsCompilerTools' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAIAgentCompilerConfigInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'opsUpdateAIAgentCompilerConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voiceAgentTools' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AiAgentSettingsCompilerToolsMutation, AiAgentSettingsCompilerToolsMutationVariables>
export const SmsOpsTakeoverEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmsOpsTakeoverEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'events' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SmsOpsTakeoverEventsQuery, SmsOpsTakeoverEventsQueryVariables>
export const SmsOpsMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmsOpsMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerMessageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isInitialMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workflowRunId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sendDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SmsOpsMessagesQuery, SmsOpsMessagesQueryVariables>
export const SmsOpsThreadsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmsOpsThreads' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'threads' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastIncomingMessageDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastOutgoingMessageDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activeWorkflowId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentActivityId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentBrief' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentBriefSetDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentLastMessageDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentReplyDueDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameSetAtDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameSetByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SmsOpsThreadsQuery, SmsOpsThreadsQueryVariables>
export const SmsOpsOptOutsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmsOpsOptOuts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optOuts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SmsOpsOptOutsQuery, SmsOpsOptOutsQueryVariables>
export const SmsOpsAiTurnsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmsOpsAiTurns' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aiConversationTurns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latencyMs' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'steps' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'toolResults' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'toolName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isError' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SmsOpsAiTurnsQuery, SmsOpsAiTurnsQueryVariables>
export const SmsOpsReplyAttemptsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmsOpsReplyAttempts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aiConversationTurns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failureReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SmsOpsReplyAttemptsQuery, SmsOpsReplyAttemptsQueryVariables>
export const OpsVoiceAgentLocationMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OpsVoiceAgentLocationMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'VoiceAgentLocationMetricsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'opsVoiceAgentLocationMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentsBooked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentsCompleted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toolErrorCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toolTimeoutCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toolDuplicateCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failedCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'llmFailedCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'llmSlowCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disconnectedCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxDurationCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unsuccessfulCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gptFailedCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsFailedCalls' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentsBooked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentsCompleted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toolErrorCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toolTimeoutCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toolDuplicateCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failedCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'llmFailedCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'llmSlowCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disconnectedCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxDurationCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unsuccessfulCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gptFailedCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsFailedCalls' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'compareRows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentsBooked' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'compareTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentsBooked' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpsVoiceAgentLocationMetricsQuery, OpsVoiceAgentLocationMetricsQueryVariables>
export const OpsVoiceAgentDailyMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OpsVoiceAgentDailyMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'VoiceAgentDailyMetricsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'opsVoiceAgentDailyMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daily' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failedCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gptFailedCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsFailedCalls' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCallBeforeRange' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'days' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aiCalls' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpsVoiceAgentDailyMetricsQuery, OpsVoiceAgentDailyMetricsQueryVariables>
export const OpsVoiceAgentCallDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OpsVoiceAgentCallData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'extractedData' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toolError' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toolTimeout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toolDuplicate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'terminationReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callSuccessful' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'noBookingReason' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpsVoiceAgentCallDataQuery, OpsVoiceAgentCallDataQueryVariables>
export const VoiceAgentMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VoiceAgentMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voiceAgentMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newPatientCalls' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentsBooked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentsCompleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCalls' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VoiceAgentMetricsQuery, VoiceAgentMetricsQueryVariables>
export const AgentBookingsCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AgentBookingsCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentBookingsCountQuery, AgentBookingsCountQueryVariables>
export const AgentAppointmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AgentAppointments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentMadeDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode1Amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode1Time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode2Amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode2Time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode3' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode3Amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode3Time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sikkaOfficeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sikkaPracticeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeToAppointment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentAppointmentsQuery, AgentAppointmentsQueryVariables>
export const AgentPatientContactsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AgentPatientContacts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentPatientContactsQuery, AgentPatientContactsQueryVariables>
export const ConversionsDashboardMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ConversionsDashboardMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversionMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'QUALIFIED_LEAD_GENERATED' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'NEW_PATIENT_APPOINTMENT_SCHEDULED' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'NEW_PATIENT_GENERATED' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ADDITIONAL_TREATMENT_REVENUE' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversionsDashboardMetricsQuery, ConversionsDashboardMetricsQueryVariables>
export const FinancialPageMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FinancialPageMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'compareRange' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revenueMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'compareRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'compareRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'grossProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'netProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adjustments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collections' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgGrossProductionPerVisit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgNetProductionPerVisit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgAdjustmentsPerVisit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'comparisonStats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'grossProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'netProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adjustments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collections' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgGrossProductionPerVisit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgNetProductionPerVisit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgAdjustmentsPerVisit' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dailyMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'grossProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'netProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collections' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'comparisonDailyMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'grossProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'netProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collections' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FinancialPageMetricsQuery, FinancialPageMetricsQueryVariables>
export const MarketingLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MarketingLocations' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegrated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarketingLocationsQuery, MarketingLocationsQueryVariables>
export const MarketingStaffBreakdownDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MarketingStaffBreakdown' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffBreakdown' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isStaff' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qualifiedNPCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disqualifiedNPCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledNPCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unscheduledNPCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'speedToLead' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'NPCallScheduleRate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarketingStaffBreakdownQuery, MarketingStaffBreakdownQueryVariables>
export const NewPatientsMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewPatientsMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'compareRange' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hideMultiLocationPatients' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newPatientsMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'compareRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'compareRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'platform' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hideMultiLocationPatients' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hideMultiLocationPatients' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reappointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reappointmentPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageTimeToAppointment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageProductionPerNewPatientVisit' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'byChannel' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'comparisonSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reappointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reappointmentPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageTimeToAppointment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageProductionPerNewPatientVisit' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'byChannel' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dailyMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'byChannel' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'comparisonMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'byChannel' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dailyScheduledMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'byChannel' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reappointmentPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reappointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brokenAppointmentCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageTimeToAppointment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageProductionPerNewPatientVisit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientsFromDigitalMarketing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientsFromReferralMarketing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientsFromTraditionalMarketing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientsFromUnknown' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledNewPatients' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegrated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncDate' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewPatientsMetricsQuery, NewPatientsMetricsQueryVariables>
export const AttributionFlowFilteredDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AttributionFlowFiltered' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showDisqualified' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'production' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roi' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttributionFlowFilteredQuery, AttributionFlowFilteredQueryVariables>
export const LeadsBreakdownDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LeadsBreakdown' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leadsBreakdown' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'platform' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showDisqualified' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'byActivityTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'leadsByFirstActivityType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'leadsByStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeadsBreakdownQuery, LeadsBreakdownQueryVariables>
export const ScheduleRateQualifiedLeadCountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduleRateQualifiedLeadCounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'compareFromDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'compareToDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'activityType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualifiedLeadCounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'compareFromDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'compareFromDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'compareToDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'compareToDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'activityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'activityType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'platform' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disqualified' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduleRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notScheduled' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'comparisonStats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduleRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notScheduled' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'series' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledRate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleRateQualifiedLeadCountsQuery, ScheduleRateQualifiedLeadCountsQueryVariables>
export const AvailabilityProvidersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AvailabilityProviders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'providers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deactivated' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailabilityProvidersQuery, AvailabilityProvidersQueryVariables>
export const UpdateProviderStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateProviderStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateProviderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProvider' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProviderStatusMutation, UpdateProviderStatusMutationVariables>
export const SyncAvailabilityProvidersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SyncAvailabilityProviders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syncProviders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'synced' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SyncAvailabilityProvidersMutation, SyncAvailabilityProvidersMutationVariables>
export const AvailabilitySettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AvailabilitySettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schedulingConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowDoubleBooking' } },
                { kind: 'Field', name: { kind: 'Name', value: 'doubleBookingCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesRejected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isStateInsuranceAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'granularity' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailabilitySettingsQuery, AvailabilitySettingsQueryVariables>
export const SaveAvailabilitySettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveAvailabilitySettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schedInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateSchedulingConfigurationInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateLocationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSchedulingConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schedInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowDoubleBooking' } },
                { kind: 'Field', name: { kind: 'Name', value: 'doubleBookingCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesRejected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isStateInsuranceAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'granularity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSchedulerLive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAIAgentLive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availabilityMode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveAvailabilitySettingsMutation, SaveAvailabilitySettingsMutationVariables>
export const AvailabilityViewOperatoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AvailabilityViewOperatories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remote_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailabilityViewOperatoriesQuery, AvailabilityViewOperatoriesQueryVariables>
export const SyncProvidersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SyncProviders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syncProviders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SyncProvidersMutation, SyncProvidersMutationVariables>
export const SyncSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SyncSchedules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syncSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SyncSchedulesMutation, SyncSchedulesMutationVariables>
export const CallTranscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CallTranscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callTranscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CallTranscriptionQuery, CallTranscriptionQueryVariables>
export const CallInfoUpdateCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CallInfoUpdateCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateCallInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsConversationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answered' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ai' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actionItems' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'people' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'extractionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tokenUsage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'inputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTokens' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'waveforms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDateString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recordingDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'landingPageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recordings' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'patients' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staff' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'aiAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'golden' } },
                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'people' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'allPatientOutcomes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CallInfoUpdateCallMutation, CallInfoUpdateCallMutationVariables>
export const CarestackDashboardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CarestackDashboard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'period' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carestackDashboard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'period' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'period' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workspaces' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CarestackDashboardQuery, CarestackDashboardQueryVariables>
export const InitiateCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InitiateCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'InitiateCallInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initiateCall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'calledNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InitiateCallMutation, InitiateCallMutationVariables>
export const OutboundNumbersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OutboundNumbers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeMainNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryTrackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callRailCompanyId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OutboundNumbersQuery, OutboundNumbersQueryVariables>
export const LocationMarketingMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationMarketingMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showDisqualified' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'MQLs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'production' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ROI' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduleRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPQL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPA' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CAC' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disqualified' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'MQLs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduleRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cpls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roi' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iCPL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iCPQL' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationMarketingMetricsQuery, LocationMarketingMetricsQueryVariables>
export const LocationTotalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationTotals' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'MQLs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cpls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roi' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iCPL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iCPQL' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationTotalsQuery, LocationTotalsQueryVariables>
export const WorkspaceMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkspaceMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'MQLs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduleRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cpls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roi' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iCPL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iCPQL' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceMetricsQuery, WorkspaceMetricsQueryVariables>
export const CreateWorkspaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateWorkspace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateWorkspaceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWorkspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>
export const ContactHoverableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactHoverable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unbookedTreatmentValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adClickDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadOwner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'convertedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pipelines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactHoverableQuery, ContactHoverableQueryVariables>
export const UpdateContactLeadStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateContactLeadStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateContactInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateContactLeadStatusMutation, UpdateContactLeadStatusMutationVariables>
export const CommLogEntriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CommLogEntries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commLogs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsPatientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentOrReceived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userNum' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'programNum' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsUpdatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommLogEntriesQuery, CommLogEntriesQueryVariables>
export const CommLogCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CommLogCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commLogs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommLogCountQuery, CommLogCountQueryVariables>
export const CloseLostFromDrawerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CloseLostFromDrawer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateContactInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CloseLostFromDrawerMutation, CloseLostFromDrawerMutationVariables>
export const ContactTagsTagValuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTagsTagValues' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tagValues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entity' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactTagsTagValuesQuery, ContactTagsTagValuesQueryVariables>
export const CreateNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateActivityInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateNoteMutation, CreateNoteMutationVariables>
export const LastCommCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LastCommCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answered' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allPatientOutcomes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ai' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LastCommCallQuery, LastCommCallQueryVariables>
export const ContactStatusChangesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactStatusChanges' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactStatusChangesQuery, ContactStatusChangesQueryVariables>
export const SendSmsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendSms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendMessageInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendSms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInitialMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerMessageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendSmsMutation, SendSmsMutationVariables>
export const ThreadEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ThreadEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'events' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ThreadEventsQuery, ThreadEventsQueryVariables>
export const SmsOptOutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmsOptOut' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optOuts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SmsOptOutQuery, SmsOptOutQueryVariables>
export const InboxSmsProviderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InboxSmsProvider' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryTrackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callRailCompanyId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twilioNumbers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'phone' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboxSmsProviderQuery, InboxSmsProviderQueryVariables>
export const InboxDebugTracesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InboxDebugTraces' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'threadId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aiConversationTurns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'threadId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'threadId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'turnIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isInitialMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'temperature' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latencyMs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'response' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'systemPrompt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tokenUsage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'inputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cachedInputTokens' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'inputTokenDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cacheReadTokens' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'steps' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'toolCalls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'toolName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'args' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'toolResults' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'toolName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isError' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboxDebugTracesQuery, InboxDebugTracesQueryVariables>
export const EmailAttachmentUrlsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EmailAttachmentUrls' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailAttachmentUrls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmailAttachmentUrlsQuery, EmailAttachmentUrlsQueryVariables>
export const LocationCanSendEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationCanSendEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationCanSendEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationCanSendEmailQuery, LocationCanSendEmailQueryVariables>
export const ContactTreatmentProceduresDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTreatmentProcedures' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'procedures' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tooth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'feeAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'planIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCreateDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactTreatmentProceduresQuery, ContactTreatmentProceduresQueryVariables>
export const ContactKollaTreatmentPlansDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactKollaTreatmentPlans' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'treatmentPlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'planCreateDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureIds' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactKollaTreatmentPlansQuery, ContactKollaTreatmentPlansQueryVariables>
export const BulkCreateTagColorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BulkCreateTagColor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTagColorInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTagColor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkCreateTagColorMutation, BulkCreateTagColorMutationVariables>
export const SwitchWorkspaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SwitchWorkspace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'targetWorkspaceId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'switchWorkspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'targetWorkspaceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'targetWorkspaceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accessToken' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchWorkspaceMutation, SwitchWorkspaceMutationVariables>
export const DniPoolNumbersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DniPoolNumbers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dniId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dniPoolNumbers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dniId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dniId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DniPoolNumbersQuery, DniPoolNumbersQueryVariables>
export const DniIntegrationStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DniIntegrationStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integrationStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integration' },
                value: { kind: 'StringValue', value: 'dynamic number insertion', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DniIntegrationStatusQuery, DniIntegrationStatusQueryVariables>
export const UpdateLocationFacebookDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateLocationFacebook' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateLocationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegratedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'migrationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sikkaOfficeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sikkaPracticeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConnectorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaPracticeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaPageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availabilityMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callRailCompanyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsAgentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callRailBackfillStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jotformFormIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookFormIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carestackId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ringCentralPhoneNumbers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twilioNumbers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poolId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'areaCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poolSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionDuration' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeTransferNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleAdsCustomerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookAdSetIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'openHours' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sunday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'monday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tuesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wednesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'thursday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'saturday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgTags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labels' } },
                { kind: 'Field', name: { kind: 'Name', value: 'products' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRailRouting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryTrackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primarySmsNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeMainNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeTransferNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jotFormIgnoredForms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSyncFailureDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncCompleteDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastRingCentralSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCallrailWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTwilioWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAICallDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSikkaWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastJotformWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastFacebookWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookSpendUpdateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleSpendUpdateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookAdsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleAdsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSchedulerLive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAIAgentLive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowDoubleBookingScheduling' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gravityFormsKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'webflowFormsKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'googleAdsV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adGroupId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'googleAdsV3' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conversionActions' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookAdsV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adSetId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookLeadsPages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jotform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'folderId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jotformV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCalculation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentsSetNewPatient' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentCompletionStatuses' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionBrokenCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ignorePII' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excludeParentsFromNewPatients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstVisitSetNewPatient' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastGravityFormWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPatientSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastProcedureSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPatientReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastProcedureReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ascendLocationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alarmQuietStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alarmQuietEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dailySyncHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegrated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLocationFacebookMutation, UpdateLocationFacebookMutationVariables>
export const AddOverrideOpsUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AddOverrideOpsUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'opsUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddOverrideOpsUsersQuery, AddOverrideOpsUsersQueryVariables>
export const FeatureToggleOpsUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeatureToggleOpsUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'opsUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureToggleOpsUsersQuery, FeatureToggleOpsUsersQueryVariables>
export const OverrideNameWorkspaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OverrideNameWorkspace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OverrideNameWorkspaceQuery, OverrideNameWorkspaceQueryVariables>
export const CacheFlushDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CacheFlush' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pattern' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cacheFlush' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pattern' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pattern' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CacheFlushMutation, CacheFlushMutationVariables>
export const ResetPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>
export const PaperworkByTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaperworkByToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paperworkByToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'linkState' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'practice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'packet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'submittedFormIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkByTokenQuery, PaperworkByTokenQueryVariables>
export const SubmitPaperworkFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitPaperworkForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'formId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'formVersion' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'answers' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'PublicAnswerInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitPaperworkForm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'formId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'formId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'formVersion' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'formVersion' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'answers' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'answers' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'linkState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'submittedFormIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitPaperworkFormMutation, SubmitPaperworkFormMutationVariables>
export const PaletteContactsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaletteContacts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unbookedTreatmentValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adClickDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'leadOwner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'convertedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pipelines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaletteContactsQuery, PaletteContactsQueryVariables>
export const PaletteMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaletteMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isInitialMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workflowRunId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerMessageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'images' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaletteMessagesQuery, PaletteMessagesQueryVariables>
export const PaletteActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaletteActivities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contacts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'matchDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nameFromActivity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'peopleIndex' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'needsReview' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reviewReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameFromActivity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneFromActivity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmAccountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fbclid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingOptIn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaletteActivitiesQuery, PaletteActivitiesQueryVariables>
export const OpsWorkspaceSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OpsWorkspaceSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'opsWorkspaceSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpsWorkspaceSearchQuery, OpsWorkspaceSearchQueryVariables>
export const FileImportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FileImports' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileImports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'importIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FileImportsQuery, FileImportsQueryVariables>
export const FileImportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FileImport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileImport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'importIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FileImportQuery, FileImportQueryVariables>
export const DeleteFileImportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteFileImport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFileImport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFileImportMutation, DeleteFileImportMutationVariables>
export const ImportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Imports' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fileImportId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAppointmentTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'staff' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImportsQuery, ImportsQueryVariables>
export const ImportDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ImportDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'importDetail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestedAppointmentTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'staff' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImportDetailQuery, ImportDetailQueryVariables>
export const CreateImportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateImport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateImportInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createImport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateImportMutation, CreateImportMutationVariables>
export const CreateFileImportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFileImport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFileImportInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFileImport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFileImportMutation, CreateFileImportMutationVariables>
export const InboxLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InboxLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryTrackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'products' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboxLocationQuery, InboxLocationQueryVariables>
export const InboxCallerIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InboxCallerId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'callerPhone' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callerId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'callerPhone' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'callerPhone' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboxCallerIdQuery, InboxCallerIdQueryVariables>
export const HasActiveAgentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HasActiveAgent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aiAgentConfigurations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'systemPrompt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HasActiveAgentQuery, HasActiveAgentQueryVariables>
export const ThreadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Thread' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thread' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ThreadQuery, ThreadQueryVariables>
export const InboxThreadsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InboxThreads' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'threads' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboxThreadsQuery, InboxThreadsQueryVariables>
export const ThreadEngageAgentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ThreadEngageAgent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'threadId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'threadEngageAgent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'threadId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'threadId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ThreadEngageAgentMutation, ThreadEngageAgentMutationVariables>
export const UpdateThreadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateThread' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateThreadInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateThread' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateThreadMutation, UpdateThreadMutationVariables>
export const LocationIntegrationStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationIntegrationStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integration' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integrationStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integration' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integration' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientsCompletion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentsCompletion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transactionsCompletion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remainingPatients' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remainingAppointments' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remainingTransactions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remainingCalls' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remainingForms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remainingSpendRecords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredPages' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationIntegrationStatusQuery, LocationIntegrationStatusQueryVariables>
export const RecentSyncJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RecentSyncJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'kolla' },
            name: { kind: 'Name', value: 'backgroundJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'StringValue', value: 'kolla-sync', block: false },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'StringValue', value: 'createdAt', block: false },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'DESC' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SyncJobProgress' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'sikka' },
            name: { kind: 'Name', value: 'backgroundJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'StringValue', value: 'sikka-sync', block: false },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'StringValue', value: 'createdAt', block: false },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'DESC' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SyncJobProgress' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'carestack' },
            name: { kind: 'Name', value: 'backgroundJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'StringValue', value: 'carestack-sync', block: false },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'StringValue', value: 'createdAt', block: false },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'DESC' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SyncJobProgress' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'ascend' },
            name: { kind: 'Name', value: 'backgroundJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'StringValue', value: 'ascend-sync', block: false },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'StringValue', value: 'createdAt', block: false },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'DESC' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SyncJobProgress' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SyncJobProgress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BackgroundJobProgress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecentSyncJobsQuery, RecentSyncJobsQueryVariables>
export const FacebookAdSetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FacebookAdSets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'refresh' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integrationOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookAdSets' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'refresh' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'refresh' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FacebookAdSetsQuery, FacebookAdSetsQueryVariables>
export const DniManagedNumbersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DniManagedNumbers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DniManagedNumbersQuery, DniManagedNumbersQueryVariables>
export const DniForModalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DniForModal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dni' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'forwardTo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'areaCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'poolSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxPoolSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minFree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buyStep' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minPoolSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ivrConfigId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DniForModalQuery, DniForModalQueryVariables>
export const RingCentralPhoneNumbersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RingCentralPhoneNumbers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integrationOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ringCentralPhoneNumbers' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUsed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RingCentralPhoneNumbersQuery, RingCentralPhoneNumbersQueryVariables>
export const CallRailCompaniesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CallRailCompanies' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integrationOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRailCompanies' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUsed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CallRailCompaniesQuery, CallRailCompaniesQueryVariables>
export const SikkaOfficesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SikkaOffices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integrationOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sikkaOffices' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'practices' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isUsed' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SikkaOfficesQuery, SikkaOfficesQueryVariables>
export const AscendLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AscendLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integrationOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ascendLocations' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUsed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AscendLocationsQuery, AscendLocationsQueryVariables>
export const CarestackPracticesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CarestackPractices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integrationOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carestackPractices' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUsed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CarestackPracticesQuery, CarestackPracticesQueryVariables>
export const JotformFormsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JotformForms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integrationOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jotformForms' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUsed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'usedByLocationName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JotformFormsQuery, JotformFormsQueryVariables>
export const TwilioPhoneNumbersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TwilioPhoneNumbers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integrationOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twilioPhoneNumbers' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUsed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TwilioPhoneNumbersQuery, TwilioPhoneNumbersQueryVariables>
export const ElevenLabsAgentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ElevenLabsAgents' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'integrationOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'elevenLabsAgents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUsed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ElevenLabsAgentsQuery, ElevenLabsAgentsQueryVariables>
export const ElevenLabsBoundLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ElevenLabsBoundLocations' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1000' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsAgentId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ElevenLabsBoundLocationsQuery, ElevenLabsBoundLocationsQueryVariables>
export const BindLocationElevenLabsAgentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BindLocationElevenLabsAgent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'elevenLabsAgentId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bindLocationElevenLabsAgent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'elevenLabsAgentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'elevenLabsAgentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsAgentId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BindLocationElevenLabsAgentMutation, BindLocationElevenLabsAgentMutationVariables>
export const UnbindLocationElevenLabsAgentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnbindLocationElevenLabsAgent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unbindLocationElevenLabsAgent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnbindLocationElevenLabsAgentMutation, UnbindLocationElevenLabsAgentMutationVariables>
export const SaveGravityFormsIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveGravityFormsIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'gravityFormsKey' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveGravityFormsIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'gravityFormsKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'gravityFormsKey' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isNew' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveGravityFormsIntegrationMutation, SaveGravityFormsIntegrationMutationVariables>
export const SaveWebflowFormsIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveWebflowFormsIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'webflowFormsKey' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveWebflowFormsIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'webflowFormsKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'webflowFormsKey' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isNew' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveWebflowFormsIntegrationMutation, SaveWebflowFormsIntegrationMutationVariables>
export const SaveFacebookAdsIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveFacebookAdsIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'account' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaigns' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'FacebookAdsCampaignInput' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveFacebookAdsIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'account' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'account' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaigns' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaigns' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isNew' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveFacebookAdsIntegrationMutation, SaveFacebookAdsIntegrationMutationVariables>
export const SaveCallRailIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveCallRailIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'backfillStartDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveCallRailIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'backfillStartDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'backfillStartDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isNew' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveCallRailIntegrationMutation, SaveCallRailIntegrationMutationVariables>
export const SaveCarestackIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveCarestackIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'selection' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveCarestackIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'selection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'selection' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveCarestackIntegrationMutation, SaveCarestackIntegrationMutationVariables>
export const SaveAscendIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveAscendIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ascendLocationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveAscendIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ascendLocationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ascendLocationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveAscendIntegrationMutation, SaveAscendIntegrationMutationVariables>
export const SaveSikkaIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveSikkaIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'selection' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveSikkaIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'selection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'selection' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveSikkaIntegrationMutation, SaveSikkaIntegrationMutationVariables>
export const SaveRingCentralIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveRingCentralIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'phoneNumbers' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveRingCentralIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phoneNumbers' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'phoneNumbers' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isNew' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveRingCentralIntegrationMutation, SaveRingCentralIntegrationMutationVariables>
export const SaveTwilioIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveTwilioIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'poolSelection' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'TwilioNumberInput' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'aiSelection' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'aiTestingSelection' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveTwilioIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'poolSelection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'poolSelection' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'aiSelection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'aiSelection' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'aiTestingSelection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'aiTestingSelection' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isNew' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isNew' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveTwilioIntegrationMutation, SaveTwilioIntegrationMutationVariables>
export const SaveKollaIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveKollaIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kollaConsumerId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kollaConnectorId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kollaPracticeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveKollaIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kollaConsumerId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'kollaConsumerId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kollaConnectorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'kollaConnectorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kollaPracticeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'kollaPracticeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveKollaIntegrationMutation, SaveKollaIntegrationMutationVariables>
export const RemoveLocationIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveLocationIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integration' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeLocationIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integration' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integration' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveLocationIntegrationMutation, RemoveLocationIntegrationMutationVariables>
export const DeleteStaffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteStaff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteStaff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteStaffMutation, DeleteStaffMutationVariables>
export const IvrPhoneNumbersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IvrPhoneNumbers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IvrPhoneNumbersQuery, IvrPhoneNumbersQueryVariables>
export const IvrConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IvrConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'phoneNumberId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ivrConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phoneNumberId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'phoneNumberId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'root' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nodes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IvrConfigQuery, IvrConfigQueryVariables>
export const IvrConfigsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IvrConfigs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ivrConfigs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumberId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IvrConfigsQuery, IvrConfigsQueryVariables>
export const CreateIvrConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateIvrConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SaveIvrConfigInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createIvrConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'root' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nodes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateIvrConfigMutation, CreateIvrConfigMutationVariables>
export const UpdateIvrConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateIvrConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SaveIvrConfigInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateIvrConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'root' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nodes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateIvrConfigMutation, UpdateIvrConfigMutationVariables>
export const SendingDomainsForIdentityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendingDomainsForIdentity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendingDomains' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendingDomainsForIdentityQuery, SendingDomainsForIdentityQueryVariables>
export const TrackableSendingDomainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TrackableSendingDomain' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'trackableSendingDomain' } }],
      },
    },
  ],
} as unknown as DocumentNode<TrackableSendingDomainQuery, TrackableSendingDomainQueryVariables>
export const CheckSendingEmailAvailableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CheckSendingEmailAvailable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'localPart' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'domain' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkSendingEmailAvailable' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'localPart' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'localPart' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'domain' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'domain' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CheckSendingEmailAvailableQuery, CheckSendingEmailAvailableQueryVariables>
export const LocationEmailIdentitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationEmailIdentities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationEmailIdentities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sendingDomainId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'localPart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'replyTo' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationEmailIdentitiesQuery, LocationEmailIdentitiesQueryVariables>
export const SetLocationEmailIdentityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetLocationEmailIdentity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetLocationEmailIdentityInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setLocationEmailIdentity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sendingDomainId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'localPart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fromName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'replyTo' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetLocationEmailIdentityMutation, SetLocationEmailIdentityMutationVariables>
export const DeleteLocationEmailIdentityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteLocationEmailIdentity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteLocationEmailIdentity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteLocationEmailIdentityMutation, DeleteLocationEmailIdentityMutationVariables>
export const LocationPhoneNumbersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationPhoneNumbers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerResourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'registrationStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'registrationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provisioningError' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationPhoneNumbersQuery, LocationPhoneNumbersQueryVariables>
export const SearchAvailablePhoneNumbersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchAvailablePhoneNumbers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PhoneNumberType' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areaCode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchAvailablePhoneNumbers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'areaCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areaCode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locality' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchAvailablePhoneNumbersQuery, SearchAvailablePhoneNumbersQueryVariables>
export const PurchasePhoneNumberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PurchasePhoneNumber' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PurchasePhoneNumberInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'purchasePhoneNumber' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provisioningError' } },
                { kind: 'Field', name: { kind: 'Name', value: 'registrationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PurchasePhoneNumberMutation, PurchasePhoneNumberMutationVariables>
export const UpdatePhoneNumberRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePhoneNumberRoles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePhoneNumberInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePhoneNumber' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePhoneNumberRolesMutation, UpdatePhoneNumberRolesMutationVariables>
export const ReleasePhoneNumberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleasePhoneNumber' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'releasePhoneNumber' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>
export const LocationSmsNumbersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationSmsNumbers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationSmsNumbers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationSmsNumbersQuery, LocationSmsNumbersQueryVariables>
export const DeleteBudgetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteBudget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBudget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteBudgetMutation, DeleteBudgetMutationVariables>
export const UpdateBudgetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBudget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateBudgetInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBudget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBudgetMutation, UpdateBudgetMutationVariables>
export const CreateBudgetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBudget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateBudgetInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBudget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBudgetMutation, CreateBudgetMutationVariables>
export const CreateAdPlatformMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAdPlatformMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateAdPlatformMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAdPlatformMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAdPlatformMappingMutation, CreateAdPlatformMappingMutationVariables>
export const UpdateAdPlatformMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAdPlatformMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAdPlatformMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAdPlatformMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAdPlatformMappingMutation, UpdateAdPlatformMappingMutationVariables>
export const DeleteAdPlatformMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAdPlatformMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAdPlatformMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAdPlatformMappingMutation, DeleteAdPlatformMappingMutationVariables>
export const CreateUtmAliasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUtmAlias' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateUtmAliasInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUtmAlias' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'original' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUtmAliasMutation, CreateUtmAliasMutationVariables>
export const UpdateUtmAliasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUtmAlias' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateUtmAliasInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUtmAlias' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'original' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUtmAliasMutation, UpdateUtmAliasMutationVariables>
export const DeleteUtmAliasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteUtmAlias' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteUtmAlias' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUtmAliasMutation, DeleteUtmAliasMutationVariables>
export const CreateChannelMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateChannelMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateChannelMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createChannelMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateChannelMappingMutation, CreateChannelMappingMutationVariables>
export const UpdateChannelMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateChannelMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateChannelMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateChannelMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateChannelMappingMutation, UpdateChannelMappingMutationVariables>
export const DeleteChannelMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteChannelMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteChannelMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteChannelMappingMutation, DeleteChannelMappingMutationVariables>
export const CreateFormFieldMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFormFieldMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFormFieldMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFormFieldMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFormFieldMappingMutation, CreateFormFieldMappingMutationVariables>
export const UpdateFormFieldMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFormFieldMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFormFieldMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFormFieldMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFormFieldMappingMutation, UpdateFormFieldMappingMutationVariables>
export const DeleteFormFieldMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteFormFieldMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFormFieldMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFormFieldMappingMutation, DeleteFormFieldMappingMutationVariables>
export const OnlineSchedulerLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OnlineSchedulerLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSchedulerLive' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schedulingConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowDoubleBooking' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesRejected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isStateInsuranceAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'granularity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customQuestions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'marketingConsent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optIn' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadOverrideEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadOverrideConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnlineSchedulerLocationQuery, OnlineSchedulerLocationQueryVariables>
export const UpdateOnlineSchedulerConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOnlineSchedulerConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateSchedulingConfigurationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSchedulingConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowDoubleBooking' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesRejected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isStateInsuranceAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'granularity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customQuestions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'marketingConsent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optIn' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadOverrideEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadOverrideConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateOnlineSchedulerConfigMutation, UpdateOnlineSchedulerConfigMutationVariables>
export const ToggleOnlineSchedulerLiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ToggleOnlineSchedulerLive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateLocationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSchedulerLive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ToggleOnlineSchedulerLiveMutation, ToggleOnlineSchedulerLiveMutationVariables>
export const OnlineSchedulerLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OnlineSchedulerLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schedulerSort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSchedulerLive' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schedulers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1000' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schedulerSort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnlineSchedulerLocationsQuery, OnlineSchedulerLocationsQueryVariables>
export const CacheSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CacheSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pattern' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cacheSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pattern' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pattern' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CacheSearchMutation, CacheSearchMutationVariables>
export const CacheDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CacheDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pattern' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cacheDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pattern' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pattern' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CacheDeleteMutation, CacheDeleteMutationVariables>
export const ExtractionDashboardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExtractionDashboard' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'extractionDashboard' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowStats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last24h' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgMatchScore' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'byWorkspace' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExtractionDashboardQuery, ExtractionDashboardQueryVariables>
export const OpsReconcileCandidatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OpsReconcileCandidates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unbookedTreatmentValue' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pipelines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpsReconcileCandidatesQuery, OpsReconcileCandidatesQueryVariables>
export const OpsReconcileAddToPipelineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OpsReconcileAddToPipeline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pipeline' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactPipelineInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addToPipeline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pipeline' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pipeline' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpsReconcileAddToPipelineMutation, OpsReconcileAddToPipelineMutationVariables>
export const PaperworkFormTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaperworkFormTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'formId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'formId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'formId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'questionsJson' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkFormTemplatesQuery, PaperworkFormTemplatesQueryVariables>
export const PaperworkFormTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaperworkFormTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'questionsJson' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkFormTemplateQuery, PaperworkFormTemplateQueryVariables>
export const PaperworkCreateFormTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PaperworkCreateFormTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFormTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFormTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'questionsJson' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkCreateFormTemplateMutation, PaperworkCreateFormTemplateMutationVariables>
export const PaperworkUpdateFormTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PaperworkUpdateFormTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFormTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFormTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'questionsJson' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkUpdateFormTemplateMutation, PaperworkUpdateFormTemplateMutationVariables>
export const PaperworkPublishFormTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PaperworkPublishFormTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishFormTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'questionsJson' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkPublishFormTemplateMutation, PaperworkPublishFormTemplateMutationVariables>
export const PaperworkDraftNextFormTemplateVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PaperworkDraftNextFormTemplateVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'draftNextFormTemplateVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'questionsJson' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PaperworkDraftNextFormTemplateVersionMutation,
  PaperworkDraftNextFormTemplateVersionMutationVariables
>
export const PaperworkDeleteFormTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PaperworkDeleteFormTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFormTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkDeleteFormTemplateMutation, PaperworkDeleteFormTemplateMutationVariables>
export const PaperworkTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaperworkTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paperworkTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formsJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brandingJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appearanceJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'welcomeJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completionJson' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkTemplatesQuery, PaperworkTemplatesQueryVariables>
export const PaperworkTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaperworkTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paperworkTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formsJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brandingJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appearanceJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'welcomeJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionJson' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkTemplateQuery, PaperworkTemplateQueryVariables>
export const PaperworkCreateTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PaperworkCreateTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePaperworkTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPaperworkTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formsJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brandingJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appearanceJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'welcomeJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionJson' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkCreateTemplateMutation, PaperworkCreateTemplateMutationVariables>
export const PaperworkUpdateTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PaperworkUpdateTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePaperworkTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePaperworkTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formsJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brandingJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appearanceJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'welcomeJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionJson' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkUpdateTemplateMutation, PaperworkUpdateTemplateMutationVariables>
export const PaperworkDeleteTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PaperworkDeleteTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePaperworkTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkDeleteTemplateMutation, PaperworkDeleteTemplateMutationVariables>
export const PaperworkBrandingLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaperworkBrandingLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'businessPhone' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkBrandingLocationsQuery, PaperworkBrandingLocationsQueryVariables>
export const ContactPaperworksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactPaperworks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paperworks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paperworkTemplateId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiresDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cancelledDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'snapshotJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'submissionsJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'processingStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'processingCompletedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'chartWritesJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullyComplete' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formStatuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'submittedDate' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'chartWriteStatuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedDate' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactPaperworksQuery, ContactPaperworksQueryVariables>
export const ResendPaperworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResendPaperwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resendPaperwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cancelledDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResendPaperworkMutation, ResendPaperworkMutationVariables>
export const CancelPaperworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelPaperwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelPaperwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cancelledDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelPaperworkMutation, CancelPaperworkMutationVariables>
export const PaperworkPatientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaperworkPatients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsPatientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastVisit' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaperworkPatientsQuery, PaperworkPatientsQueryVariables>
export const CreatePaperworkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePaperwork' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePaperworkInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPaperwork' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'link' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePaperworkMutation, CreatePaperworkMutationVariables>
export const PipelineCardPreviewLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PipelineCardPreviewLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PipelineCardPreviewLocationQuery, PipelineCardPreviewLocationQueryVariables>
export const CreateCommLogWritebackRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCommLogWritebackRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCommLogWritebackRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCommLogWritebackRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCommLogWritebackRuleMutation, CreateCommLogWritebackRuleMutationVariables>
export const UpdateCommLogWritebackRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCommLogWritebackRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateCommLogWritebackRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCommLogWritebackRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCommLogWritebackRuleMutation, UpdateCommLogWritebackRuleMutationVariables>
export const DeleteCommLogWritebackRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCommLogWritebackRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCommLogWritebackRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCommLogWritebackRuleMutation, DeleteCommLogWritebackRuleMutationVariables>
export const PmsReferralMappingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PmsReferralMappings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pmsReferralMappings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referralType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'force' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PmsReferralMappingsQuery, PmsReferralMappingsQueryVariables>
export const CreatePmsReferralMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePmsReferralMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePmsReferralMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPmsReferralMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referralType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'campaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'force' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePmsReferralMappingMutation, CreatePmsReferralMappingMutationVariables>
export const UpdatePmsReferralMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePmsReferralMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePmsReferralMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePmsReferralMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referralType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'campaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'force' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePmsReferralMappingMutation, UpdatePmsReferralMappingMutationVariables>
export const PatientsReferralTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PatientsReferralTypes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referralType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientsReferralTypesQuery, PatientsReferralTypesQueryVariables>
export const PatientsCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PatientsCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientsCountQuery, PatientsCountQueryVariables>
export const PmsSchedulesLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PmsSchedulesLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PmsSchedulesLocationQuery, PmsSchedulesLocationQueryVariables>
export const PmsSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PmsSchedules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schedulesSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schedulesSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blocks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'additionalData' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'appointmentType' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentTypes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '200' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentLength' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activeScheduler' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PmsSchedulesQuery, PmsSchedulesQueryVariables>
export const ResetSetPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetSetPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accessToken' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetSetPasswordMutation, ResetSetPasswordMutationVariables>
export const ScheduleWeekAppointmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduleWeekAppointments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCodes' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleWeekAppointmentsQuery, ScheduleWeekAppointmentsQueryVariables>
export const ScheduleSlotCandidatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduleSlotCandidates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleSlotCandidatesQuery, ScheduleSlotCandidatesQueryVariables>
export const ScheduleWeekOperatoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduleWeekOperatories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remote_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleWeekOperatoriesQuery, ScheduleWeekOperatoriesQueryVariables>
export const ScheduleRoomSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduleRoomSchedules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blocks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleRoomSchedulesQuery, ScheduleRoomSchedulesQueryVariables>
export const ScheduleDayLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduleDayLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleDayLocationQuery, ScheduleDayLocationQueryVariables>
export const ScheduleWeekLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduleWeekLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentSyncDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleWeekLocationQuery, ScheduleWeekLocationQueryVariables>
export const SchedulingAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SchedulingAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availabilityMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'providers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '200' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deactivated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasProfilePicture' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsDisplayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsShortDisplayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxonomy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentTypes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '200' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentLength' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activeScheduler' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SchedulingAvailabilityQuery, SchedulingAvailabilityQueryVariables>
export const SchedulingLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SchedulingLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSchedulerLive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'products' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SchedulingLocationQuery, SchedulingLocationQueryVariables>
export const ToggleSchedulerLiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ToggleSchedulerLive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateLocationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSchedulerLive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ToggleSchedulerLiveMutation, ToggleSchedulerLiveMutationVariables>
export const SchedulingSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SchedulingSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schedulingConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowDoubleBooking' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesRejected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isStateInsuranceAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'granularity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customQuestions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'marketingConsent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optIn' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadOverrideEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadOverrideConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SchedulingSettingsQuery, SchedulingSettingsQueryVariables>
export const UpdateSchedulingConfigurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSchedulingConfiguration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateSchedulingConfigurationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSchedulingConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowDoubleBooking' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insurancesRejected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isStateInsuranceAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'granularity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customQuestions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'marketingConsent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optIn' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadOverrideEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadOverrideConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSchedulingConfigurationMutation, UpdateSchedulingConfigurationMutationVariables>
export const CreateAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateAvailabilityInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAvailability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operatoryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operatoryIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backupAvailability' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>
export const UpdateAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAvailabilityInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAvailability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operatoryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operatoryIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backupAvailability' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>
export const ProviderAvailabilitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProviderAvailabilities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'providerId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'providerAvailabilities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'providerId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'providerId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operatoryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operatoryIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backupAvailability' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeSlots' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sunday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'monday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tuesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wednesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'thursday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'saturday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProviderAvailabilitiesQuery, ProviderAvailabilitiesQueryVariables>
export const DeleteProviderAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteProviderAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteProviderAvailability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteProviderAvailabilityMutation, DeleteProviderAvailabilityMutationVariables>
export const CallsModalStaffCallActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CallsModalStaffCallActivities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bucket' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'staffId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'staffName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffCallActivities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bucket' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'bucket' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'staffId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'staffId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'staffName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'staffName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contacts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneFromActivity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CallsModalStaffCallActivitiesQuery, CallsModalStaffCallActivitiesQueryVariables>
export const CreateScorecardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateScorecard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateScorecardInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createScorecard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateScorecardMutation, CreateScorecardMutationVariables>
export const UpdateScorecardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateScorecard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateScorecardInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateScorecard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateScorecardMutation, UpdateScorecardMutationVariables>
export const ScorecardMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScorecardMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'grouping' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locations' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'staff' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lookbackType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lookbackAmount' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scorecardMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'grouping' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'grouping' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locations' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locations' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'staff' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'staff' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lookbackType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lookbackType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lookbackAmount' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lookbackAmount' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                { kind: 'Field', name: { kind: 'Name', value: 'MQLs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                { kind: 'Field', name: { kind: 'Name', value: 'production' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalSpend' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ROI' } },
                { kind: 'Field', name: { kind: 'Name', value: 'CPL' } },
                { kind: 'Field', name: { kind: 'Name', value: 'CPQL' } },
                { kind: 'Field', name: { kind: 'Name', value: 'CPA' } },
                { kind: 'Field', name: { kind: 'Name', value: 'CAC' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadsNeedsAction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadsInProgress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadsScheduled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadsClosedWon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadsClosedLost' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subRows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'MQLs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'production' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ROI' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPQL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPA' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CAC' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduleRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsNeedsAction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsInProgress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsClosedWon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsClosedLost' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScorecardMetricsQuery, ScorecardMetricsQueryVariables>
export const SendingDomainsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendingDomains' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendingDomains' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dnsRecords' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'found' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendingDomainsQuery, SendingDomainsQueryVariables>
export const CreateSendingDomainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSendingDomain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateSendingDomainInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSendingDomain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dnsRecords' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'found' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSendingDomainMutation, CreateSendingDomainMutationVariables>
export const VerifySendingDomainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerifySendingDomain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifySendingDomain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dnsRecords' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'found' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifySendingDomainMutation, VerifySendingDomainMutationVariables>
export const DeleteSendingDomainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteSendingDomain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteSendingDomain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteSendingDomainMutation, DeleteSendingDomainMutationVariables>
export const SettingsAiAgentLocationSetLiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SettingsAIAgentLocationSetLive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateLocationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAIAgentLive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsAiAgentLocationSetLiveMutation, SettingsAiAgentLocationSetLiveMutationVariables>
export const PatientIdsByReferralTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PatientIdsByReferralType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientIdsByReferralTypeQuery, PatientIdsByReferralTypeQueryVariables>
export const ContactCardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactCard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactCardQuery, ContactCardQueryVariables>
export const LocationKollaConsumerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationKollaConsumer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationKollaConsumerQuery, LocationKollaConsumerQueryVariables>
export const MonthlyMarketingMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MonthlyMarketingMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showDisqualified' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'MQLs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'production' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ROI' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPQL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPA' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CAC' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cpls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roi' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iCPL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iCPQL' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MonthlyMarketingMetricsQuery, MonthlyMarketingMetricsQueryVariables>
export const NewPatientsMonthlyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewPatientsMonthly' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newPatientsMonthlyBreakdown' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reappointmentPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokenAppointmentCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageTimeToAppointment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageProductionPerNewPatientVisit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newPatients' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledNewPatients' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewPatientsMonthlyQuery, NewPatientsMonthlyQueryVariables>
export const CreateStaffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateStaff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateStaffInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createStaff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDuplicated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateStaffMutation, CreateStaffMutationVariables>
export const StaffFormUpdateStaffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffFormUpdateStaff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateStaffInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateStaff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDuplicated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffFormUpdateStaffMutation, StaffFormUpdateStaffMutationVariables>
export const StaffFormDeleteStaffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffFormDeleteStaff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteStaff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffFormDeleteStaffMutation, StaffFormDeleteStaffMutationVariables>
export const StoredCredentialsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StoredCredentials' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'storedCredentials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StoredCredentialsQuery, StoredCredentialsQueryVariables>
export const StoredCredentialPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StoredCredentialPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'storedCredentialPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'password' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StoredCredentialPasswordQuery, StoredCredentialPasswordQueryVariables>
export const CreateStoredCredentialDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateStoredCredential' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'targetWorkspaceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateStoredCredentialInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createStoredCredential' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'targetWorkspaceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'targetWorkspaceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateStoredCredentialMutation, CreateStoredCredentialMutationVariables>
export const UpdateStoredCredentialDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateStoredCredential' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateStoredCredentialInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateStoredCredential' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateStoredCredentialMutation, UpdateStoredCredentialMutationVariables>
export const DeleteStoredCredentialDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteStoredCredential' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteStoredCredential' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteStoredCredentialMutation, DeleteStoredCredentialMutationVariables>
export const StoredCredentialOpsLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StoredCredentialOpsLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'LocationFilter' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'opsLocations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StoredCredentialOpsLocationsQuery, StoredCredentialOpsLocationsQueryVariables>
export const AssignCellUpdateStaffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignCellUpdateStaff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateStaffInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateStaff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignCellUpdateStaffMutation, AssignCellUpdateStaffMutationVariables>
export const AddTagShadcnTagColorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AddTagShadcnTagColors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tagColors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddTagShadcnTagColorsQuery, AddTagShadcnTagColorsQueryVariables>
export const TaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Task' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'task' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdById' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskQuery, TaskQueryVariables>
export const TaskOwnerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaskOwner' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskOwnerQuery, TaskOwnerQueryVariables>
export const CreateTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTaskInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdById' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTaskMutation, CreateTaskMutationVariables>
export const UpdateTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateTaskInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdById' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaskMutation, UpdateTaskMutationVariables>
export const DeleteTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTaskMutation, DeleteTaskMutationVariables>
export const OpsUsageCostMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OpsUsageCostMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsageCostInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'opsUsageCostMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voiceCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsConversations' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voiceMinutes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTokensInput' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTokensOutput' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgCostPerVoiceCall' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgCostPerSmsConversation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'telephonyCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsLlmUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsPlatformUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsTotalUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsLlmCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsCarrierCostUsd' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buckets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voiceCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsConversations' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voiceCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voiceMinutes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tokensInput' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tokensOutput' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voiceCalls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsConversations' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voiceCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgCostPerInteraction' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'voiceOutcomes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'voiceTransferredCalls' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smsToolCalls' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'avgSmsLatencyMs' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpsUsageCostMetricsQuery, OpsUsageCostMetricsQueryVariables>
export const OpsUsageCostVoiceCallsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OpsUsageCostVoiceCalls' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsageCostDetailInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'opsUsageCostVoiceCalls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'callId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callerPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transferred' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'telephonyCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsAsrUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsTtsUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsLlmUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsPlatformUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsTotalUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'llmInputTokens' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'llmOutputTokens' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCostUsd' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpsUsageCostVoiceCallsQuery, OpsUsageCostVoiceCallsQueryVariables>
export const OpsUsageCostSmsThreadsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OpsUsageCostSmsThreads' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsageCostDetailInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'opsUsageCostSmsThreads' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'turns' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstTurnDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTurnDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tokensInput' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tokensOutput' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'llmCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCostUsd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgLatencyMs' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpsUsageCostSmsThreadsQuery, OpsUsageCostSmsThreadsQueryVariables>
export const UserActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserActivityQuery, UserActivityQueryVariables>
export const ImpersonateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ImpersonateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'impersonateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accessToken' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImpersonateUserMutation, ImpersonateUserMutationVariables>
export const CreateUserFromDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUserFromDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserFromDetailsMutation, CreateUserFromDetailsMutationVariables>
export const UpdateUserFromDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserFromDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserFromDetailsMutation, UpdateUserFromDetailsMutationVariables>
export const OpsSetUserTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OpsSetUserType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'opsSetUserType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpsSetUserTypeMutation, OpsSetUserTypeMutationVariables>
export const CreateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>
export const CreateWorkspaceInviteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateWorkspaceInvite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateWorkspaceInviteInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWorkspaceInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateWorkspaceInviteMutation, CreateWorkspaceInviteMutationVariables>
export const UserNotificationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserNotificationSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userNotificationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneCalls' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'canceledAppointment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allUnscheduledCalls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newPatientUnscheduledCalls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callbackRequested' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'missedCalls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'voicemail' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'incomingCall' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'popup' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sound' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aiAgent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newAIAgentCall' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'emergencyAppointmentRequest' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newAppointmentBooked' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'textMessages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newTextMessage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'popup' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sound' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formSubmissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newFormSubmission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduler' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newAppointmentBooked' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pmsData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'noPatientLinkedOnScheduledContact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'noAppointmentFoundOnScheduledContact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'brokenAppointment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workflowPaused' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'app' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserNotificationSettingsQuery, UserNotificationSettingsQueryVariables>
export const UpdateUserNotificationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserNotificationSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserNotificationSettingsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserNotificationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserNotificationSettingsMutation, UpdateUserNotificationSettingsMutationVariables>
export const GetSuperNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSuperNotifications' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSuperNotifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toolError' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toolTimeout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toolDuplicate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noCallsIn48h' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangesEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangeOffers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangeServices' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangeBusinessDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangeAppointmentTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangeInsurance' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSuperNotificationsQuery, GetSuperNotificationsQueryVariables>
export const UpdateSuperNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSuperNotifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SuperNotificationSettingsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSuperNotifications' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toolError' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toolTimeout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toolDuplicate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noCallsIn48h' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangesEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangeOffers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangeServices' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangeBusinessDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangeAppointmentTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentChangeInsurance' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSuperNotificationsMutation, UpdateSuperNotificationsMutationVariables>
export const WorkspaceSmsConsentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkspaceSmsConsent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'marketingConsentConfirmedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceSmsConsentQuery, WorkspaceSmsConsentQueryVariables>
export const ConfirmMarketingConsentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConfirmMarketingConsent' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'confirmMarketingConsent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'marketingConsentConfirmedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'marketingConsentConfirmedByUserId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConfirmMarketingConsentMutation, ConfirmMarketingConsentMutationVariables>
export const WorkflowDateTriggerFieldsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkflowDateTriggerFields' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workflowDateTriggerFields' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'storage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowDateTriggerFieldsQuery, WorkflowDateTriggerFieldsQueryVariables>
export const SmsAgentReadyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmsAgentReady' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'smsAgentReady' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SmsAgentReadyQuery, SmsAgentReadyQueryVariables>
export const ThreadAgentStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ThreadAgentState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thread' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiEnabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ThreadAgentStateQuery, ThreadAgentStateQueryVariables>
export const ContactThreadIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactThreadIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactThreadIdsQuery, ContactThreadIdsQueryVariables>
export const ThreadsAgentStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ThreadsAgentState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'threads' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ThreadsAgentStateQuery, ThreadsAgentStateQueryVariables>
export const BlockoutNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BlockoutNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blockoutNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'note' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlockoutNotesQuery, BlockoutNotesQueryVariables>
export const InboxLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InboxLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'products' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboxLocationsQuery, InboxLocationsQueryVariables>
export const ListMembersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListMembers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'listId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stageId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listMembers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'listId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'listId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stageId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'stageId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'members' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stageId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListMembersQuery, ListMembersQueryVariables>
export const ListStageCountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListStageCounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'listId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listStageCounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'listId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'listId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'stageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListStageCountsQuery, ListStageCountsQueryVariables>
export const CreateListItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateListItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateListItemInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createListItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateListItemMutation, CreateListItemMutationVariables>
export const UpdateListItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateListItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateListItemInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateListItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateListItemMutation, UpdateListItemMutationVariables>
export const DeleteListItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteListItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteListItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteListItemMutation, DeleteListItemMutationVariables>
export const ListItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'listId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListItemsQuery, ListItemsQueryVariables>
export const SidebarListsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SidebarLists' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lists' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'join' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SidebarListsQuery, SidebarListsQueryVariables>
export const SystemListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SystemList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'list' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultStageId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SystemListQuery, SystemListQueryVariables>
export const MarketingContactsModalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MarketingContactsModal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filterBy' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filterBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filterBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fromDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unbookedTreatmentValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adClickDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'leadOwner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'convertedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pipelines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarketingContactsModalQuery, MarketingContactsModalQueryVariables>
export const MarketingContactsTableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MarketingContactsTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filterBy' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rawChannel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'leadOwnerId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'leadOwnerName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schedulingActivityType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstActivityType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaign' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'utmSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'utmMedium' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'utmCampaign' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackableCampaignId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportedAttribution' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hideNonPatients' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hideMultiLocationPatients' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filterBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filterBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fromDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rawChannel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rawChannel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'platform' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'leadOwnerId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'leadOwnerId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'leadOwnerName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'leadOwnerName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'schedulingActivityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schedulingActivityType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstActivityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstActivityType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaign' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaign' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'utmSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'utmSource' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'utmMedium' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'utmMedium' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'utmCampaign' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'utmCampaign' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'trackableCampaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'trackableCampaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportedAttribution' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportedAttribution' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showDisqualified' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hideNonPatients' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hideNonPatients' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hideMultiLocationPatients' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hideMultiLocationPatients' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unbookedTreatmentValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adClickDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'leadOwner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'convertedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pipelines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarketingContactsTableQuery, MarketingContactsTableQueryVariables>
export const MarkMessageReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkMessageRead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'read' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markMessageRead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'read' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'read' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkMessageReadMutation, MarkMessageReadMutationVariables>
export const ArchiveMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchiveMessageMutation, ArchiveMessageMutationVariables>
export const LinkMessageToContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LinkMessageToContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkMessageToContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contactId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinkMessageToContactMutation, LinkMessageToContactMutationVariables>
export const RoleNameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoleName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoleNameQuery, RoleNameQueryVariables>
export const HeldMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HeldMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sendDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeldMessagesQuery, HeldMessagesQueryVariables>
export const CancelScheduledMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelScheduledMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelScheduledMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sendDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelScheduledMessageMutation, CancelScheduledMessageMutationVariables>
export const AttributionMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AttributionMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'production' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roi' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'byChannel' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'channel' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'production' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttributionMetricsQuery, AttributionMetricsQueryVariables>
export const AttributionAdCampaignsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AttributionAdCampaigns' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaigns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttributionAdCampaignsQuery, AttributionAdCampaignsQueryVariables>
export const AttributionDaysDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AttributionDays' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: { kind: 'StringValue', value: 'days', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'byChannel' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttributionDaysQuery, AttributionDaysQueryVariables>
export const FeatureToggleOverrideUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeatureToggleOverrideUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureToggleOverrideUserQuery, FeatureToggleOverrideUserQueryVariables>
export const LiveAlertPreferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LiveAlertPreferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userNotificationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'textMessages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newTextMessage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'popup' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sound' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneCalls' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'incomingCall' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'popup' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sound' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LiveAlertPreferencesQuery, LiveAlertPreferencesQueryVariables>
export const LocationMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'compareRange' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelOp' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hideMultiLocationPatients' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'compareRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'compareRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelOp' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channelOp' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'platform' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showDisqualified' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showDisqualified' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hideMultiLocationPatients' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hideMultiLocationPatients' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'MQLs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'production' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ROI' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPQL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPA' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CAC' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disqualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closedWon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closedLost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsClosedWon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsNeedsAction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsInProgress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsClosedLost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cpls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roi' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iCPL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iCPQL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduleRate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'MQLs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'production' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ROI' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPQL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPA' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CAC' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disqualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closedWon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closedLost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsClosedWon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsNeedsAction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsInProgress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsClosedLost' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'leadsByFirstActivityType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'compareTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'MQLs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'production' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ROI' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPQL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CPA' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CAC' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disqualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closedWon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closedLost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsClosedWon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsNeedsAction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsInProgress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadsClosedLost' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'leadsByFirstActivityType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mqls' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointments' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patients' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationMetricsQuery, LocationMetricsQueryVariables>
export const LocationOptOutsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationOptOuts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optOuts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationOptOutsQuery, LocationOptOutsQueryVariables>
export const LocationTimezoneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationTimezone' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationTimezoneQuery, LocationTimezoneQueryVariables>
export const PipelineCommContextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PipelineCommContext' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PipelineCommContextQuery, PipelineCommContextQueryVariables>
export const PipelineTaskCountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PipelineTaskCounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PipelineTaskCountsQuery, PipelineTaskCountsQueryVariables>
export const PipelinesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Pipelines' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pipelines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PipelinesQuery, PipelinesQueryVariables>
export const SidebarCountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SidebarCounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'activeLeadsSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'activitiesSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledLeadsSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'closedLostLeadsSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dueForHygieneSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dueIn30DaysSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'openTasksSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'myTasksSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'allTasksSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'allContacts' },
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'allActivities' },
            name: { kind: 'Name', value: 'activities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'activitiesSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'activeLeads' },
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'activeLeadsSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'scheduledLeads' },
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledLeadsSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'closedLostLeads' },
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'closedLostLeadsSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dueForHygiene' },
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dueForHygieneSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dueIn30Days' },
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dueIn30DaysSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'openTasks' },
            name: { kind: 'Name', value: 'tasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'openTasksSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'myTasks' },
            name: { kind: 'Name', value: 'tasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'myTasksSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'allTasks' },
            name: { kind: 'Name', value: 'tasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'allTasksSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'allWorkspaces' },
            name: { kind: 'Name', value: 'workspaces' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'allLocations' },
            name: { kind: 'Name', value: 'locations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SidebarCountsQuery, SidebarCountsQueryVariables>
export const UnreadInboxMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UnreadInboxMessages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'StringValue',
                  value:
                    '!read:true AND NOT archived:true AND !sentByUserId:* AND !isAgent:true AND NOT status:pending',
                  block: false,
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnreadInboxMessagesQuery, UnreadInboxMessagesQueryVariables>
export const ContactSidebarCustomPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactSidebarCustomPages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'StringValue', value: 'type:contacts', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1000' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactSidebarCustomPagesQuery, ContactSidebarCustomPagesQueryVariables>
export const ActivitySidebarCustomPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActivitySidebarCustomPages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'StringValue', value: 'type:activities', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1000' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivitySidebarCustomPagesQuery, ActivitySidebarCustomPagesQueryVariables>
export const TaskSidebarCustomPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaskSidebarCustomPages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'StringValue', value: 'type:tasks', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1000' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskSidebarCustomPagesQuery, TaskSidebarCustomPagesQueryVariables>
export const SidebarPipelinesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SidebarPipelines' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pipelines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SidebarPipelinesQuery, SidebarPipelinesQueryVariables>
export const QualifiedLeadCountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'QualifiedLeadCounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualifiedLeadCounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationStatus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'platform' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disqualified' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffConversionMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disqualified' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QualifiedLeadCountsQuery, QualifiedLeadCountsQueryVariables>
export const AddActivityTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddActivityTags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addActivityTags' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tags' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddActivityTagsMutation, AddActivityTagsMutationVariables>
export const RemoveActivityTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveActivityTags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeActivityTags' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tags' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveActivityTagsMutation, RemoveActivityTagsMutationVariables>
export const AddContactTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddContactTags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addTags' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tags' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddContactTagsMutation, AddContactTagsMutationVariables>
export const RemoveContactTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveContactTags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeTags' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tags' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveContactTagsMutation, RemoveContactTagsMutationVariables>
export const ActivityTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActivityTags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivityTagsQuery, ActivityTagsQueryVariables>
export const ContactTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactTagsQuery, ContactTagsQueryVariables>
export const UpdateTagsCreateTagColorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTagsCreateTagColor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTagColorInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTagColor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTagsCreateTagColorMutation, UpdateTagsCreateTagColorMutationVariables>
export const AddWorkspaceOrgTagDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddWorkspaceOrgTag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tag' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addWorkspaceOrgTag' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tag' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tag' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgTags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddWorkspaceOrgTagMutation, AddWorkspaceOrgTagMutationVariables>
export const RemoveWorkspaceOrgTagDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveWorkspaceOrgTag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tag' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeWorkspaceOrgTag' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tag' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tag' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgTags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveWorkspaceOrgTagMutation, RemoveWorkspaceOrgTagMutationVariables>
export const PipelinesForFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PipelinesForFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pipelines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PipelinesForFilterQuery, PipelinesForFilterQueryVariables>
export const TagColorsFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TagColorsFilter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tagColors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TagColorsFilterQuery, TagColorsFilterQueryVariables>
export const TagValuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TagValues' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tagValues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entity' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TagValuesQuery, TagValuesQueryVariables>
export const InboxMessagesWithArchivedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InboxMessagesWithArchived' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isInitialMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'htmlBody' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerMessageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboxMessagesWithArchivedQuery, InboxMessagesWithArchivedQueryVariables>
export const UnreadOptOutKeysDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UnreadOptOutKeys' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optOuts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnreadOptOutKeysQuery, UnreadOptOutKeysQueryVariables>
export const SetWorkflowCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetWorkflowCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'MessageCategory' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setWorkflowCategory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'category' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetWorkflowCategoryMutation, SetWorkflowCategoryMutationVariables>
export const WorkflowsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Workflows' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workflows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pausedReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pausedNodeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pausedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'triggerStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'triggerJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodesJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'edgesJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'settingsJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'builderJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowsQuery, WorkflowsQueryVariables>
export const FormActivitiesForPickerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FormActivitiesForPicker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FormActivitiesForPickerQuery, FormActivitiesForPickerQueryVariables>
export const TriggerSampleActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TriggerSampleActivities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contacts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TriggerSampleActivitiesQuery, TriggerSampleActivitiesQueryVariables>
export const WorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Workflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedNodeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggerStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggerJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nodesJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edgesJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settingsJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'builderJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowQuery, WorkflowQueryVariables>
export const CreateWorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateWorkflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateWorkflowInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedNodeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggerStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggerJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nodesJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edgesJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settingsJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'builderJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateWorkflowMutation, CreateWorkflowMutationVariables>
export const UpdateWorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWorkflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateWorkflowInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedNodeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggerStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggerJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nodesJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edgesJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settingsJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'builderJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>
export const DeleteWorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteWorkflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>
export const WorkflowTriggerEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkflowTriggerEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'events' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workflowIds' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowTriggerEventsQuery, WorkflowTriggerEventsQueryVariables>
export const WorkflowEnrollmentEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkflowEnrollmentEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'event' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowEnrollmentEventQuery, WorkflowEnrollmentEventQueryVariables>
export const WorkflowRunsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkflowRuns' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workflowRuns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workflowId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentNodeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resumeAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waitingFor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exitReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrollmentEventId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowRunsQuery, WorkflowRunsQueryVariables>
export const WorkflowStoppedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkflowStopped' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'heldSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedNodeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pausedDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workflowRuns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'heldSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowStoppedQuery, WorkflowStoppedQueryVariables>
export const WorkflowRejectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkflowRejections' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workflowRunEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'outputJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowRejectionsQuery, WorkflowRejectionsQueryVariables>
export const WorkflowRunEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkflowRunEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workflowRunEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'runId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'outputJson' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowRunEventsQuery, WorkflowRunEventsQueryVariables>
export const CancelWorkflowRunDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelWorkflowRun' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelWorkflowRun' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitReason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelWorkflowRunMutation, CancelWorkflowRunMutationVariables>
export const TriggerWorkflowOnContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TriggerWorkflowOnContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerWorkflowOnContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contactId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TriggerWorkflowOnContactMutation, TriggerWorkflowOnContactMutationVariables>
export const WorkflowTestContactsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkflowTestContacts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowTestContactsQuery, WorkflowTestContactsQueryVariables>
export const WorkspaceThrottleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkspaceThrottle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxOutboundMonthly' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxOutboundDaily' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxEnrollmentsPerHour' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceThrottleQuery, WorkspaceThrottleQueryVariables>
export const WorkflowLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkflowLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'products' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegrated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kollaConnectorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callRailCompanyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryTrackingNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'openHours' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sunday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'monday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tuesday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'wednesday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thursday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'friday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'saturday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowLocationsQuery, WorkflowLocationsQueryVariables>
export const WorkflowLookbackContactsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkflowLookbackContacts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pipelines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowLookbackContactsQuery, WorkflowLookbackContactsQueryVariables>
export const WorkflowLookbackAppointmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkflowLookbackAppointments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkflowLookbackAppointmentsQuery, WorkflowLookbackAppointmentsQueryVariables>
export const PreviewWorkflowTriggerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PreviewWorkflowTrigger' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trigger' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkflowTriggerInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'windowStart' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'windowEnd' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewWorkflowTrigger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'trigger' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'trigger' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'windowStart' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'windowStart' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'windowEnd' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'windowEnd' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'matches' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conditionValues' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reconstructedFromRecord' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                { kind: 'Field', name: { kind: 'Name', value: 'examinedCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conditionRejections' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rejectedCount' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'eventHistoryStart' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PreviewWorkflowTriggerQuery, PreviewWorkflowTriggerQueryVariables>
export const UpdateMeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMe' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMe' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMeMutation, UpdateMeMutationVariables>
export const DeleteTagColorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTagColor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTagColor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTagColorMutation, DeleteTagColorMutationVariables>
export const SettingsCreateTagColorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SettingsCreateTagColor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTagColorInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTagColor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsCreateTagColorMutation, SettingsCreateTagColorMutationVariables>
export const UpdateTagColorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTagColor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'color' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTagColor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'color' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'color' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTagColorMutation, UpdateTagColorMutationVariables>
export const AiAgentConfigurationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AIAgentConfigurations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aiAgentConfigurations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentVoiceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'services' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lowPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'highPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consultRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consultPrice' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'servicesNotOffered' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lowPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'highPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consultRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consultPrice' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'offers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eligibleInsurance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onlyEmergencyEligible' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emergencyApptId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generalApptId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'smsConfirmationEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postBookingMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygienePostBookingMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consultApptId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limitedExamApptId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voiceAgentAddendum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cleaningRequiresInitialExam' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pediatricOnly' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voiceAgentTools' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AiAgentConfigurationsQuery, AiAgentConfigurationsQueryVariables>
export const ActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Activities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contacts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'peopleIndex' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fbclid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameFromActivity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'needsReview' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneFromActivity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivitiesQuery, ActivitiesQueryVariables>
export const ActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Activity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'peopleIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fbclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nameFromActivity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'needsReview' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneFromActivity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivityQuery, ActivityQueryVariables>
export const DeleteActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteActivityMutation, DeleteActivityMutationVariables>
export const UpdateNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateNoteInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'peopleIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fbclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nameFromActivity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'needsReview' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneFromActivity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNoteMutation, UpdateNoteMutationVariables>
export const UpdateMilestoneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMilestone' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateMilestoneInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMilestone' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'peopleIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fbclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nameFromActivity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'needsReview' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneFromActivity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMilestoneMutation, UpdateMilestoneMutationVariables>
export const ReassignActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReassignActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReassignActivityInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reassignActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'peopleIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fbclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nameFromActivity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'needsReview' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneFromActivity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReassignActivityMutation, ReassignActivityMutationVariables>
export const AdCampaignsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdCampaigns' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaigns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendorCampaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdCampaignsQuery, AdCampaignsQueryVariables>
export const AdCampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdCampaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorCampaignId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdCampaignQuery, AdCampaignQueryVariables>
export const AdPlatformMappingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdPlatformMappings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adPlatformMappings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdPlatformMappingsQuery, AdPlatformMappingsQueryVariables>
export const CreateAdPlatformMappingStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAdPlatformMappingStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateAdPlatformMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAdPlatformMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAdPlatformMappingStoreMutation, CreateAdPlatformMappingStoreMutationVariables>
export const UpdateAdPlatformMappingStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAdPlatformMappingStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAdPlatformMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAdPlatformMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAdPlatformMappingStoreMutation, UpdateAdPlatformMappingStoreMutationVariables>
export const AppointmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Appointments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentMadeDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode1Amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode1Time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode2Amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode2Time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode3' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode3Amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode3Time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sikkaOfficeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sikkaPracticeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeToAppointment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentsQuery, AppointmentsQueryVariables>
export const AppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Appointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentMadeDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode1Amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode1Time' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode2Amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode2Time' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode3' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode3Amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode3Time' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCodes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sikkaOfficeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sikkaPracticeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeToAppointment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentQuery, AppointmentQueryVariables>
export const AppointmentTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AppointmentTypes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentTypes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'activeAgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activeScheduler' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentLength' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'blockScheduling' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'blockSchedulingNotes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'doubleBookingExclusion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excludedBlockouts' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'generalBuffer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'morningBuffer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'morningBufferLookahead' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startIncrement' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentTypesQuery, AppointmentTypesQueryVariables>
export const UpdateAppointmentTypeStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAppointmentTypeStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAppointmentTypeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAppointmentType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activeAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeScheduler' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blockScheduling' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blockSchedulingNotes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'doubleBookingExclusion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'excludedBlockouts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generalBuffer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'morningBuffer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'morningBufferLookahead' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCodes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startIncrement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAppointmentTypeStoreMutation, UpdateAppointmentTypeStoreMutationVariables>
export const AuthStoreMeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AuthStoreMe' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isOrgRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowedLocationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedWorkspaceIds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workspaces' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'products' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthStoreMeQuery, AuthStoreMeQueryVariables>
export const AuthWorkspaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AuthWorkspace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthWorkspaceQuery, AuthWorkspaceQueryVariables>
export const LoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Login' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'login' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>
export const VerifyOtpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerifyOtp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pendingToken' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyOtp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pendingToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pendingToken' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accessToken' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyOtpMutation, VerifyOtpMutationVariables>
export const LoginWithGoogleCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LoginWithGoogleCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'redirectUri' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginWithGoogleCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'redirectUri' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'redirectUri' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginWithGoogleCodeMutation, LoginWithGoogleCodeMutationVariables>
export const LogoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Logout' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'logout' } }] },
    },
  ],
} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>
export const BudgetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Budgets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'budgets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'internalGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mqlGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetSpend' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'yearMonth' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BudgetsQuery, BudgetsQueryVariables>
export const UpdateBudgetStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBudgetStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateBudgetInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBudget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentGoal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'internalGoal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadGoal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mqlGoal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientGoal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetSpend' } },
                { kind: 'Field', name: { kind: 'Name', value: 'yearMonth' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBudgetStoreMutation, UpdateBudgetStoreMutationVariables>
export const CallsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Calls' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsConversationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'answered' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ai' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'actionItems' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'people' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'extractionDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tokenUsage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'inputTokens' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'outputTokens' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalTokens' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientNames' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waveforms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentDateString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callerPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'businessPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recordingDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'landingPageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recordings' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'patients' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'staff' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiAgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'golden' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'people' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'allPatientOutcomes' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CallsQuery, CallsQueryVariables>
export const CallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Call' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsConversationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answered' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ai' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actionItems' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'people' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'extractionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tokenUsage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'inputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTokens' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'waveforms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDateString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recordingDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'landingPageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recordings' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'patients' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staff' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'aiAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'golden' } },
                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'people' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'allPatientOutcomes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CallQuery, CallQueryVariables>
export const UpdateCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateCallInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsConversationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answered' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ai' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actionItems' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'people' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'answerer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'extractionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tokenUsage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'inputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outputTokens' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTokens' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'waveforms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDateString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recordingDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referringUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'landingPageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recordings' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'patients' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staff' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'aiAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'golden' } },
                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'people' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serviceRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'outcomes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reasonForNotScheduling' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCaller' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'allPatientOutcomes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCallMutation, UpdateCallMutationVariables>
export const DeleteCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCallMutation, DeleteCallMutationVariables>
export const CdtCodeMappingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CdtCodeMappings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cdtCodeMappings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cdtCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CdtCodeMappingsQuery, CdtCodeMappingsQueryVariables>
export const CreateCdtCodeMappingStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCdtCodeMappingStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCdtCodeMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCdtCodeMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cdtCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCdtCodeMappingStoreMutation, CreateCdtCodeMappingStoreMutationVariables>
export const UpdateCdtCodeMappingStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCdtCodeMappingStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateCdtCodeMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCdtCodeMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cdtCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCdtCodeMappingStoreMutation, UpdateCdtCodeMappingStoreMutationVariables>
export const DeleteCdtCodeMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCdtCodeMapping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCdtCodeMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCdtCodeMappingMutation, DeleteCdtCodeMappingMutationVariables>
export const ChannelMappingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChannelMappings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'channelMappings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChannelMappingsQuery, ChannelMappingsQueryVariables>
export const CreateChannelMappingStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateChannelMappingStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateChannelMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createChannelMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateChannelMappingStoreMutation, CreateChannelMappingStoreMutationVariables>
export const UpdateChannelMappingStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateChannelMappingStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateChannelMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateChannelMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateChannelMappingStoreMutation, UpdateChannelMappingStoreMutationVariables>
export const ContactsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Contacts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'magicTerms' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fields' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'magicTerms' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'magicTerms' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fields' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fields' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adClickDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'convertedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fbclid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hygieneStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'landingPageURL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadConversionStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'leadOwner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pipelines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referralURL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatmentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unbookedTreatmentValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactsQuery, ContactsQueryVariables>
export const ContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Contact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adClickDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'convertedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fbclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'landingPageURL' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadConversionStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadOwner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pipelines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referralURL' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treatmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unbookedTreatmentValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactQuery, ContactQueryVariables>
export const CreateContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateContactInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treatmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadOwner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pipelines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateContactMutation, CreateContactMutationVariables>
export const UpdateContactStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateContactStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateContactInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treatmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadOwner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pipelines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateContactStoreMutation, UpdateContactStoreMutationVariables>
export const MergeContactsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MergeContacts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'leftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rightId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mergeContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'leftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'leftId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rightId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rightId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MergeContactsMutation, MergeContactsMutationVariables>
export const RecalculateContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecalculateContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recalculateContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treatmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadOwner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pipelines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecalculateContactMutation, RecalculateContactMutationVariables>
export const AddTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddTags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addTags' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tags' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treatmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadOwner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pipelines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddTagsMutation, AddTagsMutationVariables>
export const AddToPipelineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddToPipeline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pipeline' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactPipelineInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addToPipeline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pipeline' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pipeline' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activityTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameInactiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedLostReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collectedLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstContactReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstTransactionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fvv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneDueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hygieneStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treatmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPerio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isQualified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActivityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCommActivitySubType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHygieneDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadOwner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lifecycleStage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nearestAppointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neededAction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'needsActionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'otherPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientCreatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pipelines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredCommunicationMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredContact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productionLtv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportedAttribution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledProduction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'smsMarketingConsent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackableCampaignId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmKeywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddToPipelineMutation, AddToPipelineMutationVariables>
export const ConversionLogsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ConversionLogs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversionLogs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'becameLeadDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'becamePatientDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conversionDateTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conversionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conversionValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstAppointmentMadeDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gclid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleAdsAccountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversionLogsQuery, ConversionLogsQueryVariables>
export const CustomPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CustomPages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomPagesQuery, CustomPagesQueryVariables>
export const CustomPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CustomPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomPageQuery, CustomPageQueryVariables>
export const CreateCustomPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCustomPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCustomPageInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCustomPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCustomPageMutation, CreateCustomPageMutationVariables>
export const UpdateCustomPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCustomPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateCustomPageInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCustomPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCustomPageMutation, UpdateCustomPageMutationVariables>
export const DeleteCustomPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCustomPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCustomPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCustomPageMutation, DeleteCustomPageMutationVariables>
export const ExtractionPromptsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExtractionPrompts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'extractionPrompts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'promptVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExtractionPromptsQuery, ExtractionPromptsQueryVariables>
export const ExtractionPromptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExtractionPrompt' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'extractionPrompt' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promptVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExtractionPromptQuery, ExtractionPromptQueryVariables>
export const CreateExtractionPromptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateExtractionPrompt' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateExtractionPromptInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createExtractionPrompt' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promptVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateExtractionPromptMutation, CreateExtractionPromptMutationVariables>
export const FeatureToggleDefinitionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeatureToggleDefinitions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggleDefinitions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'release' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureToggleDefinitionsQuery, FeatureToggleDefinitionsQueryVariables>
export const FeatureTogglesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeatureToggles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureTogglesQuery, FeatureTogglesQueryVariables>
export const FeatureTogglesByNameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeatureTogglesByName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'names' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureTogglesByName' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'names' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'names' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureTogglesByNameQuery, FeatureTogglesByNameQueryVariables>
export const CreateFeatureToggleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFeatureToggle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFeatureToggleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFeatureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFeatureToggleMutation, CreateFeatureToggleMutationVariables>
export const UpdateFeatureToggleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFeatureToggle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFeatureToggleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFeatureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFeatureToggleMutation, UpdateFeatureToggleMutationVariables>
export const DeleteFeatureToggleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteFeatureToggle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFeatureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFeatureToggleMutation, DeleteFeatureToggleMutationVariables>
export const FollowUpStoreListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FollowUpStoreList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'followUps' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'followUpDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'associatedType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'associatedTypeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'associatedPeopleIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FollowUpStoreListQuery, FollowUpStoreListQueryVariables>
export const FollowUpStoreGetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FollowUpStoreGet' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'followUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'followUpDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'associatedType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'associatedTypeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'associatedPeopleIndex' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FollowUpStoreGetQuery, FollowUpStoreGetQueryVariables>
export const FollowUpStoreCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FollowUpStoreCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFollowUpInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFollowUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'followUpDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'associatedType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'associatedTypeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'associatedPeopleIndex' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FollowUpStoreCreateMutation, FollowUpStoreCreateMutationVariables>
export const FollowUpStoreUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FollowUpStoreUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFollowUpInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFollowUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'followUpDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'associatedType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'associatedTypeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'associatedPeopleIndex' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FollowUpStoreUpdateMutation, FollowUpStoreUpdateMutationVariables>
export const DeleteFollowUpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteFollowUp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFollowUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFollowUpMutation, DeleteFollowUpMutationVariables>
export const FormFieldMappingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FormFieldMappings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formFieldMappings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formField' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rawKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FormFieldMappingsQuery, FormFieldMappingsQueryVariables>
export const CreateFormFieldMappingStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFormFieldMappingStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFormFieldMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFormFieldMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formField' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFormFieldMappingStoreMutation, CreateFormFieldMappingStoreMutationVariables>
export const UpdateFormFieldMappingStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFormFieldMappingStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFormFieldMappingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFormFieldMapping' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formField' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFormFieldMappingStoreMutation, UpdateFormFieldMappingStoreMutationVariables>
export const ImportsStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ImportsStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fileImportId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAppointmentTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'staff' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImportsStoreQuery, ImportsStoreQueryVariables>
export const ImportDetailStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ImportDetailStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'importDetail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileImportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestedAppointmentTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'staff' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treatment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmMedium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utmSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImportDetailStoreQuery, ImportDetailStoreQueryVariables>
export const IncomingCallsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IncomingCalls' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'incomingCalls' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callerState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingNumberName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IncomingCallsQuery, IncomingCallsQueryVariables>
export const ListsStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListsStore' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lists' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultStageId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListsStoreQuery, ListsStoreQueryVariables>
export const ListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'List' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'list' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultStageId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListQuery, ListQueryVariables>
export const CreateListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateListInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultStageId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateListMutation, CreateListMutationVariables>
export const UpdateListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateListInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultStageId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryAttribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secondaryValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'static' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nonEmpty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useAsterisk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subQuery' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOperator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeToday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeYesterday' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeWeeks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limitToMonth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeInThePast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'options' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'join' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateListMutation, UpdateListMutationVariables>
export const DeleteListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteListMutation, DeleteListMutationVariables>
export const LocationStoreLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationStoreLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegratedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'migrationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sikkaOfficeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sikkaPracticeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kollaConnectorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kollaPracticeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kollaPageSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availabilityMode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callRailCompanyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsAgentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callRailBackfillStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'jotformFormIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookFormIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carestackId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ringCentralPhoneNumbers' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'twilioNumbers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sourceName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'poolId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'areaCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'poolSize' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sessionDuration' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryNumberId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'officeTransferNumberId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleAdsCustomerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookAdSetIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'openHours' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sunday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'monday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tuesday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'wednesday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thursday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'friday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'saturday' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hours' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'labels' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'products' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callRailRouting' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryTrackingNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primarySmsNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'businessPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'officeMainNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'officeTransferNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'jotFormIgnoredForms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastSyncFailureDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncCompleteDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastRingCentralSyncDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastCallrailWebhookDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTwilioWebhookDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAICallDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastSikkaWebhookDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastJotformWebhookDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastFacebookWebhookDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookSpendUpdateDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleSpendUpdateDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookAdsActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googleAdsActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSchedulerLive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAIAgentLive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowDoubleBookingScheduling' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gravityFormsKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'webflowFormsKey' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'googleAdsV2' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'adGroupId' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'googleAdsV3' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'campaignIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'conversionActions' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'facebookAdsV2' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'adSetId' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'facebookLeadsPages' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jotform' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'folderId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jotformV2' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'settings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'newPatientCalculation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentsSetNewPatient' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointmentCompletionStatuses' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'transactionBrokenCodes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'newPatientCodes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ignorePII' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'excludeParentsFromNewPatients' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstVisitSetNewPatient' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackEnabledDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackProvider' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastGravityFormWebhookDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPatientSyncDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentSyncDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionSyncDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastProcedureSyncDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanSyncDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPatientReceivedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentReceivedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionReceivedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastProcedureReceivedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanReceivedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ascendLocationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alarmQuietStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alarmQuietEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dailySyncHour' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegrated' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationStoreLocationsQuery, LocationStoreLocationsQueryVariables>
export const LocationStoreLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationStoreLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegratedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'migrationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sikkaOfficeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sikkaPracticeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConnectorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaPracticeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaPageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availabilityMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callRailCompanyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsAgentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callRailBackfillStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jotformFormIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookFormIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carestackId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ringCentralPhoneNumbers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twilioNumbers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poolId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'areaCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poolSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionDuration' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeTransferNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleAdsCustomerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookAdSetIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'openHours' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sunday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'monday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tuesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wednesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'thursday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'saturday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgTags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labels' } },
                { kind: 'Field', name: { kind: 'Name', value: 'products' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRailRouting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryTrackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primarySmsNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeMainNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeTransferNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jotFormIgnoredForms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSyncFailureDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncCompleteDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastRingCentralSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCallrailWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTwilioWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAICallDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSikkaWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastJotformWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastFacebookWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookSpendUpdateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleSpendUpdateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookAdsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleAdsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSchedulerLive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAIAgentLive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowDoubleBookingScheduling' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gravityFormsKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'webflowFormsKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'googleAdsV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adGroupId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'googleAdsV3' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conversionActions' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookAdsV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adSetId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookLeadsPages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jotform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'folderId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jotformV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCalculation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentsSetNewPatient' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentCompletionStatuses' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionBrokenCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ignorePII' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excludeParentsFromNewPatients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstVisitSetNewPatient' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackEnabledDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackProvider' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastGravityFormWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPatientSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastProcedureSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPatientReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastProcedureReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ascendLocationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alarmQuietStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alarmQuietEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dailySyncHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegrated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationStoreLocationQuery, LocationStoreLocationQueryVariables>
export const LocationStoreCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LocationStoreCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateLocationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegratedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'migrationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sikkaOfficeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sikkaPracticeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConnectorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaPracticeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaPageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availabilityMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callRailCompanyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsAgentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callRailBackfillStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jotformFormIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookFormIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carestackId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ringCentralPhoneNumbers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twilioNumbers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poolId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'areaCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poolSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionDuration' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeTransferNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleAdsCustomerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookAdSetIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'openHours' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sunday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'monday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tuesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wednesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'thursday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'saturday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgTags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labels' } },
                { kind: 'Field', name: { kind: 'Name', value: 'products' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRailRouting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryTrackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primarySmsNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeMainNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeTransferNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jotFormIgnoredForms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSyncFailureDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncCompleteDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastRingCentralSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCallrailWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTwilioWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAICallDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSikkaWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastJotformWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastFacebookWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookSpendUpdateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleSpendUpdateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookAdsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleAdsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSchedulerLive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAIAgentLive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowDoubleBookingScheduling' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gravityFormsKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'webflowFormsKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'googleAdsV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adGroupId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'googleAdsV3' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conversionActions' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookAdsV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adSetId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookLeadsPages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jotform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'folderId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jotformV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCalculation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentsSetNewPatient' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentCompletionStatuses' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionBrokenCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ignorePII' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excludeParentsFromNewPatients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstVisitSetNewPatient' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackEnabledDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackProvider' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastGravityFormWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPatientSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastProcedureSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPatientReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastProcedureReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ascendLocationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alarmQuietStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alarmQuietEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dailySyncHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegrated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationStoreCreateMutation, LocationStoreCreateMutationVariables>
export const LocationStoreUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LocationStoreUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateLocationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegratedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'migrationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sikkaOfficeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sikkaPracticeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConnectorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaPracticeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaPageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availabilityMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callRailCompanyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elevenLabsAgentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callRailBackfillStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jotformFormIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookFormIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carestackId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ringCentralPhoneNumbers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twilioNumbers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poolId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'areaCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poolSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionDuration' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeTransferNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleAdsCustomerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookAdSetIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'openHours' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sunday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'monday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tuesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wednesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'thursday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'saturday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'open' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgTags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labels' } },
                { kind: 'Field', name: { kind: 'Name', value: 'products' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRailRouting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryTrackingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primarySmsNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeMainNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'officeTransferNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jotFormIgnoredForms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSyncFailureDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncCompleteDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastRingCentralSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCallrailWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTwilioWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAICallDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSikkaWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastJotformWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastFacebookWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookSpendUpdateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleSpendUpdateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookAdsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googleAdsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSchedulerLive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAIAgentLive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowDoubleBookingScheduling' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gravityFormsKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'webflowFormsKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'googleAdsV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adGroupId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'googleAdsV3' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conversionActions' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookAdsV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adSetId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookLeadsPages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jotform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'folderId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jotformV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCalculation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentsSetNewPatient' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentCompletionStatuses' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionBrokenCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newPatientCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ignorePII' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excludeParentsFromNewPatients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstVisitSetNewPatient' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackEnabledDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commLogWritebackProvider' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastGravityFormWebhookDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPatientSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastProcedureSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPatientReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAppointmentReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTransactionReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastProcedureReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastTreatmentPlanReceivedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ascendLocationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alarmQuietStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alarmQuietEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dailySyncHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsIntegrated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationStoreUpdateMutation, LocationStoreUpdateMutationVariables>
export const DeleteLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteLocationMutation, DeleteLocationMutationVariables>
export const MessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Messages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isInitialMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'htmlBody' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerMessageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessagesQuery, MessagesQueryVariables>
export const MessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Message' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'message' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiWorkflowName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInitialMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'callerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                { kind: 'Field', name: { kind: 'Name', value: 'htmlBody' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerMessageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageQuery, MessageQueryVariables>
export const SendContactEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendContactEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendContactEmailInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendContactEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'threadId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'htmlBody' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerMessageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendContactEmailMutation, SendContactEmailMutationVariables>
export const NoteTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NoteTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'noteTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NoteTemplatesQuery, NoteTemplatesQueryVariables>
export const NoteTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NoteTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'noteTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NoteTemplateQuery, NoteTemplateQueryVariables>
export const CreateNoteTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNoteTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateNoteTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNoteTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateNoteTemplateMutation, CreateNoteTemplateMutationVariables>
export const UpdateNoteTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNoteTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateNoteTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNoteTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNoteTemplateMutation, UpdateNoteTemplateMutationVariables>
export const DeleteNoteTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteNoteTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteNoteTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteNoteTemplateMutation, DeleteNoteTemplateMutationVariables>
export const NotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Notifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifications' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'activityId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clicked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'managedNotification' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'objectType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'triggerDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workflowId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workflowReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workflowStep' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>
export const NotificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Notification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clicked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managedNotification' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'objectType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggerDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowStep' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationQuery, NotificationQueryVariables>
export const UpdateNotificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNotification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateNotificationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNotification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clicked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managedNotification' } },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'objectType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggerDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowStep' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNotificationMutation, UpdateNotificationMutationVariables>
export const NotificationUnreadCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NotificationUnreadCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifications' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'StringValue', value: '!read:true', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationUnreadCountQuery, NotificationUnreadCountQueryVariables>
export const MarkAllNotificationsReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkAllNotificationsRead' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markAllNotificationsRead' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>
export const ResetNotificationUnseenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetNotificationUnseen' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetNotificationUnseen' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetNotificationUnseenMutation, ResetNotificationUnseenMutationVariables>
export const PatientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Patients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstVisit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guarantorFirstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guarantorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guarantorLastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastVisit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referralType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subscriberId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientsQuery, PatientsQueryVariables>
export const PatientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Patient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cellPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstVisit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guarantorFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guarantorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guarantorLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'homePhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insuranceProvider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastVisit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientReferral' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referralType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscriberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workPhone' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientQuery, PatientQueryVariables>
export const PipelinesStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PipelinesStore' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pipelines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PipelinesStoreQuery, PipelinesStoreQueryVariables>
export const PipelineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Pipeline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pipeline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PipelineQuery, PipelineQueryVariables>
export const CreatePipelineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePipeline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePipelineInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPipeline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePipelineMutation, CreatePipelineMutationVariables>
export const UpdatePipelineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePipeline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePipelineInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePipeline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePipelineMutation, UpdatePipelineMutationVariables>
export const DeletePipelineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePipeline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePipeline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePipelineMutation, DeletePipelineMutationVariables>
export const ProceduresDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Procedures' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'procedures' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tooth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'feeAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'billedAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appointmentIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'planIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCreateDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureUpdateDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProceduresQuery, ProceduresQueryVariables>
export const ProcedureDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Procedure' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'procedure' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tooth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feeAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billedAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'planIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCreateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureUpdateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProcedureQuery, ProcedureQueryVariables>
export const ProvidersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Providers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'providers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deactivated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasProfilePicture' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsDisplayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pmsShortDisplayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'practiceIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxonomy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProvidersQuery, ProvidersQueryVariables>
export const ProviderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Provider' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'provider' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasProfilePicture' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsShortDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'practiceIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxonomy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProviderQuery, ProviderQueryVariables>
export const UpdateProviderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateProvider' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateProviderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProvider' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasProfilePicture' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kollaConsumerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pmsShortDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'practiceIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxonomy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProviderMutation, UpdateProviderMutationVariables>
export const RolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Roles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RolesQuery, RolesQueryVariables>
export const RoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Role' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoleQuery, RoleQueryVariables>
export const CreateRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRoleInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRoleMutation, CreateRoleMutationVariables>
export const UpdateRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateRoleInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRoleMutation, UpdateRoleMutationVariables>
export const DeleteRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteRoleMutation, DeleteRoleMutationVariables>
export const ScorecardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Scorecards' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scorecards' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'objectIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateRange' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lookbackType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lookbackAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'columnVisibility' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'columnOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'grouping' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScorecardsQuery, ScorecardsQueryVariables>
export const CreateScorecardStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateScorecardStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateScorecardInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createScorecard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'objectIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dateRange' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lookbackType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lookbackAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columnVisibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columnOrder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'grouping' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateScorecardStoreMutation, CreateScorecardStoreMutationVariables>
export const UpdateScorecardStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateScorecardStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateScorecardInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateScorecard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'objectIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dateRange' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lookbackType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lookbackAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columnVisibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columnOrder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'grouping' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateScorecardStoreMutation, UpdateScorecardStoreMutationVariables>
export const SmsTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmsTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'smsTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SmsTemplatesQuery, SmsTemplatesQueryVariables>
export const SmsTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmsTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'smsTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SmsTemplateQuery, SmsTemplateQueryVariables>
export const CreateSmsTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSmsTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateSmsTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSmsTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSmsTemplateMutation, CreateSmsTemplateMutationVariables>
export const UpdateSmsTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSmsTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateSmsTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSmsTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSmsTemplateMutation, UpdateSmsTemplateMutationVariables>
export const DeleteSmsTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteSmsTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteSmsTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteSmsTemplateMutation, DeleteSmsTemplateMutationVariables>
export const TagColorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TagColors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tagColors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isOrgTag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastUsedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TagColorsQuery, TagColorsQueryVariables>
export const TagColorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TagColor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tagColor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isOrgTag' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUsedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TagColorQuery, TagColorQueryVariables>
export const TasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Tasks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdById' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TasksQuery, TasksQueryVariables>
export const TaskStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaskStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'task' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdById' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskStoreQuery, TaskStoreQueryVariables>
export const CreateTaskStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTaskStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTaskInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdById' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTaskStoreMutation, CreateTaskStoreMutationVariables>
export const UpdateTaskStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTaskStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateTaskInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdById' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaskStoreMutation, UpdateTaskStoreMutationVariables>
export const TaskTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaskTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dueInDays' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskTemplatesQuery, TaskTemplatesQueryVariables>
export const TaskTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaskTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueInDays' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskTemplateQuery, TaskTemplateQueryVariables>
export const CreateTaskTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTaskTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTaskTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTaskTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueInDays' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTaskTemplateMutation, CreateTaskTemplateMutationVariables>
export const UpdateTaskTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTaskTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateTaskTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTaskTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueInDays' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaskTemplateMutation, UpdateTaskTemplateMutationVariables>
export const DeleteTaskTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTaskTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTaskTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTaskTemplateMutation, DeleteTaskTemplateMutationVariables>
export const TransactionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Transactions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sikkaOfficeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionEntryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionSrNo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'treatmentCategory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TransactionsQuery, TransactionsQueryVariables>
export const TransactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Transaction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transaction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sikkaOfficeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transactionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transactionEntryDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transactionSrNo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transactionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treatmentCategory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TransactionQuery, TransactionQueryVariables>
export const TreatmentPlansDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TreatmentPlans' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'treatmentPlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureFeeOverrides' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'planCreateDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'planUpdateDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TreatmentPlansQuery, TreatmentPlansQueryVariables>
export const TreatmentPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TreatmentPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'treatmentPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patientId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureFeeOverrides' } },
                { kind: 'Field', name: { kind: 'Name', value: 'planCreateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'planUpdateDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TreatmentPlanQuery, TreatmentPlanQueryVariables>
export const UnmappedFormKeysDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UnmappedFormKeys' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unmappedFormKeys' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rawKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendors' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnmappedFormKeysQuery, UnmappedFormKeysQueryVariables>
export const UserSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'key' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserSettingsQuery, UserSettingsQueryVariables>
export const SaveUserSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveUserSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveUserSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'key' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveUserSettingsMutation, SaveUserSettingsMutationVariables>
export const UsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Users' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowedLocationIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assignedLocationIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assignedWorkspaceIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastLoginDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferredChannel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workspaces' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>
export const UserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'User' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowedLocationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedLocationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedWorkspaceIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLoginDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredChannel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workspaces' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserQuery, UserQueryVariables>
export const DeleteUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'aliases' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowedLocationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedLocationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedWorkspaceIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLoginDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferredChannel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workspaces' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>
export const UtmAliasesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UtmAliases' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'utmAliases' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'original' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UtmAliasesQuery, UtmAliasesQueryVariables>
export const CreateUtmAliasStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUtmAliasStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateUtmAliasInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUtmAlias' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'original' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUtmAliasStoreMutation, CreateUtmAliasStoreMutationVariables>
export const UpdateUtmAliasStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUtmAliasStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateUtmAliasInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUtmAlias' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'original' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUtmAliasStoreMutation, UpdateUtmAliasStoreMutationVariables>
export const WorkspaceInvitesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkspaceInvites' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workspaceInvites' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invitedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'staffId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceInvitesQuery, WorkspaceInvitesQueryVariables>
export const WorkspaceInviteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WorkspaceInvite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workspaceInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invitedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'staffId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceInviteQuery, WorkspaceInviteQueryVariables>
export const CreateWorkspaceInviteStoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateWorkspaceInviteStore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateWorkspaceInviteInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWorkspaceInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invitedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'staffId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateWorkspaceInviteStoreMutation, CreateWorkspaceInviteStoreMutationVariables>
export const UpdateWorkspaceInviteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWorkspaceInvite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateWorkspaceInviteInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWorkspaceInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invitedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'staffId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWorkspaceInviteMutation, UpdateWorkspaceInviteMutationVariables>
export const DeleteWorkspaceInviteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteWorkspaceInvite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteWorkspaceInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteWorkspaceInviteMutation, DeleteWorkspaceInviteMutationVariables>
export const WorkspacesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Workspaces' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workspaces' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carestackId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastFacebookLeadsErrorDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxEnrollmentsPerHour' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxOutboundDaily' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxOutboundMonthly' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'promptAddendum' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspacesQuery, WorkspacesQueryVariables>
export const UpdateWorkspaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWorkspace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateWorkspaceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWorkspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carestackId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastFacebookLeadsErrorDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxEnrollmentsPerHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxOutboundDaily' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxOutboundMonthly' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgTags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promptAddendum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>
export const WorkspaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Workspace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carestackId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastFacebookLeadsErrorDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastPmsSyncDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxEnrollmentsPerHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxOutboundDaily' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxOutboundMonthly' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgTags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promptAddendum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceQuery, WorkspaceQueryVariables>
export const DeleteWorkspaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteWorkspace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteWorkspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>
export const UpdateBudgetTableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBudgetTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateBudgetInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBudget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBudgetTableMutation, UpdateBudgetTableMutationVariables>
export const UpdateContactTableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateContactTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateContactInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateContactTableMutation, UpdateContactTableMutationVariables>
export const UpdateTaskTableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTaskTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateTaskInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaskTableMutation, UpdateTaskTableMutationVariables>
export const SwitchWorkspaceOrgDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SwitchWorkspaceOrg' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'targetWorkspaceId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'targetOrgId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'switchWorkspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'targetWorkspaceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'targetWorkspaceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'targetOrgId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'targetOrgId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accessToken' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwitchWorkspaceOrgMutation, SwitchWorkspaceOrgMutationVariables>
